var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj2, key, value) => key in obj2 ? __defProp(obj2, key, { enumerable: true, configurable: true, writable: true, value }) : obj2[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));

// ../../node_modules/.pnpm/clone@2.1.2/node_modules/clone/clone.js
var require_clone = __commonJS({
  "../../node_modules/.pnpm/clone@2.1.2/node_modules/clone/clone.js"(exports2, module2) {
    var clone = function() {
      "use strict";
      function _instanceof(obj2, type) {
        return type != null && obj2 instanceof type;
      }
      var nativeMap;
      try {
        nativeMap = Map;
      } catch (_) {
        nativeMap = function() {
        };
      }
      var nativeSet;
      try {
        nativeSet = Set;
      } catch (_) {
        nativeSet = function() {
        };
      }
      var nativePromise;
      try {
        nativePromise = Promise;
      } catch (_) {
        nativePromise = function() {
        };
      }
      function clone2(parent2, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === "object") {
          depth = circular.depth;
          prototype = circular.prototype;
          includeNonEnumerable = circular.includeNonEnumerable;
          circular = circular.circular;
        }
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof Buffer != "undefined";
        if (typeof circular == "undefined")
          circular = true;
        if (typeof depth == "undefined")
          depth = Infinity;
        function _clone(parent3, depth2) {
          if (parent3 === null)
            return null;
          if (depth2 === 0)
            return parent3;
          var child;
          var proto;
          if (typeof parent3 != "object") {
            return parent3;
          }
          if (_instanceof(parent3, nativeMap)) {
            child = new nativeMap();
          } else if (_instanceof(parent3, nativeSet)) {
            child = new nativeSet();
          } else if (_instanceof(parent3, nativePromise)) {
            child = new nativePromise(function(resolve, reject) {
              parent3.then(function(value) {
                resolve(_clone(value, depth2 - 1));
              }, function(err) {
                reject(_clone(err, depth2 - 1));
              });
            });
          } else if (clone2.__isArray(parent3)) {
            child = [];
          } else if (clone2.__isRegExp(parent3)) {
            child = new RegExp(parent3.source, __getRegExpFlags(parent3));
            if (parent3.lastIndex)
              child.lastIndex = parent3.lastIndex;
          } else if (clone2.__isDate(parent3)) {
            child = new Date(parent3.getTime());
          } else if (useBuffer && Buffer.isBuffer(parent3)) {
            if (Buffer.allocUnsafe) {
              child = Buffer.allocUnsafe(parent3.length);
            } else {
              child = new Buffer(parent3.length);
            }
            parent3.copy(child);
            return child;
          } else if (_instanceof(parent3, Error)) {
            child = Object.create(parent3);
          } else {
            if (typeof prototype == "undefined") {
              proto = Object.getPrototypeOf(parent3);
              child = Object.create(proto);
            } else {
              child = Object.create(prototype);
              proto = prototype;
            }
          }
          if (circular) {
            var index = allParents.indexOf(parent3);
            if (index != -1) {
              return allChildren[index];
            }
            allParents.push(parent3);
            allChildren.push(child);
          }
          if (_instanceof(parent3, nativeMap)) {
            parent3.forEach(function(value, key) {
              var keyChild = _clone(key, depth2 - 1);
              var valueChild = _clone(value, depth2 - 1);
              child.set(keyChild, valueChild);
            });
          }
          if (_instanceof(parent3, nativeSet)) {
            parent3.forEach(function(value) {
              var entryChild = _clone(value, depth2 - 1);
              child.add(entryChild);
            });
          }
          for (var i in parent3) {
            var attrs;
            if (proto) {
              attrs = Object.getOwnPropertyDescriptor(proto, i);
            }
            if (attrs && attrs.set == null) {
              continue;
            }
            child[i] = _clone(parent3[i], depth2 - 1);
          }
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(parent3);
            for (var i = 0; i < symbols.length; i++) {
              var symbol = symbols[i];
              var descriptor = Object.getOwnPropertyDescriptor(parent3, symbol);
              if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                continue;
              }
              child[symbol] = _clone(parent3[symbol], depth2 - 1);
              if (!descriptor.enumerable) {
                Object.defineProperty(child, symbol, {
                  enumerable: false
                });
              }
            }
          }
          if (includeNonEnumerable) {
            var allPropertyNames = Object.getOwnPropertyNames(parent3);
            for (var i = 0; i < allPropertyNames.length; i++) {
              var propertyName = allPropertyNames[i];
              var descriptor = Object.getOwnPropertyDescriptor(parent3, propertyName);
              if (descriptor && descriptor.enumerable) {
                continue;
              }
              child[propertyName] = _clone(parent3[propertyName], depth2 - 1);
              Object.defineProperty(child, propertyName, {
                enumerable: false
              });
            }
          }
          return child;
        }
        return _clone(parent2, depth);
      }
      clone2.clonePrototype = function clonePrototype(parent2) {
        if (parent2 === null)
          return null;
        var c = function() {
        };
        c.prototype = parent2;
        return new c();
      };
      function __objToStr(o) {
        return Object.prototype.toString.call(o);
      }
      clone2.__objToStr = __objToStr;
      function __isDate(o) {
        return typeof o === "object" && __objToStr(o) === "[object Date]";
      }
      clone2.__isDate = __isDate;
      function __isArray(o) {
        return typeof o === "object" && __objToStr(o) === "[object Array]";
      }
      clone2.__isArray = __isArray;
      function __isRegExp(o) {
        return typeof o === "object" && __objToStr(o) === "[object RegExp]";
      }
      clone2.__isRegExp = __isRegExp;
      function __getRegExpFlags(re) {
        var flags = "";
        if (re.global)
          flags += "g";
        if (re.ignoreCase)
          flags += "i";
        if (re.multiline)
          flags += "m";
        return flags;
      }
      clone2.__getRegExpFlags = __getRegExpFlags;
      return clone2;
    }();
    if (typeof module2 === "object" && module2.exports) {
      module2.exports = clone;
    }
  }
});

// ../../node_modules/.pnpm/events@3.3.0/node_modules/events/events.js
var require_events = __commonJS({
  "../../node_modules/.pnpm/events@3.3.0/node_modules/events/events.js"(exports2, module2) {
    "use strict";
    var R = typeof Reflect === "object" ? Reflect : null;
    var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver2, args) {
      return Function.prototype.apply.call(target, receiver2, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === "function") {
      ReflectOwnKeys = R.ownKeys;
    } else if (Object.getOwnPropertySymbols) {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
      };
    } else {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target);
      };
    }
    function ProcessEmitWarning(warning) {
      if (console && console.warn)
        console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
      return value !== value;
    };
    function EventEmitter() {
      EventEmitter.init.call(this);
    }
    module2.exports = EventEmitter;
    module2.exports.once = once;
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.prototype._events = void 0;
    EventEmitter.prototype._eventsCount = 0;
    EventEmitter.prototype._maxListeners = void 0;
    var defaultMaxListeners = 10;
    function checkListener(listener) {
      if (typeof listener !== "function") {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
    }
    Object.defineProperty(EventEmitter, "defaultMaxListeners", {
      enumerable: true,
      get: function() {
        return defaultMaxListeners;
      },
      set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
          throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        }
        defaultMaxListeners = arg;
      }
    });
    EventEmitter.init = function() {
      if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
      }
      this._maxListeners = this._maxListeners || void 0;
    };
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
      if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) {
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
      }
      this._maxListeners = n;
      return this;
    };
    function _getMaxListeners(that) {
      if (that._maxListeners === void 0)
        return EventEmitter.defaultMaxListeners;
      return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
      return _getMaxListeners(this);
    };
    EventEmitter.prototype.emit = function emit(type) {
      var args = [];
      for (var i = 1; i < arguments.length; i++)
        args.push(arguments[i]);
      var doError = type === "error";
      var events = this._events;
      if (events !== void 0)
        doError = doError && events.error === void 0;
      else if (!doError)
        return false;
      if (doError) {
        var er;
        if (args.length > 0)
          er = args[0];
        if (er instanceof Error) {
          throw er;
        }
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err;
      }
      var handler = events[type];
      if (handler === void 0)
        return false;
      if (typeof handler === "function") {
        ReflectApply(handler, this, args);
      } else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          ReflectApply(listeners[i], this, args);
      }
      return true;
    };
    function _addListener(target, type, listener, prepend) {
      var m;
      var events;
      var existing;
      checkListener(listener);
      events = target._events;
      if (events === void 0) {
        events = target._events = /* @__PURE__ */ Object.create(null);
        target._eventsCount = 0;
      } else {
        if (events.newListener !== void 0) {
          target.emit("newListener", type, listener.listener ? listener.listener : listener);
          events = target._events;
        }
        existing = events[type];
      }
      if (existing === void 0) {
        existing = events[type] = listener;
        ++target._eventsCount;
      } else {
        if (typeof existing === "function") {
          existing = events[type] = prepend ? [listener, existing] : [existing, listener];
        } else if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
          existing.warned = true;
          var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          w.name = "MaxListenersExceededWarning";
          w.emitter = target;
          w.type = type;
          w.count = existing.length;
          ProcessEmitWarning(w);
        }
      }
      return target;
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
      return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };
    function onceWrapper() {
      if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0)
          return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
      }
    }
    function _onceWrap(target, type, listener) {
      var state = { fired: false, wrapFn: void 0, target, type, listener };
      var wrapped = onceWrapper.bind(state);
      wrapped.listener = listener;
      state.wrapFn = wrapped;
      return wrapped;
    }
    EventEmitter.prototype.once = function once2(type, listener) {
      checkListener(listener);
      this.on(type, _onceWrap(this, type, listener));
      return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
      var list, events, position, i, originalListener;
      checkListener(listener);
      events = this._events;
      if (events === void 0)
        return this;
      list = events[type];
      if (list === void 0)
        return this;
      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = /* @__PURE__ */ Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit("removeListener", type, list.listener || listener);
        }
      } else if (typeof list !== "function") {
        position = -1;
        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }
        if (position < 0)
          return this;
        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }
        if (list.length === 1)
          events[type] = list[0];
        if (events.removeListener !== void 0)
          this.emit("removeListener", type, originalListener || listener);
      }
      return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
      var listeners, events, i;
      events = this._events;
      if (events === void 0)
        return this;
      if (events.removeListener === void 0) {
        if (arguments.length === 0) {
          this._events = /* @__PURE__ */ Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== void 0) {
          if (--this._eventsCount === 0)
            this._events = /* @__PURE__ */ Object.create(null);
          else
            delete events[type];
        }
        return this;
      }
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === "removeListener")
            continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
        return this;
      }
      listeners = events[type];
      if (typeof listeners === "function") {
        this.removeListener(type, listeners);
      } else if (listeners !== void 0) {
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }
      return this;
    };
    function _listeners(target, type, unwrap) {
      var events = target._events;
      if (events === void 0)
        return [];
      var evlistener = events[type];
      if (evlistener === void 0)
        return [];
      if (typeof evlistener === "function")
        return unwrap ? [evlistener.listener || evlistener] : [evlistener];
      return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter.prototype.listeners = function listeners(type) {
      return _listeners(this, type, true);
    };
    EventEmitter.prototype.rawListeners = function rawListeners(type) {
      return _listeners(this, type, false);
    };
    EventEmitter.listenerCount = function(emitter, type) {
      if (typeof emitter.listenerCount === "function") {
        return emitter.listenerCount(type);
      } else {
        return listenerCount.call(emitter, type);
      }
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
      var events = this._events;
      if (events !== void 0) {
        var evlistener = events[type];
        if (typeof evlistener === "function") {
          return 1;
        } else if (evlistener !== void 0) {
          return evlistener.length;
        }
      }
      return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
      return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
      var copy = new Array(n);
      for (var i = 0; i < n; ++i)
        copy[i] = arr[i];
      return copy;
    }
    function spliceOne(list, index) {
      for (; index + 1 < list.length; index++)
        list[index] = list[index + 1];
      list.pop();
    }
    function unwrapListeners(arr) {
      var ret2 = new Array(arr.length);
      for (var i = 0; i < ret2.length; ++i) {
        ret2[i] = arr[i].listener || arr[i];
      }
      return ret2;
    }
    function once(emitter, name) {
      return new Promise(function(resolve, reject) {
        function errorListener(err) {
          emitter.removeListener(name, resolver);
          reject(err);
        }
        function resolver() {
          if (typeof emitter.removeListener === "function") {
            emitter.removeListener("error", errorListener);
          }
          resolve([].slice.call(arguments));
        }
        ;
        eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
        if (name !== "error") {
          addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
        }
      });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
      if (typeof emitter.on === "function") {
        eventTargetAgnosticAddListener(emitter, "error", handler, flags);
      }
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
      if (typeof emitter.on === "function") {
        if (flags.once) {
          emitter.once(name, listener);
        } else {
          emitter.on(name, listener);
        }
      } else if (typeof emitter.addEventListener === "function") {
        emitter.addEventListener(name, function wrapListener(arg) {
          if (flags.once) {
            emitter.removeEventListener(name, wrapListener);
          }
          listener(arg);
        });
      } else {
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
      }
    }
  }
});

// ../../node_modules/.pnpm/node-cache@5.1.2/node_modules/node-cache/lib/node_cache.js
var require_node_cache = __commonJS({
  "../../node_modules/.pnpm/node-cache@5.1.2/node_modules/node-cache/lib/node_cache.js"(exports2, module2) {
    (function() {
      var EventEmitter, NodeCache3, clone, splice = [].splice, boundMethodCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new Error("Bound instance method accessed before binding");
        }
      }, indexOf = [].indexOf;
      clone = require_clone();
      EventEmitter = require_events().EventEmitter;
      module2.exports = NodeCache3 = function() {
        class NodeCache4 extends EventEmitter {
          constructor(options = {}) {
            super();
            this.get = this.get.bind(this);
            this.mget = this.mget.bind(this);
            this.set = this.set.bind(this);
            this.mset = this.mset.bind(this);
            this.del = this.del.bind(this);
            this.take = this.take.bind(this);
            this.ttl = this.ttl.bind(this);
            this.getTtl = this.getTtl.bind(this);
            this.keys = this.keys.bind(this);
            this.has = this.has.bind(this);
            this.getStats = this.getStats.bind(this);
            this.flushAll = this.flushAll.bind(this);
            this.flushStats = this.flushStats.bind(this);
            this.close = this.close.bind(this);
            this._checkData = this._checkData.bind(this);
            this._check = this._check.bind(this);
            this._isInvalidKey = this._isInvalidKey.bind(this);
            this._wrap = this._wrap.bind(this);
            this._getValLength = this._getValLength.bind(this);
            this._error = this._error.bind(this);
            this._initErrors = this._initErrors.bind(this);
            this.options = options;
            this._initErrors();
            this.data = {};
            this.options = Object.assign({
              forceString: false,
              objectValueSize: 80,
              promiseValueSize: 80,
              arrayValueSize: 40,
              stdTTL: 0,
              checkperiod: 600,
              useClones: true,
              deleteOnExpire: true,
              enableLegacyCallbacks: false,
              maxKeys: -1
            }, this.options);
            if (this.options.enableLegacyCallbacks) {
              console.warn("WARNING! node-cache legacy callback support will drop in v6.x");
              ["get", "mget", "set", "del", "ttl", "getTtl", "keys", "has"].forEach((methodKey) => {
                var oldMethod;
                oldMethod = this[methodKey];
                this[methodKey] = function(...args) {
                  var cb, err, ref, res;
                  ref = args, [...args] = ref, [cb] = splice.call(args, -1);
                  if (typeof cb === "function") {
                    try {
                      res = oldMethod(...args);
                      cb(null, res);
                    } catch (error1) {
                      err = error1;
                      cb(err);
                    }
                  } else {
                    return oldMethod(...args, cb);
                  }
                };
              });
            }
            this.stats = {
              hits: 0,
              misses: 0,
              keys: 0,
              ksize: 0,
              vsize: 0
            };
            this.validKeyTypes = ["string", "number"];
            this._checkData();
            return;
          }
          get(key) {
            var _ret, err;
            boundMethodCheck(this, NodeCache4);
            if ((err = this._isInvalidKey(key)) != null) {
              throw err;
            }
            if (this.data[key] != null && this._check(key, this.data[key])) {
              this.stats.hits++;
              _ret = this._unwrap(this.data[key]);
              return _ret;
            } else {
              this.stats.misses++;
              return void 0;
            }
          }
          mget(keys) {
            var _err, err, i, key, len, oRet;
            boundMethodCheck(this, NodeCache4);
            if (!Array.isArray(keys)) {
              _err = this._error("EKEYSTYPE");
              throw _err;
            }
            oRet = {};
            for (i = 0, len = keys.length; i < len; i++) {
              key = keys[i];
              if ((err = this._isInvalidKey(key)) != null) {
                throw err;
              }
              if (this.data[key] != null && this._check(key, this.data[key])) {
                this.stats.hits++;
                oRet[key] = this._unwrap(this.data[key]);
              } else {
                this.stats.misses++;
              }
            }
            return oRet;
          }
          set(key, value, ttl) {
            var _err, err, existent;
            boundMethodCheck(this, NodeCache4);
            if (this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) {
              _err = this._error("ECACHEFULL");
              throw _err;
            }
            if (this.options.forceString && !typeof value === "string") {
              value = JSON.stringify(value);
            }
            if (ttl == null) {
              ttl = this.options.stdTTL;
            }
            if ((err = this._isInvalidKey(key)) != null) {
              throw err;
            }
            existent = false;
            if (this.data[key]) {
              existent = true;
              this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
            }
            this.data[key] = this._wrap(value, ttl);
            this.stats.vsize += this._getValLength(value);
            if (!existent) {
              this.stats.ksize += this._getKeyLength(key);
              this.stats.keys++;
            }
            this.emit("set", key, value);
            return true;
          }
          mset(keyValueSet) {
            var _err, err, i, j, key, keyValuePair, len, len1, ttl, val;
            boundMethodCheck(this, NodeCache4);
            if (this.options.maxKeys > -1 && this.stats.keys + keyValueSet.length >= this.options.maxKeys) {
              _err = this._error("ECACHEFULL");
              throw _err;
            }
            for (i = 0, len = keyValueSet.length; i < len; i++) {
              keyValuePair = keyValueSet[i];
              ({ key, val, ttl } = keyValuePair);
              if (ttl && typeof ttl !== "number") {
                _err = this._error("ETTLTYPE");
                throw _err;
              }
              if ((err = this._isInvalidKey(key)) != null) {
                throw err;
              }
            }
            for (j = 0, len1 = keyValueSet.length; j < len1; j++) {
              keyValuePair = keyValueSet[j];
              ({ key, val, ttl } = keyValuePair);
              this.set(key, val, ttl);
            }
            return true;
          }
          del(keys) {
            var delCount, err, i, key, len, oldVal;
            boundMethodCheck(this, NodeCache4);
            if (!Array.isArray(keys)) {
              keys = [keys];
            }
            delCount = 0;
            for (i = 0, len = keys.length; i < len; i++) {
              key = keys[i];
              if ((err = this._isInvalidKey(key)) != null) {
                throw err;
              }
              if (this.data[key] != null) {
                this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                this.stats.ksize -= this._getKeyLength(key);
                this.stats.keys--;
                delCount++;
                oldVal = this.data[key];
                delete this.data[key];
                this.emit("del", key, oldVal.v);
              }
            }
            return delCount;
          }
          take(key) {
            var _ret;
            boundMethodCheck(this, NodeCache4);
            _ret = this.get(key);
            if (_ret != null) {
              this.del(key);
            }
            return _ret;
          }
          ttl(key, ttl) {
            var err;
            boundMethodCheck(this, NodeCache4);
            ttl || (ttl = this.options.stdTTL);
            if (!key) {
              return false;
            }
            if ((err = this._isInvalidKey(key)) != null) {
              throw err;
            }
            if (this.data[key] != null && this._check(key, this.data[key])) {
              if (ttl >= 0) {
                this.data[key] = this._wrap(this.data[key].v, ttl, false);
              } else {
                this.del(key);
              }
              return true;
            } else {
              return false;
            }
          }
          getTtl(key) {
            var _ttl, err;
            boundMethodCheck(this, NodeCache4);
            if (!key) {
              return void 0;
            }
            if ((err = this._isInvalidKey(key)) != null) {
              throw err;
            }
            if (this.data[key] != null && this._check(key, this.data[key])) {
              _ttl = this.data[key].t;
              return _ttl;
            } else {
              return void 0;
            }
          }
          keys() {
            var _keys;
            boundMethodCheck(this, NodeCache4);
            _keys = Object.keys(this.data);
            return _keys;
          }
          has(key) {
            var _exists;
            boundMethodCheck(this, NodeCache4);
            _exists = this.data[key] != null && this._check(key, this.data[key]);
            return _exists;
          }
          getStats() {
            boundMethodCheck(this, NodeCache4);
            return this.stats;
          }
          flushAll(_startPeriod = true) {
            boundMethodCheck(this, NodeCache4);
            this.data = {};
            this.stats = {
              hits: 0,
              misses: 0,
              keys: 0,
              ksize: 0,
              vsize: 0
            };
            this._killCheckPeriod();
            this._checkData(_startPeriod);
            this.emit("flush");
          }
          flushStats() {
            boundMethodCheck(this, NodeCache4);
            this.stats = {
              hits: 0,
              misses: 0,
              keys: 0,
              ksize: 0,
              vsize: 0
            };
            this.emit("flush_stats");
          }
          close() {
            boundMethodCheck(this, NodeCache4);
            this._killCheckPeriod();
          }
          _checkData(startPeriod = true) {
            var key, ref, value;
            boundMethodCheck(this, NodeCache4);
            ref = this.data;
            for (key in ref) {
              value = ref[key];
              this._check(key, value);
            }
            if (startPeriod && this.options.checkperiod > 0) {
              this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1e3, startPeriod);
              if (this.checkTimeout != null && this.checkTimeout.unref != null) {
                this.checkTimeout.unref();
              }
            }
          }
          _killCheckPeriod() {
            if (this.checkTimeout != null) {
              return clearTimeout(this.checkTimeout);
            }
          }
          _check(key, data) {
            var _retval;
            boundMethodCheck(this, NodeCache4);
            _retval = true;
            if (data.t !== 0 && data.t < Date.now()) {
              if (this.options.deleteOnExpire) {
                _retval = false;
                this.del(key);
              }
              this.emit("expired", key, this._unwrap(data));
            }
            return _retval;
          }
          _isInvalidKey(key) {
            var ref;
            boundMethodCheck(this, NodeCache4);
            if (ref = typeof key, indexOf.call(this.validKeyTypes, ref) < 0) {
              return this._error("EKEYTYPE", {
                type: typeof key
              });
            }
          }
          _wrap(value, ttl, asClone = true) {
            var livetime, now, oReturn, ttlMultiplicator;
            boundMethodCheck(this, NodeCache4);
            if (!this.options.useClones) {
              asClone = false;
            }
            now = Date.now();
            livetime = 0;
            ttlMultiplicator = 1e3;
            if (ttl === 0) {
              livetime = 0;
            } else if (ttl) {
              livetime = now + ttl * ttlMultiplicator;
            } else {
              if (this.options.stdTTL === 0) {
                livetime = this.options.stdTTL;
              } else {
                livetime = now + this.options.stdTTL * ttlMultiplicator;
              }
            }
            return oReturn = {
              t: livetime,
              v: asClone ? clone(value) : value
            };
          }
          _unwrap(value, asClone = true) {
            if (!this.options.useClones) {
              asClone = false;
            }
            if (value.v != null) {
              if (asClone) {
                return clone(value.v);
              } else {
                return value.v;
              }
            }
            return null;
          }
          _getKeyLength(key) {
            return key.toString().length;
          }
          _getValLength(value) {
            boundMethodCheck(this, NodeCache4);
            if (typeof value === "string") {
              return value.length;
            } else if (this.options.forceString) {
              return JSON.stringify(value).length;
            } else if (Array.isArray(value)) {
              return this.options.arrayValueSize * value.length;
            } else if (typeof value === "number") {
              return 8;
            } else if (typeof (value != null ? value.then : void 0) === "function") {
              return this.options.promiseValueSize;
            } else if (typeof Buffer !== "undefined" && Buffer !== null ? Buffer.isBuffer(value) : void 0) {
              return value.length;
            } else if (value != null && typeof value === "object") {
              return this.options.objectValueSize * Object.keys(value).length;
            } else if (typeof value === "boolean") {
              return 8;
            } else {
              return 0;
            }
          }
          _error(type, data = {}) {
            var error;
            boundMethodCheck(this, NodeCache4);
            error = new Error();
            error.name = type;
            error.errorcode = type;
            error.message = this.ERRORS[type] != null ? this.ERRORS[type](data) : "-";
            error.data = data;
            return error;
          }
          _initErrors() {
            var _errMsg, _errT, ref;
            boundMethodCheck(this, NodeCache4);
            this.ERRORS = {};
            ref = this._ERRORS;
            for (_errT in ref) {
              _errMsg = ref[_errT];
              this.ERRORS[_errT] = this.createErrorMessage(_errMsg);
            }
          }
          createErrorMessage(errMsg) {
            return function(args) {
              return errMsg.replace("__key", args.type);
            };
          }
        }
        ;
        NodeCache4.prototype._ERRORS = {
          "ENOTFOUND": "Key `__key` not found",
          "ECACHEFULL": "Cache max keys amount exceeded",
          "EKEYTYPE": "The key argument has to be of type `string` or `number`. Found: `__key`",
          "EKEYSTYPE": "The keys argument has to be an array.",
          "ETTLTYPE": "The ttl argument has to be a number."
        };
        return NodeCache4;
      }.call(this);
    }).call(exports2);
  }
});

// ../../node_modules/.pnpm/node-cache@5.1.2/node_modules/node-cache/index.js
var require_node_cache2 = __commonJS({
  "../../node_modules/.pnpm/node-cache@5.1.2/node_modules/node-cache/index.js"(exports2, module2) {
    (function() {
      var exports3;
      exports3 = module2.exports = require_node_cache();
      exports3.version = "5.1.2";
    }).call(exports2);
  }
});

// ../../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.js
var require_tslib = __commonJS({
  "../../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.js"(exports2, module2) {
    var __extends3;
    var __assign3;
    var __rest3;
    var __decorate3;
    var __param3;
    var __metadata3;
    var __awaiter3;
    var __generator3;
    var __exportStar3;
    var __values3;
    var __read3;
    var __spread3;
    var __spreadArrays3;
    var __spreadArray2;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator3;
    var __asyncValues3;
    var __makeTemplateObject3;
    var __importStar3;
    var __importDefault3;
    var __classPrivateFieldGet3;
    var __classPrivateFieldSet3;
    var __classPrivateFieldIn2;
    var __createBinding3;
    (function(factory) {
      var root3 = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports3) {
          factory(createExporter(root3, createExporter(exports3)));
        });
      } else if (typeof module2 === "object" && typeof module2.exports === "object") {
        factory(createExporter(root3, createExporter(module2.exports)));
      } else {
        factory(createExporter(root3));
      }
      function createExporter(exports3, previous) {
        if (exports3 !== root3) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports3, "__esModule", { value: true });
          } else {
            exports3.__esModule = true;
          }
        }
        return function(id, v) {
          return exports3[id] = previous ? previous(id, v) : v;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b)
          if (Object.prototype.hasOwnProperty.call(b, p))
            d[p] = b[p];
      };
      __extends3 = function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
      __assign3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      __rest3 = function(s, e) {
        var t = {};
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
          }
        return t;
      };
      __decorate3 = function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
              r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };
      __param3 = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata3 = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter3 = function(thisArg, _arguments, P, generator) {
        function adopt(value) {
          return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
          });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator3 = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t[0] & 1)
            throw t[1];
          return t[1];
        }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
          return this;
        }), g;
        function verb(n) {
          return function(v) {
            return step([n, v]);
          };
        }
        function step(op) {
          if (f)
            throw new TypeError("Generator is already executing.");
          while (_)
            try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                return t;
              if (y = 0, t)
                op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __exportStar3 = function(m, o) {
        for (var p in m)
          if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p))
            __createBinding3(o, m, p);
      };
      __createBinding3 = Object.create ? function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
          desc = { enumerable: true, get: function() {
            return m[k];
          } };
        }
        Object.defineProperty(o, k2, desc);
      } : function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        o[k2] = m[k];
      };
      __values3 = function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m)
          return m.call(o);
        if (o && typeof o.length === "number")
          return {
            next: function() {
              if (o && i >= o.length)
                o = void 0;
              return { value: o && o[i++], done: !o };
            }
          };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read3 = function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m)
          return o;
        var i = m.call(o), r, ar = [], e;
        try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r && !r.done && (m = i["return"]))
              m.call(i);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread3 = function() {
        for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read3(arguments[i]));
        return ar;
      };
      __spreadArrays3 = function() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++)
          s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
        return r;
      };
      __spreadArray2 = function(to, from2, pack) {
        if (pack || arguments.length === 2)
          for (var i = 0, l = from2.length, ar; i < l; i++) {
            if (ar || !(i in from2)) {
              if (!ar)
                ar = Array.prototype.slice.call(from2, 0, i);
              ar[i] = from2[i];
            }
          }
        return to.concat(ar || Array.prototype.slice.call(from2));
      };
      __await3 = function(v) {
        return this instanceof __await3 ? (this.v = v, this) : new __await3(v);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i;
        function verb(n) {
          if (g[n])
            i[n] = function(v) {
              return new Promise(function(a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
        }
        function resume(n, v) {
          try {
            step(g[n](v));
          } catch (e) {
            settle(q[0][3], e);
          }
        }
        function step(r) {
          r.value instanceof __await3 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f, v) {
          if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator3 = function(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i[Symbol.iterator] = function() {
          return this;
        }, i;
        function verb(n, f) {
          i[n] = o[n] ? function(v) {
            return (p = !p) ? { value: __await3(o[n](v)), done: n === "return" } : f ? f(v) : v;
          } : f;
        }
      };
      __asyncValues3 = function(o) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values3 === "function" ? __values3(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i);
        function verb(n) {
          i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
              v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
          };
        }
        function settle(resolve, reject, d, v) {
          Promise.resolve(v).then(function(v2) {
            resolve({ value: v2, done: d });
          }, reject);
        }
      };
      __makeTemplateObject3 = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      var __setModuleDefault = Object.create ? function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
      } : function(o, v) {
        o["default"] = v;
      };
      __importStar3 = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result2 = {};
        if (mod != null) {
          for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
              __createBinding3(result2, mod, k);
        }
        __setModuleDefault(result2, mod);
        return result2;
      };
      __importDefault3 = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet3 = function(receiver2, state, kind, f) {
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver2 !== state || !f : !state.has(receiver2))
          throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver2) : f ? f.value : state.get(receiver2);
      };
      __classPrivateFieldSet3 = function(receiver2, state, value, kind, f) {
        if (kind === "m")
          throw new TypeError("Private method is not writable");
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver2 !== state || !f : !state.has(receiver2))
          throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver2, value) : f ? f.value = value : state.set(receiver2, value), value;
      };
      __classPrivateFieldIn2 = function(state, receiver2) {
        if (receiver2 === null || typeof receiver2 !== "object" && typeof receiver2 !== "function")
          throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver2 === state : state.has(receiver2);
      };
      exporter("__extends", __extends3);
      exporter("__assign", __assign3);
      exporter("__rest", __rest3);
      exporter("__decorate", __decorate3);
      exporter("__param", __param3);
      exporter("__metadata", __metadata3);
      exporter("__awaiter", __awaiter3);
      exporter("__generator", __generator3);
      exporter("__exportStar", __exportStar3);
      exporter("__createBinding", __createBinding3);
      exporter("__values", __values3);
      exporter("__read", __read3);
      exporter("__spread", __spread3);
      exporter("__spreadArrays", __spreadArrays3);
      exporter("__spreadArray", __spreadArray2);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator3);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject3);
      exporter("__importStar", __importStar3);
      exporter("__importDefault", __importDefault3);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet3);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet3);
      exporter("__classPrivateFieldIn", __classPrivateFieldIn2);
    });
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/devAssert.js
var require_devAssert = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/devAssert.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = devAssert;
    function devAssert(condition, message) {
      var booleanCondition = Boolean(condition);
      if (!booleanCondition) {
        throw new Error(message);
      }
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/defineToStringTag.js
var require_defineToStringTag = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/defineToStringTag.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = defineToStringTag;
    function defineToStringTag(classObject) {
      if (typeof Symbol === "function" && Symbol.toStringTag) {
        Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
          get: function get() {
            return this.constructor.name;
          }
        });
      }
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/source.js
var require_source = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/source.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.Source = void 0;
    var _devAssert = _interopRequireDefault(require_devAssert());
    var _defineToStringTag = _interopRequireDefault(require_defineToStringTag());
    function _interopRequireDefault(obj2) {
      return obj2 && obj2.__esModule ? obj2 : { default: obj2 };
    }
    var Source2 = function Source3(body, name, locationOffset) {
      this.body = body;
      this.name = name || "GraphQL request";
      this.locationOffset = locationOffset || {
        line: 1,
        column: 1
      };
      this.locationOffset.line > 0 || (0, _devAssert.default)(0, "line in locationOffset is 1-indexed and must be positive");
      this.locationOffset.column > 0 || (0, _devAssert.default)(0, "column in locationOffset is 1-indexed and must be positive");
    };
    exports2.Source = Source2;
    (0, _defineToStringTag.default)(Source2);
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/location.js
var require_location = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/location.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.getLocation = getLocation2;
    function getLocation2(source, position) {
      var lineRegexp = /\r\n|[\n\r]/g;
      var line = 1;
      var column = position + 1;
      var match;
      while ((match = lineRegexp.exec(source.body)) && match.index < position) {
        line += 1;
        column = position + 1 - (match.index + match[0].length);
      }
      return {
        line,
        column
      };
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/printLocation.js
var require_printLocation = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/printLocation.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.printLocation = printLocation2;
    exports2.printSourceLocation = printSourceLocation2;
    var _location = require_location();
    function printLocation2(location) {
      return printSourceLocation2(location.source, (0, _location.getLocation)(location.source, location.start));
    }
    function printSourceLocation2(source, sourceLocation) {
      var firstLineColumnOffset = source.locationOffset.column - 1;
      var body = whitespace(firstLineColumnOffset) + source.body;
      var lineIndex = sourceLocation.line - 1;
      var lineOffset = source.locationOffset.line - 1;
      var lineNum = sourceLocation.line + lineOffset;
      var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
      var columnNum = sourceLocation.column + columnOffset;
      var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
      var lines = body.split(/\r\n|[\n\r]/g);
      var locationLine = lines[lineIndex];
      if (locationLine.length > 120) {
        var sublineIndex = Math.floor(columnNum / 80);
        var sublineColumnNum = columnNum % 80;
        var sublines = [];
        for (var i = 0; i < locationLine.length; i += 80) {
          sublines.push(locationLine.slice(i, i + 80));
        }
        return locationStr + printPrefixedLines([["".concat(lineNum), sublines[0]]].concat(sublines.slice(1, sublineIndex + 1).map(function(subline) {
          return ["", subline];
        }), [[" ", whitespace(sublineColumnNum - 1) + "^"], ["", sublines[sublineIndex + 1]]]));
      }
      return locationStr + printPrefixedLines([
        ["".concat(lineNum - 1), lines[lineIndex - 1]],
        ["".concat(lineNum), locationLine],
        ["", whitespace(columnNum - 1) + "^"],
        ["".concat(lineNum + 1), lines[lineIndex + 1]]
      ]);
    }
    function printPrefixedLines(lines) {
      var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== void 0;
      });
      var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
      }));
      return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return lpad(padLen, prefix) + (line ? " | " + line : " |");
      }).join("\n");
    }
    function whitespace(len) {
      return Array(len + 1).join(" ");
    }
    function lpad(len, str) {
      return whitespace(len - str.length) + str;
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/kinds.js
var require_kinds = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/kinds.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.Kind = void 0;
    var Kind2 = Object.freeze({
      NAME: "Name",
      DOCUMENT: "Document",
      OPERATION_DEFINITION: "OperationDefinition",
      VARIABLE_DEFINITION: "VariableDefinition",
      SELECTION_SET: "SelectionSet",
      FIELD: "Field",
      ARGUMENT: "Argument",
      FRAGMENT_SPREAD: "FragmentSpread",
      INLINE_FRAGMENT: "InlineFragment",
      FRAGMENT_DEFINITION: "FragmentDefinition",
      VARIABLE: "Variable",
      INT: "IntValue",
      FLOAT: "FloatValue",
      STRING: "StringValue",
      BOOLEAN: "BooleanValue",
      NULL: "NullValue",
      ENUM: "EnumValue",
      LIST: "ListValue",
      OBJECT: "ObjectValue",
      OBJECT_FIELD: "ObjectField",
      DIRECTIVE: "Directive",
      NAMED_TYPE: "NamedType",
      LIST_TYPE: "ListType",
      NON_NULL_TYPE: "NonNullType",
      SCHEMA_DEFINITION: "SchemaDefinition",
      OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
      SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
      OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
      FIELD_DEFINITION: "FieldDefinition",
      INPUT_VALUE_DEFINITION: "InputValueDefinition",
      INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
      UNION_TYPE_DEFINITION: "UnionTypeDefinition",
      ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
      ENUM_VALUE_DEFINITION: "EnumValueDefinition",
      INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
      DIRECTIVE_DEFINITION: "DirectiveDefinition",
      SCHEMA_EXTENSION: "SchemaExtension",
      SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
      OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
      INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
      UNION_TYPE_EXTENSION: "UnionTypeExtension",
      ENUM_TYPE_EXTENSION: "EnumTypeExtension",
      INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
    });
    exports2.Kind = Kind2;
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/tokenKind.js
var require_tokenKind = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/tokenKind.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.TokenKind = void 0;
    var TokenKind2 = Object.freeze({
      SOF: "<SOF>",
      EOF: "<EOF>",
      BANG: "!",
      DOLLAR: "$",
      AMP: "&",
      PAREN_L: "(",
      PAREN_R: ")",
      SPREAD: "...",
      COLON: ":",
      EQUALS: "=",
      AT: "@",
      BRACKET_L: "[",
      BRACKET_R: "]",
      BRACE_L: "{",
      PIPE: "|",
      BRACE_R: "}",
      NAME: "Name",
      INT: "Int",
      FLOAT: "Float",
      STRING: "String",
      BLOCK_STRING: "BlockString",
      COMMENT: "Comment"
    });
    exports2.TokenKind = TokenKind2;
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/nodejsCustomInspectSymbol.js
var require_nodejsCustomInspectSymbol = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/nodejsCustomInspectSymbol.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
    var _default = nodejsCustomInspectSymbol;
    exports2.default = _default;
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/defineToJSON.js
var require_defineToJSON = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/defineToJSON.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = defineToJSON;
    var _nodejsCustomInspectSymbol = _interopRequireDefault(require_nodejsCustomInspectSymbol());
    function _interopRequireDefault(obj2) {
      return obj2 && obj2.__esModule ? obj2 : { default: obj2 };
    }
    function defineToJSON(classObject) {
      var fn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : classObject.prototype.toString;
      classObject.prototype.toJSON = fn;
      classObject.prototype.inspect = fn;
      if (_nodejsCustomInspectSymbol.default) {
        classObject.prototype[_nodejsCustomInspectSymbol.default] = fn;
      }
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/isObjectLike.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = isObjectLike2;
    function _typeof(obj2) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof2(obj3) {
          return typeof obj3;
        };
      } else {
        _typeof = function _typeof2(obj3) {
          return obj3 && typeof Symbol === "function" && obj3.constructor === Symbol && obj3 !== Symbol.prototype ? "symbol" : typeof obj3;
        };
      }
      return _typeof(obj2);
    }
    function isObjectLike2(value) {
      return _typeof(value) == "object" && value !== null;
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/error/GraphQLError.js
var require_GraphQLError = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/error/GraphQLError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.GraphQLError = GraphQLError;
    exports2.printError = printError;
    var _isObjectLike = _interopRequireDefault(require_isObjectLike());
    var _location = require_location();
    var _printLocation = require_printLocation();
    function _interopRequireDefault(obj2) {
      return obj2 && obj2.__esModule ? obj2 : { default: obj2 };
    }
    function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
      var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : void 0 : nodes ? [nodes] : void 0;
      var _source = source;
      if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
      }
      var _positions = positions;
      if (!_positions && _nodes) {
        _positions = _nodes.reduce(function(list, node2) {
          if (node2.loc) {
            list.push(node2.loc.start);
          }
          return list;
        }, []);
      }
      if (_positions && _positions.length === 0) {
        _positions = void 0;
      }
      var _locations;
      if (positions && source) {
        _locations = positions.map(function(pos) {
          return (0, _location.getLocation)(source, pos);
        });
      } else if (_nodes) {
        _locations = _nodes.reduce(function(list, node2) {
          if (node2.loc) {
            list.push((0, _location.getLocation)(node2.loc.source, node2.loc.start));
          }
          return list;
        }, []);
      }
      var _extensions = extensions;
      if (_extensions == null && originalError != null) {
        var originalExtensions = originalError.extensions;
        if ((0, _isObjectLike.default)(originalExtensions)) {
          _extensions = originalExtensions;
        }
      }
      Object.defineProperties(this, {
        message: {
          value: message,
          enumerable: true,
          writable: true
        },
        locations: {
          value: _locations || void 0,
          enumerable: Boolean(_locations)
        },
        path: {
          value: path || void 0,
          enumerable: Boolean(path)
        },
        nodes: {
          value: _nodes || void 0
        },
        source: {
          value: _source || void 0
        },
        positions: {
          value: _positions || void 0
        },
        originalError: {
          value: originalError
        },
        extensions: {
          value: _extensions || void 0,
          enumerable: Boolean(_extensions)
        }
      });
      if (originalError && originalError.stack) {
        Object.defineProperty(this, "stack", {
          value: originalError.stack,
          writable: true,
          configurable: true
        });
      } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, GraphQLError);
      } else {
        Object.defineProperty(this, "stack", {
          value: Error().stack,
          writable: true,
          configurable: true
        });
      }
    }
    GraphQLError.prototype = Object.create(Error.prototype, {
      constructor: {
        value: GraphQLError
      },
      name: {
        value: "GraphQLError"
      },
      toString: {
        value: function toString3() {
          return printError(this);
        }
      }
    });
    function printError(error) {
      var output = error.message;
      if (error.nodes) {
        for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
          var node = _error$nodes2[_i2];
          if (node.loc) {
            output += "\n\n" + (0, _printLocation.printLocation)(node.loc);
          }
        }
      } else if (error.source && error.locations) {
        for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
          var location = _error$locations2[_i4];
          output += "\n\n" + (0, _printLocation.printSourceLocation)(error.source, location);
        }
      }
      return output;
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/error/syntaxError.js
var require_syntaxError = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/error/syntaxError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.syntaxError = syntaxError;
    var _GraphQLError = require_GraphQLError();
    function syntaxError(source, position, description) {
      return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), void 0, source, [position]);
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/blockString.js
var require_blockString = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/blockString.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.dedentBlockStringValue = dedentBlockStringValue;
    exports2.getBlockStringIndentation = getBlockStringIndentation;
    exports2.printBlockString = printBlockString;
    function dedentBlockStringValue(rawString) {
      var lines = rawString.split(/\r\n|[\n\r]/g);
      var commonIndent = getBlockStringIndentation(lines);
      if (commonIndent !== 0) {
        for (var i = 1; i < lines.length; i++) {
          lines[i] = lines[i].slice(commonIndent);
        }
      }
      while (lines.length > 0 && isBlank(lines[0])) {
        lines.shift();
      }
      while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
        lines.pop();
      }
      return lines.join("\n");
    }
    function getBlockStringIndentation(lines) {
      var commonIndent = null;
      for (var i = 1; i < lines.length; i++) {
        var line = lines[i];
        var indent = leadingWhitespace(line);
        if (indent === line.length) {
          continue;
        }
        if (commonIndent === null || indent < commonIndent) {
          commonIndent = indent;
          if (commonIndent === 0) {
            break;
          }
        }
      }
      return commonIndent === null ? 0 : commonIndent;
    }
    function leadingWhitespace(str) {
      var i = 0;
      while (i < str.length && (str[i] === " " || str[i] === "	")) {
        i++;
      }
      return i;
    }
    function isBlank(str) {
      return leadingWhitespace(str) === str.length;
    }
    function printBlockString(value) {
      var indentation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      var preferMultipleLines = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      var isSingleLine = value.indexOf("\n") === -1;
      var hasLeadingSpace = value[0] === " " || value[0] === "	";
      var hasTrailingQuote = value[value.length - 1] === '"';
      var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
      var result2 = "";
      if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
        result2 += "\n" + indentation;
      }
      result2 += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
      if (printAsMultipleLines) {
        result2 += "\n";
      }
      return '"""' + result2.replace(/"""/g, '\\"""') + '"""';
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/lexer.js
var require_lexer = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/lexer.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.createLexer = createLexer2;
    exports2.isPunctuatorToken = isPunctuatorToken;
    var _defineToJSON = _interopRequireDefault(require_defineToJSON());
    var _syntaxError = require_syntaxError();
    var _blockString = require_blockString();
    var _tokenKind = require_tokenKind();
    function _interopRequireDefault(obj2) {
      return obj2 && obj2.__esModule ? obj2 : { default: obj2 };
    }
    function createLexer2(source, options) {
      var startOfFileToken = new Tok(_tokenKind.TokenKind.SOF, 0, 0, 0, 0, null);
      var lexer = {
        source,
        options,
        lastToken: startOfFileToken,
        token: startOfFileToken,
        line: 1,
        lineStart: 0,
        advance: advanceLexer,
        lookahead
      };
      return lexer;
    }
    function advanceLexer() {
      this.lastToken = this.token;
      var token = this.token = this.lookahead();
      return token;
    }
    function lookahead() {
      var token = this.token;
      if (token.kind !== _tokenKind.TokenKind.EOF) {
        do {
          token = token.next || (token.next = readToken(this, token));
        } while (token.kind === _tokenKind.TokenKind.COMMENT);
      }
      return token;
    }
    function isPunctuatorToken(token) {
      var kind = token.kind;
      return kind === _tokenKind.TokenKind.BANG || kind === _tokenKind.TokenKind.DOLLAR || kind === _tokenKind.TokenKind.AMP || kind === _tokenKind.TokenKind.PAREN_L || kind === _tokenKind.TokenKind.PAREN_R || kind === _tokenKind.TokenKind.SPREAD || kind === _tokenKind.TokenKind.COLON || kind === _tokenKind.TokenKind.EQUALS || kind === _tokenKind.TokenKind.AT || kind === _tokenKind.TokenKind.BRACKET_L || kind === _tokenKind.TokenKind.BRACKET_R || kind === _tokenKind.TokenKind.BRACE_L || kind === _tokenKind.TokenKind.PIPE || kind === _tokenKind.TokenKind.BRACE_R;
    }
    function Tok(kind, start, end, line, column, prev, value) {
      this.kind = kind;
      this.start = start;
      this.end = end;
      this.line = line;
      this.column = column;
      this.value = value;
      this.prev = prev;
      this.next = null;
    }
    (0, _defineToJSON.default)(Tok, function() {
      return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
      };
    });
    function printCharCode(code) {
      return isNaN(code) ? _tokenKind.TokenKind.EOF : code < 127 ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
    }
    function readToken(lexer, prev) {
      var source = lexer.source;
      var body = source.body;
      var bodyLength = body.length;
      var pos = positionAfterWhitespace(body, prev.end, lexer);
      var line = lexer.line;
      var col = 1 + pos - lexer.lineStart;
      if (pos >= bodyLength) {
        return new Tok(_tokenKind.TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
      }
      var code = body.charCodeAt(pos);
      switch (code) {
        case 33:
          return new Tok(_tokenKind.TokenKind.BANG, pos, pos + 1, line, col, prev);
        case 35:
          return readComment(source, pos, line, col, prev);
        case 36:
          return new Tok(_tokenKind.TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
        case 38:
          return new Tok(_tokenKind.TokenKind.AMP, pos, pos + 1, line, col, prev);
        case 40:
          return new Tok(_tokenKind.TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
        case 41:
          return new Tok(_tokenKind.TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
        case 46:
          if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
            return new Tok(_tokenKind.TokenKind.SPREAD, pos, pos + 3, line, col, prev);
          }
          break;
        case 58:
          return new Tok(_tokenKind.TokenKind.COLON, pos, pos + 1, line, col, prev);
        case 61:
          return new Tok(_tokenKind.TokenKind.EQUALS, pos, pos + 1, line, col, prev);
        case 64:
          return new Tok(_tokenKind.TokenKind.AT, pos, pos + 1, line, col, prev);
        case 91:
          return new Tok(_tokenKind.TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
        case 93:
          return new Tok(_tokenKind.TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
        case 123:
          return new Tok(_tokenKind.TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
        case 124:
          return new Tok(_tokenKind.TokenKind.PIPE, pos, pos + 1, line, col, prev);
        case 125:
          return new Tok(_tokenKind.TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
          return readName(source, pos, line, col, prev);
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
          return readNumber(source, pos, code, line, col, prev);
        case 34:
          if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
            return readBlockString(source, pos, line, col, prev, lexer);
          }
          return readString(source, pos, line, col, prev);
      }
      throw (0, _syntaxError.syntaxError)(source, pos, unexpectedCharacterMessage(code));
    }
    function unexpectedCharacterMessage(code) {
      if (code < 32 && code !== 9 && code !== 10 && code !== 13) {
        return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
      }
      if (code === 39) {
        return `Unexpected single quote character ('), did you mean to use a double quote (")?`;
      }
      return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
    }
    function positionAfterWhitespace(body, startPosition, lexer) {
      var bodyLength = body.length;
      var position = startPosition;
      while (position < bodyLength) {
        var code = body.charCodeAt(position);
        if (code === 9 || code === 32 || code === 44 || code === 65279) {
          ++position;
        } else if (code === 10) {
          ++position;
          ++lexer.line;
          lexer.lineStart = position;
        } else if (code === 13) {
          if (body.charCodeAt(position + 1) === 10) {
            position += 2;
          } else {
            ++position;
          }
          ++lexer.line;
          lexer.lineStart = position;
        } else {
          break;
        }
      }
      return position;
    }
    function readComment(source, start, line, col, prev) {
      var body = source.body;
      var code;
      var position = start;
      do {
        code = body.charCodeAt(++position);
      } while (!isNaN(code) && (code > 31 || code === 9));
      return new Tok(_tokenKind.TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
    }
    function readNumber(source, start, firstCode, line, col, prev) {
      var body = source.body;
      var code = firstCode;
      var position = start;
      var isFloat = false;
      if (code === 45) {
        code = body.charCodeAt(++position);
      }
      if (code === 48) {
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) {
          throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
        }
      } else {
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
      }
      if (code === 46) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
      }
      if (code === 69 || code === 101) {
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) {
          code = body.charCodeAt(++position);
        }
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
      }
      if (code === 46 || code === 69 || code === 101) {
        throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
      }
      return new Tok(isFloat ? _tokenKind.TokenKind.FLOAT : _tokenKind.TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
    }
    function readDigits(source, start, firstCode) {
      var body = source.body;
      var position = start;
      var code = firstCode;
      if (code >= 48 && code <= 57) {
        do {
          code = body.charCodeAt(++position);
        } while (code >= 48 && code <= 57);
        return position;
      }
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
    }
    function readString(source, start, line, col, prev) {
      var body = source.body;
      var position = start + 1;
      var chunkStart = position;
      var code = 0;
      var value = "";
      while (position < body.length && !isNaN(code = body.charCodeAt(position)) && code !== 10 && code !== 13) {
        if (code === 34) {
          value += body.slice(chunkStart, position);
          return new Tok(_tokenKind.TokenKind.STRING, start, position + 1, line, col, prev, value);
        }
        if (code < 32 && code !== 9) {
          throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        }
        ++position;
        if (code === 92) {
          value += body.slice(chunkStart, position - 1);
          code = body.charCodeAt(position);
          switch (code) {
            case 34:
              value += '"';
              break;
            case 47:
              value += "/";
              break;
            case 92:
              value += "\\";
              break;
            case 98:
              value += "\b";
              break;
            case 102:
              value += "\f";
              break;
            case 110:
              value += "\n";
              break;
            case 114:
              value += "\r";
              break;
            case 116:
              value += "	";
              break;
            case 117: {
              var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
              if (charCode < 0) {
                var invalidSequence = body.slice(position + 1, position + 5);
                throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
              }
              value += String.fromCharCode(charCode);
              position += 4;
              break;
            }
            default:
              throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
          }
          ++position;
          chunkStart = position;
        }
      }
      throw (0, _syntaxError.syntaxError)(source, position, "Unterminated string.");
    }
    function readBlockString(source, start, line, col, prev, lexer) {
      var body = source.body;
      var position = start + 3;
      var chunkStart = position;
      var code = 0;
      var rawValue = "";
      while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
          rawValue += body.slice(chunkStart, position);
          return new Tok(_tokenKind.TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockString.dedentBlockStringValue)(rawValue));
        }
        if (code < 32 && code !== 9 && code !== 10 && code !== 13) {
          throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        }
        if (code === 10) {
          ++position;
          ++lexer.line;
          lexer.lineStart = position;
        } else if (code === 13) {
          if (body.charCodeAt(position + 1) === 10) {
            position += 2;
          } else {
            ++position;
          }
          ++lexer.line;
          lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
          rawValue += body.slice(chunkStart, position) + '"""';
          position += 4;
          chunkStart = position;
        } else {
          ++position;
        }
      }
      throw (0, _syntaxError.syntaxError)(source, position, "Unterminated string.");
    }
    function uniCharCode(a, b, c, d) {
      return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
    }
    function char2hex(a) {
      return a >= 48 && a <= 57 ? a - 48 : a >= 65 && a <= 70 ? a - 55 : a >= 97 && a <= 102 ? a - 87 : -1;
    }
    function readName(source, start, line, col, prev) {
      var body = source.body;
      var bodyLength = body.length;
      var position = start + 1;
      var code = 0;
      while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122)) {
        ++position;
      }
      return new Tok(_tokenKind.TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/inspect.js
var require_inspect = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/jsutils/inspect.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = inspect;
    var _nodejsCustomInspectSymbol = _interopRequireDefault(require_nodejsCustomInspectSymbol());
    function _interopRequireDefault(obj2) {
      return obj2 && obj2.__esModule ? obj2 : { default: obj2 };
    }
    function _typeof(obj2) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof2(obj3) {
          return typeof obj3;
        };
      } else {
        _typeof = function _typeof2(obj3) {
          return obj3 && typeof Symbol === "function" && obj3.constructor === Symbol && obj3 !== Symbol.prototype ? "symbol" : typeof obj3;
        };
      }
      return _typeof(obj2);
    }
    var MAX_ARRAY_LENGTH = 10;
    var MAX_RECURSIVE_DEPTH = 2;
    function inspect(value) {
      return formatValue(value, []);
    }
    function formatValue(value, seenValues) {
      switch (_typeof(value)) {
        case "string":
          return JSON.stringify(value);
        case "function":
          return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
          if (value === null) {
            return "null";
          }
          return formatObjectValue(value, seenValues);
        default:
          return String(value);
      }
    }
    function formatObjectValue(value, previouslySeenValues) {
      if (previouslySeenValues.indexOf(value) !== -1) {
        return "[Circular]";
      }
      var seenValues = [].concat(previouslySeenValues, [value]);
      var customInspectFn = getCustomFn(value);
      if (customInspectFn !== void 0) {
        var customValue = customInspectFn.call(value);
        if (customValue !== value) {
          return typeof customValue === "string" ? customValue : formatValue(customValue, seenValues);
        }
      } else if (Array.isArray(value)) {
        return formatArray(value, seenValues);
      }
      return formatObject(value, seenValues);
    }
    function formatObject(object, seenValues) {
      var keys = Object.keys(object);
      if (keys.length === 0) {
        return "{}";
      }
      if (seenValues.length > MAX_RECURSIVE_DEPTH) {
        return "[" + getObjectTag(object) + "]";
      }
      var properties = keys.map(function(key) {
        var value = formatValue(object[key], seenValues);
        return key + ": " + value;
      });
      return "{ " + properties.join(", ") + " }";
    }
    function formatArray(array, seenValues) {
      if (array.length === 0) {
        return "[]";
      }
      if (seenValues.length > MAX_RECURSIVE_DEPTH) {
        return "[Array]";
      }
      var len = Math.min(MAX_ARRAY_LENGTH, array.length);
      var remaining = array.length - len;
      var items = [];
      for (var i = 0; i < len; ++i) {
        items.push(formatValue(array[i], seenValues));
      }
      if (remaining === 1) {
        items.push("... 1 more item");
      } else if (remaining > 1) {
        items.push("... ".concat(remaining, " more items"));
      }
      return "[" + items.join(", ") + "]";
    }
    function getCustomFn(object) {
      var customInspectFn = object[String(_nodejsCustomInspectSymbol.default)];
      if (typeof customInspectFn === "function") {
        return customInspectFn;
      }
      if (typeof object.inspect === "function") {
        return object.inspect;
      }
    }
    function getObjectTag(object) {
      var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
      if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") {
          return name;
        }
      }
      return tag;
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/directiveLocation.js
var require_directiveLocation = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/directiveLocation.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.DirectiveLocation = void 0;
    var DirectiveLocation2 = Object.freeze({
      QUERY: "QUERY",
      MUTATION: "MUTATION",
      SUBSCRIPTION: "SUBSCRIPTION",
      FIELD: "FIELD",
      FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
      FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
      INLINE_FRAGMENT: "INLINE_FRAGMENT",
      VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
      SCHEMA: "SCHEMA",
      SCALAR: "SCALAR",
      OBJECT: "OBJECT",
      FIELD_DEFINITION: "FIELD_DEFINITION",
      ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
      INTERFACE: "INTERFACE",
      UNION: "UNION",
      ENUM: "ENUM",
      ENUM_VALUE: "ENUM_VALUE",
      INPUT_OBJECT: "INPUT_OBJECT",
      INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
    });
    exports2.DirectiveLocation = DirectiveLocation2;
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/parser.js
var require_parser = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/parser.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.parse = parse2;
    exports2.parseValue = parseValue2;
    exports2.parseType = parseType2;
    var _inspect = _interopRequireDefault(require_inspect());
    var _devAssert = _interopRequireDefault(require_devAssert());
    var _defineToJSON = _interopRequireDefault(require_defineToJSON());
    var _syntaxError = require_syntaxError();
    var _kinds = require_kinds();
    var _source = require_source();
    var _lexer = require_lexer();
    var _directiveLocation = require_directiveLocation();
    var _tokenKind = require_tokenKind();
    function _interopRequireDefault(obj2) {
      return obj2 && obj2.__esModule ? obj2 : { default: obj2 };
    }
    function parse2(source, options) {
      var parser = new Parser(source, options);
      return parser.parseDocument();
    }
    function parseValue2(source, options) {
      var parser = new Parser(source, options);
      parser.expectToken(_tokenKind.TokenKind.SOF);
      var value = parser.parseValueLiteral(false);
      parser.expectToken(_tokenKind.TokenKind.EOF);
      return value;
    }
    function parseType2(source, options) {
      var parser = new Parser(source, options);
      parser.expectToken(_tokenKind.TokenKind.SOF);
      var type = parser.parseTypeReference();
      parser.expectToken(_tokenKind.TokenKind.EOF);
      return type;
    }
    var Parser = /* @__PURE__ */ function() {
      function Parser2(source, options) {
        var sourceObj = typeof source === "string" ? new _source.Source(source) : source;
        sourceObj instanceof _source.Source || (0, _devAssert.default)(0, "Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
        this._lexer = (0, _lexer.createLexer)(sourceObj);
        this._options = options || {};
      }
      var _proto = Parser2.prototype;
      _proto.parseName = function parseName() {
        var token = this.expectToken(_tokenKind.TokenKind.NAME);
        return {
          kind: _kinds.Kind.NAME,
          value: token.value,
          loc: this.loc(token)
        };
      };
      _proto.parseDocument = function parseDocument2() {
        var start = this._lexer.token;
        return {
          kind: _kinds.Kind.DOCUMENT,
          definitions: this.many(_tokenKind.TokenKind.SOF, this.parseDefinition, _tokenKind.TokenKind.EOF),
          loc: this.loc(start)
        };
      };
      _proto.parseDefinition = function parseDefinition() {
        if (this.peek(_tokenKind.TokenKind.NAME)) {
          switch (this._lexer.token.value) {
            case "query":
            case "mutation":
            case "subscription":
              return this.parseOperationDefinition();
            case "fragment":
              return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
              return this.parseTypeSystemDefinition();
            case "extend":
              return this.parseTypeSystemExtension();
          }
        } else if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
          return this.parseOperationDefinition();
        } else if (this.peekDescription()) {
          return this.parseTypeSystemDefinition();
        }
        throw this.unexpected();
      };
      _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
          return {
            kind: _kinds.Kind.OPERATION_DEFINITION,
            operation: "query",
            name: void 0,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
          };
        }
        var operation = this.parseOperationType();
        var name;
        if (this.peek(_tokenKind.TokenKind.NAME)) {
          name = this.parseName();
        }
        return {
          kind: _kinds.Kind.OPERATION_DEFINITION,
          operation,
          name,
          variableDefinitions: this.parseVariableDefinitions(),
          directives: this.parseDirectives(false),
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(start)
        };
      };
      _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken(_tokenKind.TokenKind.NAME);
        switch (operationToken.value) {
          case "query":
            return "query";
          case "mutation":
            return "mutation";
          case "subscription":
            return "subscription";
        }
        throw this.unexpected(operationToken);
      };
      _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseVariableDefinition, _tokenKind.TokenKind.PAREN_R);
      };
      _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
          kind: _kinds.Kind.VARIABLE_DEFINITION,
          variable: this.parseVariable(),
          type: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseTypeReference()),
          defaultValue: this.expectOptionalToken(_tokenKind.TokenKind.EQUALS) ? this.parseValueLiteral(true) : void 0,
          directives: this.parseDirectives(true),
          loc: this.loc(start)
        };
      };
      _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken(_tokenKind.TokenKind.DOLLAR);
        return {
          kind: _kinds.Kind.VARIABLE,
          name: this.parseName(),
          loc: this.loc(start)
        };
      };
      _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
          kind: _kinds.Kind.SELECTION_SET,
          selections: this.many(_tokenKind.TokenKind.BRACE_L, this.parseSelection, _tokenKind.TokenKind.BRACE_R),
          loc: this.loc(start)
        };
      };
      _proto.parseSelection = function parseSelection() {
        return this.peek(_tokenKind.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
      };
      _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken(_tokenKind.TokenKind.COLON)) {
          alias = nameOrAlias;
          name = this.parseName();
        } else {
          name = nameOrAlias;
        }
        return {
          kind: _kinds.Kind.FIELD,
          alias,
          name,
          arguments: this.parseArguments(false),
          directives: this.parseDirectives(false),
          selectionSet: this.peek(_tokenKind.TokenKind.BRACE_L) ? this.parseSelectionSet() : void 0,
          loc: this.loc(start)
        };
      };
      _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany(_tokenKind.TokenKind.PAREN_L, item, _tokenKind.TokenKind.PAREN_R);
      };
      _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken(_tokenKind.TokenKind.COLON);
        return {
          kind: _kinds.Kind.ARGUMENT,
          name,
          value: this.parseValueLiteral(false),
          loc: this.loc(start)
        };
      };
      _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
          kind: _kinds.Kind.ARGUMENT,
          name: this.parseName(),
          value: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseValueLiteral(true)),
          loc: this.loc(start)
        };
      };
      _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken(_tokenKind.TokenKind.SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek(_tokenKind.TokenKind.NAME)) {
          return {
            kind: _kinds.Kind.FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
          };
        }
        return {
          kind: _kinds.Kind.INLINE_FRAGMENT,
          typeCondition: hasTypeCondition ? this.parseNamedType() : void 0,
          directives: this.parseDirectives(false),
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(start)
        };
      };
      _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var start = this._lexer.token;
        this.expectKeyword("fragment");
        if (this._options.experimentalFragmentVariables) {
          return {
            kind: _kinds.Kind.FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
          };
        }
        return {
          kind: _kinds.Kind.FRAGMENT_DEFINITION,
          name: this.parseFragmentName(),
          typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
          directives: this.parseDirectives(false),
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(start)
        };
      };
      _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") {
          throw this.unexpected();
        }
        return this.parseName();
      };
      _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch (token.kind) {
          case _tokenKind.TokenKind.BRACKET_L:
            return this.parseList(isConst);
          case _tokenKind.TokenKind.BRACE_L:
            return this.parseObject(isConst);
          case _tokenKind.TokenKind.INT:
            this._lexer.advance();
            return {
              kind: _kinds.Kind.INT,
              value: token.value,
              loc: this.loc(token)
            };
          case _tokenKind.TokenKind.FLOAT:
            this._lexer.advance();
            return {
              kind: _kinds.Kind.FLOAT,
              value: token.value,
              loc: this.loc(token)
            };
          case _tokenKind.TokenKind.STRING:
          case _tokenKind.TokenKind.BLOCK_STRING:
            return this.parseStringLiteral();
          case _tokenKind.TokenKind.NAME:
            if (token.value === "true" || token.value === "false") {
              this._lexer.advance();
              return {
                kind: _kinds.Kind.BOOLEAN,
                value: token.value === "true",
                loc: this.loc(token)
              };
            } else if (token.value === "null") {
              this._lexer.advance();
              return {
                kind: _kinds.Kind.NULL,
                loc: this.loc(token)
              };
            }
            this._lexer.advance();
            return {
              kind: _kinds.Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
          case _tokenKind.TokenKind.DOLLAR:
            if (!isConst) {
              return this.parseVariable();
            }
            break;
        }
        throw this.unexpected();
      };
      _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
          kind: _kinds.Kind.STRING,
          value: token.value,
          block: token.kind === _tokenKind.TokenKind.BLOCK_STRING,
          loc: this.loc(token)
        };
      };
      _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item2() {
          return _this.parseValueLiteral(isConst);
        };
        return {
          kind: _kinds.Kind.LIST,
          values: this.any(_tokenKind.TokenKind.BRACKET_L, item, _tokenKind.TokenKind.BRACKET_R),
          loc: this.loc(start)
        };
      };
      _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item2() {
          return _this2.parseObjectField(isConst);
        };
        return {
          kind: _kinds.Kind.OBJECT,
          fields: this.any(_tokenKind.TokenKind.BRACE_L, item, _tokenKind.TokenKind.BRACE_R),
          loc: this.loc(start)
        };
      };
      _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken(_tokenKind.TokenKind.COLON);
        return {
          kind: _kinds.Kind.OBJECT_FIELD,
          name,
          value: this.parseValueLiteral(isConst),
          loc: this.loc(start)
        };
      };
      _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while (this.peek(_tokenKind.TokenKind.AT)) {
          directives.push(this.parseDirective(isConst));
        }
        return directives;
      };
      _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken(_tokenKind.TokenKind.AT);
        return {
          kind: _kinds.Kind.DIRECTIVE,
          name: this.parseName(),
          arguments: this.parseArguments(isConst),
          loc: this.loc(start)
        };
      };
      _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken(_tokenKind.TokenKind.BRACKET_L)) {
          type = this.parseTypeReference();
          this.expectToken(_tokenKind.TokenKind.BRACKET_R);
          type = {
            kind: _kinds.Kind.LIST_TYPE,
            type,
            loc: this.loc(start)
          };
        } else {
          type = this.parseNamedType();
        }
        if (this.expectOptionalToken(_tokenKind.TokenKind.BANG)) {
          return {
            kind: _kinds.Kind.NON_NULL_TYPE,
            type,
            loc: this.loc(start)
          };
        }
        return type;
      };
      _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
          kind: _kinds.Kind.NAMED_TYPE,
          name: this.parseName(),
          loc: this.loc(start)
        };
      };
      _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
          switch (keywordToken.value) {
            case "schema":
              return this.parseSchemaDefinition();
            case "scalar":
              return this.parseScalarTypeDefinition();
            case "type":
              return this.parseObjectTypeDefinition();
            case "interface":
              return this.parseInterfaceTypeDefinition();
            case "union":
              return this.parseUnionTypeDefinition();
            case "enum":
              return this.parseEnumTypeDefinition();
            case "input":
              return this.parseInputObjectTypeDefinition();
            case "directive":
              return this.parseDirectiveDefinition();
          }
        }
        throw this.unexpected(keywordToken);
      };
      _proto.peekDescription = function peekDescription() {
        return this.peek(_tokenKind.TokenKind.STRING) || this.peek(_tokenKind.TokenKind.BLOCK_STRING);
      };
      _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) {
          return this.parseStringLiteral();
        }
      };
      _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);
        return {
          kind: _kinds.Kind.SCHEMA_DEFINITION,
          directives,
          operationTypes,
          loc: this.loc(start)
        };
      };
      _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken(_tokenKind.TokenKind.COLON);
        var type = this.parseNamedType();
        return {
          kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
          operation,
          type,
          loc: this.loc(start)
        };
      };
      _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
          kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
          description,
          name,
          directives,
          loc: this.loc(start)
        };
      };
      _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
          kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
          description,
          name,
          interfaces,
          directives,
          fields,
          loc: this.loc(start)
        };
      };
      _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var types = [];
        if (this.expectOptionalKeyword("implements")) {
          this.expectOptionalToken(_tokenKind.TokenKind.AMP);
          do {
            types.push(this.parseNamedType());
          } while (this.expectOptionalToken(_tokenKind.TokenKind.AMP) || this._options.allowLegacySDLImplementsInterfaces && this.peek(_tokenKind.TokenKind.NAME));
        }
        return types;
      };
      _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        if (this._options.allowLegacySDLEmptyFields && this.peek(_tokenKind.TokenKind.BRACE_L) && this._lexer.lookahead().kind === _tokenKind.TokenKind.BRACE_R) {
          this._lexer.advance();
          this._lexer.advance();
          return [];
        }
        return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseFieldDefinition, _tokenKind.TokenKind.BRACE_R);
      };
      _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken(_tokenKind.TokenKind.COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
          kind: _kinds.Kind.FIELD_DEFINITION,
          description,
          name,
          arguments: args,
          type,
          directives,
          loc: this.loc(start)
        };
      };
      _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseInputValueDef, _tokenKind.TokenKind.PAREN_R);
      };
      _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken(_tokenKind.TokenKind.COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
          defaultValue = this.parseValueLiteral(true);
        }
        var directives = this.parseDirectives(true);
        return {
          kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
          description,
          name,
          type,
          defaultValue,
          directives,
          loc: this.loc(start)
        };
      };
      _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
          kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
          description,
          name,
          directives,
          fields,
          loc: this.loc(start)
        };
      };
      _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
          kind: _kinds.Kind.UNION_TYPE_DEFINITION,
          description,
          name,
          directives,
          types,
          loc: this.loc(start)
        };
      };
      _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        var types = [];
        if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
          this.expectOptionalToken(_tokenKind.TokenKind.PIPE);
          do {
            types.push(this.parseNamedType());
          } while (this.expectOptionalToken(_tokenKind.TokenKind.PIPE));
        }
        return types;
      };
      _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
          kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
          description,
          name,
          directives,
          values,
          loc: this.loc(start)
        };
      };
      _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseEnumValueDefinition, _tokenKind.TokenKind.BRACE_R);
      };
      _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
          kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
          description,
          name,
          directives,
          loc: this.loc(start)
        };
      };
      _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
          kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
          description,
          name,
          directives,
          fields,
          loc: this.loc(start)
        };
      };
      _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseInputValueDef, _tokenKind.TokenKind.BRACE_R);
      };
      _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
          switch (keywordToken.value) {
            case "schema":
              return this.parseSchemaExtension();
            case "scalar":
              return this.parseScalarTypeExtension();
            case "type":
              return this.parseObjectTypeExtension();
            case "interface":
              return this.parseInterfaceTypeExtension();
            case "union":
              return this.parseUnionTypeExtension();
            case "enum":
              return this.parseEnumTypeExtension();
            case "input":
              return this.parseInputObjectTypeExtension();
          }
        }
        throw this.unexpected(keywordToken);
      };
      _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) {
          throw this.unexpected();
        }
        return {
          kind: _kinds.Kind.SCHEMA_EXTENSION,
          directives,
          operationTypes,
          loc: this.loc(start)
        };
      };
      _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) {
          throw this.unexpected();
        }
        return {
          kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
          name,
          directives,
          loc: this.loc(start)
        };
      };
      _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
          throw this.unexpected();
        }
        return {
          kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
          name,
          interfaces,
          directives,
          fields,
          loc: this.loc(start)
        };
      };
      _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) {
          throw this.unexpected();
        }
        return {
          kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
          name,
          directives,
          fields,
          loc: this.loc(start)
        };
      };
      _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) {
          throw this.unexpected();
        }
        return {
          kind: _kinds.Kind.UNION_TYPE_EXTENSION,
          name,
          directives,
          types,
          loc: this.loc(start)
        };
      };
      _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) {
          throw this.unexpected();
        }
        return {
          kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
          name,
          directives,
          values,
          loc: this.loc(start)
        };
      };
      _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) {
          throw this.unexpected();
        }
        return {
          kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
          name,
          directives,
          fields,
          loc: this.loc(start)
        };
      };
      _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken(_tokenKind.TokenKind.AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
          kind: _kinds.Kind.DIRECTIVE_DEFINITION,
          description,
          name,
          arguments: args,
          repeatable,
          locations,
          loc: this.loc(start)
        };
      };
      _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        this.expectOptionalToken(_tokenKind.TokenKind.PIPE);
        var locations = [];
        do {
          locations.push(this.parseDirectiveLocation());
        } while (this.expectOptionalToken(_tokenKind.TokenKind.PIPE));
        return locations;
      };
      _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if (_directiveLocation.DirectiveLocation[name.value] !== void 0) {
          return name;
        }
        throw this.unexpected(start);
      };
      _proto.loc = function loc(startToken) {
        if (!this._options.noLocation) {
          return new Loc(startToken, this._lexer.lastToken, this._lexer.source);
        }
      };
      _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
      };
      _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
          this._lexer.advance();
          return token;
        }
        throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat(getTokenDesc(token)));
      };
      _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
          this._lexer.advance();
          return token;
        }
        return void 0;
      };
      _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
          this._lexer.advance();
        } else {
          throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat(getTokenDesc(token)));
        }
      };
      _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
          this._lexer.advance();
          return true;
        }
        return false;
      };
      _proto.unexpected = function unexpected(atToken) {
        var token = atToken || this._lexer.token;
        return (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token)));
      };
      _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while (!this.expectOptionalToken(closeKind)) {
          nodes.push(parseFn.call(this));
        }
        return nodes;
      };
      _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
          var nodes = [];
          do {
            nodes.push(parseFn.call(this));
          } while (!this.expectOptionalToken(closeKind));
          return nodes;
        }
        return [];
      };
      _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do {
          nodes.push(parseFn.call(this));
        } while (!this.expectOptionalToken(closeKind));
        return nodes;
      };
      return Parser2;
    }();
    function Loc(startToken, endToken, source) {
      this.start = startToken.start;
      this.end = endToken.end;
      this.startToken = startToken;
      this.endToken = endToken;
      this.source = source;
    }
    (0, _defineToJSON.default)(Loc, function() {
      return {
        start: this.start,
        end: this.end
      };
    });
    function getTokenDesc(token) {
      var value = token.value;
      return value ? "".concat(token.kind, ' "').concat(value, '"') : token.kind;
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/visitor.js
var require_visitor = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/visitor.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.visit = visit4;
    exports2.visitInParallel = visitInParallel2;
    exports2.visitWithTypeInfo = visitWithTypeInfo2;
    exports2.getVisitFn = getVisitFn2;
    exports2.BREAK = exports2.QueryDocumentKeys = void 0;
    var _inspect = _interopRequireDefault(require_inspect());
    function _interopRequireDefault(obj2) {
      return obj2 && obj2.__esModule ? obj2 : { default: obj2 };
    }
    var QueryDocumentKeys = {
      Name: [],
      Document: ["definitions"],
      OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
      VariableDefinition: ["variable", "type", "defaultValue", "directives"],
      Variable: ["name"],
      SelectionSet: ["selections"],
      Field: ["alias", "name", "arguments", "directives", "selectionSet"],
      Argument: ["name", "value"],
      FragmentSpread: ["name", "directives"],
      InlineFragment: ["typeCondition", "directives", "selectionSet"],
      FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
      ],
      IntValue: [],
      FloatValue: [],
      StringValue: [],
      BooleanValue: [],
      NullValue: [],
      EnumValue: [],
      ListValue: ["values"],
      ObjectValue: ["fields"],
      ObjectField: ["name", "value"],
      Directive: ["name", "arguments"],
      NamedType: ["name"],
      ListType: ["type"],
      NonNullType: ["type"],
      SchemaDefinition: ["directives", "operationTypes"],
      OperationTypeDefinition: ["type"],
      ScalarTypeDefinition: ["description", "name", "directives"],
      ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
      FieldDefinition: ["description", "name", "arguments", "type", "directives"],
      InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
      InterfaceTypeDefinition: ["description", "name", "directives", "fields"],
      UnionTypeDefinition: ["description", "name", "directives", "types"],
      EnumTypeDefinition: ["description", "name", "directives", "values"],
      EnumValueDefinition: ["description", "name", "directives"],
      InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
      DirectiveDefinition: ["description", "name", "arguments", "locations"],
      SchemaExtension: ["directives", "operationTypes"],
      ScalarTypeExtension: ["name", "directives"],
      ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
      InterfaceTypeExtension: ["name", "directives", "fields"],
      UnionTypeExtension: ["name", "directives", "types"],
      EnumTypeExtension: ["name", "directives", "values"],
      InputObjectTypeExtension: ["name", "directives", "fields"]
    };
    exports2.QueryDocumentKeys = QueryDocumentKeys;
    var BREAK3 = Object.freeze({});
    exports2.BREAK = BREAK3;
    function visit4(root3, visitor) {
      var visitorKeys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : QueryDocumentKeys;
      var stack = void 0;
      var inArray = Array.isArray(root3);
      var keys = [root3];
      var index = -1;
      var edits = [];
      var node = void 0;
      var key = void 0;
      var parent2 = void 0;
      var path = [];
      var ancestors = [];
      var newRoot = root3;
      do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
          key = ancestors.length === 0 ? void 0 : path[path.length - 1];
          node = parent2;
          parent2 = ancestors.pop();
          if (isEdited) {
            if (inArray) {
              node = node.slice();
            } else {
              var clone = {};
              for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
                var k = _Object$keys2[_i2];
                clone[k] = node[k];
              }
              node = clone;
            }
            var editOffset = 0;
            for (var ii = 0; ii < edits.length; ii++) {
              var editKey = edits[ii][0];
              var editValue = edits[ii][1];
              if (inArray) {
                editKey -= editOffset;
              }
              if (inArray && editValue === null) {
                node.splice(editKey, 1);
                editOffset++;
              } else {
                node[editKey] = editValue;
              }
            }
          }
          index = stack.index;
          keys = stack.keys;
          edits = stack.edits;
          inArray = stack.inArray;
          stack = stack.prev;
        } else {
          key = parent2 ? inArray ? index : keys[index] : void 0;
          node = parent2 ? parent2[key] : newRoot;
          if (node === null || node === void 0) {
            continue;
          }
          if (parent2) {
            path.push(key);
          }
        }
        var result2 = void 0;
        if (!Array.isArray(node)) {
          if (!isNode2(node)) {
            throw new Error("Invalid AST Node: " + (0, _inspect.default)(node));
          }
          var visitFn = getVisitFn2(visitor, node.kind, isLeaving);
          if (visitFn) {
            result2 = visitFn.call(visitor, node, key, parent2, path, ancestors);
            if (result2 === BREAK3) {
              break;
            }
            if (result2 === false) {
              if (!isLeaving) {
                path.pop();
                continue;
              }
            } else if (result2 !== void 0) {
              edits.push([key, result2]);
              if (!isLeaving) {
                if (isNode2(result2)) {
                  node = result2;
                } else {
                  path.pop();
                  continue;
                }
              }
            }
          }
        }
        if (result2 === void 0 && isEdited) {
          edits.push([key, node]);
        }
        if (isLeaving) {
          path.pop();
        } else {
          stack = {
            inArray,
            index,
            keys,
            edits,
            prev: stack
          };
          inArray = Array.isArray(node);
          keys = inArray ? node : visitorKeys[node.kind] || [];
          index = -1;
          edits = [];
          if (parent2) {
            ancestors.push(parent2);
          }
          parent2 = node;
        }
      } while (stack !== void 0);
      if (edits.length !== 0) {
        newRoot = edits[edits.length - 1][1];
      }
      return newRoot;
    }
    function isNode2(maybeNode) {
      return Boolean(maybeNode && typeof maybeNode.kind === "string");
    }
    function visitInParallel2(visitors) {
      var skipping = new Array(visitors.length);
      return {
        enter: function enter(node) {
          for (var i = 0; i < visitors.length; i++) {
            if (!skipping[i]) {
              var fn = getVisitFn2(visitors[i], node.kind, false);
              if (fn) {
                var result2 = fn.apply(visitors[i], arguments);
                if (result2 === false) {
                  skipping[i] = node;
                } else if (result2 === BREAK3) {
                  skipping[i] = BREAK3;
                } else if (result2 !== void 0) {
                  return result2;
                }
              }
            }
          }
        },
        leave: function leave(node) {
          for (var i = 0; i < visitors.length; i++) {
            if (!skipping[i]) {
              var fn = getVisitFn2(visitors[i], node.kind, true);
              if (fn) {
                var result2 = fn.apply(visitors[i], arguments);
                if (result2 === BREAK3) {
                  skipping[i] = BREAK3;
                } else if (result2 !== void 0 && result2 !== false) {
                  return result2;
                }
              }
            } else if (skipping[i] === node) {
              skipping[i] = null;
            }
          }
        }
      };
    }
    function visitWithTypeInfo2(typeInfo, visitor) {
      return {
        enter: function enter(node) {
          typeInfo.enter(node);
          var fn = getVisitFn2(visitor, node.kind, false);
          if (fn) {
            var result2 = fn.apply(visitor, arguments);
            if (result2 !== void 0) {
              typeInfo.leave(node);
              if (isNode2(result2)) {
                typeInfo.enter(result2);
              }
            }
            return result2;
          }
        },
        leave: function leave(node) {
          var fn = getVisitFn2(visitor, node.kind, true);
          var result2;
          if (fn) {
            result2 = fn.apply(visitor, arguments);
          }
          typeInfo.leave(node);
          return result2;
        }
      };
    }
    function getVisitFn2(visitor, kind, isLeaving) {
      var kindVisitor = visitor[kind];
      if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") {
          return kindVisitor;
        }
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") {
          return kindSpecificVisitor;
        }
      } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
          if (typeof specificVisitor === "function") {
            return specificVisitor;
          }
          var specificKindVisitor = specificVisitor[kind];
          if (typeof specificKindVisitor === "function") {
            return specificKindVisitor;
          }
        }
      }
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/printer.js
var require_printer = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/printer.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.print = print3;
    var _visitor = require_visitor();
    var _blockString = require_blockString();
    function print3(ast) {
      return (0, _visitor.visit)(ast, {
        leave: printDocASTReducer
      });
    }
    var printDocASTReducer = {
      Name: function Name(node) {
        return node.value;
      },
      Variable: function Variable(node) {
        return "$" + node.name;
      },
      Document: function Document(node) {
        return join(node.definitions, "\n\n") + "\n";
      },
      OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = wrap2("(", join(node.variableDefinitions, ", "), ")");
        var directives = join(node.directives, " ");
        var selectionSet = node.selectionSet;
        return !name && !directives && !varDefs && op === "query" ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], " ");
      },
      VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + wrap2(" = ", defaultValue) + wrap2(" ", join(directives, " "));
      },
      SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return block(selections);
      },
      Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return join([wrap2("", alias, ": ") + name + wrap2("(", join(args, ", "), ")"), join(directives, " "), selectionSet], " ");
      },
      Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
      },
      FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + wrap2(" ", join(directives, " "));
      },
      InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return join(["...", wrap2("on ", typeCondition), join(directives, " "), selectionSet], " ");
      },
      FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return "fragment ".concat(name).concat(wrap2("(", join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat(wrap2("", join(directives, " "), " ")) + selectionSet;
      },
      IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
      },
      FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
      },
      StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, _blockString.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
      },
      BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
      },
      NullValue: function NullValue() {
        return "null";
      },
      EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
      },
      ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + join(values, ", ") + "]";
      },
      ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + join(fields, ", ") + "}";
      },
      ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
      },
      Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + wrap2("(", join(args, ", "), ")");
      },
      NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
      },
      ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
      },
      NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
      },
      SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return join(["schema", join(directives, " "), block(operationTypes)], " ");
      },
      OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
      },
      ScalarTypeDefinition: addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return join(["scalar", name, join(directives, " ")], " ");
      }),
      ObjectTypeDefinition: addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return join(["type", name, wrap2("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
      }),
      FieldDefinition: addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + (hasMultilineItems(args) ? wrap2("(\n", indent(join(args, "\n")), "\n)") : wrap2("(", join(args, ", "), ")")) + ": " + type + wrap2(" ", join(directives, " "));
      }),
      InputValueDefinition: addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return join([name + ": " + type, wrap2("= ", defaultValue), join(directives, " ")], " ");
      }),
      InterfaceTypeDefinition: addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return join(["interface", name, join(directives, " "), block(fields)], " ");
      }),
      UnionTypeDefinition: addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return join(["union", name, join(directives, " "), types && types.length !== 0 ? "= " + join(types, " | ") : ""], " ");
      }),
      EnumTypeDefinition: addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return join(["enum", name, join(directives, " "), block(values)], " ");
      }),
      EnumValueDefinition: addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return join([name, join(directives, " ")], " ");
      }),
      InputObjectTypeDefinition: addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return join(["input", name, join(directives, " "), block(fields)], " ");
      }),
      DirectiveDefinition: addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + (hasMultilineItems(args) ? wrap2("(\n", indent(join(args, "\n")), "\n)") : wrap2("(", join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + join(locations, " | ");
      }),
      SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return join(["extend schema", join(directives, " "), block(operationTypes)], " ");
      },
      ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return join(["extend scalar", name, join(directives, " ")], " ");
      },
      ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return join(["extend type", name, wrap2("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
      },
      InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return join(["extend interface", name, join(directives, " "), block(fields)], " ");
      },
      UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return join(["extend union", name, join(directives, " "), types && types.length !== 0 ? "= " + join(types, " | ") : ""], " ");
      },
      EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return join(["extend enum", name, join(directives, " "), block(values)], " ");
      },
      InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return join(["extend input", name, join(directives, " "), block(fields)], " ");
      }
    };
    function addDescription(cb) {
      return function(node) {
        return join([node.description, cb(node)], "\n");
      };
    }
    function join(maybeArray, separator) {
      return maybeArray ? maybeArray.filter(function(x) {
        return x;
      }).join(separator || "") : "";
    }
    function block(array) {
      return array && array.length !== 0 ? "{\n" + indent(join(array, "\n")) + "\n}" : "";
    }
    function wrap2(start, maybeString, end) {
      return maybeString ? start + maybeString + (end || "") : "";
    }
    function indent(maybeString) {
      return maybeString && "  " + maybeString.replace(/\n/g, "\n  ");
    }
    function isMultiline(string) {
      return string.indexOf("\n") !== -1;
    }
    function hasMultilineItems(maybeArray) {
      return maybeArray && maybeArray.some(isMultiline);
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/predicates.js
var require_predicates = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/predicates.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.isDefinitionNode = isDefinitionNode2;
    exports2.isExecutableDefinitionNode = isExecutableDefinitionNode2;
    exports2.isSelectionNode = isSelectionNode2;
    exports2.isValueNode = isValueNode2;
    exports2.isTypeNode = isTypeNode2;
    exports2.isTypeSystemDefinitionNode = isTypeSystemDefinitionNode2;
    exports2.isTypeDefinitionNode = isTypeDefinitionNode2;
    exports2.isTypeSystemExtensionNode = isTypeSystemExtensionNode2;
    exports2.isTypeExtensionNode = isTypeExtensionNode2;
    var _kinds = require_kinds();
    function isDefinitionNode2(node) {
      return isExecutableDefinitionNode2(node) || isTypeSystemDefinitionNode2(node) || isTypeSystemExtensionNode2(node);
    }
    function isExecutableDefinitionNode2(node) {
      return node.kind === _kinds.Kind.OPERATION_DEFINITION || node.kind === _kinds.Kind.FRAGMENT_DEFINITION;
    }
    function isSelectionNode2(node) {
      return node.kind === _kinds.Kind.FIELD || node.kind === _kinds.Kind.FRAGMENT_SPREAD || node.kind === _kinds.Kind.INLINE_FRAGMENT;
    }
    function isValueNode2(node) {
      return node.kind === _kinds.Kind.VARIABLE || node.kind === _kinds.Kind.INT || node.kind === _kinds.Kind.FLOAT || node.kind === _kinds.Kind.STRING || node.kind === _kinds.Kind.BOOLEAN || node.kind === _kinds.Kind.NULL || node.kind === _kinds.Kind.ENUM || node.kind === _kinds.Kind.LIST || node.kind === _kinds.Kind.OBJECT;
    }
    function isTypeNode2(node) {
      return node.kind === _kinds.Kind.NAMED_TYPE || node.kind === _kinds.Kind.LIST_TYPE || node.kind === _kinds.Kind.NON_NULL_TYPE;
    }
    function isTypeSystemDefinitionNode2(node) {
      return node.kind === _kinds.Kind.SCHEMA_DEFINITION || isTypeDefinitionNode2(node) || node.kind === _kinds.Kind.DIRECTIVE_DEFINITION;
    }
    function isTypeDefinitionNode2(node) {
      return node.kind === _kinds.Kind.SCALAR_TYPE_DEFINITION || node.kind === _kinds.Kind.OBJECT_TYPE_DEFINITION || node.kind === _kinds.Kind.INTERFACE_TYPE_DEFINITION || node.kind === _kinds.Kind.UNION_TYPE_DEFINITION || node.kind === _kinds.Kind.ENUM_TYPE_DEFINITION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION;
    }
    function isTypeSystemExtensionNode2(node) {
      return node.kind === _kinds.Kind.SCHEMA_EXTENSION || isTypeExtensionNode2(node);
    }
    function isTypeExtensionNode2(node) {
      return node.kind === _kinds.Kind.SCALAR_TYPE_EXTENSION || node.kind === _kinds.Kind.OBJECT_TYPE_EXTENSION || node.kind === _kinds.Kind.INTERFACE_TYPE_EXTENSION || node.kind === _kinds.Kind.UNION_TYPE_EXTENSION || node.kind === _kinds.Kind.ENUM_TYPE_EXTENSION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION;
    }
  }
});

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/index.js
var require_language = __commonJS({
  "../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/language/index.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    Object.defineProperty(exports2, "Source", {
      enumerable: true,
      get: function get() {
        return _source.Source;
      }
    });
    Object.defineProperty(exports2, "getLocation", {
      enumerable: true,
      get: function get() {
        return _location.getLocation;
      }
    });
    Object.defineProperty(exports2, "printLocation", {
      enumerable: true,
      get: function get() {
        return _printLocation.printLocation;
      }
    });
    Object.defineProperty(exports2, "printSourceLocation", {
      enumerable: true,
      get: function get() {
        return _printLocation.printSourceLocation;
      }
    });
    Object.defineProperty(exports2, "Kind", {
      enumerable: true,
      get: function get() {
        return _kinds.Kind;
      }
    });
    Object.defineProperty(exports2, "TokenKind", {
      enumerable: true,
      get: function get() {
        return _tokenKind.TokenKind;
      }
    });
    Object.defineProperty(exports2, "createLexer", {
      enumerable: true,
      get: function get() {
        return _lexer.createLexer;
      }
    });
    Object.defineProperty(exports2, "parse", {
      enumerable: true,
      get: function get() {
        return _parser.parse;
      }
    });
    Object.defineProperty(exports2, "parseValue", {
      enumerable: true,
      get: function get() {
        return _parser.parseValue;
      }
    });
    Object.defineProperty(exports2, "parseType", {
      enumerable: true,
      get: function get() {
        return _parser.parseType;
      }
    });
    Object.defineProperty(exports2, "print", {
      enumerable: true,
      get: function get() {
        return _printer.print;
      }
    });
    Object.defineProperty(exports2, "visit", {
      enumerable: true,
      get: function get() {
        return _visitor.visit;
      }
    });
    Object.defineProperty(exports2, "visitInParallel", {
      enumerable: true,
      get: function get() {
        return _visitor.visitInParallel;
      }
    });
    Object.defineProperty(exports2, "visitWithTypeInfo", {
      enumerable: true,
      get: function get() {
        return _visitor.visitWithTypeInfo;
      }
    });
    Object.defineProperty(exports2, "getVisitFn", {
      enumerable: true,
      get: function get() {
        return _visitor.getVisitFn;
      }
    });
    Object.defineProperty(exports2, "BREAK", {
      enumerable: true,
      get: function get() {
        return _visitor.BREAK;
      }
    });
    Object.defineProperty(exports2, "isDefinitionNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isDefinitionNode;
      }
    });
    Object.defineProperty(exports2, "isExecutableDefinitionNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isExecutableDefinitionNode;
      }
    });
    Object.defineProperty(exports2, "isSelectionNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isSelectionNode;
      }
    });
    Object.defineProperty(exports2, "isValueNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isValueNode;
      }
    });
    Object.defineProperty(exports2, "isTypeNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isTypeNode;
      }
    });
    Object.defineProperty(exports2, "isTypeSystemDefinitionNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isTypeSystemDefinitionNode;
      }
    });
    Object.defineProperty(exports2, "isTypeDefinitionNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isTypeDefinitionNode;
      }
    });
    Object.defineProperty(exports2, "isTypeSystemExtensionNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isTypeSystemExtensionNode;
      }
    });
    Object.defineProperty(exports2, "isTypeExtensionNode", {
      enumerable: true,
      get: function get() {
        return _predicates.isTypeExtensionNode;
      }
    });
    Object.defineProperty(exports2, "DirectiveLocation", {
      enumerable: true,
      get: function get() {
        return _directiveLocation.DirectiveLocation;
      }
    });
    var _source = require_source();
    var _location = require_location();
    var _printLocation = require_printLocation();
    var _kinds = require_kinds();
    var _tokenKind = require_tokenKind();
    var _lexer = require_lexer();
    var _parser = require_parser();
    var _printer = require_printer();
    var _visitor = require_visitor();
    var _predicates = require_predicates();
    var _directiveLocation = require_directiveLocation();
  }
});

// ../../node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.js
var require_tslib2 = __commonJS({
  "../../node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.js"(exports2, module2) {
    var __extends3;
    var __assign3;
    var __rest3;
    var __decorate3;
    var __param3;
    var __metadata3;
    var __awaiter3;
    var __generator3;
    var __exportStar3;
    var __values3;
    var __read3;
    var __spread3;
    var __spreadArrays3;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator3;
    var __asyncValues3;
    var __makeTemplateObject3;
    var __importStar3;
    var __importDefault3;
    var __classPrivateFieldGet3;
    var __classPrivateFieldSet3;
    var __createBinding3;
    (function(factory) {
      var root3 = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports3) {
          factory(createExporter(root3, createExporter(exports3)));
        });
      } else if (typeof module2 === "object" && typeof module2.exports === "object") {
        factory(createExporter(root3, createExporter(module2.exports)));
      } else {
        factory(createExporter(root3));
      }
      function createExporter(exports3, previous) {
        if (exports3 !== root3) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports3, "__esModule", { value: true });
          } else {
            exports3.__esModule = true;
          }
        }
        return function(id, v) {
          return exports3[id] = previous ? previous(id, v) : v;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b)
          if (b.hasOwnProperty(p))
            d[p] = b[p];
      };
      __extends3 = function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
      __assign3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      __rest3 = function(s, e) {
        var t = {};
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
          }
        return t;
      };
      __decorate3 = function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
              r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };
      __param3 = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata3 = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter3 = function(thisArg, _arguments, P, generator) {
        function adopt(value) {
          return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
          });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator3 = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t[0] & 1)
            throw t[1];
          return t[1];
        }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
          return this;
        }), g;
        function verb(n) {
          return function(v) {
            return step([n, v]);
          };
        }
        function step(op) {
          if (f)
            throw new TypeError("Generator is already executing.");
          while (_)
            try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                return t;
              if (y = 0, t)
                op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding3 = function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        o[k2] = m[k];
      };
      __exportStar3 = function(m, exports3) {
        for (var p in m)
          if (p !== "default" && !exports3.hasOwnProperty(p))
            exports3[p] = m[p];
      };
      __values3 = function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m)
          return m.call(o);
        if (o && typeof o.length === "number")
          return {
            next: function() {
              if (o && i >= o.length)
                o = void 0;
              return { value: o && o[i++], done: !o };
            }
          };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read3 = function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m)
          return o;
        var i = m.call(o), r, ar = [], e;
        try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r && !r.done && (m = i["return"]))
              m.call(i);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread3 = function() {
        for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read3(arguments[i]));
        return ar;
      };
      __spreadArrays3 = function() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++)
          s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
        return r;
      };
      __await3 = function(v) {
        return this instanceof __await3 ? (this.v = v, this) : new __await3(v);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i;
        function verb(n) {
          if (g[n])
            i[n] = function(v) {
              return new Promise(function(a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
        }
        function resume(n, v) {
          try {
            step(g[n](v));
          } catch (e) {
            settle(q[0][3], e);
          }
        }
        function step(r) {
          r.value instanceof __await3 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f, v) {
          if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator3 = function(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i[Symbol.iterator] = function() {
          return this;
        }, i;
        function verb(n, f) {
          i[n] = o[n] ? function(v) {
            return (p = !p) ? { value: __await3(o[n](v)), done: n === "return" } : f ? f(v) : v;
          } : f;
        }
      };
      __asyncValues3 = function(o) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values3 === "function" ? __values3(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i);
        function verb(n) {
          i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
              v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
          };
        }
        function settle(resolve, reject, d, v) {
          Promise.resolve(v).then(function(v2) {
            resolve({ value: v2, done: d });
          }, reject);
        }
      };
      __makeTemplateObject3 = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar3 = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result2 = {};
        if (mod != null) {
          for (var k in mod)
            if (Object.hasOwnProperty.call(mod, k))
              result2[k] = mod[k];
        }
        result2["default"] = mod;
        return result2;
      };
      __importDefault3 = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet3 = function(receiver2, privateMap) {
        if (!privateMap.has(receiver2)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver2);
      };
      __classPrivateFieldSet3 = function(receiver2, privateMap, value) {
        if (!privateMap.has(receiver2)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver2, value);
        return value;
      };
      exporter("__extends", __extends3);
      exporter("__assign", __assign3);
      exporter("__rest", __rest3);
      exporter("__decorate", __decorate3);
      exporter("__param", __param3);
      exporter("__metadata", __metadata3);
      exporter("__awaiter", __awaiter3);
      exporter("__generator", __generator3);
      exporter("__exportStar", __exportStar3);
      exporter("__createBinding", __createBinding3);
      exporter("__values", __values3);
      exporter("__read", __read3);
      exporter("__spread", __spread3);
      exporter("__spreadArrays", __spreadArrays3);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator3);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject3);
      exporter("__importStar", __importStar3);
      exporter("__importDefault", __importDefault3);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet3);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet3);
    });
  }
});

// ../../node_modules/.pnpm/fast-json-stable-stringify@2.1.0/node_modules/fast-json-stable-stringify/index.js
var require_fast_json_stable_stringify = __commonJS({
  "../../node_modules/.pnpm/fast-json-stable-stringify@2.1.0/node_modules/fast-json-stable-stringify/index.js"(exports2, module2) {
    "use strict";
    module2.exports = function(data, opts) {
      if (!opts)
        opts = {};
      if (typeof opts === "function")
        opts = { cmp: opts };
      var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
      var cmp = opts.cmp && function(f) {
        return function(node) {
          return function(a, b) {
            var aobj = { key: a, value: node[a] };
            var bobj = { key: b, value: node[b] };
            return f(aobj, bobj);
          };
        };
      }(opts.cmp);
      var seen = [];
      return function stringify3(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") {
          node = node.toJSON();
        }
        if (node === void 0)
          return;
        if (typeof node == "number")
          return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object")
          return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
          out = "[";
          for (i = 0; i < node.length; i++) {
            if (i)
              out += ",";
            out += stringify3(node[i]) || "null";
          }
          return out + "]";
        }
        if (node === null)
          return "null";
        if (seen.indexOf(node) !== -1) {
          if (cycles)
            return JSON.stringify("__cycle__");
          throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for (i = 0; i < keys.length; i++) {
          var key = keys[i];
          var value = stringify3(node[key]);
          if (!value)
            continue;
          if (out)
            out += ",";
          out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
      }(data);
    };
  }
});

// ../../node_modules/.pnpm/zen-observable@0.8.15/node_modules/zen-observable/lib/Observable.js
var require_Observable = __commonJS({
  "../../node_modules/.pnpm/zen-observable@0.8.15/node_modules/zen-observable/lib/Observable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.Observable = void 0;
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        _defineProperties(Constructor, staticProps);
      return Constructor;
    }
    var hasSymbols = function() {
      return typeof Symbol === "function";
    };
    var hasSymbol = function(name) {
      return hasSymbols() && Boolean(Symbol[name]);
    };
    var getSymbol = function(name) {
      return hasSymbol(name) ? Symbol[name] : "@@" + name;
    };
    if (hasSymbols() && !hasSymbol("observable")) {
      Symbol.observable = Symbol("observable");
    }
    var SymbolIterator = getSymbol("iterator");
    var SymbolObservable = getSymbol("observable");
    var SymbolSpecies = getSymbol("species");
    function getMethod(obj2, key) {
      var value = obj2[key];
      if (value == null)
        return void 0;
      if (typeof value !== "function")
        throw new TypeError(value + " is not a function");
      return value;
    }
    function getSpecies(obj2) {
      var ctor = obj2.constructor;
      if (ctor !== void 0) {
        ctor = ctor[SymbolSpecies];
        if (ctor === null) {
          ctor = void 0;
        }
      }
      return ctor !== void 0 ? ctor : Observable3;
    }
    function isObservable(x) {
      return x instanceof Observable3;
    }
    function hostReportError(e) {
      if (hostReportError.log) {
        hostReportError.log(e);
      } else {
        setTimeout(function() {
          throw e;
        });
      }
    }
    function enqueue(fn) {
      Promise.resolve().then(function() {
        try {
          fn();
        } catch (e) {
          hostReportError(e);
        }
      });
    }
    function cleanupSubscription(subscription) {
      var cleanup = subscription._cleanup;
      if (cleanup === void 0)
        return;
      subscription._cleanup = void 0;
      if (!cleanup) {
        return;
      }
      try {
        if (typeof cleanup === "function") {
          cleanup();
        } else {
          var unsubscribe = getMethod(cleanup, "unsubscribe");
          if (unsubscribe) {
            unsubscribe.call(cleanup);
          }
        }
      } catch (e) {
        hostReportError(e);
      }
    }
    function closeSubscription(subscription) {
      subscription._observer = void 0;
      subscription._queue = void 0;
      subscription._state = "closed";
    }
    function flushSubscription(subscription) {
      var queue = subscription._queue;
      if (!queue) {
        return;
      }
      subscription._queue = void 0;
      subscription._state = "ready";
      for (var i = 0; i < queue.length; ++i) {
        notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed")
          break;
      }
    }
    function notifySubscription(subscription, type, value) {
      subscription._state = "running";
      var observer = subscription._observer;
      try {
        var m = getMethod(observer, type);
        switch (type) {
          case "next":
            if (m)
              m.call(observer, value);
            break;
          case "error":
            closeSubscription(subscription);
            if (m)
              m.call(observer, value);
            else
              throw value;
            break;
          case "complete":
            closeSubscription(subscription);
            if (m)
              m.call(observer);
            break;
        }
      } catch (e) {
        hostReportError(e);
      }
      if (subscription._state === "closed")
        cleanupSubscription(subscription);
      else if (subscription._state === "running")
        subscription._state = "ready";
    }
    function onNotify(subscription, type, value) {
      if (subscription._state === "closed")
        return;
      if (subscription._state === "buffering") {
        subscription._queue.push({
          type,
          value
        });
        return;
      }
      if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [{
          type,
          value
        }];
        enqueue(function() {
          return flushSubscription(subscription);
        });
        return;
      }
      notifySubscription(subscription, type, value);
    }
    var Subscription = /* @__PURE__ */ function() {
      function Subscription2(observer, subscriber) {
        _classCallCheck(this, Subscription2);
        this._cleanup = void 0;
        this._observer = observer;
        this._queue = void 0;
        this._state = "initializing";
        var subscriptionObserver = new SubscriptionObserver(this);
        try {
          this._cleanup = subscriber.call(void 0, subscriptionObserver);
        } catch (e) {
          subscriptionObserver.error(e);
        }
        if (this._state === "initializing")
          this._state = "ready";
      }
      _createClass(Subscription2, [{
        key: "unsubscribe",
        value: function unsubscribe() {
          if (this._state !== "closed") {
            closeSubscription(this);
            cleanupSubscription(this);
          }
        }
      }, {
        key: "closed",
        get: function() {
          return this._state === "closed";
        }
      }]);
      return Subscription2;
    }();
    var SubscriptionObserver = /* @__PURE__ */ function() {
      function SubscriptionObserver2(subscription) {
        _classCallCheck(this, SubscriptionObserver2);
        this._subscription = subscription;
      }
      _createClass(SubscriptionObserver2, [{
        key: "next",
        value: function next(value) {
          onNotify(this._subscription, "next", value);
        }
      }, {
        key: "error",
        value: function error(value) {
          onNotify(this._subscription, "error", value);
        }
      }, {
        key: "complete",
        value: function complete() {
          onNotify(this._subscription, "complete");
        }
      }, {
        key: "closed",
        get: function() {
          return this._subscription._state === "closed";
        }
      }]);
      return SubscriptionObserver2;
    }();
    var Observable3 = /* @__PURE__ */ function() {
      function Observable4(subscriber) {
        _classCallCheck(this, Observable4);
        if (!(this instanceof Observable4))
          throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function")
          throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
      }
      _createClass(Observable4, [{
        key: "subscribe",
        value: function subscribe(observer) {
          if (typeof observer !== "object" || observer === null) {
            observer = {
              next: observer,
              error: arguments[1],
              complete: arguments[2]
            };
          }
          return new Subscription(observer, this._subscriber);
        }
      }, {
        key: "forEach",
        value: function forEach(fn) {
          var _this = this;
          return new Promise(function(resolve, reject) {
            if (typeof fn !== "function") {
              reject(new TypeError(fn + " is not a function"));
              return;
            }
            function done() {
              subscription.unsubscribe();
              resolve();
            }
            var subscription = _this.subscribe({
              next: function(value) {
                try {
                  fn(value, done);
                } catch (e) {
                  reject(e);
                  subscription.unsubscribe();
                }
              },
              error: reject,
              complete: resolve
            });
          });
        }
      }, {
        key: "map",
        value: function map(fn) {
          var _this2 = this;
          if (typeof fn !== "function")
            throw new TypeError(fn + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            return _this2.subscribe({
              next: function(value) {
                try {
                  value = fn(value);
                } catch (e) {
                  return observer.error(e);
                }
                observer.next(value);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                observer.complete();
              }
            });
          });
        }
      }, {
        key: "filter",
        value: function filter(fn) {
          var _this3 = this;
          if (typeof fn !== "function")
            throw new TypeError(fn + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            return _this3.subscribe({
              next: function(value) {
                try {
                  if (!fn(value))
                    return;
                } catch (e) {
                  return observer.error(e);
                }
                observer.next(value);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                observer.complete();
              }
            });
          });
        }
      }, {
        key: "reduce",
        value: function reduce(fn) {
          var _this4 = this;
          if (typeof fn !== "function")
            throw new TypeError(fn + " is not a function");
          var C = getSpecies(this);
          var hasSeed = arguments.length > 1;
          var hasValue = false;
          var seed = arguments[1];
          var acc = seed;
          return new C(function(observer) {
            return _this4.subscribe({
              next: function(value) {
                var first = !hasValue;
                hasValue = true;
                if (!first || hasSeed) {
                  try {
                    acc = fn(acc, value);
                  } catch (e) {
                    return observer.error(e);
                  }
                } else {
                  acc = value;
                }
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                if (!hasValue && !hasSeed)
                  return observer.error(new TypeError("Cannot reduce an empty sequence"));
                observer.next(acc);
                observer.complete();
              }
            });
          });
        }
      }, {
        key: "concat",
        value: function concat2() {
          var _this5 = this;
          for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
            sources[_key] = arguments[_key];
          }
          var C = getSpecies(this);
          return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
              subscription = next.subscribe({
                next: function(v) {
                  observer.next(v);
                },
                error: function(e) {
                  observer.error(e);
                },
                complete: function() {
                  if (index === sources.length) {
                    subscription = void 0;
                    observer.complete();
                  } else {
                    startNext(C.from(sources[index++]));
                  }
                }
              });
            }
            startNext(_this5);
            return function() {
              if (subscription) {
                subscription.unsubscribe();
                subscription = void 0;
              }
            };
          });
        }
      }, {
        key: "flatMap",
        value: function flatMap(fn) {
          var _this6 = this;
          if (typeof fn !== "function")
            throw new TypeError(fn + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
              next: function(value) {
                if (fn) {
                  try {
                    value = fn(value);
                  } catch (e) {
                    return observer.error(e);
                  }
                }
                var inner = C.from(value).subscribe({
                  next: function(value2) {
                    observer.next(value2);
                  },
                  error: function(e) {
                    observer.error(e);
                  },
                  complete: function() {
                    var i = subscriptions.indexOf(inner);
                    if (i >= 0)
                      subscriptions.splice(i, 1);
                    completeIfDone();
                  }
                });
                subscriptions.push(inner);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                completeIfDone();
              }
            });
            function completeIfDone() {
              if (outer.closed && subscriptions.length === 0)
                observer.complete();
            }
            return function() {
              subscriptions.forEach(function(s) {
                return s.unsubscribe();
              });
              outer.unsubscribe();
            };
          });
        }
      }, {
        key: SymbolObservable,
        value: function() {
          return this;
        }
      }], [{
        key: "from",
        value: function from2(x) {
          var C = typeof this === "function" ? this : Observable4;
          if (x == null)
            throw new TypeError(x + " is not an object");
          var method = getMethod(x, SymbolObservable);
          if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable)
              throw new TypeError(observable + " is not an object");
            if (isObservable(observable) && observable.constructor === C)
              return observable;
            return new C(function(observer) {
              return observable.subscribe(observer);
            });
          }
          if (hasSymbol("iterator")) {
            method = getMethod(x, SymbolIterator);
            if (method) {
              return new C(function(observer) {
                enqueue(function() {
                  if (observer.closed)
                    return;
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = void 0;
                  try {
                    for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var _item = _step.value;
                      observer.next(_item);
                      if (observer.closed)
                        return;
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                  observer.complete();
                });
              });
            }
          }
          if (Array.isArray(x)) {
            return new C(function(observer) {
              enqueue(function() {
                if (observer.closed)
                  return;
                for (var i = 0; i < x.length; ++i) {
                  observer.next(x[i]);
                  if (observer.closed)
                    return;
                }
                observer.complete();
              });
            });
          }
          throw new TypeError(x + " is not observable");
        }
      }, {
        key: "of",
        value: function of() {
          for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            items[_key2] = arguments[_key2];
          }
          var C = typeof this === "function" ? this : Observable4;
          return new C(function(observer) {
            enqueue(function() {
              if (observer.closed)
                return;
              for (var i = 0; i < items.length; ++i) {
                observer.next(items[i]);
                if (observer.closed)
                  return;
              }
              observer.complete();
            });
          });
        }
      }, {
        key: SymbolSpecies,
        get: function() {
          return this;
        }
      }]);
      return Observable4;
    }();
    exports2.Observable = Observable3;
    if (hasSymbols()) {
      Object.defineProperty(Observable3, Symbol("extensions"), {
        value: {
          symbol: SymbolObservable,
          hostReportError
        },
        configurable: true
      });
    }
  }
});

// ../../node_modules/.pnpm/zen-observable@0.8.15/node_modules/zen-observable/index.js
var require_zen_observable = __commonJS({
  "../../node_modules/.pnpm/zen-observable@0.8.15/node_modules/zen-observable/index.js"(exports2, module2) {
    module2.exports = require_Observable().Observable;
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/dayjs.min.js"(exports2, module2) {
    !function(t, e) {
      typeof exports2 == "object" && typeof module2 != "undefined" ? module2.exports = e() : typeof define == "function" && define.amd ? define(e) : (t = typeof globalThis != "undefined" ? globalThis : t || self).dayjs = e();
    }(exports2, function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      } }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date())
          return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, f), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), f);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return t2 === void 0;
      } }, g = "en", D = {};
      D[g] = M;
      var p = function(t2) {
        return t2 instanceof _;
      }, S = function t2(e2, n2, r2) {
        var i2;
        if (!e2)
          return g;
        if (typeof e2 == "string") {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1)
            return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, w = function(t2, e2) {
        if (p(t2))
          return t2.clone();
        var n2 = typeof e2 == "object" ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, O = v;
      O.l = S, O.i = p, O.w = function(t2, e2) {
        return w(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = function() {
        function M2(t2) {
          this.$L = S(t2.locale, null, true), this.parse(t2);
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (e2 === null)
              return new Date(NaN);
            if (O.u(e2))
              return new Date();
            if (e2 instanceof Date)
              return new Date(e2);
            if (typeof e2 == "string" && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          }(t2), this.$x = t2.x || {}, this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return O;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = w(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return w(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < w(t2);
        }, m2.$g = function(t2, e2, n2) {
          return O.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!O.u(e2) || e2, h2 = O.p(t2), l2 = function(t3, e3) {
            var i2 = O.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, $2 = function(t3, e3) {
            return O.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (h2) {
            case c:
              return r2 ? l2(1, 0) : l2(31, 11);
            case f:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = O.p(t2), h2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = h2 + "Date", n2[d] = h2 + "Date", n2[f] = h2 + "Month", n2[c] = h2 + "FullYear", n2[u] = h2 + "Hours", n2[s] = h2 + "Minutes", n2[i] = h2 + "Seconds", n2[r] = h2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === f || o2 === c) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else
            l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[O.p(t2)]();
        }, m2.add = function(r2, h2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = O.p(h2), y2 = function(t2) {
            var e2 = w(l2);
            return O.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          };
          if ($2 === f)
            return this.set(f, this.$M + r2);
          if ($2 === c)
            return this.set(c, this.$y + r2);
          if ($2 === a)
            return y2(1);
          if ($2 === o)
            return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return O.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid())
            return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, f2 = n2.months, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, c2 = function(t3) {
            return O.s(s2 % 12 || 12, t3, "0");
          }, d2 = n2.meridiem || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          }, $2 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a2 + 1, MM: O.s(a2 + 1, 2, "0"), MMM: h2(n2.monthsShort, a2, f2, 3), MMMM: h2(f2, a2), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: h2(n2.weekdaysMin, this.$W, o2, 2), ddd: h2(n2.weekdaysShort, this.$W, o2, 3), dddd: o2[this.$W], H: String(s2), HH: O.s(s2, 2, "0"), h: c2(1), hh: c2(2), a: d2(s2, u2, true), A: d2(s2, u2, false), m: String(u2), mm: O.s(u2, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: i2 };
          return r2.replace(y, function(t3, e3) {
            return e3 || $2[t3] || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = O.p(d2), M3 = w(r2), m3 = (M3.utcOffset() - this.utcOffset()) * e, v2 = this - M3, g2 = O.m(this, M3);
          return g2 = ($2 = {}, $2[c] = g2 / 12, $2[f] = g2, $2[h] = g2 / 3, $2[o] = (v2 - m3) / 6048e5, $2[a] = (v2 - m3) / 864e5, $2[u] = v2 / n, $2[s] = v2 / e, $2[i] = v2 / t, $2)[y2] || v2, l2 ? g2 : O.a(g2);
        }, m2.daysInMonth = function() {
          return this.endOf(f).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2)
            return this.$L;
          var n2 = this.clone(), r2 = S(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return O.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), T = _.prototype;
      return w.prototype = T, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function(t2) {
        T[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      }), w.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, w), t2.$i = true), w;
      }, w.locale = S, w.isDayjs = p, w.unix = function(t2) {
        return w(1e3 * t2);
      }, w.en = D[g], w.Ls = D, w.p = {}, w;
    });
  }
});

// ../../node_modules/.pnpm/bluebird@3.7.2/node_modules/bluebird/js/browser/bluebird.js
var require_bluebird = __commonJS({
  "../../node_modules/.pnpm/bluebird@3.7.2/node_modules/bluebird/js/browser/bluebird.js"(exports, module) {
    !function(e) {
      if (typeof exports == "object" && typeof module != "undefined")
        module.exports = e();
      else if (typeof define == "function" && define.amd)
        define([], e);
      else {
        var f;
        typeof window != "undefined" ? f = window : typeof global != "undefined" ? f = global : typeof self != "undefined" && (f = self), f.Promise = e();
      }
    }(function() {
      var define, module, exports;
      return function e(t, n, r) {
        function s(o2, u) {
          if (!n[o2]) {
            if (!t[o2]) {
              var a = typeof _dereq_ == "function" && _dereq_;
              if (!u && a)
                return a(o2, true);
              if (i)
                return i(o2, true);
              var f = new Error("Cannot find module '" + o2 + "'");
              throw f.code = "MODULE_NOT_FOUND", f;
            }
            var l = n[o2] = { exports: {} };
            t[o2][0].call(l.exports, function(e2) {
              var n2 = t[o2][1][e2];
              return s(n2 ? n2 : e2);
            }, l, l.exports, e, t, n, r);
          }
          return n[o2].exports;
        }
        var i = typeof _dereq_ == "function" && _dereq_;
        for (var o = 0; o < r.length; o++)
          s(r[o]);
        return s;
      }({ 1: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3) {
          var SomePromiseArray = Promise3._SomePromiseArray;
          function any(promises) {
            var ret2 = new SomePromiseArray(promises);
            var promise = ret2.promise();
            ret2.setHowMany(1);
            ret2.setUnwrap();
            ret2.init();
            return promise;
          }
          Promise3.any = function(promises) {
            return any(promises);
          };
          Promise3.prototype.any = function() {
            return any(this);
          };
        };
      }, {}], 2: [function(_dereq_2, module2, exports2) {
        "use strict";
        var firstLineError;
        try {
          throw new Error();
        } catch (e) {
          firstLineError = e;
        }
        var schedule = _dereq_2("./schedule");
        var Queue = _dereq_2("./queue");
        function Async() {
          this._customScheduler = false;
          this._isTickUsed = false;
          this._lateQueue = new Queue(16);
          this._normalQueue = new Queue(16);
          this._haveDrainedQueues = false;
          var self2 = this;
          this.drainQueues = function() {
            self2._drainQueues();
          };
          this._schedule = schedule;
        }
        Async.prototype.setScheduler = function(fn) {
          var prev = this._schedule;
          this._schedule = fn;
          this._customScheduler = true;
          return prev;
        };
        Async.prototype.hasCustomScheduler = function() {
          return this._customScheduler;
        };
        Async.prototype.haveItemsQueued = function() {
          return this._isTickUsed || this._haveDrainedQueues;
        };
        Async.prototype.fatalError = function(e, isNode2) {
          if (isNode2) {
            process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
            process.exit(2);
          } else {
            this.throwLater(e);
          }
        };
        Async.prototype.throwLater = function(fn, arg) {
          if (arguments.length === 1) {
            arg = fn;
            fn = function() {
              throw arg;
            };
          }
          if (typeof setTimeout !== "undefined") {
            setTimeout(function() {
              fn(arg);
            }, 0);
          } else
            try {
              this._schedule(function() {
                fn(arg);
              });
            } catch (e) {
              throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
            }
        };
        function AsyncInvokeLater(fn, receiver2, arg) {
          this._lateQueue.push(fn, receiver2, arg);
          this._queueTick();
        }
        function AsyncInvoke(fn, receiver2, arg) {
          this._normalQueue.push(fn, receiver2, arg);
          this._queueTick();
        }
        function AsyncSettlePromises(promise) {
          this._normalQueue._pushOne(promise);
          this._queueTick();
        }
        Async.prototype.invokeLater = AsyncInvokeLater;
        Async.prototype.invoke = AsyncInvoke;
        Async.prototype.settlePromises = AsyncSettlePromises;
        function _drainQueue(queue) {
          while (queue.length() > 0) {
            _drainQueueStep(queue);
          }
        }
        function _drainQueueStep(queue) {
          var fn = queue.shift();
          if (typeof fn !== "function") {
            fn._settlePromises();
          } else {
            var receiver2 = queue.shift();
            var arg = queue.shift();
            fn.call(receiver2, arg);
          }
        }
        Async.prototype._drainQueues = function() {
          _drainQueue(this._normalQueue);
          this._reset();
          this._haveDrainedQueues = true;
          _drainQueue(this._lateQueue);
        };
        Async.prototype._queueTick = function() {
          if (!this._isTickUsed) {
            this._isTickUsed = true;
            this._schedule(this.drainQueues);
          }
        };
        Async.prototype._reset = function() {
          this._isTickUsed = false;
        };
        module2.exports = Async;
        module2.exports.firstLineError = firstLineError;
      }, { "./queue": 26, "./schedule": 29 }], 3: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL, tryConvertToPromise, debug) {
          var calledBind = false;
          var rejectThis = function(_, e) {
            this._reject(e);
          };
          var targetRejected = function(e, context) {
            context.promiseRejectionQueued = true;
            context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
          };
          var bindingResolved = function(thisArg, context) {
            if ((this._bitField & 50397184) === 0) {
              this._resolveCallback(context.target);
            }
          };
          var bindingRejected = function(e, context) {
            if (!context.promiseRejectionQueued)
              this._reject(e);
          };
          Promise3.prototype.bind = function(thisArg) {
            if (!calledBind) {
              calledBind = true;
              Promise3.prototype._propagateFrom = debug.propagateFromFunction();
              Promise3.prototype._boundValue = debug.boundValueFunction();
            }
            var maybePromise = tryConvertToPromise(thisArg);
            var ret2 = new Promise3(INTERNAL);
            ret2._propagateFrom(this, 1);
            var target = this._target();
            ret2._setBoundTo(maybePromise);
            if (maybePromise instanceof Promise3) {
              var context = {
                promiseRejectionQueued: false,
                promise: ret2,
                target,
                bindingPromise: maybePromise
              };
              target._then(INTERNAL, targetRejected, void 0, ret2, context);
              maybePromise._then(bindingResolved, bindingRejected, void 0, ret2, context);
              ret2._setOnCancel(maybePromise);
            } else {
              ret2._resolveCallback(target);
            }
            return ret2;
          };
          Promise3.prototype._setBoundTo = function(obj2) {
            if (obj2 !== void 0) {
              this._bitField = this._bitField | 2097152;
              this._boundTo = obj2;
            } else {
              this._bitField = this._bitField & ~2097152;
            }
          };
          Promise3.prototype._isBound = function() {
            return (this._bitField & 2097152) === 2097152;
          };
          Promise3.bind = function(thisArg, value) {
            return Promise3.resolve(value).bind(thisArg);
          };
        };
      }, {}], 4: [function(_dereq_2, module2, exports2) {
        "use strict";
        var old;
        if (typeof Promise !== "undefined")
          old = Promise;
        function noConflict() {
          try {
            if (Promise === bluebird)
              Promise = old;
          } catch (e) {
          }
          return bluebird;
        }
        var bluebird = _dereq_2("./promise")();
        bluebird.noConflict = noConflict;
        module2.exports = bluebird;
      }, { "./promise": 22 }], 5: [function(_dereq_2, module2, exports2) {
        "use strict";
        var cr = Object.create;
        if (cr) {
          var callerCache = cr(null);
          var getterCache = cr(null);
          callerCache[" size"] = getterCache[" size"] = 0;
        }
        module2.exports = function(Promise3) {
          var util = _dereq_2("./util");
          var canEvaluate2 = util.canEvaluate;
          var isIdentifier2 = util.isIdentifier;
          var getMethodCaller;
          var getGetter;
          if (false) {
            var makeMethodCaller = function(methodName) {
              return new Function("ensureMethod", "                                    \n        return function(obj) {                                               \n            'use strict'                                                     \n            var len = this.length;                                           \n            ensureMethod(obj, 'methodName');                                 \n            switch(len) {                                                    \n                case 1: return obj.methodName(this[0]);                      \n                case 2: return obj.methodName(this[0], this[1]);             \n                case 3: return obj.methodName(this[0], this[1], this[2]);    \n                case 0: return obj.methodName();                             \n                default:                                                     \n                    return obj.methodName.apply(obj, this);                  \n            }                                                                \n        };                                                                   \n        ".replace(/methodName/g, methodName))(ensureMethod);
            };
            var makeGetter = function(propertyName) {
              return new Function("obj", "                                             \n        'use strict';                                                        \n        return obj.propertyName;                                             \n        ".replace("propertyName", propertyName));
            };
            var getCompiled = function(name, compiler, cache) {
              var ret2 = cache[name];
              if (typeof ret2 !== "function") {
                if (!isIdentifier2(name)) {
                  return null;
                }
                ret2 = compiler(name);
                cache[name] = ret2;
                cache[" size"]++;
                if (cache[" size"] > 512) {
                  var keys = Object.keys(cache);
                  for (var i = 0; i < 256; ++i)
                    delete cache[keys[i]];
                  cache[" size"] = keys.length - 256;
                }
              }
              return ret2;
            };
            getMethodCaller = function(name) {
              return getCompiled(name, makeMethodCaller, callerCache);
            };
            getGetter = function(name) {
              return getCompiled(name, makeGetter, getterCache);
            };
          }
          function ensureMethod(obj2, methodName) {
            var fn;
            if (obj2 != null)
              fn = obj2[methodName];
            if (typeof fn !== "function") {
              var message = "Object " + util.classString(obj2) + " has no method '" + util.toString(methodName) + "'";
              throw new Promise3.TypeError(message);
            }
            return fn;
          }
          function caller(obj2) {
            var methodName = this.pop();
            var fn = ensureMethod(obj2, methodName);
            return fn.apply(obj2, this);
          }
          Promise3.prototype.call = function(methodName) {
            var args = [].slice.call(arguments, 1);
            ;
            if (false) {
              if (canEvaluate2) {
                var maybeCaller = getMethodCaller(methodName);
                if (maybeCaller !== null) {
                  return this._then(maybeCaller, void 0, void 0, args, void 0);
                }
              }
            }
            args.push(methodName);
            return this._then(caller, void 0, void 0, args, void 0);
          };
          function namedGetter(obj2) {
            return obj2[this];
          }
          function indexedGetter(obj2) {
            var index = +this;
            if (index < 0)
              index = Math.max(0, index + obj2.length);
            return obj2[index];
          }
          Promise3.prototype.get = function(propertyName) {
            var isIndex = typeof propertyName === "number";
            var getter;
            if (!isIndex) {
              if (canEvaluate2) {
                var maybeGetter = getGetter(propertyName);
                getter = maybeGetter !== null ? maybeGetter : namedGetter;
              } else {
                getter = namedGetter;
              }
            } else {
              getter = indexedGetter;
            }
            return this._then(getter, void 0, void 0, propertyName, void 0);
          };
        };
      }, { "./util": 36 }], 6: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, PromiseArray, apiRejection, debug) {
          var util = _dereq_2("./util");
          var tryCatch2 = util.tryCatch;
          var errorObj2 = util.errorObj;
          var async = Promise3._async;
          Promise3.prototype["break"] = Promise3.prototype.cancel = function() {
            if (!debug.cancellation())
              return this._warn("cancellation is disabled");
            var promise = this;
            var child = promise;
            while (promise._isCancellable()) {
              if (!promise._cancelBy(child)) {
                if (child._isFollowing()) {
                  child._followee().cancel();
                } else {
                  child._cancelBranched();
                }
                break;
              }
              var parent2 = promise._cancellationParent;
              if (parent2 == null || !parent2._isCancellable()) {
                if (promise._isFollowing()) {
                  promise._followee().cancel();
                } else {
                  promise._cancelBranched();
                }
                break;
              } else {
                if (promise._isFollowing())
                  promise._followee().cancel();
                promise._setWillBeCancelled();
                child = promise;
                promise = parent2;
              }
            }
          };
          Promise3.prototype._branchHasCancelled = function() {
            this._branchesRemainingToCancel--;
          };
          Promise3.prototype._enoughBranchesHaveCancelled = function() {
            return this._branchesRemainingToCancel === void 0 || this._branchesRemainingToCancel <= 0;
          };
          Promise3.prototype._cancelBy = function(canceller) {
            if (canceller === this) {
              this._branchesRemainingToCancel = 0;
              this._invokeOnCancel();
              return true;
            } else {
              this._branchHasCancelled();
              if (this._enoughBranchesHaveCancelled()) {
                this._invokeOnCancel();
                return true;
              }
            }
            return false;
          };
          Promise3.prototype._cancelBranched = function() {
            if (this._enoughBranchesHaveCancelled()) {
              this._cancel();
            }
          };
          Promise3.prototype._cancel = function() {
            if (!this._isCancellable())
              return;
            this._setCancelled();
            async.invoke(this._cancelPromises, this, void 0);
          };
          Promise3.prototype._cancelPromises = function() {
            if (this._length() > 0)
              this._settlePromises();
          };
          Promise3.prototype._unsetOnCancel = function() {
            this._onCancelField = void 0;
          };
          Promise3.prototype._isCancellable = function() {
            return this.isPending() && !this._isCancelled();
          };
          Promise3.prototype.isCancellable = function() {
            return this.isPending() && !this.isCancelled();
          };
          Promise3.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
            if (util.isArray(onCancelCallback)) {
              for (var i = 0; i < onCancelCallback.length; ++i) {
                this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
              }
            } else if (onCancelCallback !== void 0) {
              if (typeof onCancelCallback === "function") {
                if (!internalOnly) {
                  var e = tryCatch2(onCancelCallback).call(this._boundValue());
                  if (e === errorObj2) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                  }
                }
              } else {
                onCancelCallback._resultCancelled(this);
              }
            }
          };
          Promise3.prototype._invokeOnCancel = function() {
            var onCancelCallback = this._onCancel();
            this._unsetOnCancel();
            async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
          };
          Promise3.prototype._invokeInternalOnCancel = function() {
            if (this._isCancellable()) {
              this._doInvokeOnCancel(this._onCancel(), true);
              this._unsetOnCancel();
            }
          };
          Promise3.prototype._resultCancelled = function() {
            this.cancel();
          };
        };
      }, { "./util": 36 }], 7: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(NEXT_FILTER) {
          var util = _dereq_2("./util");
          var getKeys = _dereq_2("./es5").keys;
          var tryCatch2 = util.tryCatch;
          var errorObj2 = util.errorObj;
          function catchFilter(instances, cb, promise) {
            return function(e) {
              var boundTo = promise._boundValue();
              predicateLoop:
                for (var i = 0; i < instances.length; ++i) {
                  var item = instances[i];
                  if (item === Error || item != null && item.prototype instanceof Error) {
                    if (e instanceof item) {
                      return tryCatch2(cb).call(boundTo, e);
                    }
                  } else if (typeof item === "function") {
                    var matchesPredicate = tryCatch2(item).call(boundTo, e);
                    if (matchesPredicate === errorObj2) {
                      return matchesPredicate;
                    } else if (matchesPredicate) {
                      return tryCatch2(cb).call(boundTo, e);
                    }
                  } else if (util.isObject(e)) {
                    var keys = getKeys(item);
                    for (var j = 0; j < keys.length; ++j) {
                      var key = keys[j];
                      if (item[key] != e[key]) {
                        continue predicateLoop;
                      }
                    }
                    return tryCatch2(cb).call(boundTo, e);
                  }
                }
              return NEXT_FILTER;
            };
          }
          return catchFilter;
        };
      }, { "./es5": 13, "./util": 36 }], 8: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3) {
          var longStackTraces = false;
          var contextStack = [];
          Promise3.prototype._promiseCreated = function() {
          };
          Promise3.prototype._pushContext = function() {
          };
          Promise3.prototype._popContext = function() {
            return null;
          };
          Promise3._peekContext = Promise3.prototype._peekContext = function() {
          };
          function Context() {
            this._trace = new Context.CapturedTrace(peekContext());
          }
          Context.prototype._pushContext = function() {
            if (this._trace !== void 0) {
              this._trace._promiseCreated = null;
              contextStack.push(this._trace);
            }
          };
          Context.prototype._popContext = function() {
            if (this._trace !== void 0) {
              var trace = contextStack.pop();
              var ret2 = trace._promiseCreated;
              trace._promiseCreated = null;
              return ret2;
            }
            return null;
          };
          function createContext3() {
            if (longStackTraces)
              return new Context();
          }
          function peekContext() {
            var lastIndex = contextStack.length - 1;
            if (lastIndex >= 0) {
              return contextStack[lastIndex];
            }
            return void 0;
          }
          Context.CapturedTrace = null;
          Context.create = createContext3;
          Context.deactivateLongStackTraces = function() {
          };
          Context.activateLongStackTraces = function() {
            var Promise_pushContext = Promise3.prototype._pushContext;
            var Promise_popContext = Promise3.prototype._popContext;
            var Promise_PeekContext = Promise3._peekContext;
            var Promise_peekContext = Promise3.prototype._peekContext;
            var Promise_promiseCreated = Promise3.prototype._promiseCreated;
            Context.deactivateLongStackTraces = function() {
              Promise3.prototype._pushContext = Promise_pushContext;
              Promise3.prototype._popContext = Promise_popContext;
              Promise3._peekContext = Promise_PeekContext;
              Promise3.prototype._peekContext = Promise_peekContext;
              Promise3.prototype._promiseCreated = Promise_promiseCreated;
              longStackTraces = false;
            };
            longStackTraces = true;
            Promise3.prototype._pushContext = Context.prototype._pushContext;
            Promise3.prototype._popContext = Context.prototype._popContext;
            Promise3._peekContext = Promise3.prototype._peekContext = peekContext;
            Promise3.prototype._promiseCreated = function() {
              var ctx = this._peekContext();
              if (ctx && ctx._promiseCreated == null)
                ctx._promiseCreated = this;
            };
          };
          return Context;
        };
      }, {}], 9: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, Context, enableAsyncHooks, disableAsyncHooks) {
          var async = Promise3._async;
          var Warning = _dereq_2("./errors").Warning;
          var util = _dereq_2("./util");
          var es52 = _dereq_2("./es5");
          var canAttachTrace2 = util.canAttachTrace;
          var unhandledRejectionHandled;
          var possiblyUnhandledRejection;
          var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
          var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
          var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
          var stackFramePattern = null;
          var formatStack = null;
          var indentStackFrames = false;
          var printWarning;
          var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && true);
          var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
          var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
          var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
          var deferUnhandledRejectionCheck;
          (function() {
            var promises = [];
            function unhandledRejectionCheck() {
              for (var i = 0; i < promises.length; ++i) {
                promises[i]._notifyUnhandledRejection();
              }
              unhandledRejectionClear();
            }
            function unhandledRejectionClear() {
              promises.length = 0;
            }
            deferUnhandledRejectionCheck = function(promise) {
              promises.push(promise);
              setTimeout(unhandledRejectionCheck, 1);
            };
            es52.defineProperty(Promise3, "_unhandledRejectionCheck", {
              value: unhandledRejectionCheck
            });
            es52.defineProperty(Promise3, "_unhandledRejectionClear", {
              value: unhandledRejectionClear
            });
          })();
          Promise3.prototype.suppressUnhandledRejections = function() {
            var target = this._target();
            target._bitField = target._bitField & ~1048576 | 524288;
          };
          Promise3.prototype._ensurePossibleRejectionHandled = function() {
            if ((this._bitField & 524288) !== 0)
              return;
            this._setRejectionIsUnhandled();
            deferUnhandledRejectionCheck(this);
          };
          Promise3.prototype._notifyUnhandledRejectionIsHandled = function() {
            fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, void 0, this);
          };
          Promise3.prototype._setReturnedNonUndefined = function() {
            this._bitField = this._bitField | 268435456;
          };
          Promise3.prototype._returnedNonUndefined = function() {
            return (this._bitField & 268435456) !== 0;
          };
          Promise3.prototype._notifyUnhandledRejection = function() {
            if (this._isRejectionUnhandled()) {
              var reason = this._settledValue();
              this._setUnhandledRejectionIsNotified();
              fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
            }
          };
          Promise3.prototype._setUnhandledRejectionIsNotified = function() {
            this._bitField = this._bitField | 262144;
          };
          Promise3.prototype._unsetUnhandledRejectionIsNotified = function() {
            this._bitField = this._bitField & ~262144;
          };
          Promise3.prototype._isUnhandledRejectionNotified = function() {
            return (this._bitField & 262144) > 0;
          };
          Promise3.prototype._setRejectionIsUnhandled = function() {
            this._bitField = this._bitField | 1048576;
          };
          Promise3.prototype._unsetRejectionIsUnhandled = function() {
            this._bitField = this._bitField & ~1048576;
            if (this._isUnhandledRejectionNotified()) {
              this._unsetUnhandledRejectionIsNotified();
              this._notifyUnhandledRejectionIsHandled();
            }
          };
          Promise3.prototype._isRejectionUnhandled = function() {
            return (this._bitField & 1048576) > 0;
          };
          Promise3.prototype._warn = function(message, shouldUseOwnTrace, promise) {
            return warn(message, shouldUseOwnTrace, promise || this);
          };
          Promise3.onPossiblyUnhandledRejection = function(fn) {
            var context = Promise3._getContext();
            possiblyUnhandledRejection = util.contextBind(context, fn);
          };
          Promise3.onUnhandledRejectionHandled = function(fn) {
            var context = Promise3._getContext();
            unhandledRejectionHandled = util.contextBind(context, fn);
          };
          var disableLongStackTraces = function() {
          };
          Promise3.longStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
              throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
            }
            if (!config.longStackTraces && longStackTracesIsSupported()) {
              var Promise_captureStackTrace = Promise3.prototype._captureStackTrace;
              var Promise_attachExtraTrace = Promise3.prototype._attachExtraTrace;
              var Promise_dereferenceTrace = Promise3.prototype._dereferenceTrace;
              config.longStackTraces = true;
              disableLongStackTraces = function() {
                if (async.haveItemsQueued() && !config.longStackTraces) {
                  throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                }
                Promise3.prototype._captureStackTrace = Promise_captureStackTrace;
                Promise3.prototype._attachExtraTrace = Promise_attachExtraTrace;
                Promise3.prototype._dereferenceTrace = Promise_dereferenceTrace;
                Context.deactivateLongStackTraces();
                config.longStackTraces = false;
              };
              Promise3.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
              Promise3.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
              Promise3.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
              Context.activateLongStackTraces();
            }
          };
          Promise3.hasLongStackTraces = function() {
            return config.longStackTraces && longStackTracesIsSupported();
          };
          var legacyHandlers = {
            unhandledrejection: {
              before: function() {
                var ret2 = util.global.onunhandledrejection;
                util.global.onunhandledrejection = null;
                return ret2;
              },
              after: function(fn) {
                util.global.onunhandledrejection = fn;
              }
            },
            rejectionhandled: {
              before: function() {
                var ret2 = util.global.onrejectionhandled;
                util.global.onrejectionhandled = null;
                return ret2;
              },
              after: function(fn) {
                util.global.onrejectionhandled = fn;
              }
            }
          };
          var fireDomEvent = function() {
            var dispatch = function(legacy, e) {
              if (legacy) {
                var fn;
                try {
                  fn = legacy.before();
                  return !util.global.dispatchEvent(e);
                } finally {
                  legacy.after(fn);
                }
              } else {
                return !util.global.dispatchEvent(e);
              }
            };
            try {
              if (typeof CustomEvent === "function") {
                var event = new CustomEvent("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event2) {
                  name = name.toLowerCase();
                  var eventData = {
                    detail: event2,
                    cancelable: true
                  };
                  var domEvent = new CustomEvent(name, eventData);
                  es52.defineProperty(domEvent, "promise", { value: event2.promise });
                  es52.defineProperty(domEvent, "reason", { value: event2.reason });
                  return dispatch(legacyHandlers[name], domEvent);
                };
              } else if (typeof Event === "function") {
                var event = new Event("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event2) {
                  name = name.toLowerCase();
                  var domEvent = new Event(name, {
                    cancelable: true
                  });
                  domEvent.detail = event2;
                  es52.defineProperty(domEvent, "promise", { value: event2.promise });
                  es52.defineProperty(domEvent, "reason", { value: event2.reason });
                  return dispatch(legacyHandlers[name], domEvent);
                };
              } else {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                util.global.dispatchEvent(event);
                return function(name, event2) {
                  name = name.toLowerCase();
                  var domEvent = document.createEvent("CustomEvent");
                  domEvent.initCustomEvent(name, false, true, event2);
                  return dispatch(legacyHandlers[name], domEvent);
                };
              }
            } catch (e) {
            }
            return function() {
              return false;
            };
          }();
          var fireGlobalEvent = function() {
            if (util.isNode) {
              return function() {
                return process.emit.apply(process, arguments);
              };
            } else {
              if (!util.global) {
                return function() {
                  return false;
                };
              }
              return function(name) {
                var methodName = "on" + name.toLowerCase();
                var method = util.global[methodName];
                if (!method)
                  return false;
                method.apply(util.global, [].slice.call(arguments, 1));
                return true;
              };
            }
          }();
          function generatePromiseLifecycleEventObject(name, promise) {
            return { promise };
          }
          var eventToObjectGenerator = {
            promiseCreated: generatePromiseLifecycleEventObject,
            promiseFulfilled: generatePromiseLifecycleEventObject,
            promiseRejected: generatePromiseLifecycleEventObject,
            promiseResolved: generatePromiseLifecycleEventObject,
            promiseCancelled: generatePromiseLifecycleEventObject,
            promiseChained: function(name, promise, child) {
              return { promise, child };
            },
            warning: function(name, warning) {
              return { warning };
            },
            unhandledRejection: function(name, reason, promise) {
              return { reason, promise };
            },
            rejectionHandled: generatePromiseLifecycleEventObject
          };
          var activeFireEvent = function(name) {
            var globalEventFired = false;
            try {
              globalEventFired = fireGlobalEvent.apply(null, arguments);
            } catch (e) {
              async.throwLater(e);
              globalEventFired = true;
            }
            var domEventFired = false;
            try {
              domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
            } catch (e) {
              async.throwLater(e);
              domEventFired = true;
            }
            return domEventFired || globalEventFired;
          };
          Promise3.config = function(opts) {
            opts = Object(opts);
            if ("longStackTraces" in opts) {
              if (opts.longStackTraces) {
                Promise3.longStackTraces();
              } else if (!opts.longStackTraces && Promise3.hasLongStackTraces()) {
                disableLongStackTraces();
              }
            }
            if ("warnings" in opts) {
              var warningsOption = opts.warnings;
              config.warnings = !!warningsOption;
              wForgottenReturn = config.warnings;
              if (util.isObject(warningsOption)) {
                if ("wForgottenReturn" in warningsOption) {
                  wForgottenReturn = !!warningsOption.wForgottenReturn;
                }
              }
            }
            if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
              if (async.haveItemsQueued()) {
                throw new Error("cannot enable cancellation after promises are in use");
              }
              Promise3.prototype._clearCancellationData = cancellationClearCancellationData;
              Promise3.prototype._propagateFrom = cancellationPropagateFrom;
              Promise3.prototype._onCancel = cancellationOnCancel;
              Promise3.prototype._setOnCancel = cancellationSetOnCancel;
              Promise3.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
              Promise3.prototype._execute = cancellationExecute;
              propagateFromFunction = cancellationPropagateFrom;
              config.cancellation = true;
            }
            if ("monitoring" in opts) {
              if (opts.monitoring && !config.monitoring) {
                config.monitoring = true;
                Promise3.prototype._fireEvent = activeFireEvent;
              } else if (!opts.monitoring && config.monitoring) {
                config.monitoring = false;
                Promise3.prototype._fireEvent = defaultFireEvent;
              }
            }
            if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
              var prev = config.asyncHooks;
              var cur = !!opts.asyncHooks;
              if (prev !== cur) {
                config.asyncHooks = cur;
                if (cur) {
                  enableAsyncHooks();
                } else {
                  disableAsyncHooks();
                }
              }
            }
            return Promise3;
          };
          function defaultFireEvent() {
            return false;
          }
          Promise3.prototype._fireEvent = defaultFireEvent;
          Promise3.prototype._execute = function(executor, resolve, reject) {
            try {
              executor(resolve, reject);
            } catch (e) {
              return e;
            }
          };
          Promise3.prototype._onCancel = function() {
          };
          Promise3.prototype._setOnCancel = function(handler) {
            ;
          };
          Promise3.prototype._attachCancellationCallback = function(onCancel) {
            ;
          };
          Promise3.prototype._captureStackTrace = function() {
          };
          Promise3.prototype._attachExtraTrace = function() {
          };
          Promise3.prototype._dereferenceTrace = function() {
          };
          Promise3.prototype._clearCancellationData = function() {
          };
          Promise3.prototype._propagateFrom = function(parent2, flags) {
            ;
            ;
          };
          function cancellationExecute(executor, resolve, reject) {
            var promise = this;
            try {
              executor(resolve, reject, function(onCancel) {
                if (typeof onCancel !== "function") {
                  throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                }
                promise._attachCancellationCallback(onCancel);
              });
            } catch (e) {
              return e;
            }
          }
          function cancellationAttachCancellationCallback(onCancel) {
            if (!this._isCancellable())
              return this;
            var previousOnCancel = this._onCancel();
            if (previousOnCancel !== void 0) {
              if (util.isArray(previousOnCancel)) {
                previousOnCancel.push(onCancel);
              } else {
                this._setOnCancel([previousOnCancel, onCancel]);
              }
            } else {
              this._setOnCancel(onCancel);
            }
          }
          function cancellationOnCancel() {
            return this._onCancelField;
          }
          function cancellationSetOnCancel(onCancel) {
            this._onCancelField = onCancel;
          }
          function cancellationClearCancellationData() {
            this._cancellationParent = void 0;
            this._onCancelField = void 0;
          }
          function cancellationPropagateFrom(parent2, flags) {
            if ((flags & 1) !== 0) {
              this._cancellationParent = parent2;
              var branchesRemainingToCancel = parent2._branchesRemainingToCancel;
              if (branchesRemainingToCancel === void 0) {
                branchesRemainingToCancel = 0;
              }
              parent2._branchesRemainingToCancel = branchesRemainingToCancel + 1;
            }
            if ((flags & 2) !== 0 && parent2._isBound()) {
              this._setBoundTo(parent2._boundTo);
            }
          }
          function bindingPropagateFrom(parent2, flags) {
            if ((flags & 2) !== 0 && parent2._isBound()) {
              this._setBoundTo(parent2._boundTo);
            }
          }
          var propagateFromFunction = bindingPropagateFrom;
          function boundValueFunction() {
            var ret2 = this._boundTo;
            if (ret2 !== void 0) {
              if (ret2 instanceof Promise3) {
                if (ret2.isFulfilled()) {
                  return ret2.value();
                } else {
                  return void 0;
                }
              }
            }
            return ret2;
          }
          function longStackTracesCaptureStackTrace() {
            this._trace = new CapturedTrace(this._peekContext());
          }
          function longStackTracesAttachExtraTrace(error, ignoreSelf) {
            if (canAttachTrace2(error)) {
              var trace = this._trace;
              if (trace !== void 0) {
                if (ignoreSelf)
                  trace = trace._parent;
              }
              if (trace !== void 0) {
                trace.attachExtraTrace(error);
              } else if (!error.__stackCleaned__) {
                var parsed = parseStackAndMessage(error);
                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                util.notEnumerableProp(error, "__stackCleaned__", true);
              }
            }
          }
          function longStackTracesDereferenceTrace() {
            this._trace = void 0;
          }
          function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent2) {
            if (returnValue === void 0 && promiseCreated !== null && wForgottenReturn) {
              if (parent2 !== void 0 && parent2._returnedNonUndefined())
                return;
              if ((promise._bitField & 65535) === 0)
                return;
              if (name)
                name = name + " ";
              var handlerLine = "";
              var creatorLine = "";
              if (promiseCreated._trace) {
                var traceLines = promiseCreated._trace.stack.split("\n");
                var stack = cleanStack(traceLines);
                for (var i = stack.length - 1; i >= 0; --i) {
                  var line = stack[i];
                  if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                      handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                  }
                }
                if (stack.length > 0) {
                  var firstUserLine = stack[0];
                  for (var i = 0; i < traceLines.length; ++i) {
                    if (traceLines[i] === firstUserLine) {
                      if (i > 0) {
                        creatorLine = "\n" + traceLines[i - 1];
                      }
                      break;
                    }
                  }
                }
              }
              var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, see http://goo.gl/rRqMUw" + creatorLine;
              promise._warn(msg, true, promiseCreated);
            }
          }
          function deprecated(name, replacement) {
            var message = name + " is deprecated and will be removed in a future version.";
            if (replacement)
              message += " Use " + replacement + " instead.";
            return warn(message);
          }
          function warn(message, shouldUseOwnTrace, promise) {
            if (!config.warnings)
              return;
            var warning = new Warning(message);
            var ctx;
            if (shouldUseOwnTrace) {
              promise._attachExtraTrace(warning);
            } else if (config.longStackTraces && (ctx = Promise3._peekContext())) {
              ctx.attachExtraTrace(warning);
            } else {
              var parsed = parseStackAndMessage(warning);
              warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
            }
            if (!activeFireEvent("warning", warning)) {
              formatAndLogError(warning, "", true);
            }
          }
          function reconstructStack(message, stacks) {
            for (var i = 0; i < stacks.length - 1; ++i) {
              stacks[i].push("From previous event:");
              stacks[i] = stacks[i].join("\n");
            }
            if (i < stacks.length) {
              stacks[i] = stacks[i].join("\n");
            }
            return message + "\n" + stacks.join("\n");
          }
          function removeDuplicateOrEmptyJumps(stacks) {
            for (var i = 0; i < stacks.length; ++i) {
              if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                stacks.splice(i, 1);
                i--;
              }
            }
          }
          function removeCommonRoots(stacks) {
            var current = stacks[0];
            for (var i = 1; i < stacks.length; ++i) {
              var prev = stacks[i];
              var currentLastIndex = current.length - 1;
              var currentLastLine = current[currentLastIndex];
              var commonRootMeetPoint = -1;
              for (var j = prev.length - 1; j >= 0; --j) {
                if (prev[j] === currentLastLine) {
                  commonRootMeetPoint = j;
                  break;
                }
              }
              for (var j = commonRootMeetPoint; j >= 0; --j) {
                var line = prev[j];
                if (current[currentLastIndex] === line) {
                  current.pop();
                  currentLastIndex--;
                } else {
                  break;
                }
              }
              current = prev;
            }
          }
          function cleanStack(stack) {
            var ret2 = [];
            for (var i = 0; i < stack.length; ++i) {
              var line = stack[i];
              var isTraceLine = line === "    (No stack trace)" || stackFramePattern.test(line);
              var isInternalFrame = isTraceLine && shouldIgnore(line);
              if (isTraceLine && !isInternalFrame) {
                if (indentStackFrames && line.charAt(0) !== " ") {
                  line = "    " + line;
                }
                ret2.push(line);
              }
            }
            return ret2;
          }
          function stackFramesAsArray(error) {
            var stack = error.stack.replace(/\s+$/g, "").split("\n");
            for (var i = 0; i < stack.length; ++i) {
              var line = stack[i];
              if (line === "    (No stack trace)" || stackFramePattern.test(line)) {
                break;
              }
            }
            if (i > 0 && error.name != "SyntaxError") {
              stack = stack.slice(i);
            }
            return stack;
          }
          function parseStackAndMessage(error) {
            var stack = error.stack;
            var message = error.toString();
            stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : ["    (No stack trace)"];
            return {
              message,
              stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
            };
          }
          function formatAndLogError(error, title, isSoft) {
            if (typeof console !== "undefined") {
              var message;
              if (util.isObject(error)) {
                var stack = error.stack;
                message = title + formatStack(stack, error);
              } else {
                message = title + String(error);
              }
              if (typeof printWarning === "function") {
                printWarning(message, isSoft);
              } else if (typeof console.log === "function" || typeof console.log === "object") {
                console.log(message);
              }
            }
          }
          function fireRejectionEvent(name, localHandler, reason, promise) {
            var localEventFired = false;
            try {
              if (typeof localHandler === "function") {
                localEventFired = true;
                if (name === "rejectionHandled") {
                  localHandler(promise);
                } else {
                  localHandler(reason, promise);
                }
              }
            } catch (e) {
              async.throwLater(e);
            }
            if (name === "unhandledRejection") {
              if (!activeFireEvent(name, reason, promise) && !localEventFired) {
                formatAndLogError(reason, "Unhandled rejection ");
              }
            } else {
              activeFireEvent(name, promise);
            }
          }
          function formatNonError(obj2) {
            var str;
            if (typeof obj2 === "function") {
              str = "[function " + (obj2.name || "anonymous") + "]";
            } else {
              str = obj2 && typeof obj2.toString === "function" ? obj2.toString() : util.toString(obj2);
              var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
              if (ruselessToString.test(str)) {
                try {
                  var newStr = JSON.stringify(obj2);
                  str = newStr;
                } catch (e) {
                }
              }
              if (str.length === 0) {
                str = "(empty array)";
              }
            }
            return "(<" + snip(str) + ">, no stack trace)";
          }
          function snip(str) {
            var maxChars = 41;
            if (str.length < maxChars) {
              return str;
            }
            return str.substr(0, maxChars - 3) + "...";
          }
          function longStackTracesIsSupported() {
            return typeof captureStackTrace === "function";
          }
          var shouldIgnore = function() {
            return false;
          };
          var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
          function parseLineInfo(line) {
            var matches = line.match(parseLineInfoRegex);
            if (matches) {
              return {
                fileName: matches[1],
                line: parseInt(matches[2], 10)
              };
            }
          }
          function setBounds(firstLineError, lastLineError) {
            if (!longStackTracesIsSupported())
              return;
            var firstStackLines = (firstLineError.stack || "").split("\n");
            var lastStackLines = (lastLineError.stack || "").split("\n");
            var firstIndex = -1;
            var lastIndex = -1;
            var firstFileName;
            var lastFileName;
            for (var i = 0; i < firstStackLines.length; ++i) {
              var result2 = parseLineInfo(firstStackLines[i]);
              if (result2) {
                firstFileName = result2.fileName;
                firstIndex = result2.line;
                break;
              }
            }
            for (var i = 0; i < lastStackLines.length; ++i) {
              var result2 = parseLineInfo(lastStackLines[i]);
              if (result2) {
                lastFileName = result2.fileName;
                lastIndex = result2.line;
                break;
              }
            }
            if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) {
              return;
            }
            shouldIgnore = function(line) {
              if (bluebirdFramePattern.test(line))
                return true;
              var info = parseLineInfo(line);
              if (info) {
                if (info.fileName === firstFileName && (firstIndex <= info.line && info.line <= lastIndex)) {
                  return true;
                }
              }
              return false;
            };
          }
          function CapturedTrace(parent2) {
            this._parent = parent2;
            this._promisesCreated = 0;
            var length = this._length = 1 + (parent2 === void 0 ? 0 : parent2._length);
            captureStackTrace(this, CapturedTrace);
            if (length > 32)
              this.uncycle();
          }
          util.inherits(CapturedTrace, Error);
          Context.CapturedTrace = CapturedTrace;
          CapturedTrace.prototype.uncycle = function() {
            var length = this._length;
            if (length < 2)
              return;
            var nodes = [];
            var stackToIndex = {};
            for (var i = 0, node = this; node !== void 0; ++i) {
              nodes.push(node);
              node = node._parent;
            }
            length = this._length = i;
            for (var i = length - 1; i >= 0; --i) {
              var stack = nodes[i].stack;
              if (stackToIndex[stack] === void 0) {
                stackToIndex[stack] = i;
              }
            }
            for (var i = 0; i < length; ++i) {
              var currentStack = nodes[i].stack;
              var index = stackToIndex[currentStack];
              if (index !== void 0 && index !== i) {
                if (index > 0) {
                  nodes[index - 1]._parent = void 0;
                  nodes[index - 1]._length = 1;
                }
                nodes[i]._parent = void 0;
                nodes[i]._length = 1;
                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                if (index < length - 1) {
                  cycleEdgeNode._parent = nodes[index + 1];
                  cycleEdgeNode._parent.uncycle();
                  cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                } else {
                  cycleEdgeNode._parent = void 0;
                  cycleEdgeNode._length = 1;
                }
                var currentChildLength = cycleEdgeNode._length + 1;
                for (var j = i - 2; j >= 0; --j) {
                  nodes[j]._length = currentChildLength;
                  currentChildLength++;
                }
                return;
              }
            }
          };
          CapturedTrace.prototype.attachExtraTrace = function(error) {
            if (error.__stackCleaned__)
              return;
            this.uncycle();
            var parsed = parseStackAndMessage(error);
            var message = parsed.message;
            var stacks = [parsed.stack];
            var trace = this;
            while (trace !== void 0) {
              stacks.push(cleanStack(trace.stack.split("\n")));
              trace = trace._parent;
            }
            removeCommonRoots(stacks);
            removeDuplicateOrEmptyJumps(stacks);
            util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
            util.notEnumerableProp(error, "__stackCleaned__", true);
          };
          var captureStackTrace = function stackDetection() {
            var v8stackFramePattern = /^\s*at\s*/;
            var v8stackFormatter = function(stack, error) {
              if (typeof stack === "string")
                return stack;
              if (error.name !== void 0 && error.message !== void 0) {
                return error.toString();
              }
              return formatNonError(error);
            };
            if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
              Error.stackTraceLimit += 6;
              stackFramePattern = v8stackFramePattern;
              formatStack = v8stackFormatter;
              var captureStackTrace2 = Error.captureStackTrace;
              shouldIgnore = function(line) {
                return bluebirdFramePattern.test(line);
              };
              return function(receiver2, ignoreUntil) {
                Error.stackTraceLimit += 6;
                captureStackTrace2(receiver2, ignoreUntil);
                Error.stackTraceLimit -= 6;
              };
            }
            var err = new Error();
            if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
              stackFramePattern = /@/;
              formatStack = v8stackFormatter;
              indentStackFrames = true;
              return function captureStackTrace3(o) {
                o.stack = new Error().stack;
              };
            }
            var hasStackAfterThrow;
            try {
              throw new Error();
            } catch (e) {
              hasStackAfterThrow = "stack" in e;
            }
            if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
              stackFramePattern = v8stackFramePattern;
              formatStack = v8stackFormatter;
              return function captureStackTrace3(o) {
                Error.stackTraceLimit += 6;
                try {
                  throw new Error();
                } catch (e) {
                  o.stack = e.stack;
                }
                Error.stackTraceLimit -= 6;
              };
            }
            formatStack = function(stack, error) {
              if (typeof stack === "string")
                return stack;
              if ((typeof error === "object" || typeof error === "function") && error.name !== void 0 && error.message !== void 0) {
                return error.toString();
              }
              return formatNonError(error);
            };
            return null;
          }([]);
          if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
            printWarning = function(message) {
              console.warn(message);
            };
            if (util.isNode && process.stderr.isTTY) {
              printWarning = function(message, isSoft) {
                var color = isSoft ? "\x1B[33m" : "\x1B[31m";
                console.warn(color + message + "\x1B[0m\n");
              };
            } else if (!util.isNode && typeof new Error().stack === "string") {
              printWarning = function(message, isSoft) {
                console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
              };
            }
          }
          var config = {
            warnings,
            longStackTraces: false,
            cancellation: false,
            monitoring: false,
            asyncHooks: false
          };
          if (longStackTraces)
            Promise3.longStackTraces();
          return {
            asyncHooks: function() {
              return config.asyncHooks;
            },
            longStackTraces: function() {
              return config.longStackTraces;
            },
            warnings: function() {
              return config.warnings;
            },
            cancellation: function() {
              return config.cancellation;
            },
            monitoring: function() {
              return config.monitoring;
            },
            propagateFromFunction: function() {
              return propagateFromFunction;
            },
            boundValueFunction: function() {
              return boundValueFunction;
            },
            checkForgottenReturns,
            setBounds,
            warn,
            deprecated,
            CapturedTrace,
            fireDomEvent,
            fireGlobalEvent
          };
        };
      }, { "./errors": 12, "./es5": 13, "./util": 36 }], 10: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3) {
          function returner() {
            return this.value;
          }
          function thrower2() {
            throw this.reason;
          }
          Promise3.prototype["return"] = Promise3.prototype.thenReturn = function(value) {
            if (value instanceof Promise3)
              value.suppressUnhandledRejections();
            return this._then(returner, void 0, void 0, { value }, void 0);
          };
          Promise3.prototype["throw"] = Promise3.prototype.thenThrow = function(reason) {
            return this._then(thrower2, void 0, void 0, { reason }, void 0);
          };
          Promise3.prototype.catchThrow = function(reason) {
            if (arguments.length <= 1) {
              return this._then(void 0, thrower2, void 0, { reason }, void 0);
            } else {
              var _reason = arguments[1];
              var handler = function() {
                throw _reason;
              };
              return this.caught(reason, handler);
            }
          };
          Promise3.prototype.catchReturn = function(value) {
            if (arguments.length <= 1) {
              if (value instanceof Promise3)
                value.suppressUnhandledRejections();
              return this._then(void 0, returner, void 0, { value }, void 0);
            } else {
              var _value = arguments[1];
              if (_value instanceof Promise3)
                _value.suppressUnhandledRejections();
              var handler = function() {
                return _value;
              };
              return this.caught(value, handler);
            }
          };
        };
      }, {}], 11: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL) {
          var PromiseReduce = Promise3.reduce;
          var PromiseAll = Promise3.all;
          function promiseAllThis() {
            return PromiseAll(this);
          }
          function PromiseMapSeries(promises, fn) {
            return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
          }
          Promise3.prototype.each = function(fn) {
            return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, void 0, void 0, this, void 0);
          };
          Promise3.prototype.mapSeries = function(fn) {
            return PromiseReduce(this, fn, INTERNAL, INTERNAL);
          };
          Promise3.each = function(promises, fn) {
            return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, void 0, void 0, promises, void 0);
          };
          Promise3.mapSeries = PromiseMapSeries;
        };
      }, {}], 12: [function(_dereq_2, module2, exports2) {
        "use strict";
        var es52 = _dereq_2("./es5");
        var Objectfreeze = es52.freeze;
        var util = _dereq_2("./util");
        var inherits2 = util.inherits;
        var notEnumerableProp2 = util.notEnumerableProp;
        function subError(nameProperty, defaultMessage) {
          function SubError(message) {
            if (!(this instanceof SubError))
              return new SubError(message);
            notEnumerableProp2(this, "message", typeof message === "string" ? message : defaultMessage);
            notEnumerableProp2(this, "name", nameProperty);
            if (Error.captureStackTrace) {
              Error.captureStackTrace(this, this.constructor);
            } else {
              Error.call(this);
            }
          }
          inherits2(SubError, Error);
          return SubError;
        }
        var _TypeError, _RangeError;
        var Warning = subError("Warning", "warning");
        var CancellationError = subError("CancellationError", "cancellation error");
        var TimeoutError3 = subError("TimeoutError", "timeout error");
        var AggregateError = subError("AggregateError", "aggregate error");
        try {
          _TypeError = TypeError;
          _RangeError = RangeError;
        } catch (e) {
          _TypeError = subError("TypeError", "type error");
          _RangeError = subError("RangeError", "range error");
        }
        var methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
        for (var i = 0; i < methods.length; ++i) {
          if (typeof Array.prototype[methods[i]] === "function") {
            AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
          }
        }
        es52.defineProperty(AggregateError.prototype, "length", {
          value: 0,
          configurable: false,
          writable: true,
          enumerable: true
        });
        AggregateError.prototype["isOperational"] = true;
        var level = 0;
        AggregateError.prototype.toString = function() {
          var indent = Array(level * 4 + 1).join(" ");
          var ret2 = "\n" + indent + "AggregateError of:\n";
          level++;
          indent = Array(level * 4 + 1).join(" ");
          for (var i2 = 0; i2 < this.length; ++i2) {
            var str = this[i2] === this ? "[Circular AggregateError]" : this[i2] + "";
            var lines = str.split("\n");
            for (var j = 0; j < lines.length; ++j) {
              lines[j] = indent + lines[j];
            }
            str = lines.join("\n");
            ret2 += str + "\n";
          }
          level--;
          return ret2;
        };
        function OperationalError(message) {
          if (!(this instanceof OperationalError))
            return new OperationalError(message);
          notEnumerableProp2(this, "name", "OperationalError");
          notEnumerableProp2(this, "message", message);
          this.cause = message;
          this["isOperational"] = true;
          if (message instanceof Error) {
            notEnumerableProp2(this, "message", message.message);
            notEnumerableProp2(this, "stack", message.stack);
          } else if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
          }
        }
        inherits2(OperationalError, Error);
        var errorTypes = Error["__BluebirdErrorTypes__"];
        if (!errorTypes) {
          errorTypes = Objectfreeze({
            CancellationError,
            TimeoutError: TimeoutError3,
            OperationalError,
            RejectionError: OperationalError,
            AggregateError
          });
          es52.defineProperty(Error, "__BluebirdErrorTypes__", {
            value: errorTypes,
            writable: false,
            enumerable: false,
            configurable: false
          });
        }
        module2.exports = {
          Error,
          TypeError: _TypeError,
          RangeError: _RangeError,
          CancellationError: errorTypes.CancellationError,
          OperationalError: errorTypes.OperationalError,
          TimeoutError: errorTypes.TimeoutError,
          AggregateError: errorTypes.AggregateError,
          Warning
        };
      }, { "./es5": 13, "./util": 36 }], 13: [function(_dereq_2, module2, exports2) {
        var isES5 = function() {
          "use strict";
          return this === void 0;
        }();
        if (isES5) {
          module2.exports = {
            freeze: Object.freeze,
            defineProperty: Object.defineProperty,
            getDescriptor: Object.getOwnPropertyDescriptor,
            keys: Object.keys,
            names: Object.getOwnPropertyNames,
            getPrototypeOf: Object.getPrototypeOf,
            isArray: Array.isArray,
            isES5,
            propertyIsWritable: function(obj2, prop) {
              var descriptor = Object.getOwnPropertyDescriptor(obj2, prop);
              return !!(!descriptor || descriptor.writable || descriptor.set);
            }
          };
        } else {
          var has = {}.hasOwnProperty;
          var str = {}.toString;
          var proto = {}.constructor.prototype;
          var ObjectKeys = function(o) {
            var ret2 = [];
            for (var key in o) {
              if (has.call(o, key)) {
                ret2.push(key);
              }
            }
            return ret2;
          };
          var ObjectGetDescriptor = function(o, key) {
            return { value: o[key] };
          };
          var ObjectDefineProperty = function(o, key, desc) {
            o[key] = desc.value;
            return o;
          };
          var ObjectFreeze = function(obj2) {
            return obj2;
          };
          var ObjectGetPrototypeOf = function(obj2) {
            try {
              return Object(obj2).constructor.prototype;
            } catch (e) {
              return proto;
            }
          };
          var ArrayIsArray = function(obj2) {
            try {
              return str.call(obj2) === "[object Array]";
            } catch (e) {
              return false;
            }
          };
          module2.exports = {
            isArray: ArrayIsArray,
            keys: ObjectKeys,
            names: ObjectKeys,
            defineProperty: ObjectDefineProperty,
            getDescriptor: ObjectGetDescriptor,
            freeze: ObjectFreeze,
            getPrototypeOf: ObjectGetPrototypeOf,
            isES5,
            propertyIsWritable: function() {
              return true;
            }
          };
        }
      }, {}], 14: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL) {
          var PromiseMap = Promise3.map;
          Promise3.prototype.filter = function(fn, options) {
            return PromiseMap(this, fn, options, INTERNAL);
          };
          Promise3.filter = function(promises, fn, options) {
            return PromiseMap(promises, fn, options, INTERNAL);
          };
        };
      }, {}], 15: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, tryConvertToPromise, NEXT_FILTER) {
          var util = _dereq_2("./util");
          var CancellationError = Promise3.CancellationError;
          var errorObj2 = util.errorObj;
          var catchFilter = _dereq_2("./catch_filter")(NEXT_FILTER);
          function PassThroughHandlerContext(promise, type, handler) {
            this.promise = promise;
            this.type = type;
            this.handler = handler;
            this.called = false;
            this.cancelPromise = null;
          }
          PassThroughHandlerContext.prototype.isFinallyHandler = function() {
            return this.type === 0;
          };
          function FinallyHandlerCancelReaction(finallyHandler2) {
            this.finallyHandler = finallyHandler2;
          }
          FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
            checkCancel(this.finallyHandler);
          };
          function checkCancel(ctx, reason) {
            if (ctx.cancelPromise != null) {
              if (arguments.length > 1) {
                ctx.cancelPromise._reject(reason);
              } else {
                ctx.cancelPromise._cancel();
              }
              ctx.cancelPromise = null;
              return true;
            }
            return false;
          }
          function succeed() {
            return finallyHandler.call(this, this.promise._target()._settledValue());
          }
          function fail(reason) {
            if (checkCancel(this, reason))
              return;
            errorObj2.e = reason;
            return errorObj2;
          }
          function finallyHandler(reasonOrValue) {
            var promise = this.promise;
            var handler = this.handler;
            if (!this.called) {
              this.called = true;
              var ret2 = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
              if (ret2 === NEXT_FILTER) {
                return ret2;
              } else if (ret2 !== void 0) {
                promise._setReturnedNonUndefined();
                var maybePromise = tryConvertToPromise(ret2, promise);
                if (maybePromise instanceof Promise3) {
                  if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                      var reason = new CancellationError("late cancellation observer");
                      promise._attachExtraTrace(reason);
                      errorObj2.e = reason;
                      return errorObj2;
                    } else if (maybePromise.isPending()) {
                      maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                    }
                  }
                  return maybePromise._then(succeed, fail, void 0, this, void 0);
                }
              }
            }
            if (promise.isRejected()) {
              checkCancel(this);
              errorObj2.e = reasonOrValue;
              return errorObj2;
            } else {
              checkCancel(this);
              return reasonOrValue;
            }
          }
          Promise3.prototype._passThrough = function(handler, type, success, fail2) {
            if (typeof handler !== "function")
              return this.then();
            return this._then(success, fail2, void 0, new PassThroughHandlerContext(this, type, handler), void 0);
          };
          Promise3.prototype.lastly = Promise3.prototype["finally"] = function(handler) {
            return this._passThrough(handler, 0, finallyHandler, finallyHandler);
          };
          Promise3.prototype.tap = function(handler) {
            return this._passThrough(handler, 1, finallyHandler);
          };
          Promise3.prototype.tapCatch = function(handlerOrPredicate) {
            var len = arguments.length;
            if (len === 1) {
              return this._passThrough(handlerOrPredicate, 1, void 0, finallyHandler);
            } else {
              var catchInstances = new Array(len - 1), j = 0, i;
              for (i = 0; i < len - 1; ++i) {
                var item = arguments[i];
                if (util.isObject(item)) {
                  catchInstances[j++] = item;
                } else {
                  return Promise3.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + util.classString(item)));
                }
              }
              catchInstances.length = j;
              var handler = arguments[i];
              return this._passThrough(catchFilter(catchInstances, handler, this), 1, void 0, finallyHandler);
            }
          };
          return PassThroughHandlerContext;
        };
      }, { "./catch_filter": 7, "./util": 36 }], 16: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
          var errors = _dereq_2("./errors");
          var TypeError2 = errors.TypeError;
          var util = _dereq_2("./util");
          var errorObj2 = util.errorObj;
          var tryCatch2 = util.tryCatch;
          var yieldHandlers = [];
          function promiseFromYieldHandler(value, yieldHandlers2, traceParent) {
            for (var i = 0; i < yieldHandlers2.length; ++i) {
              traceParent._pushContext();
              var result2 = tryCatch2(yieldHandlers2[i])(value);
              traceParent._popContext();
              if (result2 === errorObj2) {
                traceParent._pushContext();
                var ret2 = Promise3.reject(errorObj2.e);
                traceParent._popContext();
                return ret2;
              }
              var maybePromise = tryConvertToPromise(result2, traceParent);
              if (maybePromise instanceof Promise3)
                return maybePromise;
            }
            return null;
          }
          function PromiseSpawn(generatorFunction, receiver2, yieldHandler, stack) {
            if (debug.cancellation()) {
              var internal = new Promise3(INTERNAL);
              var _finallyPromise = this._finallyPromise = new Promise3(INTERNAL);
              this._promise = internal.lastly(function() {
                return _finallyPromise;
              });
              internal._captureStackTrace();
              internal._setOnCancel(this);
            } else {
              var promise = this._promise = new Promise3(INTERNAL);
              promise._captureStackTrace();
            }
            this._stack = stack;
            this._generatorFunction = generatorFunction;
            this._receiver = receiver2;
            this._generator = void 0;
            this._yieldHandlers = typeof yieldHandler === "function" ? [yieldHandler].concat(yieldHandlers) : yieldHandlers;
            this._yieldedPromise = null;
            this._cancellationPhase = false;
          }
          util.inherits(PromiseSpawn, Proxyable);
          PromiseSpawn.prototype._isResolved = function() {
            return this._promise === null;
          };
          PromiseSpawn.prototype._cleanup = function() {
            this._promise = this._generator = null;
            if (debug.cancellation() && this._finallyPromise !== null) {
              this._finallyPromise._fulfill();
              this._finallyPromise = null;
            }
          };
          PromiseSpawn.prototype._promiseCancelled = function() {
            if (this._isResolved())
              return;
            var implementsReturn = typeof this._generator["return"] !== "undefined";
            var result2;
            if (!implementsReturn) {
              var reason = new Promise3.CancellationError("generator .return() sentinel");
              Promise3.coroutine.returnSentinel = reason;
              this._promise._attachExtraTrace(reason);
              this._promise._pushContext();
              result2 = tryCatch2(this._generator["throw"]).call(this._generator, reason);
              this._promise._popContext();
            } else {
              this._promise._pushContext();
              result2 = tryCatch2(this._generator["return"]).call(this._generator, void 0);
              this._promise._popContext();
            }
            this._cancellationPhase = true;
            this._yieldedPromise = null;
            this._continue(result2);
          };
          PromiseSpawn.prototype._promiseFulfilled = function(value) {
            this._yieldedPromise = null;
            this._promise._pushContext();
            var result2 = tryCatch2(this._generator.next).call(this._generator, value);
            this._promise._popContext();
            this._continue(result2);
          };
          PromiseSpawn.prototype._promiseRejected = function(reason) {
            this._yieldedPromise = null;
            this._promise._attachExtraTrace(reason);
            this._promise._pushContext();
            var result2 = tryCatch2(this._generator["throw"]).call(this._generator, reason);
            this._promise._popContext();
            this._continue(result2);
          };
          PromiseSpawn.prototype._resultCancelled = function() {
            if (this._yieldedPromise instanceof Promise3) {
              var promise = this._yieldedPromise;
              this._yieldedPromise = null;
              promise.cancel();
            }
          };
          PromiseSpawn.prototype.promise = function() {
            return this._promise;
          };
          PromiseSpawn.prototype._run = function() {
            this._generator = this._generatorFunction.call(this._receiver);
            this._receiver = this._generatorFunction = void 0;
            this._promiseFulfilled(void 0);
          };
          PromiseSpawn.prototype._continue = function(result2) {
            var promise = this._promise;
            if (result2 === errorObj2) {
              this._cleanup();
              if (this._cancellationPhase) {
                return promise.cancel();
              } else {
                return promise._rejectCallback(result2.e, false);
              }
            }
            var value = result2.value;
            if (result2.done === true) {
              this._cleanup();
              if (this._cancellationPhase) {
                return promise.cancel();
              } else {
                return promise._resolveCallback(value);
              }
            } else {
              var maybePromise = tryConvertToPromise(value, this._promise);
              if (!(maybePromise instanceof Promise3)) {
                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                if (maybePromise === null) {
                  this._promiseRejected(new TypeError2("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
                  return;
                }
              }
              maybePromise = maybePromise._target();
              var bitField = maybePromise._bitField;
              ;
              if ((bitField & 50397184) === 0) {
                this._yieldedPromise = maybePromise;
                maybePromise._proxy(this, null);
              } else if ((bitField & 33554432) !== 0) {
                Promise3._async.invoke(this._promiseFulfilled, this, maybePromise._value());
              } else if ((bitField & 16777216) !== 0) {
                Promise3._async.invoke(this._promiseRejected, this, maybePromise._reason());
              } else {
                this._promiseCancelled();
              }
            }
          };
          Promise3.coroutine = function(generatorFunction, options) {
            if (typeof generatorFunction !== "function") {
              throw new TypeError2("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
            }
            var yieldHandler = Object(options).yieldHandler;
            var PromiseSpawn$ = PromiseSpawn;
            var stack = new Error().stack;
            return function() {
              var generator = generatorFunction.apply(this, arguments);
              var spawn = new PromiseSpawn$(void 0, void 0, yieldHandler, stack);
              var ret2 = spawn.promise();
              spawn._generator = generator;
              spawn._promiseFulfilled(void 0);
              return ret2;
            };
          };
          Promise3.coroutine.addYieldHandler = function(fn) {
            if (typeof fn !== "function") {
              throw new TypeError2("expecting a function but got " + util.classString(fn));
            }
            yieldHandlers.push(fn);
          };
          Promise3.spawn = function(generatorFunction) {
            debug.deprecated("Promise.spawn()", "Promise.coroutine()");
            if (typeof generatorFunction !== "function") {
              return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
            }
            var spawn = new PromiseSpawn(generatorFunction, this);
            var ret2 = spawn.promise();
            spawn._run(Promise3.spawn);
            return ret2;
          };
        };
      }, { "./errors": 12, "./util": 36 }], 17: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, PromiseArray, tryConvertToPromise, INTERNAL, async) {
          var util = _dereq_2("./util");
          var canEvaluate2 = util.canEvaluate;
          var tryCatch2 = util.tryCatch;
          var errorObj2 = util.errorObj;
          var reject;
          if (false) {
            if (canEvaluate2) {
              var thenCallback = function(i2) {
                return new Function("value", "holder", "                             \n            'use strict';                                                    \n            holder.pIndex = value;                                           \n            holder.checkFulfillment(this);                                   \n            ".replace(/Index/g, i2));
              };
              var promiseSetter = function(i2) {
                return new Function("promise", "holder", "                           \n            'use strict';                                                    \n            holder.pIndex = promise;                                         \n            ".replace(/Index/g, i2));
              };
              var generateHolderClass = function(total) {
                var props = new Array(total);
                for (var i2 = 0; i2 < props.length; ++i2) {
                  props[i2] = "this.p" + (i2 + 1);
                }
                var assignment = props.join(" = ") + " = null;";
                var cancellationCode = "var promise;\n" + props.map(function(prop) {
                  return "                                                         \n                promise = " + prop + ";                                      \n                if (promise instanceof Promise) {                            \n                    promise.cancel();                                        \n                }                                                            \n            ";
                }).join("\n");
                var passedArguments = props.join(", ");
                var name = "Holder$" + total;
                var code = "return function(tryCatch, errorObj, Promise, async) {    \n            'use strict';                                                    \n            function [TheName](fn) {                                         \n                [TheProperties]                                              \n                this.fn = fn;                                                \n                this.asyncNeeded = true;                                     \n                this.now = 0;                                                \n            }                                                                \n                                                                             \n            [TheName].prototype._callFunction = function(promise) {          \n                promise._pushContext();                                      \n                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n                promise._popContext();                                       \n                if (ret === errorObj) {                                      \n                    promise._rejectCallback(ret.e, false);                   \n                } else {                                                     \n                    promise._resolveCallback(ret);                           \n                }                                                            \n            };                                                               \n                                                                             \n            [TheName].prototype.checkFulfillment = function(promise) {       \n                var now = ++this.now;                                        \n                if (now === [TheTotal]) {                                    \n                    if (this.asyncNeeded) {                                  \n                        async.invoke(this._callFunction, this, promise);     \n                    } else {                                                 \n                        this._callFunction(promise);                         \n                    }                                                        \n                                                                             \n                }                                                            \n            };                                                               \n                                                                             \n            [TheName].prototype._resultCancelled = function() {              \n                [CancellationCode]                                           \n            };                                                               \n                                                                             \n            return [TheName];                                                \n        }(tryCatch, errorObj, Promise, async);                               \n        ";
                code = code.replace(/\[TheName\]/g, name).replace(/\[TheTotal\]/g, total).replace(/\[ThePassedArguments\]/g, passedArguments).replace(/\[TheProperties\]/g, assignment).replace(/\[CancellationCode\]/g, cancellationCode);
                return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch2, errorObj2, Promise3, async);
              };
              var holderClasses = [];
              var thenCallbacks = [];
              var promiseSetters = [];
              for (var i = 0; i < 8; ++i) {
                holderClasses.push(generateHolderClass(i + 1));
                thenCallbacks.push(thenCallback(i + 1));
                promiseSetters.push(promiseSetter(i + 1));
              }
              reject = function(reason) {
                this._reject(reason);
              };
            }
          }
          Promise3.join = function() {
            var last = arguments.length - 1;
            var fn;
            if (last > 0 && typeof arguments[last] === "function") {
              fn = arguments[last];
              if (false) {
                if (last <= 8 && canEvaluate2) {
                  var ret2 = new Promise3(INTERNAL);
                  ret2._captureStackTrace();
                  var HolderClass = holderClasses[last - 1];
                  var holder = new HolderClass(fn);
                  var callbacks = thenCallbacks;
                  for (var i2 = 0; i2 < last; ++i2) {
                    var maybePromise = tryConvertToPromise(arguments[i2], ret2);
                    if (maybePromise instanceof Promise3) {
                      maybePromise = maybePromise._target();
                      var bitField = maybePromise._bitField;
                      ;
                      if ((bitField & 50397184) === 0) {
                        maybePromise._then(callbacks[i2], reject, void 0, ret2, holder);
                        promiseSetters[i2](maybePromise, holder);
                        holder.asyncNeeded = false;
                      } else if ((bitField & 33554432) !== 0) {
                        callbacks[i2].call(ret2, maybePromise._value(), holder);
                      } else if ((bitField & 16777216) !== 0) {
                        ret2._reject(maybePromise._reason());
                      } else {
                        ret2._cancel();
                      }
                    } else {
                      callbacks[i2].call(ret2, maybePromise, holder);
                    }
                  }
                  if (!ret2._isFateSealed()) {
                    if (holder.asyncNeeded) {
                      var context = Promise3._getContext();
                      holder.fn = util.contextBind(context, holder.fn);
                    }
                    ret2._setAsyncGuaranteed();
                    ret2._setOnCancel(holder);
                  }
                  return ret2;
                }
              }
            }
            var args = [].slice.call(arguments);
            ;
            if (fn)
              args.pop();
            var ret2 = new PromiseArray(args).promise();
            return fn !== void 0 ? ret2.spread(fn) : ret2;
          };
        };
      }, { "./util": 36 }], 18: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
          var util = _dereq_2("./util");
          var tryCatch2 = util.tryCatch;
          var errorObj2 = util.errorObj;
          var async = Promise3._async;
          function MappingPromiseArray(promises, fn, limit, _filter) {
            this.constructor$(promises);
            this._promise._captureStackTrace();
            var context = Promise3._getContext();
            this._callback = util.contextBind(context, fn);
            this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
            this._limit = limit;
            this._inFlight = 0;
            this._queue = [];
            async.invoke(this._asyncInit, this, void 0);
            if (util.isArray(promises)) {
              for (var i = 0; i < promises.length; ++i) {
                var maybePromise = promises[i];
                if (maybePromise instanceof Promise3) {
                  maybePromise.suppressUnhandledRejections();
                }
              }
            }
          }
          util.inherits(MappingPromiseArray, PromiseArray);
          MappingPromiseArray.prototype._asyncInit = function() {
            this._init$(void 0, -2);
          };
          MappingPromiseArray.prototype._init = function() {
          };
          MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
            var values = this._values;
            var length = this.length();
            var preservedValues = this._preservedValues;
            var limit = this._limit;
            if (index < 0) {
              index = index * -1 - 1;
              values[index] = value;
              if (limit >= 1) {
                this._inFlight--;
                this._drainQueue();
                if (this._isResolved())
                  return true;
              }
            } else {
              if (limit >= 1 && this._inFlight >= limit) {
                values[index] = value;
                this._queue.push(index);
                return false;
              }
              if (preservedValues !== null)
                preservedValues[index] = value;
              var promise = this._promise;
              var callback = this._callback;
              var receiver2 = promise._boundValue();
              promise._pushContext();
              var ret2 = tryCatch2(callback).call(receiver2, value, index, length);
              var promiseCreated = promise._popContext();
              debug.checkForgottenReturns(ret2, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
              if (ret2 === errorObj2) {
                this._reject(ret2.e);
                return true;
              }
              var maybePromise = tryConvertToPromise(ret2, this._promise);
              if (maybePromise instanceof Promise3) {
                maybePromise = maybePromise._target();
                var bitField = maybePromise._bitField;
                ;
                if ((bitField & 50397184) === 0) {
                  if (limit >= 1)
                    this._inFlight++;
                  values[index] = maybePromise;
                  maybePromise._proxy(this, (index + 1) * -1);
                  return false;
                } else if ((bitField & 33554432) !== 0) {
                  ret2 = maybePromise._value();
                } else if ((bitField & 16777216) !== 0) {
                  this._reject(maybePromise._reason());
                  return true;
                } else {
                  this._cancel();
                  return true;
                }
              }
              values[index] = ret2;
            }
            var totalResolved = ++this._totalResolved;
            if (totalResolved >= length) {
              if (preservedValues !== null) {
                this._filter(values, preservedValues);
              } else {
                this._resolve(values);
              }
              return true;
            }
            return false;
          };
          MappingPromiseArray.prototype._drainQueue = function() {
            var queue = this._queue;
            var limit = this._limit;
            var values = this._values;
            while (queue.length > 0 && this._inFlight < limit) {
              if (this._isResolved())
                return;
              var index = queue.pop();
              this._promiseFulfilled(values[index], index);
            }
          };
          MappingPromiseArray.prototype._filter = function(booleans, values) {
            var len = values.length;
            var ret2 = new Array(len);
            var j = 0;
            for (var i = 0; i < len; ++i) {
              if (booleans[i])
                ret2[j++] = values[i];
            }
            ret2.length = j;
            this._resolve(ret2);
          };
          MappingPromiseArray.prototype.preservedValues = function() {
            return this._preservedValues;
          };
          function map(promises, fn, options, _filter) {
            if (typeof fn !== "function") {
              return apiRejection("expecting a function but got " + util.classString(fn));
            }
            var limit = 0;
            if (options !== void 0) {
              if (typeof options === "object" && options !== null) {
                if (typeof options.concurrency !== "number") {
                  return Promise3.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                }
                limit = options.concurrency;
              } else {
                return Promise3.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
              }
            }
            limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
            return new MappingPromiseArray(promises, fn, limit, _filter).promise();
          }
          Promise3.prototype.map = function(fn, options) {
            return map(this, fn, options, null);
          };
          Promise3.map = function(promises, fn, options, _filter) {
            return map(promises, fn, options, _filter);
          };
        };
      }, { "./util": 36 }], 19: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL, tryConvertToPromise, apiRejection, debug) {
          var util = _dereq_2("./util");
          var tryCatch2 = util.tryCatch;
          Promise3.method = function(fn) {
            if (typeof fn !== "function") {
              throw new Promise3.TypeError("expecting a function but got " + util.classString(fn));
            }
            return function() {
              var ret2 = new Promise3(INTERNAL);
              ret2._captureStackTrace();
              ret2._pushContext();
              var value = tryCatch2(fn).apply(this, arguments);
              var promiseCreated = ret2._popContext();
              debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret2);
              ret2._resolveFromSyncValue(value);
              return ret2;
            };
          };
          Promise3.attempt = Promise3["try"] = function(fn) {
            if (typeof fn !== "function") {
              return apiRejection("expecting a function but got " + util.classString(fn));
            }
            var ret2 = new Promise3(INTERNAL);
            ret2._captureStackTrace();
            ret2._pushContext();
            var value;
            if (arguments.length > 1) {
              debug.deprecated("calling Promise.try with more than 1 argument");
              var arg = arguments[1];
              var ctx = arguments[2];
              value = util.isArray(arg) ? tryCatch2(fn).apply(ctx, arg) : tryCatch2(fn).call(ctx, arg);
            } else {
              value = tryCatch2(fn)();
            }
            var promiseCreated = ret2._popContext();
            debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret2);
            ret2._resolveFromSyncValue(value);
            return ret2;
          };
          Promise3.prototype._resolveFromSyncValue = function(value) {
            if (value === util.errorObj) {
              this._rejectCallback(value.e, false);
            } else {
              this._resolveCallback(value, true);
            }
          };
        };
      }, { "./util": 36 }], 20: [function(_dereq_2, module2, exports2) {
        "use strict";
        var util = _dereq_2("./util");
        var maybeWrapAsError2 = util.maybeWrapAsError;
        var errors = _dereq_2("./errors");
        var OperationalError = errors.OperationalError;
        var es52 = _dereq_2("./es5");
        function isUntypedError(obj2) {
          return obj2 instanceof Error && es52.getPrototypeOf(obj2) === Error.prototype;
        }
        var rErrorKey = /^(?:name|message|stack|cause)$/;
        function wrapAsOperationalError(obj2) {
          var ret2;
          if (isUntypedError(obj2)) {
            ret2 = new OperationalError(obj2);
            ret2.name = obj2.name;
            ret2.message = obj2.message;
            ret2.stack = obj2.stack;
            var keys = es52.keys(obj2);
            for (var i = 0; i < keys.length; ++i) {
              var key = keys[i];
              if (!rErrorKey.test(key)) {
                ret2[key] = obj2[key];
              }
            }
            return ret2;
          }
          util.markAsOriginatingFromRejection(obj2);
          return obj2;
        }
        function nodebackForPromise(promise, multiArgs) {
          return function(err, value) {
            if (promise === null)
              return;
            if (err) {
              var wrapped = wrapAsOperationalError(maybeWrapAsError2(err));
              promise._attachExtraTrace(wrapped);
              promise._reject(wrapped);
            } else if (!multiArgs) {
              promise._fulfill(value);
            } else {
              var args = [].slice.call(arguments, 1);
              ;
              promise._fulfill(args);
            }
            promise = null;
          };
        }
        module2.exports = nodebackForPromise;
      }, { "./errors": 12, "./es5": 13, "./util": 36 }], 21: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3) {
          var util = _dereq_2("./util");
          var async = Promise3._async;
          var tryCatch2 = util.tryCatch;
          var errorObj2 = util.errorObj;
          function spreadAdapter(val, nodeback) {
            var promise = this;
            if (!util.isArray(val))
              return successAdapter.call(promise, val, nodeback);
            var ret2 = tryCatch2(nodeback).apply(promise._boundValue(), [null].concat(val));
            if (ret2 === errorObj2) {
              async.throwLater(ret2.e);
            }
          }
          function successAdapter(val, nodeback) {
            var promise = this;
            var receiver2 = promise._boundValue();
            var ret2 = val === void 0 ? tryCatch2(nodeback).call(receiver2, null) : tryCatch2(nodeback).call(receiver2, null, val);
            if (ret2 === errorObj2) {
              async.throwLater(ret2.e);
            }
          }
          function errorAdapter(reason, nodeback) {
            var promise = this;
            if (!reason) {
              var newReason = new Error(reason + "");
              newReason.cause = reason;
              reason = newReason;
            }
            var ret2 = tryCatch2(nodeback).call(promise._boundValue(), reason);
            if (ret2 === errorObj2) {
              async.throwLater(ret2.e);
            }
          }
          Promise3.prototype.asCallback = Promise3.prototype.nodeify = function(nodeback, options) {
            if (typeof nodeback == "function") {
              var adapter = successAdapter;
              if (options !== void 0 && Object(options).spread) {
                adapter = spreadAdapter;
              }
              this._then(adapter, errorAdapter, void 0, this, nodeback);
            }
            return this;
          };
        };
      }, { "./util": 36 }], 22: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function() {
          var makeSelfResolutionError = function() {
            return new TypeError2("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
          };
          var reflectHandler2 = function() {
            return new Promise3.PromiseInspection(this._target());
          };
          var apiRejection = function(msg) {
            return Promise3.reject(new TypeError2(msg));
          };
          function Proxyable() {
          }
          var UNDEFINED_BINDING = {};
          var util = _dereq_2("./util");
          util.setReflectHandler(reflectHandler2);
          var getDomain = function() {
            var domain = process.domain;
            if (domain === void 0) {
              return null;
            }
            return domain;
          };
          var getContextDefault = function() {
            return null;
          };
          var getContextDomain = function() {
            return {
              domain: getDomain(),
              async: null
            };
          };
          var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_2("async_hooks").AsyncResource : null;
          var getContextAsyncHooks = function() {
            return {
              domain: getDomain(),
              async: new AsyncResource("Bluebird::Promise")
            };
          };
          var getContext = util.isNode ? getContextDomain : getContextDefault;
          util.notEnumerableProp(Promise3, "_getContext", getContext);
          var enableAsyncHooks = function() {
            getContext = getContextAsyncHooks;
            util.notEnumerableProp(Promise3, "_getContext", getContextAsyncHooks);
          };
          var disableAsyncHooks = function() {
            getContext = getContextDomain;
            util.notEnumerableProp(Promise3, "_getContext", getContextDomain);
          };
          var es52 = _dereq_2("./es5");
          var Async = _dereq_2("./async");
          var async = new Async();
          es52.defineProperty(Promise3, "_async", { value: async });
          var errors = _dereq_2("./errors");
          var TypeError2 = Promise3.TypeError = errors.TypeError;
          Promise3.RangeError = errors.RangeError;
          var CancellationError = Promise3.CancellationError = errors.CancellationError;
          Promise3.TimeoutError = errors.TimeoutError;
          Promise3.OperationalError = errors.OperationalError;
          Promise3.RejectionError = errors.OperationalError;
          Promise3.AggregateError = errors.AggregateError;
          var INTERNAL = function() {
          };
          var APPLY = {};
          var NEXT_FILTER = {};
          var tryConvertToPromise = _dereq_2("./thenables")(Promise3, INTERNAL);
          var PromiseArray = _dereq_2("./promise_array")(Promise3, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
          var Context = _dereq_2("./context")(Promise3);
          var createContext3 = Context.create;
          var debug = _dereq_2("./debuggability")(Promise3, Context, enableAsyncHooks, disableAsyncHooks);
          var CapturedTrace = debug.CapturedTrace;
          var PassThroughHandlerContext = _dereq_2("./finally")(Promise3, tryConvertToPromise, NEXT_FILTER);
          var catchFilter = _dereq_2("./catch_filter")(NEXT_FILTER);
          var nodebackForPromise = _dereq_2("./nodeback");
          var errorObj2 = util.errorObj;
          var tryCatch2 = util.tryCatch;
          function check2(self2, executor) {
            if (self2 == null || self2.constructor !== Promise3) {
              throw new TypeError2("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
            }
            if (typeof executor !== "function") {
              throw new TypeError2("expecting a function but got " + util.classString(executor));
            }
          }
          function Promise3(executor) {
            if (executor !== INTERNAL) {
              check2(this, executor);
            }
            this._bitField = 0;
            this._fulfillmentHandler0 = void 0;
            this._rejectionHandler0 = void 0;
            this._promise0 = void 0;
            this._receiver0 = void 0;
            this._resolveFromExecutor(executor);
            this._promiseCreated();
            this._fireEvent("promiseCreated", this);
          }
          Promise3.prototype.toString = function() {
            return "[object Promise]";
          };
          Promise3.prototype.caught = Promise3.prototype["catch"] = function(fn) {
            var len = arguments.length;
            if (len > 1) {
              var catchInstances = new Array(len - 1), j = 0, i;
              for (i = 0; i < len - 1; ++i) {
                var item = arguments[i];
                if (util.isObject(item)) {
                  catchInstances[j++] = item;
                } else {
                  return apiRejection("Catch statement predicate: expecting an object but got " + util.classString(item));
                }
              }
              catchInstances.length = j;
              fn = arguments[i];
              if (typeof fn !== "function") {
                throw new TypeError2("The last argument to .catch() must be a function, got " + util.toString(fn));
              }
              return this.then(void 0, catchFilter(catchInstances, fn, this));
            }
            return this.then(void 0, fn);
          };
          Promise3.prototype.reflect = function() {
            return this._then(reflectHandler2, reflectHandler2, void 0, this, void 0);
          };
          Promise3.prototype.then = function(didFulfill, didReject) {
            if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
              var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
              if (arguments.length > 1) {
                msg += ", " + util.classString(didReject);
              }
              this._warn(msg);
            }
            return this._then(didFulfill, didReject, void 0, void 0, void 0);
          };
          Promise3.prototype.done = function(didFulfill, didReject) {
            var promise = this._then(didFulfill, didReject, void 0, void 0, void 0);
            promise._setIsFinal();
          };
          Promise3.prototype.spread = function(fn) {
            if (typeof fn !== "function") {
              return apiRejection("expecting a function but got " + util.classString(fn));
            }
            return this.all()._then(fn, void 0, void 0, APPLY, void 0);
          };
          Promise3.prototype.toJSON = function() {
            var ret2 = {
              isFulfilled: false,
              isRejected: false,
              fulfillmentValue: void 0,
              rejectionReason: void 0
            };
            if (this.isFulfilled()) {
              ret2.fulfillmentValue = this.value();
              ret2.isFulfilled = true;
            } else if (this.isRejected()) {
              ret2.rejectionReason = this.reason();
              ret2.isRejected = true;
            }
            return ret2;
          };
          Promise3.prototype.all = function() {
            if (arguments.length > 0) {
              this._warn(".all() was passed arguments but it does not take any");
            }
            return new PromiseArray(this).promise();
          };
          Promise3.prototype.error = function(fn) {
            return this.caught(util.originatesFromRejection, fn);
          };
          Promise3.getNewLibraryCopy = module2.exports;
          Promise3.is = function(val) {
            return val instanceof Promise3;
          };
          Promise3.fromNode = Promise3.fromCallback = function(fn) {
            var ret2 = new Promise3(INTERNAL);
            ret2._captureStackTrace();
            var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
            var result2 = tryCatch2(fn)(nodebackForPromise(ret2, multiArgs));
            if (result2 === errorObj2) {
              ret2._rejectCallback(result2.e, true);
            }
            if (!ret2._isFateSealed())
              ret2._setAsyncGuaranteed();
            return ret2;
          };
          Promise3.all = function(promises) {
            return new PromiseArray(promises).promise();
          };
          Promise3.cast = function(obj2) {
            var ret2 = tryConvertToPromise(obj2);
            if (!(ret2 instanceof Promise3)) {
              ret2 = new Promise3(INTERNAL);
              ret2._captureStackTrace();
              ret2._setFulfilled();
              ret2._rejectionHandler0 = obj2;
            }
            return ret2;
          };
          Promise3.resolve = Promise3.fulfilled = Promise3.cast;
          Promise3.reject = Promise3.rejected = function(reason) {
            var ret2 = new Promise3(INTERNAL);
            ret2._captureStackTrace();
            ret2._rejectCallback(reason, true);
            return ret2;
          };
          Promise3.setScheduler = function(fn) {
            if (typeof fn !== "function") {
              throw new TypeError2("expecting a function but got " + util.classString(fn));
            }
            return async.setScheduler(fn);
          };
          Promise3.prototype._then = function(didFulfill, didReject, _, receiver2, internalData) {
            var haveInternalData = internalData !== void 0;
            var promise = haveInternalData ? internalData : new Promise3(INTERNAL);
            var target = this._target();
            var bitField = target._bitField;
            if (!haveInternalData) {
              promise._propagateFrom(this, 3);
              promise._captureStackTrace();
              if (receiver2 === void 0 && (this._bitField & 2097152) !== 0) {
                if (!((bitField & 50397184) === 0)) {
                  receiver2 = this._boundValue();
                } else {
                  receiver2 = target === this ? void 0 : this._boundTo;
                }
              }
              this._fireEvent("promiseChained", this, promise);
            }
            var context = getContext();
            if (!((bitField & 50397184) === 0)) {
              var handler, value, settler = target._settlePromiseCtx;
              if ((bitField & 33554432) !== 0) {
                value = target._rejectionHandler0;
                handler = didFulfill;
              } else if ((bitField & 16777216) !== 0) {
                value = target._fulfillmentHandler0;
                handler = didReject;
                target._unsetRejectionIsUnhandled();
              } else {
                settler = target._settlePromiseLateCancellationObserver;
                value = new CancellationError("late cancellation observer");
                target._attachExtraTrace(value);
                handler = didReject;
              }
              async.invoke(settler, target, {
                handler: util.contextBind(context, handler),
                promise,
                receiver: receiver2,
                value
              });
            } else {
              target._addCallbacks(didFulfill, didReject, promise, receiver2, context);
            }
            return promise;
          };
          Promise3.prototype._length = function() {
            return this._bitField & 65535;
          };
          Promise3.prototype._isFateSealed = function() {
            return (this._bitField & 117506048) !== 0;
          };
          Promise3.prototype._isFollowing = function() {
            return (this._bitField & 67108864) === 67108864;
          };
          Promise3.prototype._setLength = function(len) {
            this._bitField = this._bitField & -65536 | len & 65535;
          };
          Promise3.prototype._setFulfilled = function() {
            this._bitField = this._bitField | 33554432;
            this._fireEvent("promiseFulfilled", this);
          };
          Promise3.prototype._setRejected = function() {
            this._bitField = this._bitField | 16777216;
            this._fireEvent("promiseRejected", this);
          };
          Promise3.prototype._setFollowing = function() {
            this._bitField = this._bitField | 67108864;
            this._fireEvent("promiseResolved", this);
          };
          Promise3.prototype._setIsFinal = function() {
            this._bitField = this._bitField | 4194304;
          };
          Promise3.prototype._isFinal = function() {
            return (this._bitField & 4194304) > 0;
          };
          Promise3.prototype._unsetCancelled = function() {
            this._bitField = this._bitField & ~65536;
          };
          Promise3.prototype._setCancelled = function() {
            this._bitField = this._bitField | 65536;
            this._fireEvent("promiseCancelled", this);
          };
          Promise3.prototype._setWillBeCancelled = function() {
            this._bitField = this._bitField | 8388608;
          };
          Promise3.prototype._setAsyncGuaranteed = function() {
            if (async.hasCustomScheduler())
              return;
            var bitField = this._bitField;
            this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
          };
          Promise3.prototype._setNoAsyncGuarantee = function() {
            this._bitField = (this._bitField | 536870912) & ~134217728;
          };
          Promise3.prototype._receiverAt = function(index) {
            var ret2 = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
            if (ret2 === UNDEFINED_BINDING) {
              return void 0;
            } else if (ret2 === void 0 && this._isBound()) {
              return this._boundValue();
            }
            return ret2;
          };
          Promise3.prototype._promiseAt = function(index) {
            return this[index * 4 - 4 + 2];
          };
          Promise3.prototype._fulfillmentHandlerAt = function(index) {
            return this[index * 4 - 4 + 0];
          };
          Promise3.prototype._rejectionHandlerAt = function(index) {
            return this[index * 4 - 4 + 1];
          };
          Promise3.prototype._boundValue = function() {
          };
          Promise3.prototype._migrateCallback0 = function(follower) {
            var bitField = follower._bitField;
            var fulfill = follower._fulfillmentHandler0;
            var reject = follower._rejectionHandler0;
            var promise = follower._promise0;
            var receiver2 = follower._receiverAt(0);
            if (receiver2 === void 0)
              receiver2 = UNDEFINED_BINDING;
            this._addCallbacks(fulfill, reject, promise, receiver2, null);
          };
          Promise3.prototype._migrateCallbackAt = function(follower, index) {
            var fulfill = follower._fulfillmentHandlerAt(index);
            var reject = follower._rejectionHandlerAt(index);
            var promise = follower._promiseAt(index);
            var receiver2 = follower._receiverAt(index);
            if (receiver2 === void 0)
              receiver2 = UNDEFINED_BINDING;
            this._addCallbacks(fulfill, reject, promise, receiver2, null);
          };
          Promise3.prototype._addCallbacks = function(fulfill, reject, promise, receiver2, context) {
            var index = this._length();
            if (index >= 65535 - 4) {
              index = 0;
              this._setLength(0);
            }
            if (index === 0) {
              this._promise0 = promise;
              this._receiver0 = receiver2;
              if (typeof fulfill === "function") {
                this._fulfillmentHandler0 = util.contextBind(context, fulfill);
              }
              if (typeof reject === "function") {
                this._rejectionHandler0 = util.contextBind(context, reject);
              }
            } else {
              var base = index * 4 - 4;
              this[base + 2] = promise;
              this[base + 3] = receiver2;
              if (typeof fulfill === "function") {
                this[base + 0] = util.contextBind(context, fulfill);
              }
              if (typeof reject === "function") {
                this[base + 1] = util.contextBind(context, reject);
              }
            }
            this._setLength(index + 1);
            return index;
          };
          Promise3.prototype._proxy = function(proxyable, arg) {
            this._addCallbacks(void 0, void 0, arg, proxyable, null);
          };
          Promise3.prototype._resolveCallback = function(value, shouldBind) {
            if ((this._bitField & 117506048) !== 0)
              return;
            if (value === this)
              return this._rejectCallback(makeSelfResolutionError(), false);
            var maybePromise = tryConvertToPromise(value, this);
            if (!(maybePromise instanceof Promise3))
              return this._fulfill(value);
            if (shouldBind)
              this._propagateFrom(maybePromise, 2);
            var promise = maybePromise._target();
            if (promise === this) {
              this._reject(makeSelfResolutionError());
              return;
            }
            var bitField = promise._bitField;
            if ((bitField & 50397184) === 0) {
              var len = this._length();
              if (len > 0)
                promise._migrateCallback0(this);
              for (var i = 1; i < len; ++i) {
                promise._migrateCallbackAt(this, i);
              }
              this._setFollowing();
              this._setLength(0);
              this._setFollowee(maybePromise);
            } else if ((bitField & 33554432) !== 0) {
              this._fulfill(promise._value());
            } else if ((bitField & 16777216) !== 0) {
              this._reject(promise._reason());
            } else {
              var reason = new CancellationError("late cancellation observer");
              promise._attachExtraTrace(reason);
              this._reject(reason);
            }
          };
          Promise3.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
            var trace = util.ensureErrorObject(reason);
            var hasStack = trace === reason;
            if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
              var message = "a promise was rejected with a non-error: " + util.classString(reason);
              this._warn(message, true);
            }
            this._attachExtraTrace(trace, synchronous ? hasStack : false);
            this._reject(reason);
          };
          Promise3.prototype._resolveFromExecutor = function(executor) {
            if (executor === INTERNAL)
              return;
            var promise = this;
            this._captureStackTrace();
            this._pushContext();
            var synchronous = true;
            var r = this._execute(executor, function(value) {
              promise._resolveCallback(value);
            }, function(reason) {
              promise._rejectCallback(reason, synchronous);
            });
            synchronous = false;
            this._popContext();
            if (r !== void 0) {
              promise._rejectCallback(r, true);
            }
          };
          Promise3.prototype._settlePromiseFromHandler = function(handler, receiver2, value, promise) {
            var bitField = promise._bitField;
            if ((bitField & 65536) !== 0)
              return;
            promise._pushContext();
            var x;
            if (receiver2 === APPLY) {
              if (!value || typeof value.length !== "number") {
                x = errorObj2;
                x.e = new TypeError2("cannot .spread() a non-array: " + util.classString(value));
              } else {
                x = tryCatch2(handler).apply(this._boundValue(), value);
              }
            } else {
              x = tryCatch2(handler).call(receiver2, value);
            }
            var promiseCreated = promise._popContext();
            bitField = promise._bitField;
            if ((bitField & 65536) !== 0)
              return;
            if (x === NEXT_FILTER) {
              promise._reject(value);
            } else if (x === errorObj2) {
              promise._rejectCallback(x.e, false);
            } else {
              debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
              promise._resolveCallback(x);
            }
          };
          Promise3.prototype._target = function() {
            var ret2 = this;
            while (ret2._isFollowing())
              ret2 = ret2._followee();
            return ret2;
          };
          Promise3.prototype._followee = function() {
            return this._rejectionHandler0;
          };
          Promise3.prototype._setFollowee = function(promise) {
            this._rejectionHandler0 = promise;
          };
          Promise3.prototype._settlePromise = function(promise, handler, receiver2, value) {
            var isPromise = promise instanceof Promise3;
            var bitField = this._bitField;
            var asyncGuaranteed = (bitField & 134217728) !== 0;
            if ((bitField & 65536) !== 0) {
              if (isPromise)
                promise._invokeInternalOnCancel();
              if (receiver2 instanceof PassThroughHandlerContext && receiver2.isFinallyHandler()) {
                receiver2.cancelPromise = promise;
                if (tryCatch2(handler).call(receiver2, value) === errorObj2) {
                  promise._reject(errorObj2.e);
                }
              } else if (handler === reflectHandler2) {
                promise._fulfill(reflectHandler2.call(receiver2));
              } else if (receiver2 instanceof Proxyable) {
                receiver2._promiseCancelled(promise);
              } else if (isPromise || promise instanceof PromiseArray) {
                promise._cancel();
              } else {
                receiver2.cancel();
              }
            } else if (typeof handler === "function") {
              if (!isPromise) {
                handler.call(receiver2, value, promise);
              } else {
                if (asyncGuaranteed)
                  promise._setAsyncGuaranteed();
                this._settlePromiseFromHandler(handler, receiver2, value, promise);
              }
            } else if (receiver2 instanceof Proxyable) {
              if (!receiver2._isResolved()) {
                if ((bitField & 33554432) !== 0) {
                  receiver2._promiseFulfilled(value, promise);
                } else {
                  receiver2._promiseRejected(value, promise);
                }
              }
            } else if (isPromise) {
              if (asyncGuaranteed)
                promise._setAsyncGuaranteed();
              if ((bitField & 33554432) !== 0) {
                promise._fulfill(value);
              } else {
                promise._reject(value);
              }
            }
          };
          Promise3.prototype._settlePromiseLateCancellationObserver = function(ctx) {
            var handler = ctx.handler;
            var promise = ctx.promise;
            var receiver2 = ctx.receiver;
            var value = ctx.value;
            if (typeof handler === "function") {
              if (!(promise instanceof Promise3)) {
                handler.call(receiver2, value, promise);
              } else {
                this._settlePromiseFromHandler(handler, receiver2, value, promise);
              }
            } else if (promise instanceof Promise3) {
              promise._reject(value);
            }
          };
          Promise3.prototype._settlePromiseCtx = function(ctx) {
            this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
          };
          Promise3.prototype._settlePromise0 = function(handler, value, bitField) {
            var promise = this._promise0;
            var receiver2 = this._receiverAt(0);
            this._promise0 = void 0;
            this._receiver0 = void 0;
            this._settlePromise(promise, handler, receiver2, value);
          };
          Promise3.prototype._clearCallbackDataAtIndex = function(index) {
            var base = index * 4 - 4;
            this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = void 0;
          };
          Promise3.prototype._fulfill = function(value) {
            var bitField = this._bitField;
            if ((bitField & 117506048) >>> 16)
              return;
            if (value === this) {
              var err = makeSelfResolutionError();
              this._attachExtraTrace(err);
              return this._reject(err);
            }
            this._setFulfilled();
            this._rejectionHandler0 = value;
            if ((bitField & 65535) > 0) {
              if ((bitField & 134217728) !== 0) {
                this._settlePromises();
              } else {
                async.settlePromises(this);
              }
              this._dereferenceTrace();
            }
          };
          Promise3.prototype._reject = function(reason) {
            var bitField = this._bitField;
            if ((bitField & 117506048) >>> 16)
              return;
            this._setRejected();
            this._fulfillmentHandler0 = reason;
            if (this._isFinal()) {
              return async.fatalError(reason, util.isNode);
            }
            if ((bitField & 65535) > 0) {
              async.settlePromises(this);
            } else {
              this._ensurePossibleRejectionHandled();
            }
          };
          Promise3.prototype._fulfillPromises = function(len, value) {
            for (var i = 1; i < len; i++) {
              var handler = this._fulfillmentHandlerAt(i);
              var promise = this._promiseAt(i);
              var receiver2 = this._receiverAt(i);
              this._clearCallbackDataAtIndex(i);
              this._settlePromise(promise, handler, receiver2, value);
            }
          };
          Promise3.prototype._rejectPromises = function(len, reason) {
            for (var i = 1; i < len; i++) {
              var handler = this._rejectionHandlerAt(i);
              var promise = this._promiseAt(i);
              var receiver2 = this._receiverAt(i);
              this._clearCallbackDataAtIndex(i);
              this._settlePromise(promise, handler, receiver2, reason);
            }
          };
          Promise3.prototype._settlePromises = function() {
            var bitField = this._bitField;
            var len = bitField & 65535;
            if (len > 0) {
              if ((bitField & 16842752) !== 0) {
                var reason = this._fulfillmentHandler0;
                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                this._rejectPromises(len, reason);
              } else {
                var value = this._rejectionHandler0;
                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                this._fulfillPromises(len, value);
              }
              this._setLength(0);
            }
            this._clearCancellationData();
          };
          Promise3.prototype._settledValue = function() {
            var bitField = this._bitField;
            if ((bitField & 33554432) !== 0) {
              return this._rejectionHandler0;
            } else if ((bitField & 16777216) !== 0) {
              return this._fulfillmentHandler0;
            }
          };
          if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
            es52.defineProperty(Promise3.prototype, Symbol.toStringTag, {
              get: function() {
                return "Object";
              }
            });
          }
          function deferResolve(v) {
            this.promise._resolveCallback(v);
          }
          function deferReject(v) {
            this.promise._rejectCallback(v, false);
          }
          Promise3.defer = Promise3.pending = function() {
            debug.deprecated("Promise.defer", "new Promise");
            var promise = new Promise3(INTERNAL);
            return {
              promise,
              resolve: deferResolve,
              reject: deferReject
            };
          };
          util.notEnumerableProp(Promise3, "_makeSelfResolutionError", makeSelfResolutionError);
          _dereq_2("./method")(Promise3, INTERNAL, tryConvertToPromise, apiRejection, debug);
          _dereq_2("./bind")(Promise3, INTERNAL, tryConvertToPromise, debug);
          _dereq_2("./cancel")(Promise3, PromiseArray, apiRejection, debug);
          _dereq_2("./direct_resolve")(Promise3);
          _dereq_2("./synchronous_inspection")(Promise3);
          _dereq_2("./join")(Promise3, PromiseArray, tryConvertToPromise, INTERNAL, async);
          Promise3.Promise = Promise3;
          Promise3.version = "3.7.2";
          _dereq_2("./call_get.js")(Promise3);
          _dereq_2("./generators.js")(Promise3, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
          _dereq_2("./map.js")(Promise3, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
          _dereq_2("./nodeify.js")(Promise3);
          _dereq_2("./promisify.js")(Promise3, INTERNAL);
          _dereq_2("./props.js")(Promise3, PromiseArray, tryConvertToPromise, apiRejection);
          _dereq_2("./race.js")(Promise3, INTERNAL, tryConvertToPromise, apiRejection);
          _dereq_2("./reduce.js")(Promise3, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
          _dereq_2("./settle.js")(Promise3, PromiseArray, debug);
          _dereq_2("./some.js")(Promise3, PromiseArray, apiRejection);
          _dereq_2("./timers.js")(Promise3, INTERNAL, debug);
          _dereq_2("./using.js")(Promise3, apiRejection, tryConvertToPromise, createContext3, INTERNAL, debug);
          _dereq_2("./any.js")(Promise3);
          _dereq_2("./each.js")(Promise3, INTERNAL);
          _dereq_2("./filter.js")(Promise3, INTERNAL);
          util.toFastProperties(Promise3);
          util.toFastProperties(Promise3.prototype);
          function fillTypes(value) {
            var p = new Promise3(INTERNAL);
            p._fulfillmentHandler0 = value;
            p._rejectionHandler0 = value;
            p._promise0 = value;
            p._receiver0 = value;
          }
          fillTypes({ a: 1 });
          fillTypes({ b: 2 });
          fillTypes({ c: 3 });
          fillTypes(1);
          fillTypes(function() {
          });
          fillTypes(void 0);
          fillTypes(false);
          fillTypes(new Promise3(INTERNAL));
          debug.setBounds(Async.firstLineError, util.lastLineError);
          return Promise3;
        };
      }, { "./any.js": 1, "./async": 2, "./bind": 3, "./call_get.js": 5, "./cancel": 6, "./catch_filter": 7, "./context": 8, "./debuggability": 9, "./direct_resolve": 10, "./each.js": 11, "./errors": 12, "./es5": 13, "./filter.js": 14, "./finally": 15, "./generators.js": 16, "./join": 17, "./map.js": 18, "./method": 19, "./nodeback": 20, "./nodeify.js": 21, "./promise_array": 23, "./promisify.js": 24, "./props.js": 25, "./race.js": 27, "./reduce.js": 28, "./settle.js": 30, "./some.js": 31, "./synchronous_inspection": 32, "./thenables": 33, "./timers.js": 34, "./using.js": 35, "./util": 36, "async_hooks": void 0 }], 23: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
          var util = _dereq_2("./util");
          var isArray = util.isArray;
          function toResolutionValue(val) {
            switch (val) {
              case -2:
                return [];
              case -3:
                return {};
              case -6:
                return /* @__PURE__ */ new Map();
            }
          }
          function PromiseArray(values) {
            var promise = this._promise = new Promise3(INTERNAL);
            if (values instanceof Promise3) {
              promise._propagateFrom(values, 3);
              values.suppressUnhandledRejections();
            }
            promise._setOnCancel(this);
            this._values = values;
            this._length = 0;
            this._totalResolved = 0;
            this._init(void 0, -2);
          }
          util.inherits(PromiseArray, Proxyable);
          PromiseArray.prototype.length = function() {
            return this._length;
          };
          PromiseArray.prototype.promise = function() {
            return this._promise;
          };
          PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
            var values = tryConvertToPromise(this._values, this._promise);
            if (values instanceof Promise3) {
              values = values._target();
              var bitField = values._bitField;
              ;
              this._values = values;
              if ((bitField & 50397184) === 0) {
                this._promise._setAsyncGuaranteed();
                return values._then(init, this._reject, void 0, this, resolveValueIfEmpty);
              } else if ((bitField & 33554432) !== 0) {
                values = values._value();
              } else if ((bitField & 16777216) !== 0) {
                return this._reject(values._reason());
              } else {
                return this._cancel();
              }
            }
            values = util.asArray(values);
            if (values === null) {
              var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
              this._promise._rejectCallback(err, false);
              return;
            }
            if (values.length === 0) {
              if (resolveValueIfEmpty === -5) {
                this._resolveEmptyArray();
              } else {
                this._resolve(toResolutionValue(resolveValueIfEmpty));
              }
              return;
            }
            this._iterate(values);
          };
          PromiseArray.prototype._iterate = function(values) {
            var len = this.getActualLength(values.length);
            this._length = len;
            this._values = this.shouldCopyValues() ? new Array(len) : this._values;
            var result2 = this._promise;
            var isResolved = false;
            var bitField = null;
            for (var i = 0; i < len; ++i) {
              var maybePromise = tryConvertToPromise(values[i], result2);
              if (maybePromise instanceof Promise3) {
                maybePromise = maybePromise._target();
                bitField = maybePromise._bitField;
              } else {
                bitField = null;
              }
              if (isResolved) {
                if (bitField !== null) {
                  maybePromise.suppressUnhandledRejections();
                }
              } else if (bitField !== null) {
                if ((bitField & 50397184) === 0) {
                  maybePromise._proxy(this, i);
                  this._values[i] = maybePromise;
                } else if ((bitField & 33554432) !== 0) {
                  isResolved = this._promiseFulfilled(maybePromise._value(), i);
                } else if ((bitField & 16777216) !== 0) {
                  isResolved = this._promiseRejected(maybePromise._reason(), i);
                } else {
                  isResolved = this._promiseCancelled(i);
                }
              } else {
                isResolved = this._promiseFulfilled(maybePromise, i);
              }
            }
            if (!isResolved)
              result2._setAsyncGuaranteed();
          };
          PromiseArray.prototype._isResolved = function() {
            return this._values === null;
          };
          PromiseArray.prototype._resolve = function(value) {
            this._values = null;
            this._promise._fulfill(value);
          };
          PromiseArray.prototype._cancel = function() {
            if (this._isResolved() || !this._promise._isCancellable())
              return;
            this._values = null;
            this._promise._cancel();
          };
          PromiseArray.prototype._reject = function(reason) {
            this._values = null;
            this._promise._rejectCallback(reason, false);
          };
          PromiseArray.prototype._promiseFulfilled = function(value, index) {
            this._values[index] = value;
            var totalResolved = ++this._totalResolved;
            if (totalResolved >= this._length) {
              this._resolve(this._values);
              return true;
            }
            return false;
          };
          PromiseArray.prototype._promiseCancelled = function() {
            this._cancel();
            return true;
          };
          PromiseArray.prototype._promiseRejected = function(reason) {
            this._totalResolved++;
            this._reject(reason);
            return true;
          };
          PromiseArray.prototype._resultCancelled = function() {
            if (this._isResolved())
              return;
            var values = this._values;
            this._cancel();
            if (values instanceof Promise3) {
              values.cancel();
            } else {
              for (var i = 0; i < values.length; ++i) {
                if (values[i] instanceof Promise3) {
                  values[i].cancel();
                }
              }
            }
          };
          PromiseArray.prototype.shouldCopyValues = function() {
            return true;
          };
          PromiseArray.prototype.getActualLength = function(len) {
            return len;
          };
          return PromiseArray;
        };
      }, { "./util": 36 }], 24: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL) {
          var THIS = {};
          var util = _dereq_2("./util");
          var nodebackForPromise = _dereq_2("./nodeback");
          var withAppended2 = util.withAppended;
          var maybeWrapAsError2 = util.maybeWrapAsError;
          var canEvaluate2 = util.canEvaluate;
          var TypeError2 = _dereq_2("./errors").TypeError;
          var defaultSuffix = "Async";
          var defaultPromisified = { __isPromisified__: true };
          var noCopyProps = [
            "arity",
            "length",
            "name",
            "arguments",
            "caller",
            "callee",
            "prototype",
            "__isPromisified__"
          ];
          var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
          var defaultFilter = function(name) {
            return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
          };
          function propsFilter(key) {
            return !noCopyPropsPattern.test(key);
          }
          function isPromisified(fn) {
            try {
              return fn.__isPromisified__ === true;
            } catch (e) {
              return false;
            }
          }
          function hasPromisified(obj2, key, suffix) {
            var val = util.getDataPropertyOrDefault(obj2, key + suffix, defaultPromisified);
            return val ? isPromisified(val) : false;
          }
          function checkValid(ret2, suffix, suffixRegexp) {
            for (var i = 0; i < ret2.length; i += 2) {
              var key = ret2[i];
              if (suffixRegexp.test(key)) {
                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                for (var j = 0; j < ret2.length; j += 2) {
                  if (ret2[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError2("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
                  }
                }
              }
            }
          }
          function promisifiableMethods(obj2, suffix, suffixRegexp, filter) {
            var keys = util.inheritedDataKeys(obj2);
            var ret2 = [];
            for (var i = 0; i < keys.length; ++i) {
              var key = keys[i];
              var value = obj2[key];
              var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj2);
              if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj2, key, suffix) && filter(key, value, obj2, passesDefaultFilter)) {
                ret2.push(key, value);
              }
            }
            checkValid(ret2, suffix, suffixRegexp);
            return ret2;
          }
          var escapeIdentRegex = function(str) {
            return str.replace(/([$])/, "\\$");
          };
          var makeNodePromisifiedEval;
          if (false) {
            var switchCaseArgumentOrder = function(likelyArgumentCount) {
              var ret2 = [likelyArgumentCount];
              var min = Math.max(0, likelyArgumentCount - 1 - 3);
              for (var i = likelyArgumentCount - 1; i >= min; --i) {
                ret2.push(i);
              }
              for (var i = likelyArgumentCount + 1; i <= 3; ++i) {
                ret2.push(i);
              }
              return ret2;
            };
            var argumentSequence = function(argumentCount) {
              return util.filledRange(argumentCount, "_arg", "");
            };
            var parameterDeclaration = function(parameterCount2) {
              return util.filledRange(Math.max(parameterCount2, 3), "_arg", "");
            };
            var parameterCount = function(fn) {
              if (typeof fn.length === "number") {
                return Math.max(Math.min(fn.length, 1023 + 1), 0);
              }
              return 0;
            };
            makeNodePromisifiedEval = function(callback, receiver2, originalName, fn, _, multiArgs) {
              var newParameterCount = Math.max(0, parameterCount(fn) - 1);
              var argumentOrder = switchCaseArgumentOrder(newParameterCount);
              var shouldProxyThis = typeof callback === "string" || receiver2 === THIS;
              function generateCallForArgumentCount(count) {
                var args = argumentSequence(count).join(", ");
                var comma = count > 0 ? ", " : "";
                var ret2;
                if (shouldProxyThis) {
                  ret2 = "ret = callback.call(this, {{args}}, nodeback); break;\n";
                } else {
                  ret2 = receiver2 === void 0 ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
                }
                return ret2.replace("{{args}}", args).replace(", ", comma);
              }
              function generateArgumentSwitchCase() {
                var ret2 = "";
                for (var i = 0; i < argumentOrder.length; ++i) {
                  ret2 += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
                }
                ret2 += "                                                             \n        default:                                                             \n            var args = new Array(len + 1);                                   \n            var i = 0;                                                       \n            for (var i = 0; i < len; ++i) {                                  \n               args[i] = arguments[i];                                       \n            }                                                                \n            args[i] = nodeback;                                              \n            [CodeForCall]                                                    \n            break;                                                           \n        ".replace("[CodeForCall]", shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
                return ret2;
              }
              var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
              var body = "'use strict';                                                \n        var ret = function (Parameters) {                                    \n            'use strict';                                                    \n            var len = arguments.length;                                      \n            var promise = new Promise(INTERNAL);                             \n            promise._captureStackTrace();                                    \n            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n            var ret;                                                         \n            var callback = tryCatch([GetFunctionCode]);                      \n            switch(len) {                                                    \n                [CodeForSwitchCase]                                          \n            }                                                                \n            if (ret === errorObj) {                                          \n                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n            }                                                                \n            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n            return promise;                                                  \n        };                                                                   \n        notEnumerableProp(ret, '__isPromisified__', true);                   \n        return ret;                                                          \n    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase()).replace("[GetFunctionCode]", getFunctionCode);
              body = body.replace("Parameters", parameterDeclaration(newParameterCount));
              return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(Promise3, fn, receiver2, withAppended2, maybeWrapAsError2, nodebackForPromise, util.tryCatch, util.errorObj, util.notEnumerableProp, INTERNAL);
            };
          }
          function makeNodePromisifiedClosure(callback, receiver2, _, fn, __, multiArgs) {
            var defaultThis = function() {
              return this;
            }();
            var method = callback;
            if (typeof method === "string") {
              callback = fn;
            }
            function promisified() {
              var _receiver = receiver2;
              if (receiver2 === THIS)
                _receiver = this;
              var promise = new Promise3(INTERNAL);
              promise._captureStackTrace();
              var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
              var fn2 = nodebackForPromise(promise, multiArgs);
              try {
                cb.apply(_receiver, withAppended2(arguments, fn2));
              } catch (e) {
                promise._rejectCallback(maybeWrapAsError2(e), true, true);
              }
              if (!promise._isFateSealed())
                promise._setAsyncGuaranteed();
              return promise;
            }
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            return promisified;
          }
          var makeNodePromisified = canEvaluate2 ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
          function promisifyAll(obj2, suffix, filter, promisifier, multiArgs) {
            var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
            var methods = promisifiableMethods(obj2, suffix, suffixRegexp, filter);
            for (var i = 0, len = methods.length; i < len; i += 2) {
              var key = methods[i];
              var fn = methods[i + 1];
              var promisifiedKey = key + suffix;
              if (promisifier === makeNodePromisified) {
                obj2[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
              } else {
                var promisified = promisifier(fn, function() {
                  return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                });
                util.notEnumerableProp(promisified, "__isPromisified__", true);
                obj2[promisifiedKey] = promisified;
              }
            }
            util.toFastProperties(obj2);
            return obj2;
          }
          function promisify(callback, receiver2, multiArgs) {
            return makeNodePromisified(callback, receiver2, void 0, callback, null, multiArgs);
          }
          Promise3.promisify = function(fn, options) {
            if (typeof fn !== "function") {
              throw new TypeError2("expecting a function but got " + util.classString(fn));
            }
            if (isPromisified(fn)) {
              return fn;
            }
            options = Object(options);
            var receiver2 = options.context === void 0 ? THIS : options.context;
            var multiArgs = !!options.multiArgs;
            var ret2 = promisify(fn, receiver2, multiArgs);
            util.copyDescriptors(fn, ret2, propsFilter);
            return ret2;
          };
          Promise3.promisifyAll = function(target, options) {
            if (typeof target !== "function" && typeof target !== "object") {
              throw new TypeError2("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
            }
            options = Object(options);
            var multiArgs = !!options.multiArgs;
            var suffix = options.suffix;
            if (typeof suffix !== "string")
              suffix = defaultSuffix;
            var filter = options.filter;
            if (typeof filter !== "function")
              filter = defaultFilter;
            var promisifier = options.promisifier;
            if (typeof promisifier !== "function")
              promisifier = makeNodePromisified;
            if (!util.isIdentifier(suffix)) {
              throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
            }
            var keys = util.inheritedDataKeys(target);
            for (var i = 0; i < keys.length; ++i) {
              var value = target[keys[i]];
              if (keys[i] !== "constructor" && util.isClass(value)) {
                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                promisifyAll(value, suffix, filter, promisifier, multiArgs);
              }
            }
            return promisifyAll(target, suffix, filter, promisifier, multiArgs);
          };
        };
      }, { "./errors": 12, "./nodeback": 20, "./util": 36 }], 25: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, PromiseArray, tryConvertToPromise, apiRejection) {
          var util = _dereq_2("./util");
          var isObject4 = util.isObject;
          var es52 = _dereq_2("./es5");
          var Es6Map;
          if (typeof Map === "function")
            Es6Map = Map;
          var mapToEntries = function() {
            var index = 0;
            var size = 0;
            function extractEntry(value, key) {
              this[index] = value;
              this[index + size] = key;
              index++;
            }
            return function mapToEntries2(map) {
              size = map.size;
              index = 0;
              var ret2 = new Array(map.size * 2);
              map.forEach(extractEntry, ret2);
              return ret2;
            };
          }();
          var entriesToMap = function(entries) {
            var ret2 = new Es6Map();
            var length = entries.length / 2 | 0;
            for (var i = 0; i < length; ++i) {
              var key = entries[length + i];
              var value = entries[i];
              ret2.set(key, value);
            }
            return ret2;
          };
          function PropertiesPromiseArray(obj2) {
            var isMap = false;
            var entries;
            if (Es6Map !== void 0 && obj2 instanceof Es6Map) {
              entries = mapToEntries(obj2);
              isMap = true;
            } else {
              var keys = es52.keys(obj2);
              var len = keys.length;
              entries = new Array(len * 2);
              for (var i = 0; i < len; ++i) {
                var key = keys[i];
                entries[i] = obj2[key];
                entries[i + len] = key;
              }
            }
            this.constructor$(entries);
            this._isMap = isMap;
            this._init$(void 0, isMap ? -6 : -3);
          }
          util.inherits(PropertiesPromiseArray, PromiseArray);
          PropertiesPromiseArray.prototype._init = function() {
          };
          PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
            this._values[index] = value;
            var totalResolved = ++this._totalResolved;
            if (totalResolved >= this._length) {
              var val;
              if (this._isMap) {
                val = entriesToMap(this._values);
              } else {
                val = {};
                var keyOffset = this.length();
                for (var i = 0, len = this.length(); i < len; ++i) {
                  val[this._values[i + keyOffset]] = this._values[i];
                }
              }
              this._resolve(val);
              return true;
            }
            return false;
          };
          PropertiesPromiseArray.prototype.shouldCopyValues = function() {
            return false;
          };
          PropertiesPromiseArray.prototype.getActualLength = function(len) {
            return len >> 1;
          };
          function props(promises) {
            var ret2;
            var castValue = tryConvertToPromise(promises);
            if (!isObject4(castValue)) {
              return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
            } else if (castValue instanceof Promise3) {
              ret2 = castValue._then(Promise3.props, void 0, void 0, void 0, void 0);
            } else {
              ret2 = new PropertiesPromiseArray(castValue).promise();
            }
            if (castValue instanceof Promise3) {
              ret2._propagateFrom(castValue, 2);
            }
            return ret2;
          }
          Promise3.prototype.props = function() {
            return props(this);
          };
          Promise3.props = function(promises) {
            return props(promises);
          };
        };
      }, { "./es5": 13, "./util": 36 }], 26: [function(_dereq_2, module2, exports2) {
        "use strict";
        function arrayMove(src, srcIndex, dst, dstIndex, len) {
          for (var j = 0; j < len; ++j) {
            dst[j + dstIndex] = src[j + srcIndex];
            src[j + srcIndex] = void 0;
          }
        }
        function Queue(capacity) {
          this._capacity = capacity;
          this._length = 0;
          this._front = 0;
        }
        Queue.prototype._willBeOverCapacity = function(size) {
          return this._capacity < size;
        };
        Queue.prototype._pushOne = function(arg) {
          var length = this.length();
          this._checkCapacity(length + 1);
          var i = this._front + length & this._capacity - 1;
          this[i] = arg;
          this._length = length + 1;
        };
        Queue.prototype.push = function(fn, receiver2, arg) {
          var length = this.length() + 3;
          if (this._willBeOverCapacity(length)) {
            this._pushOne(fn);
            this._pushOne(receiver2);
            this._pushOne(arg);
            return;
          }
          var j = this._front + length - 3;
          this._checkCapacity(length);
          var wrapMask = this._capacity - 1;
          this[j + 0 & wrapMask] = fn;
          this[j + 1 & wrapMask] = receiver2;
          this[j + 2 & wrapMask] = arg;
          this._length = length;
        };
        Queue.prototype.shift = function() {
          var front = this._front, ret2 = this[front];
          this[front] = void 0;
          this._front = front + 1 & this._capacity - 1;
          this._length--;
          return ret2;
        };
        Queue.prototype.length = function() {
          return this._length;
        };
        Queue.prototype._checkCapacity = function(size) {
          if (this._capacity < size) {
            this._resizeTo(this._capacity << 1);
          }
        };
        Queue.prototype._resizeTo = function(capacity) {
          var oldCapacity = this._capacity;
          this._capacity = capacity;
          var front = this._front;
          var length = this._length;
          var moveItemsCount = front + length & oldCapacity - 1;
          arrayMove(this, 0, this, oldCapacity, moveItemsCount);
        };
        module2.exports = Queue;
      }, {}], 27: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL, tryConvertToPromise, apiRejection) {
          var util = _dereq_2("./util");
          var raceLater = function(promise) {
            return promise.then(function(array) {
              return race(array, promise);
            });
          };
          function race(promises, parent2) {
            var maybePromise = tryConvertToPromise(promises);
            if (maybePromise instanceof Promise3) {
              return raceLater(maybePromise);
            } else {
              promises = util.asArray(promises);
              if (promises === null)
                return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
            }
            var ret2 = new Promise3(INTERNAL);
            if (parent2 !== void 0) {
              ret2._propagateFrom(parent2, 3);
            }
            var fulfill = ret2._fulfill;
            var reject = ret2._reject;
            for (var i = 0, len = promises.length; i < len; ++i) {
              var val = promises[i];
              if (val === void 0 && !(i in promises)) {
                continue;
              }
              Promise3.cast(val)._then(fulfill, reject, void 0, ret2, null);
            }
            return ret2;
          }
          Promise3.race = function(promises) {
            return race(promises, void 0);
          };
          Promise3.prototype.race = function() {
            return race(this, void 0);
          };
        };
      }, { "./util": 36 }], 28: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
          var util = _dereq_2("./util");
          var tryCatch2 = util.tryCatch;
          function ReductionPromiseArray(promises, fn, initialValue, _each) {
            this.constructor$(promises);
            var context = Promise3._getContext();
            this._fn = util.contextBind(context, fn);
            if (initialValue !== void 0) {
              initialValue = Promise3.resolve(initialValue);
              initialValue._attachCancellationCallback(this);
            }
            this._initialValue = initialValue;
            this._currentCancellable = null;
            if (_each === INTERNAL) {
              this._eachValues = Array(this._length);
            } else if (_each === 0) {
              this._eachValues = null;
            } else {
              this._eachValues = void 0;
            }
            this._promise._captureStackTrace();
            this._init$(void 0, -5);
          }
          util.inherits(ReductionPromiseArray, PromiseArray);
          ReductionPromiseArray.prototype._gotAccum = function(accum) {
            if (this._eachValues !== void 0 && this._eachValues !== null && accum !== INTERNAL) {
              this._eachValues.push(accum);
            }
          };
          ReductionPromiseArray.prototype._eachComplete = function(value) {
            if (this._eachValues !== null) {
              this._eachValues.push(value);
            }
            return this._eachValues;
          };
          ReductionPromiseArray.prototype._init = function() {
          };
          ReductionPromiseArray.prototype._resolveEmptyArray = function() {
            this._resolve(this._eachValues !== void 0 ? this._eachValues : this._initialValue);
          };
          ReductionPromiseArray.prototype.shouldCopyValues = function() {
            return false;
          };
          ReductionPromiseArray.prototype._resolve = function(value) {
            this._promise._resolveCallback(value);
            this._values = null;
          };
          ReductionPromiseArray.prototype._resultCancelled = function(sender) {
            if (sender === this._initialValue)
              return this._cancel();
            if (this._isResolved())
              return;
            this._resultCancelled$();
            if (this._currentCancellable instanceof Promise3) {
              this._currentCancellable.cancel();
            }
            if (this._initialValue instanceof Promise3) {
              this._initialValue.cancel();
            }
          };
          ReductionPromiseArray.prototype._iterate = function(values) {
            this._values = values;
            var value;
            var i;
            var length = values.length;
            if (this._initialValue !== void 0) {
              value = this._initialValue;
              i = 0;
            } else {
              value = Promise3.resolve(values[0]);
              i = 1;
            }
            this._currentCancellable = value;
            for (var j = i; j < length; ++j) {
              var maybePromise = values[j];
              if (maybePromise instanceof Promise3) {
                maybePromise.suppressUnhandledRejections();
              }
            }
            if (!value.isRejected()) {
              for (; i < length; ++i) {
                var ctx = {
                  accum: null,
                  value: values[i],
                  index: i,
                  length,
                  array: this
                };
                value = value._then(gotAccum, void 0, void 0, ctx, void 0);
                if ((i & 127) === 0) {
                  value._setNoAsyncGuarantee();
                }
              }
            }
            if (this._eachValues !== void 0) {
              value = value._then(this._eachComplete, void 0, void 0, this, void 0);
            }
            value._then(completed, completed, void 0, value, this);
          };
          Promise3.prototype.reduce = function(fn, initialValue) {
            return reduce(this, fn, initialValue, null);
          };
          Promise3.reduce = function(promises, fn, initialValue, _each) {
            return reduce(promises, fn, initialValue, _each);
          };
          function completed(valueOrReason, array) {
            if (this.isFulfilled()) {
              array._resolve(valueOrReason);
            } else {
              array._reject(valueOrReason);
            }
          }
          function reduce(promises, fn, initialValue, _each) {
            if (typeof fn !== "function") {
              return apiRejection("expecting a function but got " + util.classString(fn));
            }
            var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
            return array.promise();
          }
          function gotAccum(accum) {
            this.accum = accum;
            this.array._gotAccum(accum);
            var value = tryConvertToPromise(this.value, this.array._promise);
            if (value instanceof Promise3) {
              this.array._currentCancellable = value;
              return value._then(gotValue, void 0, void 0, this, void 0);
            } else {
              return gotValue.call(this, value);
            }
          }
          function gotValue(value) {
            var array = this.array;
            var promise = array._promise;
            var fn = tryCatch2(array._fn);
            promise._pushContext();
            var ret2;
            if (array._eachValues !== void 0) {
              ret2 = fn.call(promise._boundValue(), value, this.index, this.length);
            } else {
              ret2 = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
            }
            if (ret2 instanceof Promise3) {
              array._currentCancellable = ret2;
            }
            var promiseCreated = promise._popContext();
            debug.checkForgottenReturns(ret2, promiseCreated, array._eachValues !== void 0 ? "Promise.each" : "Promise.reduce", promise);
            return ret2;
          }
        };
      }, { "./util": 36 }], 29: [function(_dereq_2, module2, exports2) {
        "use strict";
        var util = _dereq_2("./util");
        var schedule;
        var noAsyncScheduler = function() {
          throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
        };
        var NativePromise = util.getNativePromise();
        if (util.isNode && typeof MutationObserver === "undefined") {
          var GlobalSetImmediate = global.setImmediate;
          var ProcessNextTick = process.nextTick;
          schedule = util.isRecentNode ? function(fn) {
            GlobalSetImmediate.call(global, fn);
          } : function(fn) {
            ProcessNextTick.call(process, fn);
          };
        } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
          var nativePromise = NativePromise.resolve();
          schedule = function(fn) {
            nativePromise.then(fn);
          };
        } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) {
          schedule = function() {
            var div = document.createElement("div");
            var opts = { attributes: true };
            var toggleScheduled = false;
            var div2 = document.createElement("div");
            var o2 = new MutationObserver(function() {
              div.classList.toggle("foo");
              toggleScheduled = false;
            });
            o2.observe(div2, opts);
            var scheduleToggle = function() {
              if (toggleScheduled)
                return;
              toggleScheduled = true;
              div2.classList.toggle("foo");
            };
            return function schedule2(fn) {
              var o = new MutationObserver(function() {
                o.disconnect();
                fn();
              });
              o.observe(div, opts);
              scheduleToggle();
            };
          }();
        } else if (typeof setImmediate !== "undefined") {
          schedule = function(fn) {
            setImmediate(fn);
          };
        } else if (typeof setTimeout !== "undefined") {
          schedule = function(fn) {
            setTimeout(fn, 0);
          };
        } else {
          schedule = noAsyncScheduler;
        }
        module2.exports = schedule;
      }, { "./util": 36 }], 30: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, PromiseArray, debug) {
          var PromiseInspection = Promise3.PromiseInspection;
          var util = _dereq_2("./util");
          function SettledPromiseArray(values) {
            this.constructor$(values);
          }
          util.inherits(SettledPromiseArray, PromiseArray);
          SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
            this._values[index] = inspection;
            var totalResolved = ++this._totalResolved;
            if (totalResolved >= this._length) {
              this._resolve(this._values);
              return true;
            }
            return false;
          };
          SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
            var ret2 = new PromiseInspection();
            ret2._bitField = 33554432;
            ret2._settledValueField = value;
            return this._promiseResolved(index, ret2);
          };
          SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
            var ret2 = new PromiseInspection();
            ret2._bitField = 16777216;
            ret2._settledValueField = reason;
            return this._promiseResolved(index, ret2);
          };
          Promise3.settle = function(promises) {
            debug.deprecated(".settle()", ".reflect()");
            return new SettledPromiseArray(promises).promise();
          };
          Promise3.allSettled = function(promises) {
            return new SettledPromiseArray(promises).promise();
          };
          Promise3.prototype.settle = function() {
            return Promise3.settle(this);
          };
        };
      }, { "./util": 36 }], 31: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, PromiseArray, apiRejection) {
          var util = _dereq_2("./util");
          var RangeError2 = _dereq_2("./errors").RangeError;
          var AggregateError = _dereq_2("./errors").AggregateError;
          var isArray = util.isArray;
          var CANCELLATION = {};
          function SomePromiseArray(values) {
            this.constructor$(values);
            this._howMany = 0;
            this._unwrap = false;
            this._initialized = false;
          }
          util.inherits(SomePromiseArray, PromiseArray);
          SomePromiseArray.prototype._init = function() {
            if (!this._initialized) {
              return;
            }
            if (this._howMany === 0) {
              this._resolve([]);
              return;
            }
            this._init$(void 0, -5);
            var isArrayResolved = isArray(this._values);
            if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) {
              this._reject(this._getRangeError(this.length()));
            }
          };
          SomePromiseArray.prototype.init = function() {
            this._initialized = true;
            this._init();
          };
          SomePromiseArray.prototype.setUnwrap = function() {
            this._unwrap = true;
          };
          SomePromiseArray.prototype.howMany = function() {
            return this._howMany;
          };
          SomePromiseArray.prototype.setHowMany = function(count) {
            this._howMany = count;
          };
          SomePromiseArray.prototype._promiseFulfilled = function(value) {
            this._addFulfilled(value);
            if (this._fulfilled() === this.howMany()) {
              this._values.length = this.howMany();
              if (this.howMany() === 1 && this._unwrap) {
                this._resolve(this._values[0]);
              } else {
                this._resolve(this._values);
              }
              return true;
            }
            return false;
          };
          SomePromiseArray.prototype._promiseRejected = function(reason) {
            this._addRejected(reason);
            return this._checkOutcome();
          };
          SomePromiseArray.prototype._promiseCancelled = function() {
            if (this._values instanceof Promise3 || this._values == null) {
              return this._cancel();
            }
            this._addRejected(CANCELLATION);
            return this._checkOutcome();
          };
          SomePromiseArray.prototype._checkOutcome = function() {
            if (this.howMany() > this._canPossiblyFulfill()) {
              var e = new AggregateError();
              for (var i = this.length(); i < this._values.length; ++i) {
                if (this._values[i] !== CANCELLATION) {
                  e.push(this._values[i]);
                }
              }
              if (e.length > 0) {
                this._reject(e);
              } else {
                this._cancel();
              }
              return true;
            }
            return false;
          };
          SomePromiseArray.prototype._fulfilled = function() {
            return this._totalResolved;
          };
          SomePromiseArray.prototype._rejected = function() {
            return this._values.length - this.length();
          };
          SomePromiseArray.prototype._addRejected = function(reason) {
            this._values.push(reason);
          };
          SomePromiseArray.prototype._addFulfilled = function(value) {
            this._values[this._totalResolved++] = value;
          };
          SomePromiseArray.prototype._canPossiblyFulfill = function() {
            return this.length() - this._rejected();
          };
          SomePromiseArray.prototype._getRangeError = function(count) {
            var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
            return new RangeError2(message);
          };
          SomePromiseArray.prototype._resolveEmptyArray = function() {
            this._reject(this._getRangeError(0));
          };
          function some(promises, howMany) {
            if ((howMany | 0) !== howMany || howMany < 0) {
              return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
            }
            var ret2 = new SomePromiseArray(promises);
            var promise = ret2.promise();
            ret2.setHowMany(howMany);
            ret2.init();
            return promise;
          }
          Promise3.some = function(promises, howMany) {
            return some(promises, howMany);
          };
          Promise3.prototype.some = function(howMany) {
            return some(this, howMany);
          };
          Promise3._SomePromiseArray = SomePromiseArray;
        };
      }, { "./errors": 12, "./util": 36 }], 32: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3) {
          function PromiseInspection(promise) {
            if (promise !== void 0) {
              promise = promise._target();
              this._bitField = promise._bitField;
              this._settledValueField = promise._isFateSealed() ? promise._settledValue() : void 0;
            } else {
              this._bitField = 0;
              this._settledValueField = void 0;
            }
          }
          PromiseInspection.prototype._settledValue = function() {
            return this._settledValueField;
          };
          var value = PromiseInspection.prototype.value = function() {
            if (!this.isFulfilled()) {
              throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
            }
            return this._settledValue();
          };
          var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
            if (!this.isRejected()) {
              throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
            }
            return this._settledValue();
          };
          var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
            return (this._bitField & 33554432) !== 0;
          };
          var isRejected = PromiseInspection.prototype.isRejected = function() {
            return (this._bitField & 16777216) !== 0;
          };
          var isPending = PromiseInspection.prototype.isPending = function() {
            return (this._bitField & 50397184) === 0;
          };
          var isResolved = PromiseInspection.prototype.isResolved = function() {
            return (this._bitField & 50331648) !== 0;
          };
          PromiseInspection.prototype.isCancelled = function() {
            return (this._bitField & 8454144) !== 0;
          };
          Promise3.prototype.__isCancelled = function() {
            return (this._bitField & 65536) === 65536;
          };
          Promise3.prototype._isCancelled = function() {
            return this._target().__isCancelled();
          };
          Promise3.prototype.isCancelled = function() {
            return (this._target()._bitField & 8454144) !== 0;
          };
          Promise3.prototype.isPending = function() {
            return isPending.call(this._target());
          };
          Promise3.prototype.isRejected = function() {
            return isRejected.call(this._target());
          };
          Promise3.prototype.isFulfilled = function() {
            return isFulfilled.call(this._target());
          };
          Promise3.prototype.isResolved = function() {
            return isResolved.call(this._target());
          };
          Promise3.prototype.value = function() {
            return value.call(this._target());
          };
          Promise3.prototype.reason = function() {
            var target = this._target();
            target._unsetRejectionIsUnhandled();
            return reason.call(target);
          };
          Promise3.prototype._value = function() {
            return this._settledValue();
          };
          Promise3.prototype._reason = function() {
            this._unsetRejectionIsUnhandled();
            return this._settledValue();
          };
          Promise3.PromiseInspection = PromiseInspection;
        };
      }, {}], 33: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL) {
          var util = _dereq_2("./util");
          var errorObj2 = util.errorObj;
          var isObject4 = util.isObject;
          function tryConvertToPromise(obj2, context) {
            if (isObject4(obj2)) {
              if (obj2 instanceof Promise3)
                return obj2;
              var then = getThen(obj2);
              if (then === errorObj2) {
                if (context)
                  context._pushContext();
                var ret2 = Promise3.reject(then.e);
                if (context)
                  context._popContext();
                return ret2;
              } else if (typeof then === "function") {
                if (isAnyBluebirdPromise(obj2)) {
                  var ret2 = new Promise3(INTERNAL);
                  obj2._then(ret2._fulfill, ret2._reject, void 0, ret2, null);
                  return ret2;
                }
                return doThenable(obj2, then, context);
              }
            }
            return obj2;
          }
          function doGetThen(obj2) {
            return obj2.then;
          }
          function getThen(obj2) {
            try {
              return doGetThen(obj2);
            } catch (e) {
              errorObj2.e = e;
              return errorObj2;
            }
          }
          var hasProp = {}.hasOwnProperty;
          function isAnyBluebirdPromise(obj2) {
            try {
              return hasProp.call(obj2, "_promise0");
            } catch (e) {
              return false;
            }
          }
          function doThenable(x, then, context) {
            var promise = new Promise3(INTERNAL);
            var ret2 = promise;
            if (context)
              context._pushContext();
            promise._captureStackTrace();
            if (context)
              context._popContext();
            var synchronous = true;
            var result2 = util.tryCatch(then).call(x, resolve, reject);
            synchronous = false;
            if (promise && result2 === errorObj2) {
              promise._rejectCallback(result2.e, true, true);
              promise = null;
            }
            function resolve(value) {
              if (!promise)
                return;
              promise._resolveCallback(value);
              promise = null;
            }
            function reject(reason) {
              if (!promise)
                return;
              promise._rejectCallback(reason, synchronous, true);
              promise = null;
            }
            return ret2;
          }
          return tryConvertToPromise;
        };
      }, { "./util": 36 }], 34: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, INTERNAL, debug) {
          var util = _dereq_2("./util");
          var TimeoutError3 = Promise3.TimeoutError;
          function HandleWrapper(handle) {
            this.handle = handle;
          }
          HandleWrapper.prototype._resultCancelled = function() {
            clearTimeout(this.handle);
          };
          var afterValue = function(value) {
            return delay(+this).thenReturn(value);
          };
          var delay = Promise3.delay = function(ms, value) {
            var ret2;
            var handle;
            if (value !== void 0) {
              ret2 = Promise3.resolve(value)._then(afterValue, null, null, ms, void 0);
              if (debug.cancellation() && value instanceof Promise3) {
                ret2._setOnCancel(value);
              }
            } else {
              ret2 = new Promise3(INTERNAL);
              handle = setTimeout(function() {
                ret2._fulfill();
              }, +ms);
              if (debug.cancellation()) {
                ret2._setOnCancel(new HandleWrapper(handle));
              }
              ret2._captureStackTrace();
            }
            ret2._setAsyncGuaranteed();
            return ret2;
          };
          Promise3.prototype.delay = function(ms) {
            return delay(ms, this);
          };
          var afterTimeout = function(promise, message, parent2) {
            var err;
            if (typeof message !== "string") {
              if (message instanceof Error) {
                err = message;
              } else {
                err = new TimeoutError3("operation timed out");
              }
            } else {
              err = new TimeoutError3(message);
            }
            util.markAsOriginatingFromRejection(err);
            promise._attachExtraTrace(err);
            promise._reject(err);
            if (parent2 != null) {
              parent2.cancel();
            }
          };
          function successClear(value) {
            clearTimeout(this.handle);
            return value;
          }
          function failureClear(reason) {
            clearTimeout(this.handle);
            throw reason;
          }
          Promise3.prototype.timeout = function(ms, message) {
            ms = +ms;
            var ret2, parent2;
            var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
              if (ret2.isPending()) {
                afterTimeout(ret2, message, parent2);
              }
            }, ms));
            if (debug.cancellation()) {
              parent2 = this.then();
              ret2 = parent2._then(successClear, failureClear, void 0, handleWrapper, void 0);
              ret2._setOnCancel(handleWrapper);
            } else {
              ret2 = this._then(successClear, failureClear, void 0, handleWrapper, void 0);
            }
            return ret2;
          };
        };
      }, { "./util": 36 }], 35: [function(_dereq_2, module2, exports2) {
        "use strict";
        module2.exports = function(Promise3, apiRejection, tryConvertToPromise, createContext3, INTERNAL, debug) {
          var util = _dereq_2("./util");
          var TypeError2 = _dereq_2("./errors").TypeError;
          var inherits2 = _dereq_2("./util").inherits;
          var errorObj2 = util.errorObj;
          var tryCatch2 = util.tryCatch;
          var NULL = {};
          function thrower2(e) {
            setTimeout(function() {
              throw e;
            }, 0);
          }
          function castPreservingDisposable(thenable) {
            var maybePromise = tryConvertToPromise(thenable);
            if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) {
              maybePromise._setDisposable(thenable._getDisposer());
            }
            return maybePromise;
          }
          function dispose(resources, inspection) {
            var i = 0;
            var len = resources.length;
            var ret2 = new Promise3(INTERNAL);
            function iterator() {
              if (i >= len)
                return ret2._fulfill();
              var maybePromise = castPreservingDisposable(resources[i++]);
              if (maybePromise instanceof Promise3 && maybePromise._isDisposable()) {
                try {
                  maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                } catch (e) {
                  return thrower2(e);
                }
                if (maybePromise instanceof Promise3) {
                  return maybePromise._then(iterator, thrower2, null, null, null);
                }
              }
              iterator();
            }
            iterator();
            return ret2;
          }
          function Disposer(data, promise, context) {
            this._data = data;
            this._promise = promise;
            this._context = context;
          }
          Disposer.prototype.data = function() {
            return this._data;
          };
          Disposer.prototype.promise = function() {
            return this._promise;
          };
          Disposer.prototype.resource = function() {
            if (this.promise().isFulfilled()) {
              return this.promise().value();
            }
            return NULL;
          };
          Disposer.prototype.tryDispose = function(inspection) {
            var resource = this.resource();
            var context = this._context;
            if (context !== void 0)
              context._pushContext();
            var ret2 = resource !== NULL ? this.doDispose(resource, inspection) : null;
            if (context !== void 0)
              context._popContext();
            this._promise._unsetDisposable();
            this._data = null;
            return ret2;
          };
          Disposer.isDisposer = function(d) {
            return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
          };
          function FunctionDisposer(fn, promise, context) {
            this.constructor$(fn, promise, context);
          }
          inherits2(FunctionDisposer, Disposer);
          FunctionDisposer.prototype.doDispose = function(resource, inspection) {
            var fn = this.data();
            return fn.call(resource, resource, inspection);
          };
          function maybeUnwrapDisposer(value) {
            if (Disposer.isDisposer(value)) {
              this.resources[this.index]._setDisposable(value);
              return value.promise();
            }
            return value;
          }
          function ResourceList(length) {
            this.length = length;
            this.promise = null;
            this[length - 1] = null;
          }
          ResourceList.prototype._resultCancelled = function() {
            var len = this.length;
            for (var i = 0; i < len; ++i) {
              var item = this[i];
              if (item instanceof Promise3) {
                item.cancel();
              }
            }
          };
          Promise3.using = function() {
            var len = arguments.length;
            if (len < 2)
              return apiRejection("you must pass at least 2 arguments to Promise.using");
            var fn = arguments[len - 1];
            if (typeof fn !== "function") {
              return apiRejection("expecting a function but got " + util.classString(fn));
            }
            var input;
            var spreadArgs = true;
            if (len === 2 && Array.isArray(arguments[0])) {
              input = arguments[0];
              len = input.length;
              spreadArgs = false;
            } else {
              input = arguments;
              len--;
            }
            var resources = new ResourceList(len);
            for (var i = 0; i < len; ++i) {
              var resource = input[i];
              if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
              } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise3) {
                  resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                    resources,
                    index: i
                  }, void 0);
                }
              }
              resources[i] = resource;
            }
            var reflectedResources = new Array(resources.length);
            for (var i = 0; i < reflectedResources.length; ++i) {
              reflectedResources[i] = Promise3.resolve(resources[i]).reflect();
            }
            var resultPromise = Promise3.all(reflectedResources).then(function(inspections) {
              for (var i2 = 0; i2 < inspections.length; ++i2) {
                var inspection = inspections[i2];
                if (inspection.isRejected()) {
                  errorObj2.e = inspection.error();
                  return errorObj2;
                } else if (!inspection.isFulfilled()) {
                  resultPromise.cancel();
                  return;
                }
                inspections[i2] = inspection.value();
              }
              promise._pushContext();
              fn = tryCatch2(fn);
              var ret2 = spreadArgs ? fn.apply(void 0, inspections) : fn(inspections);
              var promiseCreated = promise._popContext();
              debug.checkForgottenReturns(ret2, promiseCreated, "Promise.using", promise);
              return ret2;
            });
            var promise = resultPromise.lastly(function() {
              var inspection = new Promise3.PromiseInspection(resultPromise);
              return dispose(resources, inspection);
            });
            resources.promise = promise;
            promise._setOnCancel(resources);
            return promise;
          };
          Promise3.prototype._setDisposable = function(disposer) {
            this._bitField = this._bitField | 131072;
            this._disposer = disposer;
          };
          Promise3.prototype._isDisposable = function() {
            return (this._bitField & 131072) > 0;
          };
          Promise3.prototype._getDisposer = function() {
            return this._disposer;
          };
          Promise3.prototype._unsetDisposable = function() {
            this._bitField = this._bitField & ~131072;
            this._disposer = void 0;
          };
          Promise3.prototype.disposer = function(fn) {
            if (typeof fn === "function") {
              return new FunctionDisposer(fn, this, createContext3());
            }
            throw new TypeError2();
          };
        };
      }, { "./errors": 12, "./util": 36 }], 36: [function(_dereq_, module, exports) {
        "use strict";
        var es5 = _dereq_("./es5");
        var canEvaluate = typeof navigator == "undefined";
        var errorObj = { e: {} };
        var tryCatchTarget;
        var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : this !== void 0 ? this : null;
        function tryCatcher() {
          try {
            var target = tryCatchTarget;
            tryCatchTarget = null;
            return target.apply(this, arguments);
          } catch (e) {
            errorObj.e = e;
            return errorObj;
          }
        }
        function tryCatch(fn) {
          tryCatchTarget = fn;
          return tryCatcher;
        }
        var inherits = function(Child, Parent) {
          var hasProp = {}.hasOwnProperty;
          function T() {
            this.constructor = Child;
            this.constructor$ = Parent;
            for (var propertyName in Parent.prototype) {
              if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") {
                this[propertyName + "$"] = Parent.prototype[propertyName];
              }
            }
          }
          T.prototype = Parent.prototype;
          Child.prototype = new T();
          return Child.prototype;
        };
        function isPrimitive(val) {
          return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
        }
        function isObject(value) {
          return typeof value === "function" || typeof value === "object" && value !== null;
        }
        function maybeWrapAsError(maybeError) {
          if (!isPrimitive(maybeError))
            return maybeError;
          return new Error(safeToString(maybeError));
        }
        function withAppended(target, appendee) {
          var len = target.length;
          var ret2 = new Array(len + 1);
          var i;
          for (i = 0; i < len; ++i) {
            ret2[i] = target[i];
          }
          ret2[i] = appendee;
          return ret2;
        }
        function getDataPropertyOrDefault(obj2, key, defaultValue) {
          if (es5.isES5) {
            var desc = Object.getOwnPropertyDescriptor(obj2, key);
            if (desc != null) {
              return desc.get == null && desc.set == null ? desc.value : defaultValue;
            }
          } else {
            return {}.hasOwnProperty.call(obj2, key) ? obj2[key] : void 0;
          }
        }
        function notEnumerableProp(obj2, name, value) {
          if (isPrimitive(obj2))
            return obj2;
          var descriptor = {
            value,
            configurable: true,
            enumerable: false,
            writable: true
          };
          es5.defineProperty(obj2, name, descriptor);
          return obj2;
        }
        function thrower(r) {
          throw r;
        }
        var inheritedDataKeys = function() {
          var excludedPrototypes = [
            Array.prototype,
            Object.prototype,
            Function.prototype
          ];
          var isExcludedProto = function(val) {
            for (var i = 0; i < excludedPrototypes.length; ++i) {
              if (excludedPrototypes[i] === val) {
                return true;
              }
            }
            return false;
          };
          if (es5.isES5) {
            var getKeys = Object.getOwnPropertyNames;
            return function(obj2) {
              var ret2 = [];
              var visitedKeys = /* @__PURE__ */ Object.create(null);
              while (obj2 != null && !isExcludedProto(obj2)) {
                var keys;
                try {
                  keys = getKeys(obj2);
                } catch (e) {
                  return ret2;
                }
                for (var i = 0; i < keys.length; ++i) {
                  var key = keys[i];
                  if (visitedKeys[key])
                    continue;
                  visitedKeys[key] = true;
                  var desc = Object.getOwnPropertyDescriptor(obj2, key);
                  if (desc != null && desc.get == null && desc.set == null) {
                    ret2.push(key);
                  }
                }
                obj2 = es5.getPrototypeOf(obj2);
              }
              return ret2;
            };
          } else {
            var hasProp = {}.hasOwnProperty;
            return function(obj2) {
              if (isExcludedProto(obj2))
                return [];
              var ret2 = [];
              enumeration:
                for (var key in obj2) {
                  if (hasProp.call(obj2, key)) {
                    ret2.push(key);
                  } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                      if (hasProp.call(excludedPrototypes[i], key)) {
                        continue enumeration;
                      }
                    }
                    ret2.push(key);
                  }
                }
              return ret2;
            };
          }
        }();
        var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
        function isClass(fn) {
          try {
            if (typeof fn === "function") {
              var keys = es5.names(fn.prototype);
              var hasMethods = es5.isES5 && keys.length > 1;
              var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
              var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
              if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) {
                return true;
              }
            }
            return false;
          } catch (e) {
            return false;
          }
        }
        function toFastProperties(obj) {
          function FakeConstructor() {
          }
          FakeConstructor.prototype = obj;
          var receiver = new FakeConstructor();
          function ic() {
            return typeof receiver.foo;
          }
          ic();
          ic();
          return obj;
          eval(obj);
        }
        var rident = /^[a-z$_][a-z$_0-9]*$/i;
        function isIdentifier(str) {
          return rident.test(str);
        }
        function filledRange(count, prefix, suffix) {
          var ret2 = new Array(count);
          for (var i = 0; i < count; ++i) {
            ret2[i] = prefix + i + suffix;
          }
          return ret2;
        }
        function safeToString(obj2) {
          try {
            return obj2 + "";
          } catch (e) {
            return "[no string representation]";
          }
        }
        function isError(obj2) {
          return obj2 instanceof Error || obj2 !== null && typeof obj2 === "object" && typeof obj2.message === "string" && typeof obj2.name === "string";
        }
        function markAsOriginatingFromRejection(e) {
          try {
            notEnumerableProp(e, "isOperational", true);
          } catch (ignore) {
          }
        }
        function originatesFromRejection(e) {
          if (e == null)
            return false;
          return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
        }
        function canAttachTrace(obj2) {
          return isError(obj2) && es5.propertyIsWritable(obj2, "stack");
        }
        var ensureErrorObject = function() {
          if (!("stack" in new Error())) {
            return function(value) {
              if (canAttachTrace(value))
                return value;
              try {
                throw new Error(safeToString(value));
              } catch (err) {
                return err;
              }
            };
          } else {
            return function(value) {
              if (canAttachTrace(value))
                return value;
              return new Error(safeToString(value));
            };
          }
        }();
        function classString(obj2) {
          return {}.toString.call(obj2);
        }
        function copyDescriptors(from2, to, filter) {
          var keys = es5.names(from2);
          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (filter(key)) {
              try {
                es5.defineProperty(to, key, es5.getDescriptor(from2, key));
              } catch (ignore) {
              }
            }
          }
        }
        var asArray = function(v) {
          if (es5.isArray(v)) {
            return v;
          }
          return null;
        };
        if (typeof Symbol !== "undefined" && Symbol.iterator) {
          var ArrayFrom = typeof Array.from === "function" ? function(v) {
            return Array.from(v);
          } : function(v) {
            var ret2 = [];
            var it = v[Symbol.iterator]();
            var itResult;
            while (!(itResult = it.next()).done) {
              ret2.push(itResult.value);
            }
            return ret2;
          };
          asArray = function(v) {
            if (es5.isArray(v)) {
              return v;
            } else if (v != null && typeof v[Symbol.iterator] === "function") {
              return ArrayFrom(v);
            }
            return null;
          };
        }
        var isNode = typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]";
        var hasEnvVariables = typeof process !== "undefined" && typeof process.env !== "undefined";
        function env(key) {
          return hasEnvVariables ? process.env[key] : void 0;
        }
        function getNativePromise() {
          if (typeof Promise === "function") {
            try {
              var promise = new Promise(function() {
              });
              if (classString(promise) === "[object Promise]") {
                return Promise;
              }
            } catch (e) {
            }
          }
        }
        var reflectHandler;
        function contextBind(ctx, cb) {
          if (ctx === null || typeof cb !== "function" || cb === reflectHandler) {
            return cb;
          }
          if (ctx.domain !== null) {
            cb = ctx.domain.bind(cb);
          }
          var async = ctx.async;
          if (async !== null) {
            var old = cb;
            cb = function() {
              var args = new Array(2).concat([].slice.call(arguments));
              ;
              args[0] = old;
              args[1] = this;
              return async.runInAsyncScope.apply(async, args);
            };
          }
          return cb;
        }
        var ret = {
          setReflectHandler: function(fn) {
            reflectHandler = fn;
          },
          isClass,
          isIdentifier,
          inheritedDataKeys,
          getDataPropertyOrDefault,
          thrower,
          isArray: es5.isArray,
          asArray,
          notEnumerableProp,
          isPrimitive,
          isObject,
          isError,
          canEvaluate,
          errorObj,
          tryCatch,
          inherits,
          withAppended,
          maybeWrapAsError,
          toFastProperties,
          filledRange,
          toString: safeToString,
          canAttachTrace,
          ensureErrorObject,
          originatesFromRejection,
          markAsOriginatingFromRejection,
          classString,
          copyDescriptors,
          isNode,
          hasEnvVariables,
          env,
          global: globalObject,
          getNativePromise,
          contextBind
        };
        ret.isRecentNode = ret.isNode && function() {
          var version2;
          if (process.versions && process.versions.node) {
            version2 = process.versions.node.split(".").map(Number);
          } else if (process.version) {
            version2 = process.version.split(".").map(Number);
          }
          return version2[0] === 0 && version2[1] > 10 || version2[0] > 0;
        }();
        ret.nodeSupportsAsyncResource = ret.isNode && function() {
          var supportsAsync = false;
          try {
            var res = _dereq_("async_hooks").AsyncResource;
            supportsAsync = typeof res.prototype.runInAsyncScope === "function";
          } catch (e) {
            supportsAsync = false;
          }
          return supportsAsync;
        }();
        if (ret.isNode)
          ret.toFastProperties(process);
        try {
          throw new Error();
        } catch (e) {
          ret.lastLineError = e;
        }
        module.exports = ret;
      }, { "./es5": 13, "async_hooks": void 0 }] }, {}, [4])(4);
    });
    if (typeof window !== "undefined" && window !== null) {
      window.P = window.Promise;
    } else if (typeof self !== "undefined" && self !== null) {
      self.P = self.Promise;
    }
  }
});

// ../../node_modules/.pnpm/err-code@1.1.2/node_modules/err-code/index.js
var require_err_code = __commonJS({
  "../../node_modules/.pnpm/err-code@1.1.2/node_modules/err-code/index.js"(exports2, module2) {
    "use strict";
    function createError(msg, code, props) {
      var err = msg instanceof Error ? msg : new Error(msg);
      var key;
      if (typeof code === "object") {
        props = code;
      } else if (code != null) {
        err.code = code;
      }
      if (props) {
        for (key in props) {
          err[key] = props[key];
        }
      }
      return err;
    }
    module2.exports = createError;
  }
});

// ../../node_modules/.pnpm/retry@0.10.1/node_modules/retry/lib/retry_operation.js
var require_retry_operation = __commonJS({
  "../../node_modules/.pnpm/retry@0.10.1/node_modules/retry/lib/retry_operation.js"(exports2, module2) {
    function RetryOperation(timeouts, options) {
      if (typeof options === "boolean") {
        options = { forever: options };
      }
      this._timeouts = timeouts;
      this._options = options || {};
      this._fn = null;
      this._errors = [];
      this._attempts = 1;
      this._operationTimeout = null;
      this._operationTimeoutCb = null;
      this._timeout = null;
      if (this._options.forever) {
        this._cachedTimeouts = this._timeouts.slice(0);
      }
    }
    module2.exports = RetryOperation;
    RetryOperation.prototype.stop = function() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      this._timeouts = [];
      this._cachedTimeouts = null;
    };
    RetryOperation.prototype.retry = function(err) {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (!err) {
        return false;
      }
      this._errors.push(err);
      var timeout2 = this._timeouts.shift();
      if (timeout2 === void 0) {
        if (this._cachedTimeouts) {
          this._errors.splice(this._errors.length - 1, this._errors.length);
          this._timeouts = this._cachedTimeouts.slice(0);
          timeout2 = this._timeouts.shift();
        } else {
          return false;
        }
      }
      var self2 = this;
      var timer = setTimeout(function() {
        self2._attempts++;
        if (self2._operationTimeoutCb) {
          self2._timeout = setTimeout(function() {
            self2._operationTimeoutCb(self2._attempts);
          }, self2._operationTimeout);
          if (this._options.unref) {
            self2._timeout.unref();
          }
        }
        self2._fn(self2._attempts);
      }, timeout2);
      if (this._options.unref) {
        timer.unref();
      }
      return true;
    };
    RetryOperation.prototype.attempt = function(fn, timeoutOps) {
      this._fn = fn;
      if (timeoutOps) {
        if (timeoutOps.timeout) {
          this._operationTimeout = timeoutOps.timeout;
        }
        if (timeoutOps.cb) {
          this._operationTimeoutCb = timeoutOps.cb;
        }
      }
      var self2 = this;
      if (this._operationTimeoutCb) {
        this._timeout = setTimeout(function() {
          self2._operationTimeoutCb();
        }, self2._operationTimeout);
      }
      this._fn(this._attempts);
    };
    RetryOperation.prototype.try = function(fn) {
      console.log("Using RetryOperation.try() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = function(fn) {
      console.log("Using RetryOperation.start() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = RetryOperation.prototype.try;
    RetryOperation.prototype.errors = function() {
      return this._errors;
    };
    RetryOperation.prototype.attempts = function() {
      return this._attempts;
    };
    RetryOperation.prototype.mainError = function() {
      if (this._errors.length === 0) {
        return null;
      }
      var counts = {};
      var mainError = null;
      var mainErrorCount = 0;
      for (var i = 0; i < this._errors.length; i++) {
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
          mainError = error;
          mainErrorCount = count;
        }
      }
      return mainError;
    };
  }
});

// ../../node_modules/.pnpm/retry@0.10.1/node_modules/retry/lib/retry.js
var require_retry = __commonJS({
  "../../node_modules/.pnpm/retry@0.10.1/node_modules/retry/lib/retry.js"(exports2) {
    var RetryOperation = require_retry_operation();
    exports2.operation = function(options) {
      var timeouts = exports2.timeouts(options);
      return new RetryOperation(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref
      });
    };
    exports2.timeouts = function(options) {
      if (options instanceof Array) {
        return [].concat(options);
      }
      var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1 * 1e3,
        maxTimeout: Infinity,
        randomize: false
      };
      for (var key in options) {
        opts[key] = options[key];
      }
      if (opts.minTimeout > opts.maxTimeout) {
        throw new Error("minTimeout is greater than maxTimeout");
      }
      var timeouts = [];
      for (var i = 0; i < opts.retries; i++) {
        timeouts.push(this.createTimeout(i, opts));
      }
      if (options && options.forever && !timeouts.length) {
        timeouts.push(this.createTimeout(i, opts));
      }
      timeouts.sort(function(a, b) {
        return a - b;
      });
      return timeouts;
    };
    exports2.createTimeout = function(attempt, opts) {
      var random = opts.randomize ? Math.random() + 1 : 1;
      var timeout2 = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
      timeout2 = Math.min(timeout2, opts.maxTimeout);
      return timeout2;
    };
    exports2.wrap = function(obj2, options, methods) {
      if (options instanceof Array) {
        methods = options;
        options = null;
      }
      if (!methods) {
        methods = [];
        for (var key in obj2) {
          if (typeof obj2[key] === "function") {
            methods.push(key);
          }
        }
      }
      for (var i = 0; i < methods.length; i++) {
        var method = methods[i];
        var original = obj2[method];
        obj2[method] = function retryWrapper() {
          var op = exports2.operation(options);
          var args = Array.prototype.slice.call(arguments);
          var callback = args.pop();
          args.push(function(err) {
            if (op.retry(err)) {
              return;
            }
            if (err) {
              arguments[0] = op.mainError();
            }
            callback.apply(this, arguments);
          });
          op.attempt(function() {
            original.apply(obj2, args);
          });
        };
        obj2[method].options = options;
      }
    };
  }
});

// ../../node_modules/.pnpm/retry@0.10.1/node_modules/retry/index.js
var require_retry2 = __commonJS({
  "../../node_modules/.pnpm/retry@0.10.1/node_modules/retry/index.js"(exports2, module2) {
    module2.exports = require_retry();
  }
});

// ../../node_modules/.pnpm/promise-retry@1.1.1/node_modules/promise-retry/index.js
var require_promise_retry = __commonJS({
  "../../node_modules/.pnpm/promise-retry@1.1.1/node_modules/promise-retry/index.js"(exports2, module2) {
    "use strict";
    var errcode = require_err_code();
    var retry2 = require_retry2();
    var hasOwn2 = Object.prototype.hasOwnProperty;
    function isRetryError(err) {
      return err && err.code === "EPROMISERETRY" && hasOwn2.call(err, "retried");
    }
    function promiseRetry2(fn, options) {
      var temp;
      var operation;
      if (typeof fn === "object" && typeof options === "function") {
        temp = options;
        options = fn;
        fn = temp;
      }
      operation = retry2.operation(options);
      return new Promise(function(resolve, reject) {
        operation.attempt(function(number) {
          Promise.resolve().then(function() {
            return fn(function(err) {
              if (isRetryError(err)) {
                err = err.retried;
              }
              throw errcode("Retrying", "EPROMISERETRY", { retried: err });
            }, number);
          }).then(resolve, function(err) {
            if (isRetryError(err)) {
              err = err.retried;
              if (operation.retry(err || new Error())) {
                return;
              }
            }
            reject(err);
          });
        });
      });
    }
    module2.exports = promiseRetry2;
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/bind.js"(exports2, module2) {
    "use strict";
    module2.exports = function bind2(fn, thisArg) {
      return function wrap2() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/utils.js"(exports2, module2) {
    "use strict";
    var bind2 = require_bind();
    var toString3 = Object.prototype.toString;
    function isArray(val) {
      return toString3.call(val) === "[object Array]";
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    function isArrayBuffer(val) {
      return toString3.call(val) === "[object ArrayBuffer]";
    }
    function isFormData(val) {
      return typeof FormData !== "undefined" && val instanceof FormData;
    }
    function isArrayBufferView(val) {
      var result2;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result2 = ArrayBuffer.isView(val);
      } else {
        result2 = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }
      return result2;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber(val) {
      return typeof val === "number";
    }
    function isObject4(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject(val) {
      if (toString3.call(val) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val) {
      return toString3.call(val) === "[object Date]";
    }
    function isFile(val) {
      return toString3.call(val) === "[object File]";
    }
    function isBlob(val) {
      return toString3.call(val) === "[object Blob]";
    }
    function isFunction2(val) {
      return toString3.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject4(val) && isFunction2(val.pipe);
    }
    function isURLSearchParams(val) {
      return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj2, fn) {
      if (obj2 === null || typeof obj2 === "undefined") {
        return;
      }
      if (typeof obj2 !== "object") {
        obj2 = [obj2];
      }
      if (isArray(obj2)) {
        for (var i = 0, l = obj2.length; i < l; i++) {
          fn.call(null, obj2[i], i, obj2);
        }
      } else {
        for (var key in obj2) {
          if (Object.prototype.hasOwnProperty.call(obj2, key)) {
            fn.call(null, obj2[key], key, obj2);
          }
        }
      }
    }
    function merge() {
      var result2 = {};
      function assignValue(val, key) {
        if (isPlainObject(result2[key]) && isPlainObject(val)) {
          result2[key] = merge(result2[key], val);
        } else if (isPlainObject(val)) {
          result2[key] = merge({}, val);
        } else if (isArray(val)) {
          result2[key] = val.slice();
        } else {
          result2[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result2;
    }
    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind2(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module2.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isObject: isObject4,
      isPlainObject,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction: isFunction2,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/buildURL.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module2.exports = function buildURL(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue2(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/InterceptorManager.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module2.exports = InterceptorManager;
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/enhanceError.js
var require_enhanceError = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/enhanceError.js"(exports2, module2) {
    "use strict";
    module2.exports = function enhanceError(error, config, code, request, response) {
      error.config = config;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      };
      return error;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/createError.js
var require_createError = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/createError.js"(exports2, module2) {
    "use strict";
    var enhanceError = require_enhanceError();
    module2.exports = function createError(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config, code, request, response);
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/settle.js"(exports2, module2) {
    "use strict";
    var createError = require_createError();
    module2.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError("Request failed with status code " + response.status, response.config, null, response.request, response));
      }
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/cookies.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils.isString(path)) {
            cookie.push("path=" + path);
          }
          if (utils.isString(domain)) {
            cookie.push("domain=" + domain);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    }() : function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove() {
        }
      };
    }();
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports2, module2) {
    "use strict";
    module2.exports = function isAbsoluteURL(url) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/combineURLs.js"(exports2, module2) {
    "use strict";
    module2.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/buildFullPath.js"(exports2, module2) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module2.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/parseHeaders.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module2.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;
      function resolveURL(url) {
        var href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }() : function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    }();
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/adapters/xhr.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var createError = require_createError();
    module2.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(resolve, reject, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError("Request aborted", config, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError("Network Error", config, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(createError(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken) {
          config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) {
              return;
            }
            request.abort();
            reject(cancel);
            request = null;
          });
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/defaults.js
var require_defaults = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/defaults.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var enhanceError = require_enhanceError();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data;
      }],
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    };
    defaults.headers = {
      common: {
        "Accept": "application/json, text/plain, */*"
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module2.exports = defaults;
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/transformData.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module2.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/cancel/isCancel.js"(exports2, module2) {
    "use strict";
    module2.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/dispatchRequest.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
    }
    module2.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(config, config.data, config.headers, config.transformRequest);
      config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
      utils.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
        delete config.headers[method];
      });
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/mergeConfig.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      var valueFromConfig2Keys = ["url", "method", "data"];
      var mergeDeepPropertiesKeys = ["headers", "auth", "proxy", "params"];
      var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
      ];
      var directMergeKeys = ["validateStatus"];
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          config[prop] = getMergedValue(void 0, config1[prop]);
        }
      }
      utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(void 0, config2[prop]);
        }
      });
      utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
      utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          config[prop] = getMergedValue(void 0, config1[prop]);
        }
      });
      utils.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) {
          config[prop] = getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          config[prop] = getMergedValue(void 0, config1[prop]);
        }
      });
      var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
      var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
      });
      utils.forEach(otherKeys, mergeDeepProperties);
      return config;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/package.json
var require_package = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/package.json"(exports2, module2) {
    module2.exports = {
      name: "axios",
      version: "0.21.4",
      description: "Promise based HTTP client for the browser and node.js",
      main: "index.js",
      scripts: {
        test: "grunt test",
        start: "node ./sandbox/server.js",
        build: "NODE_ENV=production grunt build",
        preversion: "npm test",
        version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
        postversion: "git push && git push --tags",
        examples: "node ./examples/server.js",
        coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
        fix: "eslint --fix lib/**/*.js"
      },
      repository: {
        type: "git",
        url: "https://github.com/axios/axios.git"
      },
      keywords: [
        "xhr",
        "http",
        "ajax",
        "promise",
        "node"
      ],
      author: "Matt Zabriskie",
      license: "MIT",
      bugs: {
        url: "https://github.com/axios/axios/issues"
      },
      homepage: "https://axios-http.com",
      devDependencies: {
        coveralls: "^3.0.0",
        "es6-promise": "^4.2.4",
        grunt: "^1.3.0",
        "grunt-banner": "^0.6.0",
        "grunt-cli": "^1.2.0",
        "grunt-contrib-clean": "^1.1.0",
        "grunt-contrib-watch": "^1.0.0",
        "grunt-eslint": "^23.0.0",
        "grunt-karma": "^4.0.0",
        "grunt-mocha-test": "^0.13.3",
        "grunt-ts": "^6.0.0-beta.19",
        "grunt-webpack": "^4.0.2",
        "istanbul-instrumenter-loader": "^1.0.0",
        "jasmine-core": "^2.4.1",
        karma: "^6.3.2",
        "karma-chrome-launcher": "^3.1.0",
        "karma-firefox-launcher": "^2.1.0",
        "karma-jasmine": "^1.1.1",
        "karma-jasmine-ajax": "^0.1.13",
        "karma-safari-launcher": "^1.0.0",
        "karma-sauce-launcher": "^4.3.6",
        "karma-sinon": "^1.0.5",
        "karma-sourcemap-loader": "^0.3.8",
        "karma-webpack": "^4.0.2",
        "load-grunt-tasks": "^3.5.2",
        minimist: "^1.2.0",
        mocha: "^8.2.1",
        sinon: "^4.5.0",
        "terser-webpack-plugin": "^4.2.3",
        typescript: "^4.0.5",
        "url-search-params": "^0.10.0",
        webpack: "^4.44.2",
        "webpack-dev-server": "^3.11.0"
      },
      browser: {
        "./lib/adapters/http.js": "./lib/adapters/xhr.js"
      },
      jsdelivr: "dist/axios.min.js",
      unpkg: "dist/axios.min.js",
      typings: "./index.d.ts",
      dependencies: {
        "follow-redirects": "^1.14.0"
      },
      bundlesize: [
        {
          path: "./dist/axios.min.js",
          threshold: "5kB"
        }
      ]
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/validator.js"(exports2, module2) {
    "use strict";
    var pkg = require_package();
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    var currentVerArr = pkg.version.split(".");
    function isOlderVersion(version2, thanVersion) {
      var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr;
      var destVer = version2.split(".");
      for (var i = 0; i < 3; i++) {
        if (pkgVersionArr[i] > destVer[i]) {
          return true;
        } else if (pkgVersionArr[i] < destVer[i]) {
          return false;
        }
      }
      return false;
    }
    validators.transitional = function transitional(validator, version2, message) {
      var isDeprecated = version2 && isOlderVersion(version2);
      function formatMessage(opt, desc) {
        return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed in " + version2));
        }
        if (isDeprecated && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i = keys.length;
      while (i-- > 0) {
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result2 = value === void 0 || validator(value, opt, options);
          if (result2 !== true) {
            throw new TypeError("option " + opt + " must be " + result2);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module2.exports = {
      isOlderVersion,
      assertOptions,
      validators
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/core/Axios.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(config) {
      if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        config = config || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
          forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
          clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios.prototype[method] = function(url, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data
        }));
      };
    });
    module2.exports = Axios;
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/cancel/Cancel.js
var require_Cancel = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/cancel/Cancel.js"(exports2, module2) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString3() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module2.exports = Cancel;
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/cancel/CancelToken.js"(exports2, module2) {
    "use strict";
    var Cancel = require_Cancel();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module2.exports = CancelToken;
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/spread.js"(exports2, module2) {
    "use strict";
    module2.exports = function spread(callback) {
      return function wrap2(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/helpers/isAxiosError.js"(exports2, module2) {
    "use strict";
    module2.exports = function isAxiosError(payload) {
      return typeof payload === "object" && payload.isAxiosError === true;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/lib/axios.js"(exports2, module2) {
    "use strict";
    var utils = require_utils();
    var bind2 = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig2) {
      var context = new Axios(defaultConfig2);
      var instance = bind2(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      return instance;
    }
    var axios2 = createInstance(defaults);
    axios2.Axios = Axios;
    axios2.create = function create(instanceConfig) {
      return createInstance(mergeConfig(axios2.defaults, instanceConfig));
    };
    axios2.Cancel = require_Cancel();
    axios2.CancelToken = require_CancelToken();
    axios2.isCancel = require_isCancel();
    axios2.all = function all(promises) {
      return Promise.all(promises);
    };
    axios2.spread = require_spread();
    axios2.isAxiosError = require_isAxiosError();
    module2.exports = axios2;
    module2.exports.default = axios2;
  }
});

// ../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/index.js
var require_axios2 = __commonJS({
  "../../node_modules/.pnpm/axios@0.21.4/node_modules/axios/index.js"(exports2, module2) {
    module2.exports = require_axios();
  }
});

// ../../node_modules/.pnpm/is-buffer@2.0.5/node_modules/is-buffer/index.js
var require_is_buffer = __commonJS({
  "../../node_modules/.pnpm/is-buffer@2.0.5/node_modules/is-buffer/index.js"(exports2, module2) {
    module2.exports = function isBuffer(obj2) {
      return obj2 != null && obj2.constructor != null && typeof obj2.constructor.isBuffer === "function" && obj2.constructor.isBuffer(obj2);
    };
  }
});

// ../../node_modules/.pnpm/flat@4.1.1/node_modules/flat/index.js
var require_flat = __commonJS({
  "../../node_modules/.pnpm/flat@4.1.1/node_modules/flat/index.js"(exports2, module2) {
    var isBuffer = require_is_buffer();
    module2.exports = flatten2;
    flatten2.flatten = flatten2;
    flatten2.unflatten = unflatten;
    function flatten2(target, opts) {
      opts = opts || {};
      var delimiter = opts.delimiter || ".";
      var maxDepth = opts.maxDepth;
      var output = {};
      function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function(key) {
          var value = object[key];
          var isarray = opts.safe && Array.isArray(value);
          var type = Object.prototype.toString.call(value);
          var isbuffer = isBuffer(value);
          var isobject = type === "[object Object]" || type === "[object Array]";
          var newKey = prev ? prev + delimiter + key : key;
          if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) {
            return step(value, newKey, currentDepth + 1);
          }
          output[newKey] = value;
        });
      }
      step(target);
      return output;
    }
    function unflatten(target, opts) {
      opts = opts || {};
      var delimiter = opts.delimiter || ".";
      var overwrite = opts.overwrite || false;
      var result2 = {};
      var isbuffer = isBuffer(target);
      if (isbuffer || Object.prototype.toString.call(target) !== "[object Object]") {
        return target;
      }
      function getkey(key) {
        var parsedKey = Number(key);
        return isNaN(parsedKey) || key.indexOf(".") !== -1 || opts.object ? key : parsedKey;
      }
      var sortedKeys = Object.keys(target).sort(function(keyA, keyB) {
        return keyA.length - keyB.length;
      });
      sortedKeys.forEach(function(key) {
        var split2 = key.split(delimiter);
        var key1 = getkey(split2.shift());
        var key2 = getkey(split2[0]);
        var recipient = result2;
        while (key2 !== void 0) {
          if (key1 === "__proto__") {
            return;
          }
          var type = Object.prototype.toString.call(recipient[key1]);
          var isobject = type === "[object Object]" || type === "[object Array]";
          if (!overwrite && !isobject && typeof recipient[key1] !== "undefined") {
            return;
          }
          if (overwrite && !isobject || !overwrite && recipient[key1] == null) {
            recipient[key1] = typeof key2 === "number" && !opts.object ? [] : {};
          }
          recipient = recipient[key1];
          if (split2.length > 0) {
            key1 = getkey(split2.shift());
            key2 = getkey(split2[0]);
          }
        }
        recipient[key1] = unflatten(target[key], opts);
      });
      return result2;
    }
  }
});

// src/useVimCommunication.tsx
import React2, { createContext as createContext2, useContext as useContext2, useState as useState3 } from "react";
import {
  WidgetVimCommunication,
  SubApplicationVimCommunication,
  getTabIdFromUrl
} from "@getvim/vim-connect-communication";

// src/useProductMetadata.tsx
import React, { createContext, useContext, useMemo } from "react";

// src/hooks/useAccessToken.ts
import { useCallback, useEffect, useState } from "react";

// ../../node_modules/.pnpm/just-performance@4.3.0/node_modules/just-performance/dist/esm/browser.js
var universal = typeof globalThis !== "undefined" ? globalThis : global;
var performance = universal.performance;

// ../../node_modules/.pnpm/limiter@2.1.0/node_modules/limiter/dist/esm/clock.js
function hrtime(previousTimestamp) {
  const clocktime = performance.now() * 1e-3;
  let seconds = Math.floor(clocktime);
  let nanoseconds = Math.floor(clocktime % 1 * 1e9);
  if (previousTimestamp != void 0) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds < 0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds, nanoseconds];
}
function getMilliseconds() {
  const [seconds, nanoseconds] = hrtime();
  return seconds * 1e3 + Math.floor(nanoseconds / 1e6);
}
function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// ../../node_modules/.pnpm/limiter@2.1.0/node_modules/limiter/dist/esm/TokenBucket.js
var TokenBucket = class {
  constructor({ bucketSize, tokensPerInterval, interval, parentBucket }) {
    this.bucketSize = bucketSize;
    this.tokensPerInterval = tokensPerInterval;
    if (typeof interval === "string") {
      switch (interval) {
        case "sec":
        case "second":
          this.interval = 1e3;
          break;
        case "min":
        case "minute":
          this.interval = 1e3 * 60;
          break;
        case "hr":
        case "hour":
          this.interval = 1e3 * 60 * 60;
          break;
        case "day":
          this.interval = 1e3 * 60 * 60 * 24;
          break;
        default:
          throw new Error("Invalid interval " + interval);
      }
    } else {
      this.interval = interval;
    }
    this.parentBucket = parentBucket;
    this.content = 0;
    this.lastDrip = getMilliseconds();
  }
  async removeTokens(count) {
    if (this.bucketSize === 0) {
      return Number.POSITIVE_INFINITY;
    }
    if (count > this.bucketSize) {
      throw new Error(`Requested tokens ${count} exceeds bucket size ${this.bucketSize}`);
    }
    this.drip();
    const comeBackLater = async () => {
      const waitMs = Math.ceil((count - this.content) * (this.interval / this.tokensPerInterval));
      await wait(waitMs);
      return this.removeTokens(count);
    };
    if (count > this.content)
      return comeBackLater();
    if (this.parentBucket != void 0) {
      const remainingTokens = await this.parentBucket.removeTokens(count);
      if (count > this.content)
        return comeBackLater();
      this.content -= count;
      return Math.min(remainingTokens, this.content);
    } else {
      this.content -= count;
      return this.content;
    }
  }
  tryRemoveTokens(count) {
    if (!this.bucketSize)
      return true;
    if (count > this.bucketSize)
      return false;
    this.drip();
    if (count > this.content)
      return false;
    if (this.parentBucket && !this.parentBucket.tryRemoveTokens(count))
      return false;
    this.content -= count;
    return true;
  }
  drip() {
    if (this.tokensPerInterval === 0) {
      const prevContent2 = this.content;
      this.content = this.bucketSize;
      return this.content > prevContent2;
    }
    const now = getMilliseconds();
    const deltaMS = Math.max(now - this.lastDrip, 0);
    this.lastDrip = now;
    const dripAmount = deltaMS * (this.tokensPerInterval / this.interval);
    const prevContent = this.content;
    this.content = Math.min(this.content + dripAmount, this.bucketSize);
    return Math.floor(this.content) > Math.floor(prevContent);
  }
};

// ../../node_modules/.pnpm/limiter@2.1.0/node_modules/limiter/dist/esm/RateLimiter.js
var RateLimiter = class {
  constructor({ tokensPerInterval, interval, fireImmediately }) {
    this.tokenBucket = new TokenBucket({
      bucketSize: tokensPerInterval,
      tokensPerInterval,
      interval
    });
    this.tokenBucket.content = tokensPerInterval;
    this.curIntervalStart = getMilliseconds();
    this.tokensThisInterval = 0;
    this.fireImmediately = fireImmediately !== null && fireImmediately !== void 0 ? fireImmediately : false;
  }
  async removeTokens(count) {
    if (count > this.tokenBucket.bucketSize) {
      throw new Error(`Requested tokens ${count} exceeds maximum tokens per interval ${this.tokenBucket.bucketSize}`);
    }
    const now = getMilliseconds();
    if (now < this.curIntervalStart || now - this.curIntervalStart >= this.tokenBucket.interval) {
      this.curIntervalStart = now;
      this.tokensThisInterval = 0;
    }
    if (count > this.tokenBucket.tokensPerInterval - this.tokensThisInterval) {
      if (this.fireImmediately) {
        return -1;
      } else {
        const waitMs = Math.ceil(this.curIntervalStart + this.tokenBucket.interval - now);
        await wait(waitMs);
        const remainingTokens2 = await this.tokenBucket.removeTokens(count);
        this.tokensThisInterval += count;
        return remainingTokens2;
      }
    }
    const remainingTokens = await this.tokenBucket.removeTokens(count);
    this.tokensThisInterval += count;
    return remainingTokens;
  }
  tryRemoveTokens(count) {
    if (count > this.tokenBucket.bucketSize)
      return false;
    const now = getMilliseconds();
    if (now < this.curIntervalStart || now - this.curIntervalStart >= this.tokenBucket.interval) {
      this.curIntervalStart = now;
      this.tokensThisInterval = 0;
    }
    if (count > this.tokenBucket.tokensPerInterval - this.tokensThisInterval)
      return false;
    const removed = this.tokenBucket.tryRemoveTokens(count);
    if (removed) {
      this.tokensThisInterval += count;
    }
    return removed;
  }
  getTokensRemaining() {
    this.tokenBucket.drip();
    return this.tokenBucket.content;
  }
};

// ../../packages/vim-connect-logger/build/index.js
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj2, key, value) => key in obj2 ? __defProp2(obj2, key, { enumerable: true, configurable: true, writable: true, value }) : obj2[key] = value;
var __publicField = (obj2, key, value) => {
  __defNormalProp2(obj2, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var LOG_URL = "api/log";
var VM_EXPOSED_LOCALHOST_IP = "10.211.55.2";
var VM_LOCALHOST_ALIAS = "your_mac_ip:";
var getRateLimiter = (tokensPerInterval = 30, interval = "min", fireImmediately = true) => {
  return new RateLimiter({
    tokensPerInterval,
    interval,
    fireImmediately
  });
};
var mapBackendServiceToPort = (service) => {
  switch (service) {
    case "console":
      return "6002";
    case "logger":
      return "6025";
    default:
      throw new Error(`Unexpected service value: ${service}`);
  }
};
var getUrlByEnv = (origin, service, path) => {
  if (origin.includes("staging"))
    return new URL(path, `https://${service}.staging.getvim.com`).href;
  else if (origin.includes("demo"))
    return new URL(path, `https://${service}.demo.getvim.com`).href;
  else if (origin.includes("localhost")) {
    return new URL(path, `http://localhost:${mapBackendServiceToPort(service)}`).href;
  } else if (origin.includes("dev")) {
    return new URL(path, `https://${service}.dev.devim.io`).href;
  } else if (origin.includes(VM_EXPOSED_LOCALHOST_IP)) {
    return new URL(path, `https://${service}.dev.devim.io`).href;
  } else if (origin.includes(VM_LOCALHOST_ALIAS)) {
    return new URL(path, `https://${service}.dev.devim.io`).href;
  } else
    return new URL(path, `https://${service}.getvim.com`).href;
};
function getEnvByOrigin(origin) {
  if (origin.includes("staging")) {
    return "staging";
  } else if (origin.includes("dev")) {
    return "dev";
  } else if (origin.includes("demo")) {
    return "demo";
  } else if (origin.includes("localhost")) {
    return "dev";
  } else if (origin.includes(VM_EXPOSED_LOCALHOST_IP)) {
    return "dev";
  } else if (origin.includes(VM_LOCALHOST_ALIAS)) {
    return "dev";
  } else {
    return "prod";
  }
}
var getSumoCapacitorUrlByEnv = (origin, logLevel) => {
  if (logLevel === "info") {
    logLevel = "other";
  }
  const path = `${logLevel}.log`;
  const env2 = getEnvByOrigin(origin);
  return new URL(path, `https://client-logs${env2 === "prod" ? "." : `.${env2}.`}getvim.com/`).href;
};
var scopeColors = [
  "#63b598",
  "#ce7d78",
  "#ea9e70",
  "#a48a9e",
  "#648177",
  "#0d5ac1",
  "#f205e6",
  "#14a9ad",
  "#4ca2f9",
  "#a4e43f",
  "#d298e2",
  "#6119d0",
  "#d2737d",
  "#c0a43c",
  "#f2510e",
  "#651be6",
  "#79806e",
  "#61da5e",
  "#cd2f00",
  "#9348af",
  "#01ac53",
  "#996635",
  "#b11573",
  "#4bb473",
  "#75d89e",
  "#2f3f94",
  "#2f7b99",
  "#da967d",
  "#34891f",
  "#b0d87b",
  "#ca4751",
  "#7e50a8",
  "#c4d647",
  "#11dec1",
  "#289812",
  "#566ca0",
  "#2f1179",
  "#935b6d",
  "#916988",
  "#513d98",
  "#aead3a",
  "#9e6d71",
  "#4b5bdc",
  "#0cd36d",
  "#cb5bea",
  "#228916",
  "#ac3e1b",
  "#df514a",
  "#539397",
  "#880977",
  "#ba96ce",
  "#679c9d",
  "#c6c42c",
  "#5d2c52",
  "#48b41b",
  "#e1cf3b",
  "#5be4f0",
  "#57c4d8",
  "#a4d17a",
  "#225b80",
  "#be608b",
  "#96b00c",
  "#088baf",
  "#f158bf",
  "#e145ba",
  "#05d371",
  "#5426e0",
  "#4834d0",
  "#802234",
  "#6749e8",
  "#0971f0",
  "#8fb413",
  "#c9a941",
  "#41d158",
  "#fb21a3",
  "#51aed9",
  "#5bb32d",
  "#21538e",
  "#89d534",
  "#d36647",
  "#7fb411",
  "#0023b8",
  "#3b8c2a",
  "#986b53",
  "#f50422",
  "#983f7a",
  "#ea24a3",
  "#79352c",
  "#521250",
  "#d6dd92",
  "#e33e52",
  "#b2be57",
  "#fa06ec",
  "#1bb699",
  "#6b2e5f",
  "#21538e",
  "#89d534",
  "#d36647",
  "#7fb411",
  "#0023b8",
  "#986b53",
  "#f50422",
  "#983f7a",
  "#ea24a3",
  "#79352c",
  "#e33e52",
  "#fa06ec",
  "#1bb699",
  "#6b2e5f",
  "#64820f",
  "#9cb64a",
  "#996c48",
  "#9ab9b7",
  "#06e052",
  "#0eb621",
  "#fc458e",
  "#b2db15",
  "#aa226d",
  "#792ed8",
  "#73872a",
  "#7d1d85",
  "#c4fd57",
  "#f1ae16",
  "#8fe22a",
  "#ef6e3c",
  "#243eeb",
  "#1dc180",
  "#3f8473",
  "#7a3d93",
  "#93f2d7",
  "#9b5c2a",
  "#15b9ee",
  "#0f5997",
  "#409188",
  "#911e20",
  "#1350ce",
  "#10e5b1",
  "#cb2582",
  "#ce00be",
  "#32d5d6",
  "#608572",
  "#c79bc2",
  "#00f87c",
  "#77772a",
  "#6995ba",
  "#fc6b57",
  "#f07815",
  "#8fd883",
  "#96e591",
  "#21d52e",
  "#d00043",
  "#1ec227",
  "#947002",
  "#bde052",
  "#e08c56",
  "#28fcfd",
  "#bb09b0",
  "#36486a",
  "#d02e29",
  "#1ae6db",
  "#3e464c",
  "#a84a8f",
  "#911e7e",
  "#0f525f",
  "#ac7c0a",
  "#b4c086",
  "#c9d730",
  "#30cc49",
  "#3d6751",
  "#fb4c03",
  "#640fc1",
  "#62c03e",
  "#d3493a",
  "#88aa0b",
  "#406df9",
  "#615af0",
  "#4be470",
  "#2a3434",
  "#4a543f",
  "#79bca0",
  "#00efd4",
  "#7ad236",
  "#7260d8",
  "#1deaa7",
  "#06f43a",
  "#823c59",
  "#e3d94c",
  "#dc1c06",
  "#f53b2a",
  "#b46238",
  "#2dfff6",
  "#a82b89",
  "#1a8011",
  "#436a9f",
  "#1a806a",
  "#4cf09d",
  "#67eb4b",
  "#b308d3",
  "#fc7e41",
  "#af3101",
  "#ff0650",
  "#71b1f4",
  "#a2f8a5",
  "#e23dd0",
  "#d3486d",
  "#00f7f9",
  "#474893",
  "#3cec35",
  "#1c65cb",
  "#5d1d0c",
  "#2d7d2a",
  "#ff3420",
  "#5cdd87",
  "#a259a4",
  "#e4ac44",
  "#1bede6",
  "#8798a4",
  "#d7790f",
  "#b2c24f",
  "#de73c2",
  "#d70a9c",
  "#25b670",
  "#88e9b8",
  "#86e98f",
  "#1a806b",
  "#436a9e",
  "#0ec0ff",
  "#f812b3",
  "#b17fc9",
  "#8d6c2f",
  "#d3277a",
  "#2ca1ae",
  "#9685eb",
  "#8a96c6",
  "#76fc1b",
  "#608fa4",
  "#20f6ba",
  "#07d7f6",
  "#77ecca"
];
var selectScopeColor = (scope, colors = scopeColors) => {
  let hash = 0;
  for (let i = 0; i < scope.length; i++) {
    hash = (hash << 5) - hash + scope.charCodeAt(i);
    hash |= 0;
  }
  return colors[Math.abs(hash) % colors.length];
};
var VIM_CONNECT_BG_COLOR = "#09ACE4";
var scopeConsoleLog = (scope, options) => {
  const { moduleAndScopeSameColor, moduleName } = options || {};
  const scopeColor = selectScopeColor(scope);
  return (level, message, data, options2) => {
    const { messageStyle = [] } = options2 || {};
    const levelStyle = getLogLevelStyle(level);
    const method = level === "debug" ? "debug" : "log";
    console[method](`%c ${moduleName != null ? moduleName : "Vim Connect"} %c (${level}) %c [${scope}] %c ${message || "(no message)"}`, `background: ${moduleAndScopeSameColor ? scopeColor : VIM_CONNECT_BG_COLOR}; color: white;`, levelStyle, `color: ${scopeColor};`, "", ...messageStyle, data || "");
  };
};
function getLogLevelStyle(logLevel) {
  switch (logLevel) {
    case "warning":
      return "background: #EEAA79";
    case "error":
      return "background: #BC2214";
    case "critical":
      return "background: red";
    default:
      return "";
  }
}
var TIMEOUT = 15e4;
var Logger = class {
  info(message, data, options, tags) {
    this.log("info", message, data, options, tags);
  }
  error(message, data, options, tags) {
    this.log("error", message, data, options, tags);
  }
  debug(message, data, options, tags) {
    this.log("debug", message, data, options, tags);
  }
  warning(message, data, options, tags) {
    this.log("warning", message, data, options, tags);
  }
};
var _ScopedLogger = class extends Logger {
  constructor(scope, options, tags = {}) {
    var _a3, _b;
    super();
    this.scope = scope;
    this.tags = tags;
    this.defineJsonStringifyOnError();
    const moduleName = _ScopedLogger.moduleName || (options == null ? void 0 : options.moduleName) || (tags == null ? void 0 : tags.moduleName) || (this.isLoggerInWebWorker ? void 0 : (_a3 = window == null ? void 0 : window.$vim_environment) == null ? void 0 : _a3.service) || void 0;
    this.consoleLog = scopeConsoleLog(scope, options ? __spreadProps(__spreadValues({}, options), { moduleName }) : {
      moduleName
    });
    this.rateLimiter = getRateLimiter();
    try {
      const deviceId = new URLSearchParams(globalThis.location.search).get("deviceId");
      if (deviceId) {
        _ScopedLogger.setDeviceId(deviceId);
      }
    } catch (error) {
      console.error("failed to get deviceId from URL for initLoggerDeviceId", error);
    }
    const useCapacitorByEnv = (_b = globalThis.$vim_environment) == null ? void 0 : _b.VIM_USE_SUMO_CAPACITOR_V2;
    if (useCapacitorByEnv != void 0) {
      this.useCapacitor = (useCapacitorByEnv == null ? void 0 : useCapacitorByEnv.toLowerCase()) === "true";
    }
    this.consoleLogLevelFromStorage = !this.isLoggerInWebWorker ? localStorage.getItem("VIM_CONSOLE_LOG_LEVEL") : "debug";
  }
  static setMetadata(metadata) {
    var _a3;
    this.metadata = __spreadProps(__spreadValues({}, metadata), {
      adapterName: (_a3 = metadata.adapterName) == null ? void 0 : _a3.toLowerCase()
    });
  }
  static setUserMetadata(userMetadata) {
    var _a3, _b;
    this.userMetadata = {
      id: userMetadata == null ? void 0 : userMetadata.id,
      createdAt: userMetadata == null ? void 0 : userMetadata.createdAt,
      updatedAt: userMetadata == null ? void 0 : userMetadata.updatedAt,
      activatedAt: userMetadata == null ? void 0 : userMetadata.activatedAt,
      externalId: userMetadata == null ? void 0 : userMetadata.externalId,
      npi: userMetadata == null ? void 0 : userMetadata.npi,
      tin: userMetadata == null ? void 0 : userMetadata.tin,
      firstName: userMetadata == null ? void 0 : userMetadata.firstName,
      lastName: userMetadata == null ? void 0 : userMetadata.lastName,
      linkedEhrUser: userMetadata == null ? void 0 : userMetadata.linkedEhrUser,
      tag: userMetadata == null ? void 0 : userMetadata.tag,
      title: userMetadata == null ? void 0 : userMetadata.title,
      address: userMetadata == null ? void 0 : userMetadata.address,
      organizationId: (_a3 = userMetadata == null ? void 0 : userMetadata.organization) == null ? void 0 : _a3.id,
      products: (_b = userMetadata == null ? void 0 : userMetadata.products) == null ? void 0 : _b.map((i) => i == null ? void 0 : i.name)
    };
  }
  static updateMetadata(paramsToUpdate) {
    this.metadata = __spreadValues(__spreadValues({}, this.metadata), paramsToUpdate);
    if (this.metadata.adapterName)
      this.metadata.adapterName = this.metadata.adapterName.toLowerCase();
  }
  static setStaticTags(tags) {
    this.staticTags = __spreadValues({}, tags);
  }
  static setDeviceId(deviceId) {
    this.metadata = __spreadProps(__spreadValues({
      version: "unknown",
      windowId: "unknown"
    }, this.metadata), {
      deviceId
    });
  }
  static setAccessToken(accessToken2) {
    this.accessToken = accessToken2;
  }
  static setRemoteLogSupported(supported) {
    this.remoteLogSupported = supported;
  }
  static setLimiterSupported(supported) {
    this.limiterSupported = supported;
  }
  static setOnLog(onLog) {
    this.onLog = onLog;
  }
  static setModuleName(moduleName) {
    this.moduleName = moduleName;
  }
  useCapacitor = true;
  isBlocked = false;
  rateLimiter;
  consoleLog;
  consoleLogLevelFromStorage;
  get isLoggerInWebWorker() {
    return typeof self.WorkerGlobalScope !== "undefined" && self instanceof self.WorkerGlobalScope;
  }
  getOriginSafe() {
    var _a3;
    return ((_a3 = globalThis == null ? void 0 : globalThis.location) == null ? void 0 : _a3.origin) || "";
  }
  getConsoleLogLevelByEnv() {
    return getEnvByOrigin(this.getOriginSafe()) === "prod" ? "disable" : "debug";
  }
  logLevelOrder = {
    ["disable"]: 1,
    ["critical"]: 2,
    ["error"]: 3,
    ["warning"]: 4,
    ["warn"]: 4,
    ["info"]: 5,
    ["debug"]: 6
  };
  shouldLogConsole(level) {
    var _a3, _b, _c;
    const consoleLogLevelString = (_c = (_b = (_a3 = globalThis.$vim_environment) == null ? void 0 : _a3.VIM_CONSOLE_LOG_LEVEL) != null ? _b : this.consoleLogLevelFromStorage) != null ? _c : this.getConsoleLogLevelByEnv();
    return this.logLevelOrder[level] <= this.logLevelOrder[consoleLogLevelString];
  }
  async log(level, message, data, options, tags) {
    var _a3;
    if (this.shouldLogConsole(level))
      this.consoleLog(level, message, data, options);
    const shouldSendToBackendByLevel = level !== "debug";
    const origin = this.getOriginSafe();
    const time = Date.now();
    const remainingRequests = shouldSendToBackendByLevel ? await this.rateLimiter.removeTokens(1) : this.rateLimiter.getTokensRemaining();
    if (this.shouldLog(remainingRequests)) {
      this.isBlocked = false;
      (_a3 = _ScopedLogger.onLog) == null ? void 0 : _a3.call(_ScopedLogger, level, message, data);
      if (!(options == null ? void 0 : options.local) && _ScopedLogger.remoteLogSupported) {
        const request = this.buildRequestInit(data, level, message, time, tags);
        return shouldSendToBackendByLevel && await this.sendToLoggerService(origin, request, level);
      }
    } else {
      const message2 = `Scopped logger get blocked due reaching rate limit`;
      const request = this.buildRequestInit({}, "warning", message2, time, tags);
      !this.isBlocked && shouldSendToBackendByLevel && this.sendToLoggerService(origin, request, level);
      this.isBlocked = true;
    }
  }
  buildRequestInit(data, logLevel, message, clientTime, tags) {
    return this.useCapacitor ? this.buildCapacitorRequestInit(data, logLevel, message, clientTime, tags) : this.buildOldRequestInit(data, logLevel, message, clientTime, tags);
  }
  buildOldRequestInit(data, logLevel, message, clientTime, tags) {
    var _a3, _b;
    const { metadata, staticTags, accessToken: accessToken2 } = _ScopedLogger;
    const request = {
      method: "POST",
      headers: __spreadValues({
        "Content-Type": "application/json"
      }, accessToken2 ? { authorization: accessToken2 } : void 0),
      body: JSON.stringify({
        scope: this.scope,
        message,
        data,
        logLevel,
        clientTime,
        metadata: __spreadValues({
          tabVisibility: this.isLoggerInWebWorker ? void 0 : document.visibilityState
        }, metadata),
        tags: __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, staticTags), this.tags), tags), {
          vimVersion: (_a3 = globalThis == null ? void 0 : globalThis.$vim_environment) == null ? void 0 : _a3.vim_version,
          version: (_b = globalThis == null ? void 0 : globalThis.$vim_environment) == null ? void 0 : _b.version
        })
      })
    };
    return request;
  }
  buildCapacitorRequestInit(data, logLevel, message, clientTime, tags) {
    const { metadata, staticTags, accessToken: accessToken2, moduleName } = _ScopedLogger;
    return {
      method: "POST",
      headers: __spreadValues({
        "Content-Type": "application/json"
      }, accessToken2 ? { authorization: accessToken2 } : void 0),
      body: JSON.stringify({
        log: {
          level: logLevel,
          moduleName,
          scope: this.scope,
          message,
          metadata: {
            scope: this.scope,
            userMetadata: _ScopedLogger.userMetadata,
            data,
            clientTime,
            metadata: __spreadValues({
              tabVisibility: this.isLoggerInWebWorker ? void 0 : document.visibilityState
            }, metadata),
            tags: __spreadValues(__spreadValues(__spreadValues({}, staticTags), this.tags), tags)
          }
        }
      })
    };
  }
  shouldLog(remainingRequests) {
    return !_ScopedLogger.limiterSupported || remainingRequests >= 0;
  }
  async sendToLoggerService(origin, request, logLevel, timeout2 = TIMEOUT) {
    if (origin.includes("localhost"))
      return;
    const controller = new AbortController();
    setTimeout(() => {
      controller.abort();
    }, timeout2);
    if (this.useCapacitor) {
      fetch(`${getSumoCapacitorUrlByEnv(origin, logLevel)}`, __spreadProps(__spreadValues({}, request), {
        signal: controller.signal
      })).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") {
          throw error;
        }
      });
    } else {
      fetch(`${getUrlByEnv(origin, "logger", LOG_URL)}`, __spreadProps(__spreadValues({}, request), {
        signal: controller.signal
      })).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") {
          throw error;
        }
      });
    }
  }
  defineJsonStringifyOnError() {
    if (!("toJSON" in Error.prototype)) {
      Object.defineProperty(Error.prototype, "toJSON", {
        value: function() {
          const alt = {};
          Object.getOwnPropertyNames(this).forEach((key) => {
            alt[key] = this[key];
          }, this);
          return alt;
        },
        configurable: true,
        writable: true
      });
    }
  }
};
var ScopedLogger = _ScopedLogger;
__publicField(ScopedLogger, "metadata");
__publicField(ScopedLogger, "staticTags");
__publicField(ScopedLogger, "onLog");
__publicField(ScopedLogger, "accessToken");
__publicField(ScopedLogger, "remoteLogSupported", true);
__publicField(ScopedLogger, "limiterSupported", true);
__publicField(ScopedLogger, "userMetadata");
__publicField(ScopedLogger, "moduleName");
var VimConnectLogger = class {
  setModuleName(moduleName) {
    ScopedLogger.setModuleName(moduleName);
  }
  setMetadata(metadata) {
    ScopedLogger.setMetadata(metadata);
  }
  setUserMetadata(userMetadata) {
    ScopedLogger.setUserMetadata(userMetadata);
  }
  updateMetadata(paramsToUpdate) {
    ScopedLogger.updateMetadata(paramsToUpdate);
  }
  setStaticTags(tags) {
    ScopedLogger.setStaticTags(tags);
  }
  setDeviceId(deviceId) {
    ScopedLogger.setDeviceId(deviceId);
  }
  setAccessToken(accessToken2) {
    ScopedLogger.setAccessToken(accessToken2);
  }
  setRemoteLogSupport(supported) {
    ScopedLogger.setRemoteLogSupported(supported);
  }
  setLimiterSupport(supported) {
    ScopedLogger.setLimiterSupported(supported);
  }
  setOnLog(onLog) {
    ScopedLogger.setOnLog(onLog);
  }
  scope(scope, options, tags = {}) {
    return new ScopedLogger(scope, options, tags);
  }
};
var logger = new VimConnectLogger();
var MockLogger = class extends Logger {
  log() {
  }
};
var mockLogger = new MockLogger();

// ../../packages/vim-connect/build/index.js
var import_node_cache = __toESM(require_node_cache2());

// ../../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/modules/index.js
var import_tslib = __toESM(require_tslib(), 1);
var {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __exportStar,
  __createBinding,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn
} = import_tslib.default;

// ../../node_modules/.pnpm/graphql@14.7.0/node_modules/graphql/index.mjs
var import_language = __toESM(require_language(), 1);

// ../../node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.7.0/node_modules/graphql-tag/lib/index.js
var docCache = /* @__PURE__ */ new Map();
var fragmentSourceMap = /* @__PURE__ */ new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
  return string.replace(/[\s,]+/g, " ").trim();
}
function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
  var seenKeys = /* @__PURE__ */ new Set();
  var definitions = [];
  ast.definitions.forEach(function(fragmentDefinition) {
    if (fragmentDefinition.kind === "FragmentDefinition") {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
      var sourceKeySet = fragmentSourceMap.get(fragmentName);
      if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }
      } else if (!sourceKeySet) {
        fragmentSourceMap.set(fragmentName, sourceKeySet = /* @__PURE__ */ new Set());
      }
      sourceKeySet.add(sourceKey);
      if (!seenKeys.has(sourceKey)) {
        seenKeys.add(sourceKey);
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  });
  return __assign(__assign({}, ast), { definitions });
}
function stripLoc(doc) {
  var workSet = new Set(doc.definitions);
  workSet.forEach(function(node) {
    if (node.loc)
      delete node.loc;
    Object.keys(node).forEach(function(key) {
      var value = node[key];
      if (value && typeof value === "object") {
        workSet.add(value);
      }
    });
  });
  var loc = doc.loc;
  if (loc) {
    delete loc.startToken;
    delete loc.endToken;
  }
  return doc;
}
function parseDocument(source) {
  var cacheKey = normalize(source);
  if (!docCache.has(cacheKey)) {
    var parsed = (0, import_language.parse)(source, {
      experimentalFragmentVariables,
      allowLegacyFragmentVariables: experimentalFragmentVariables
    });
    if (!parsed || parsed.kind !== "Document") {
      throw new Error("Not a valid GraphQL document.");
    }
    docCache.set(cacheKey, stripLoc(processFragments(parsed)));
  }
  return docCache.get(cacheKey);
}
function gql(literals) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (typeof literals === "string") {
    literals = [literals];
  }
  var result2 = literals[0];
  args.forEach(function(arg, i) {
    if (arg && arg.kind === "Document") {
      result2 += arg.loc.source.body;
    } else {
      result2 += arg;
    }
    result2 += literals[i + 1];
  });
  return parseDocument(result2);
}
function resetCaches() {
  docCache.clear();
  fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
  printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}
var extras = {
  gql,
  resetCaches,
  disableFragmentWarnings,
  enableExperimentalFragmentVariables,
  disableExperimentalFragmentVariables
};
(function(gql_1) {
  gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
var lib_default = gql;

// ../../node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/modules/index.js
var import_tslib3 = __toESM(require_tslib2(), 1);
var {
  __extends: __extends2,
  __assign: __assign2,
  __rest: __rest2,
  __decorate: __decorate2,
  __param: __param2,
  __metadata: __metadata2,
  __awaiter: __awaiter2,
  __generator: __generator2,
  __exportStar: __exportStar2,
  __createBinding: __createBinding2,
  __values: __values2,
  __read: __read2,
  __spread: __spread2,
  __spreadArrays: __spreadArrays2,
  __await: __await2,
  __asyncGenerator: __asyncGenerator2,
  __asyncDelegator: __asyncDelegator2,
  __asyncValues: __asyncValues2,
  __makeTemplateObject: __makeTemplateObject2,
  __importStar: __importStar2,
  __importDefault: __importDefault2,
  __classPrivateFieldGet: __classPrivateFieldGet2,
  __classPrivateFieldSet: __classPrivateFieldSet2
} = import_tslib3.default;

// ../../node_modules/.pnpm/apollo-utilities@1.3.4_graphql@14.7.0/node_modules/apollo-utilities/lib/bundle.esm.js
var import_visitor = __toESM(require_visitor());

// ../../node_modules/.pnpm/ts-invariant@0.4.4/node_modules/ts-invariant/lib/invariant.esm.js
var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf;
var setPrototypeOf = _a === void 0 ? function(obj2, proto) {
  obj2.__proto__ = proto;
  return obj2;
} : _a;
var InvariantError = function(_super) {
  __extends2(InvariantError2, _super);
  function InvariantError2(message) {
    if (message === void 0) {
      message = genericMessage;
    }
    var _this = _super.call(this, typeof message === "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
    _this.framesToPop = 1;
    _this.name = genericMessage;
    setPrototypeOf(_this, InvariantError2.prototype);
    return _this;
  }
  return InvariantError2;
}(Error);
function invariant(condition, message) {
  if (!condition) {
    throw new InvariantError(message);
  }
}
function wrapConsoleMethod(method) {
  return function() {
    return console[method].apply(console, arguments);
  };
}
(function(invariant2) {
  invariant2.warn = wrapConsoleMethod("warn");
  invariant2.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
var processStub = { env: {} };
if (typeof process === "object") {
  processStub = process;
} else
  try {
    Function("stub", "process = stub")(processStub);
  } catch (atLeastWeTried) {
  }

// ../../node_modules/.pnpm/apollo-utilities@1.3.4_graphql@14.7.0/node_modules/apollo-utilities/lib/bundle.esm.js
var import_fast_json_stable_stringify = __toESM(require_fast_json_stable_stringify());

// ../../node_modules/.pnpm/@wry+equality@0.1.11/node_modules/@wry/equality/lib/equality.esm.js
var _a2 = Object.prototype;
var toString = _a2.toString;
var hasOwnProperty = _a2.hasOwnProperty;
var previousComparisons = /* @__PURE__ */ new Map();
function equal(a, b) {
  try {
    return check(a, b);
  } finally {
    previousComparisons.clear();
  }
}
function check(a, b) {
  if (a === b) {
    return true;
  }
  var aTag = toString.call(a);
  var bTag = toString.call(b);
  if (aTag !== bTag) {
    return false;
  }
  switch (aTag) {
    case "[object Array]":
      if (a.length !== b.length)
        return false;
    case "[object Object]": {
      if (previouslyCompared(a, b))
        return true;
      var aKeys = Object.keys(a);
      var bKeys = Object.keys(b);
      var keyCount = aKeys.length;
      if (keyCount !== bKeys.length)
        return false;
      for (var k = 0; k < keyCount; ++k) {
        if (!hasOwnProperty.call(b, aKeys[k])) {
          return false;
        }
      }
      for (var k = 0; k < keyCount; ++k) {
        var key = aKeys[k];
        if (!check(a[key], b[key])) {
          return false;
        }
      }
      return true;
    }
    case "[object Error]":
      return a.name === b.name && a.message === b.message;
    case "[object Number]":
      if (a !== a)
        return b !== b;
    case "[object Boolean]":
    case "[object Date]":
      return +a === +b;
    case "[object RegExp]":
    case "[object String]":
      return a == "" + b;
    case "[object Map]":
    case "[object Set]": {
      if (a.size !== b.size)
        return false;
      if (previouslyCompared(a, b))
        return true;
      var aIterator = a.entries();
      var isMap = aTag === "[object Map]";
      while (true) {
        var info = aIterator.next();
        if (info.done)
          break;
        var _a3 = info.value, aKey = _a3[0], aValue = _a3[1];
        if (!b.has(aKey)) {
          return false;
        }
        if (isMap && !check(aValue, b.get(aKey))) {
          return false;
        }
      }
      return true;
    }
  }
  return false;
}
function previouslyCompared(a, b) {
  var bSet = previousComparisons.get(a);
  if (bSet) {
    if (bSet.has(b))
      return true;
  } else {
    previousComparisons.set(a, bSet = /* @__PURE__ */ new Set());
  }
  bSet.add(b);
  return false;
}

// ../../node_modules/.pnpm/apollo-utilities@1.3.4_graphql@14.7.0/node_modules/apollo-utilities/lib/bundle.esm.js
function isStringValue(value) {
  return value.kind === "StringValue";
}
function isBooleanValue(value) {
  return value.kind === "BooleanValue";
}
function isIntValue(value) {
  return value.kind === "IntValue";
}
function isFloatValue(value) {
  return value.kind === "FloatValue";
}
function isVariable(value) {
  return value.kind === "Variable";
}
function isObjectValue(value) {
  return value.kind === "ObjectValue";
}
function isListValue(value) {
  return value.kind === "ListValue";
}
function isEnumValue(value) {
  return value.kind === "EnumValue";
}
function isNullValue(value) {
  return value.kind === "NullValue";
}
function valueToObjectRepresentation(argObj, name, value, variables) {
  if (isIntValue(value) || isFloatValue(value)) {
    argObj[name.value] = Number(value.value);
  } else if (isBooleanValue(value) || isStringValue(value)) {
    argObj[name.value] = value.value;
  } else if (isObjectValue(value)) {
    var nestedArgObj_1 = {};
    value.fields.map(function(obj2) {
      return valueToObjectRepresentation(nestedArgObj_1, obj2.name, obj2.value, variables);
    });
    argObj[name.value] = nestedArgObj_1;
  } else if (isVariable(value)) {
    var variableValue = (variables || {})[value.name.value];
    argObj[name.value] = variableValue;
  } else if (isListValue(value)) {
    argObj[name.value] = value.values.map(function(listValue) {
      var nestedArgArrayObj = {};
      valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
      return nestedArgArrayObj[name.value];
    });
  } else if (isEnumValue(value)) {
    argObj[name.value] = value.value;
  } else if (isNullValue(value)) {
    argObj[name.value] = null;
  } else {
    throw false ? new InvariantError(17) : new InvariantError('The inline argument "' + name.value + '" of kind "' + value.kind + '"is not supported. Use variables instead of inline arguments to overcome this limitation.');
  }
}
function storeKeyNameFromField(field, variables) {
  var directivesObj = null;
  if (field.directives) {
    directivesObj = {};
    field.directives.forEach(function(directive) {
      directivesObj[directive.name.value] = {};
      if (directive.arguments) {
        directive.arguments.forEach(function(_a3) {
          var name = _a3.name, value = _a3.value;
          return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
        });
      }
    });
  }
  var argObj = null;
  if (field.arguments && field.arguments.length) {
    argObj = {};
    field.arguments.forEach(function(_a3) {
      var name = _a3.name, value = _a3.value;
      return valueToObjectRepresentation(argObj, name, value, variables);
    });
  }
  return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
];
function getStoreKeyName(fieldName, args, directives) {
  if (directives && directives["connection"] && directives["connection"]["key"]) {
    if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
      var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
      filterKeys.sort();
      var queryArgs_1 = args;
      var filteredArgs_1 = {};
      filterKeys.forEach(function(key) {
        filteredArgs_1[key] = queryArgs_1[key];
      });
      return directives["connection"]["key"] + "(" + JSON.stringify(filteredArgs_1) + ")";
    } else {
      return directives["connection"]["key"];
    }
  }
  var completeFieldName = fieldName;
  if (args) {
    var stringifiedArgs = (0, import_fast_json_stable_stringify.default)(args);
    completeFieldName += "(" + stringifiedArgs + ")";
  }
  if (directives) {
    Object.keys(directives).forEach(function(key) {
      if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
        return;
      if (directives[key] && Object.keys(directives[key]).length) {
        completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
      } else {
        completeFieldName += "@" + key;
      }
    });
  }
  return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
  if (field.arguments && field.arguments.length) {
    var argObj_1 = {};
    field.arguments.forEach(function(_a3) {
      var name = _a3.name, value = _a3.value;
      return valueToObjectRepresentation(argObj_1, name, value, variables);
    });
    return argObj_1;
  }
  return null;
}
function resultKeyNameFromField(field) {
  return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
  return selection.kind === "Field";
}
function isInlineFragment(selection) {
  return selection.kind === "InlineFragment";
}
function isIdValue(idObject) {
  return idObject && idObject.type === "id" && typeof idObject.generated === "boolean";
}
function toIdValue(idConfig, generated) {
  if (generated === void 0) {
    generated = false;
  }
  return __assign2({ type: "id", generated }, typeof idConfig === "string" ? { id: idConfig, typename: void 0 } : idConfig);
}
function isJsonValue(jsonObject) {
  return jsonObject != null && typeof jsonObject === "object" && jsonObject.type === "json";
}
function getDirectiveInfoFromField(field, variables) {
  if (field.directives && field.directives.length) {
    var directiveObj_1 = {};
    field.directives.forEach(function(directive) {
      directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
    });
    return directiveObj_1;
  }
  return null;
}
function shouldInclude(selection, variables) {
  if (variables === void 0) {
    variables = {};
  }
  return getInclusionDirectives(selection.directives).every(function(_a3) {
    var directive = _a3.directive, ifArgument = _a3.ifArgument;
    var evaledValue = false;
    if (ifArgument.value.kind === "Variable") {
      evaledValue = variables[ifArgument.value.name.value];
      false ? invariant(evaledValue !== void 0, 13) : invariant(evaledValue !== void 0, "Invalid variable referenced in @" + directive.name.value + " directive.");
    } else {
      evaledValue = ifArgument.value.value;
    }
    return directive.name.value === "skip" ? !evaledValue : evaledValue;
  });
}
function getDirectiveNames(doc) {
  var names = [];
  (0, import_visitor.visit)(doc, {
    Directive: function(node) {
      names.push(node.name.value);
    }
  });
  return names;
}
function hasDirectives(names, doc) {
  return getDirectiveNames(doc).some(function(name) {
    return names.indexOf(name) > -1;
  });
}
function hasClientExports(document2) {
  return document2 && hasDirectives(["client"], document2) && hasDirectives(["export"], document2);
}
function isInclusionDirective(_a3) {
  var value = _a3.name.value;
  return value === "skip" || value === "include";
}
function getInclusionDirectives(directives) {
  return directives ? directives.filter(isInclusionDirective).map(function(directive) {
    var directiveArguments = directive.arguments;
    var directiveName = directive.name.value;
    false ? invariant(directiveArguments && directiveArguments.length === 1, 14) : invariant(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @" + directiveName + " directive.");
    var ifArgument = directiveArguments[0];
    false ? invariant(ifArgument.name && ifArgument.name.value === "if", 15) : invariant(ifArgument.name && ifArgument.name.value === "if", "Invalid argument for the @" + directiveName + " directive.");
    var ifValue = ifArgument.value;
    false ? invariant(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 16) : invariant(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), "Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
    return { directive, ifArgument };
  }) : [];
}
function getFragmentQueryDocument(document2, fragmentName) {
  var actualFragmentName = fragmentName;
  var fragments = [];
  document2.definitions.forEach(function(definition) {
    if (definition.kind === "OperationDefinition") {
      throw false ? new InvariantError(11) : new InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : "") + ". No operations are allowed when using a fragment as a query. Only fragments are allowed.");
    }
    if (definition.kind === "FragmentDefinition") {
      fragments.push(definition);
    }
  });
  if (typeof actualFragmentName === "undefined") {
    false ? invariant(fragments.length === 1, 12) : invariant(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
    actualFragmentName = fragments[0].name.value;
  }
  var query = __assign2(__assign2({}, document2), { definitions: __spreadArrays2([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: actualFragmentName
            }
          }
        ]
      }
    }
  ], document2.definitions) });
  return query;
}
function assign(target) {
  var sources = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    sources[_i - 1] = arguments[_i];
  }
  sources.forEach(function(source) {
    if (typeof source === "undefined" || source === null) {
      return;
    }
    Object.keys(source).forEach(function(key) {
      target[key] = source[key];
    });
  });
  return target;
}
function checkDocument(doc) {
  false ? invariant(doc && doc.kind === "Document", 2) : invariant(doc && doc.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql');
  var operations = doc.definitions.filter(function(d) {
    return d.kind !== "FragmentDefinition";
  }).map(function(definition) {
    if (definition.kind !== "OperationDefinition") {
      throw false ? new InvariantError(3) : new InvariantError('Schema type definitions not allowed in queries. Found: "' + definition.kind + '"');
    }
    return definition;
  });
  false ? invariant(operations.length <= 1, 4) : invariant(operations.length <= 1, "Ambiguous GraphQL document: contains " + operations.length + " operations");
  return doc;
}
function getOperationDefinition(doc) {
  checkDocument(doc);
  return doc.definitions.filter(function(definition) {
    return definition.kind === "OperationDefinition";
  })[0];
}
function getOperationName(doc) {
  return doc.definitions.filter(function(definition) {
    return definition.kind === "OperationDefinition" && definition.name;
  }).map(function(x) {
    return x.name.value;
  })[0] || null;
}
function getFragmentDefinitions(doc) {
  return doc.definitions.filter(function(definition) {
    return definition.kind === "FragmentDefinition";
  });
}
function getQueryDefinition(doc) {
  var queryDef = getOperationDefinition(doc);
  false ? invariant(queryDef && queryDef.operation === "query", 6) : invariant(queryDef && queryDef.operation === "query", "Must contain a query definition.");
  return queryDef;
}
function getFragmentDefinition(doc) {
  false ? invariant(doc.kind === "Document", 7) : invariant(doc.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql');
  false ? invariant(doc.definitions.length <= 1, 8) : invariant(doc.definitions.length <= 1, "Fragment must have exactly one definition.");
  var fragmentDef = doc.definitions[0];
  false ? invariant(fragmentDef.kind === "FragmentDefinition", 9) : invariant(fragmentDef.kind === "FragmentDefinition", "Must be a fragment definition.");
  return fragmentDef;
}
function getMainDefinition(queryDoc) {
  checkDocument(queryDoc);
  var fragmentDefinition;
  for (var _i = 0, _a3 = queryDoc.definitions; _i < _a3.length; _i++) {
    var definition = _a3[_i];
    if (definition.kind === "OperationDefinition") {
      var operation = definition.operation;
      if (operation === "query" || operation === "mutation" || operation === "subscription") {
        return definition;
      }
    }
    if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
      fragmentDefinition = definition;
    }
  }
  if (fragmentDefinition) {
    return fragmentDefinition;
  }
  throw false ? new InvariantError(10) : new InvariantError("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.");
}
function createFragmentMap(fragments) {
  if (fragments === void 0) {
    fragments = [];
  }
  var symTable = {};
  fragments.forEach(function(fragment) {
    symTable[fragment.name.value] = fragment;
  });
  return symTable;
}
function getDefaultValues(definition) {
  if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
    var defaultValues = definition.variableDefinitions.filter(function(_a3) {
      var defaultValue = _a3.defaultValue;
      return defaultValue;
    }).map(function(_a3) {
      var variable = _a3.variable, defaultValue = _a3.defaultValue;
      var defaultValueObj = {};
      valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
      return defaultValueObj;
    });
    return assign.apply(void 0, __spreadArrays2([{}], defaultValues));
  }
  return {};
}
function filterInPlace(array, test, context) {
  var target = 0;
  array.forEach(function(elem, i) {
    if (test.call(this, elem, i, array)) {
      array[target++] = elem;
    }
  }, context);
  array.length = target;
  return array;
}
var TYPENAME_FIELD = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
};
function isEmpty(op, fragments) {
  return op.selectionSet.selections.every(function(selection) {
    return selection.kind === "FragmentSpread" && isEmpty(fragments[selection.name.value], fragments);
  });
}
function nullIfDocIsEmpty(doc) {
  return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc))) ? null : doc;
}
function getDirectiveMatcher(directives) {
  return function directiveMatcher(directive) {
    return directives.some(function(dir) {
      return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
    });
  };
}
function removeDirectivesFromDocument(directives, doc) {
  var variablesInUse = /* @__PURE__ */ Object.create(null);
  var variablesToRemove = [];
  var fragmentSpreadsInUse = /* @__PURE__ */ Object.create(null);
  var fragmentSpreadsToRemove = [];
  var modifiedDoc = nullIfDocIsEmpty((0, import_visitor.visit)(doc, {
    Variable: {
      enter: function(node, _key, parent2) {
        if (parent2.kind !== "VariableDefinition") {
          variablesInUse[node.name.value] = true;
        }
      }
    },
    Field: {
      enter: function(node) {
        if (directives && node.directives) {
          var shouldRemoveField = directives.some(function(directive) {
            return directive.remove;
          });
          if (shouldRemoveField && node.directives && node.directives.some(getDirectiveMatcher(directives))) {
            if (node.arguments) {
              node.arguments.forEach(function(arg) {
                if (arg.value.kind === "Variable") {
                  variablesToRemove.push({
                    name: arg.value.name.value
                  });
                }
              });
            }
            if (node.selectionSet) {
              getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                fragmentSpreadsToRemove.push({
                  name: frag.name.value
                });
              });
            }
            return null;
          }
        }
      }
    },
    FragmentSpread: {
      enter: function(node) {
        fragmentSpreadsInUse[node.name.value] = true;
      }
    },
    Directive: {
      enter: function(node) {
        if (getDirectiveMatcher(directives)(node)) {
          return null;
        }
      }
    }
  }));
  if (modifiedDoc && filterInPlace(variablesToRemove, function(v) {
    return !variablesInUse[v.name];
  }).length) {
    modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
  }
  if (modifiedDoc && filterInPlace(fragmentSpreadsToRemove, function(fs) {
    return !fragmentSpreadsInUse[fs.name];
  }).length) {
    modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
  }
  return modifiedDoc;
}
function addTypenameToDocument(doc) {
  return (0, import_visitor.visit)(checkDocument(doc), {
    SelectionSet: {
      enter: function(node, _key, parent2) {
        if (parent2 && parent2.kind === "OperationDefinition") {
          return;
        }
        var selections = node.selections;
        if (!selections) {
          return;
        }
        var skip = selections.some(function(selection) {
          return isField(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
        });
        if (skip) {
          return;
        }
        var field = parent2;
        if (isField(field) && field.directives && field.directives.some(function(d) {
          return d.name.value === "export";
        })) {
          return;
        }
        return __assign2(__assign2({}, node), { selections: __spreadArrays2(selections, [TYPENAME_FIELD]) });
      }
    }
  });
}
var connectionRemoveConfig = {
  test: function(directive) {
    var willRemove = directive.name.value === "connection";
    if (willRemove) {
      if (!directive.arguments || !directive.arguments.some(function(arg) {
        return arg.name.value === "key";
      })) {
        invariant.warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key.");
      }
    }
    return willRemove;
  }
};
function removeConnectionDirectiveFromDocument(doc) {
  return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function getArgumentMatcher(config) {
  return function argumentMatcher(argument) {
    return config.some(function(aConfig) {
      return argument.value && argument.value.kind === "Variable" && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
    });
  };
}
function removeArgumentsFromDocument(config, doc) {
  var argMatcher = getArgumentMatcher(config);
  return nullIfDocIsEmpty((0, import_visitor.visit)(doc, {
    OperationDefinition: {
      enter: function(node) {
        return __assign2(__assign2({}, node), { variableDefinitions: node.variableDefinitions.filter(function(varDef) {
          return !config.some(function(arg) {
            return arg.name === varDef.variable.name.value;
          });
        }) });
      }
    },
    Field: {
      enter: function(node) {
        var shouldRemoveField = config.some(function(argConfig) {
          return argConfig.remove;
        });
        if (shouldRemoveField) {
          var argMatchCount_1 = 0;
          node.arguments.forEach(function(arg) {
            if (argMatcher(arg)) {
              argMatchCount_1 += 1;
            }
          });
          if (argMatchCount_1 === 1) {
            return null;
          }
        }
      }
    },
    Argument: {
      enter: function(node) {
        if (argMatcher(node)) {
          return null;
        }
      }
    }
  }));
}
function removeFragmentSpreadFromDocument(config, doc) {
  function enter(node) {
    if (config.some(function(def) {
      return def.name === node.name.value;
    })) {
      return null;
    }
  }
  return nullIfDocIsEmpty((0, import_visitor.visit)(doc, {
    FragmentSpread: { enter },
    FragmentDefinition: { enter }
  }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
  var allFragments = [];
  selectionSet.selections.forEach(function(selection) {
    if ((isField(selection) || isInlineFragment(selection)) && selection.selectionSet) {
      getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
        return allFragments.push(frag);
      });
    } else if (selection.kind === "FragmentSpread") {
      allFragments.push(selection);
    }
  });
  return allFragments;
}
function buildQueryFromSelectionSet(document2) {
  var definition = getMainDefinition(document2);
  var definitionOperation = definition.operation;
  if (definitionOperation === "query") {
    return document2;
  }
  var modifiedDoc = (0, import_visitor.visit)(document2, {
    OperationDefinition: {
      enter: function(node) {
        return __assign2(__assign2({}, node), { operation: "query" });
      }
    }
  });
  return modifiedDoc;
}
function removeClientSetsFromDocument(document2) {
  checkDocument(document2);
  var modifiedDoc = removeDirectivesFromDocument([
    {
      test: function(directive) {
        return directive.name.value === "client";
      },
      remove: true
    }
  ], document2);
  if (modifiedDoc) {
    modifiedDoc = (0, import_visitor.visit)(modifiedDoc, {
      FragmentDefinition: {
        enter: function(node) {
          if (node.selectionSet) {
            var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
              return isField(selection) && selection.name.value === "__typename";
            });
            if (isTypenameOnly) {
              return null;
            }
          }
        }
      }
    });
  }
  return modifiedDoc;
}
var canUseWeakMap = typeof WeakMap === "function" && !(typeof navigator === "object" && navigator.product === "ReactNative");
var toString2 = Object.prototype.toString;
function cloneDeep(value) {
  return cloneDeepHelper(value, /* @__PURE__ */ new Map());
}
function cloneDeepHelper(val, seen) {
  switch (toString2.call(val)) {
    case "[object Array]": {
      if (seen.has(val))
        return seen.get(val);
      var copy_1 = val.slice(0);
      seen.set(val, copy_1);
      copy_1.forEach(function(child, i) {
        copy_1[i] = cloneDeepHelper(child, seen);
      });
      return copy_1;
    }
    case "[object Object]": {
      if (seen.has(val))
        return seen.get(val);
      var copy_2 = Object.create(Object.getPrototypeOf(val));
      seen.set(val, copy_2);
      Object.keys(val).forEach(function(key) {
        copy_2[key] = cloneDeepHelper(val[key], seen);
      });
      return copy_2;
    }
    default:
      return val;
  }
}
function getEnv() {
  if (typeof process !== "undefined" && "development") {
    return "development";
  }
  return "development";
}
function isEnv(env2) {
  return getEnv() === env2;
}
function isProduction() {
  return isEnv("production") === true;
}
function isDevelopment() {
  return isEnv("development") === true;
}
function isTest() {
  return isEnv("test") === true;
}
function tryFunctionOrLogError(f) {
  try {
    return f();
  } catch (e) {
    if (console.error) {
      console.error(e);
    }
  }
}
function graphQLResultHasError(result2) {
  return result2.errors && result2.errors.length;
}
function deepFreeze(o) {
  Object.freeze(o);
  Object.getOwnPropertyNames(o).forEach(function(prop) {
    if (o[prop] !== null && (typeof o[prop] === "object" || typeof o[prop] === "function") && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  return o;
}
function maybeDeepFreeze(obj2) {
  if (isDevelopment() || isTest()) {
    var symbolIsPolyfilled = typeof Symbol === "function" && typeof Symbol("") === "string";
    if (!symbolIsPolyfilled) {
      return deepFreeze(obj2);
    }
  }
  return obj2;
}
var hasOwnProperty2 = Object.prototype.hasOwnProperty;
function mergeDeep() {
  var sources = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }
  return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
  var target = sources[0] || {};
  var count = sources.length;
  if (count > 1) {
    var pastCopies = [];
    target = shallowCopyForMerge(target, pastCopies);
    for (var i = 1; i < count; ++i) {
      target = mergeHelper(target, sources[i], pastCopies);
    }
  }
  return target;
}
function isObject2(obj2) {
  return obj2 !== null && typeof obj2 === "object";
}
function mergeHelper(target, source, pastCopies) {
  if (isObject2(source) && isObject2(target)) {
    if (Object.isExtensible && !Object.isExtensible(target)) {
      target = shallowCopyForMerge(target, pastCopies);
    }
    Object.keys(source).forEach(function(sourceKey) {
      var sourceValue = source[sourceKey];
      if (hasOwnProperty2.call(target, sourceKey)) {
        var targetValue = target[sourceKey];
        if (sourceValue !== targetValue) {
          target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
        }
      } else {
        target[sourceKey] = sourceValue;
      }
    });
    return target;
  }
  return source;
}
function shallowCopyForMerge(value, pastCopies) {
  if (value !== null && typeof value === "object" && pastCopies.indexOf(value) < 0) {
    if (Array.isArray(value)) {
      value = value.slice(0);
    } else {
      value = __assign2({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    pastCopies.push(value);
  }
  return value;
}

// ../../node_modules/.pnpm/zen-observable-ts@0.8.21/node_modules/zen-observable-ts/lib/bundle.esm.js
var import_zen_observable = __toESM(require_zen_observable());
var Observable = import_zen_observable.default;
var bundle_esm_default = Observable;

// ../../node_modules/.pnpm/apollo-link@1.2.14_graphql@14.7.0/node_modules/apollo-link/lib/bundle.esm.js
function validateOperation(operation) {
  var OPERATION_FIELDS = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ];
  for (var _i = 0, _a3 = Object.keys(operation); _i < _a3.length; _i++) {
    var key = _a3[_i];
    if (OPERATION_FIELDS.indexOf(key) < 0) {
      throw false ? new InvariantError(2) : new InvariantError("illegal argument: " + key);
    }
  }
  return operation;
}
var LinkError = function(_super) {
  __extends2(LinkError2, _super);
  function LinkError2(message, link) {
    var _this = _super.call(this, message) || this;
    _this.link = link;
    return _this;
  }
  return LinkError2;
}(Error);
function isTerminating(link) {
  return link.request.length <= 1;
}
function fromError(errorValue) {
  return new bundle_esm_default(function(observer) {
    observer.error(errorValue);
  });
}
function transformOperation(operation) {
  var transformedOperation = {
    variables: operation.variables || {},
    extensions: operation.extensions || {},
    operationName: operation.operationName,
    query: operation.query
  };
  if (!transformedOperation.operationName) {
    transformedOperation.operationName = typeof transformedOperation.query !== "string" ? getOperationName(transformedOperation.query) : "";
  }
  return transformedOperation;
}
function createOperation(starting, operation) {
  var context = __assign2({}, starting);
  var setContext2 = function(next) {
    if (typeof next === "function") {
      context = __assign2({}, context, next(context));
    } else {
      context = __assign2({}, context, next);
    }
  };
  var getContext = function() {
    return __assign2({}, context);
  };
  Object.defineProperty(operation, "setContext", {
    enumerable: false,
    value: setContext2
  });
  Object.defineProperty(operation, "getContext", {
    enumerable: false,
    value: getContext
  });
  Object.defineProperty(operation, "toKey", {
    enumerable: false,
    value: function() {
      return getKey(operation);
    }
  });
  return operation;
}
function getKey(operation) {
  var query = operation.query, variables = operation.variables, operationName = operation.operationName;
  return JSON.stringify([operationName, query, variables]);
}
function passthrough(op, forward) {
  return forward ? forward(op) : bundle_esm_default.of();
}
function toLink(handler) {
  return typeof handler === "function" ? new ApolloLink(handler) : handler;
}
function empty() {
  return new ApolloLink(function() {
    return bundle_esm_default.of();
  });
}
function from(links) {
  if (links.length === 0)
    return empty();
  return links.map(toLink).reduce(function(x, y) {
    return x.concat(y);
  });
}
function split(test, left, right) {
  var leftLink = toLink(left);
  var rightLink = toLink(right || new ApolloLink(passthrough));
  if (isTerminating(leftLink) && isTerminating(rightLink)) {
    return new ApolloLink(function(operation) {
      return test(operation) ? leftLink.request(operation) || bundle_esm_default.of() : rightLink.request(operation) || bundle_esm_default.of();
    });
  } else {
    return new ApolloLink(function(operation, forward) {
      return test(operation) ? leftLink.request(operation, forward) || bundle_esm_default.of() : rightLink.request(operation, forward) || bundle_esm_default.of();
    });
  }
}
var concat = function(first, second) {
  var firstLink = toLink(first);
  if (isTerminating(firstLink)) {
    invariant.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
    return firstLink;
  }
  var nextLink = toLink(second);
  if (isTerminating(nextLink)) {
    return new ApolloLink(function(operation) {
      return firstLink.request(operation, function(op) {
        return nextLink.request(op) || bundle_esm_default.of();
      }) || bundle_esm_default.of();
    });
  } else {
    return new ApolloLink(function(operation, forward) {
      return firstLink.request(operation, function(op) {
        return nextLink.request(op, forward) || bundle_esm_default.of();
      }) || bundle_esm_default.of();
    });
  }
};
var ApolloLink = function() {
  function ApolloLink2(request) {
    if (request)
      this.request = request;
  }
  ApolloLink2.prototype.split = function(test, left, right) {
    return this.concat(split(test, left, right || new ApolloLink2(passthrough)));
  };
  ApolloLink2.prototype.concat = function(next) {
    return concat(this, next);
  };
  ApolloLink2.prototype.request = function(operation, forward) {
    throw false ? new InvariantError(1) : new InvariantError("request is not implemented");
  };
  ApolloLink2.empty = empty;
  ApolloLink2.from = from;
  ApolloLink2.split = split;
  ApolloLink2.execute = execute;
  return ApolloLink2;
}();
function execute(link, operation) {
  return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || bundle_esm_default.of();
}

// ../../node_modules/.pnpm/symbol-observable@1.2.0/node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root3) {
  var result2;
  var Symbol3 = root3.Symbol;
  if (typeof Symbol3 === "function") {
    if (Symbol3.observable) {
      result2 = Symbol3.observable;
    } else {
      result2 = Symbol3("observable");
      Symbol3.observable = result2;
    }
  } else {
    result2 = "@@observable";
  }
  return result2;
}

// ../../node_modules/.pnpm/symbol-observable@1.2.0/node_modules/symbol-observable/es/index.js
var root;
if (typeof self !== "undefined") {
  root = self;
} else if (typeof window !== "undefined") {
  root = window;
} else if (typeof global !== "undefined") {
  root = global;
} else if (typeof module !== "undefined") {
  root = module;
} else {
  root = Function("return this")();
}
var result = symbolObservablePonyfill(root);
var es_default = result;

// ../../node_modules/.pnpm/apollo-client@2.6.10_graphql@14.7.0/node_modules/apollo-client/bundle.esm.js
var import_visitor2 = __toESM(require_visitor());
var NetworkStatus;
(function(NetworkStatus2) {
  NetworkStatus2[NetworkStatus2["loading"] = 1] = "loading";
  NetworkStatus2[NetworkStatus2["setVariables"] = 2] = "setVariables";
  NetworkStatus2[NetworkStatus2["fetchMore"] = 3] = "fetchMore";
  NetworkStatus2[NetworkStatus2["refetch"] = 4] = "refetch";
  NetworkStatus2[NetworkStatus2["poll"] = 6] = "poll";
  NetworkStatus2[NetworkStatus2["ready"] = 7] = "ready";
  NetworkStatus2[NetworkStatus2["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
  return networkStatus < 7;
}
var Observable2 = function(_super) {
  __extends2(Observable3, _super);
  function Observable3() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Observable3.prototype[es_default] = function() {
    return this;
  };
  Observable3.prototype["@@observable"] = function() {
    return this;
  };
  return Observable3;
}(bundle_esm_default);
function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}
function isApolloError(err) {
  return err.hasOwnProperty("graphQLErrors");
}
var generateErrorMessage = function(err) {
  var message = "";
  if (isNonEmptyArray(err.graphQLErrors)) {
    err.graphQLErrors.forEach(function(graphQLError) {
      var errorMessage2 = graphQLError ? graphQLError.message : "Error message not found.";
      message += "GraphQL error: " + errorMessage2 + "\n";
    });
  }
  if (err.networkError) {
    message += "Network error: " + err.networkError.message + "\n";
  }
  message = message.replace(/\n$/, "");
  return message;
};
var ApolloError = function(_super) {
  __extends2(ApolloError2, _super);
  function ApolloError2(_a3) {
    var graphQLErrors = _a3.graphQLErrors, networkError = _a3.networkError, errorMessage2 = _a3.errorMessage, extraInfo = _a3.extraInfo;
    var _this = _super.call(this, errorMessage2) || this;
    _this.graphQLErrors = graphQLErrors || [];
    _this.networkError = networkError || null;
    if (!errorMessage2) {
      _this.message = generateErrorMessage(_this);
    } else {
      _this.message = errorMessage2;
    }
    _this.extraInfo = extraInfo;
    _this.__proto__ = ApolloError2.prototype;
    return _this;
  }
  return ApolloError2;
}(Error);
var FetchType;
(function(FetchType2) {
  FetchType2[FetchType2["normal"] = 1] = "normal";
  FetchType2[FetchType2["refetch"] = 2] = "refetch";
  FetchType2[FetchType2["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));
var hasError = function(storeValue, policy) {
  if (policy === void 0) {
    policy = "none";
  }
  return storeValue && (storeValue.networkError || policy === "none" && isNonEmptyArray(storeValue.graphQLErrors));
};
var ObservableQuery = function(_super) {
  __extends2(ObservableQuery2, _super);
  function ObservableQuery2(_a3) {
    var queryManager = _a3.queryManager, options = _a3.options, _b = _a3.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
    var _this = _super.call(this, function(observer) {
      return _this.onSubscribe(observer);
    }) || this;
    _this.observers = /* @__PURE__ */ new Set();
    _this.subscriptions = /* @__PURE__ */ new Set();
    _this.isTornDown = false;
    _this.options = options;
    _this.variables = options.variables || {};
    _this.queryId = queryManager.generateQueryId();
    _this.shouldSubscribe = shouldSubscribe;
    var opDef = getOperationDefinition(options.query);
    _this.queryName = opDef && opDef.name && opDef.name.value;
    _this.queryManager = queryManager;
    return _this;
  }
  ObservableQuery2.prototype.result = function() {
    var _this = this;
    return new Promise(function(resolve, reject) {
      var observer = {
        next: function(result2) {
          resolve(result2);
          _this.observers.delete(observer);
          if (!_this.observers.size) {
            _this.queryManager.removeQuery(_this.queryId);
          }
          setTimeout(function() {
            subscription.unsubscribe();
          }, 0);
        },
        error: reject
      };
      var subscription = _this.subscribe(observer);
    });
  };
  ObservableQuery2.prototype.currentResult = function() {
    var result2 = this.getCurrentResult();
    if (result2.data === void 0) {
      result2.data = {};
    }
    return result2;
  };
  ObservableQuery2.prototype.getCurrentResult = function() {
    if (this.isTornDown) {
      var lastResult = this.lastResult;
      return {
        data: !this.lastError && lastResult && lastResult.data || void 0,
        error: this.lastError,
        loading: false,
        networkStatus: NetworkStatus.error
      };
    }
    var _a3 = this.queryManager.getCurrentQueryResult(this), data = _a3.data, partial = _a3.partial;
    var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
    var result2;
    var fetchPolicy = this.options.fetchPolicy;
    var isNetworkFetchPolicy = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
    if (queryStoreValue) {
      var networkStatus = queryStoreValue.networkStatus;
      if (hasError(queryStoreValue, this.options.errorPolicy)) {
        return {
          data: void 0,
          loading: false,
          networkStatus,
          error: new ApolloError({
            graphQLErrors: queryStoreValue.graphQLErrors,
            networkError: queryStoreValue.networkError
          })
        };
      }
      if (queryStoreValue.variables) {
        this.options.variables = __assign2(__assign2({}, this.options.variables), queryStoreValue.variables);
        this.variables = this.options.variables;
      }
      result2 = {
        data,
        loading: isNetworkRequestInFlight(networkStatus),
        networkStatus
      };
      if (queryStoreValue.graphQLErrors && this.options.errorPolicy === "all") {
        result2.errors = queryStoreValue.graphQLErrors;
      }
    } else {
      var loading = isNetworkFetchPolicy || partial && fetchPolicy !== "cache-only";
      result2 = {
        data,
        loading,
        networkStatus: loading ? NetworkStatus.loading : NetworkStatus.ready
      };
    }
    if (!partial) {
      this.updateLastResult(__assign2(__assign2({}, result2), { stale: false }));
    }
    return __assign2(__assign2({}, result2), { partial });
  };
  ObservableQuery2.prototype.isDifferentFromLastResult = function(newResult) {
    var snapshot = this.lastResultSnapshot;
    return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && equal(snapshot.data, newResult.data));
  };
  ObservableQuery2.prototype.getLastResult = function() {
    return this.lastResult;
  };
  ObservableQuery2.prototype.getLastError = function() {
    return this.lastError;
  };
  ObservableQuery2.prototype.resetLastResults = function() {
    delete this.lastResult;
    delete this.lastResultSnapshot;
    delete this.lastError;
    this.isTornDown = false;
  };
  ObservableQuery2.prototype.resetQueryStoreErrors = function() {
    var queryStore = this.queryManager.queryStore.get(this.queryId);
    if (queryStore) {
      queryStore.networkError = null;
      queryStore.graphQLErrors = [];
    }
  };
  ObservableQuery2.prototype.refetch = function(variables) {
    var fetchPolicy = this.options.fetchPolicy;
    if (fetchPolicy === "cache-only") {
      return Promise.reject(false ? new InvariantError(1) : new InvariantError("cache-only fetchPolicy option should not be used together with query refetch."));
    }
    if (fetchPolicy !== "no-cache" && fetchPolicy !== "cache-and-network") {
      fetchPolicy = "network-only";
    }
    if (!equal(this.variables, variables)) {
      this.variables = __assign2(__assign2({}, this.variables), variables);
    }
    if (!equal(this.options.variables, this.variables)) {
      this.options.variables = __assign2(__assign2({}, this.options.variables), this.variables);
    }
    return this.queryManager.fetchQuery(this.queryId, __assign2(__assign2({}, this.options), { fetchPolicy }), FetchType.refetch);
  };
  ObservableQuery2.prototype.fetchMore = function(fetchMoreOptions) {
    var _this = this;
    false ? invariant(fetchMoreOptions.updateQuery, 2) : invariant(fetchMoreOptions.updateQuery, "updateQuery option is required. This function defines how to update the query data with the new results.");
    var combinedOptions = __assign2(__assign2({}, fetchMoreOptions.query ? fetchMoreOptions : __assign2(__assign2(__assign2({}, this.options), fetchMoreOptions), { variables: __assign2(__assign2({}, this.variables), fetchMoreOptions.variables) })), { fetchPolicy: "network-only" });
    var qid = this.queryManager.generateQueryId();
    return this.queryManager.fetchQuery(qid, combinedOptions, FetchType.normal, this.queryId).then(function(fetchMoreResult) {
      _this.updateQuery(function(previousResult) {
        return fetchMoreOptions.updateQuery(previousResult, {
          fetchMoreResult: fetchMoreResult.data,
          variables: combinedOptions.variables
        });
      });
      _this.queryManager.stopQuery(qid);
      return fetchMoreResult;
    }, function(error) {
      _this.queryManager.stopQuery(qid);
      throw error;
    });
  };
  ObservableQuery2.prototype.subscribeToMore = function(options) {
    var _this = this;
    var subscription = this.queryManager.startGraphQLSubscription({
      query: options.document,
      variables: options.variables
    }).subscribe({
      next: function(subscriptionData) {
        var updateQuery = options.updateQuery;
        if (updateQuery) {
          _this.updateQuery(function(previous, _a3) {
            var variables = _a3.variables;
            return updateQuery(previous, {
              subscriptionData,
              variables
            });
          });
        }
      },
      error: function(err) {
        if (options.onError) {
          options.onError(err);
          return;
        }
        invariant.error("Unhandled GraphQL subscription error", err);
      }
    });
    this.subscriptions.add(subscription);
    return function() {
      if (_this.subscriptions.delete(subscription)) {
        subscription.unsubscribe();
      }
    };
  };
  ObservableQuery2.prototype.setOptions = function(opts) {
    var oldFetchPolicy = this.options.fetchPolicy;
    this.options = __assign2(__assign2({}, this.options), opts);
    if (opts.pollInterval) {
      this.startPolling(opts.pollInterval);
    } else if (opts.pollInterval === 0) {
      this.stopPolling();
    }
    var fetchPolicy = opts.fetchPolicy;
    return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === "cache-only" || oldFetchPolicy === "standby" || fetchPolicy === "network-only"), opts.fetchResults);
  };
  ObservableQuery2.prototype.setVariables = function(variables, tryFetch, fetchResults) {
    if (tryFetch === void 0) {
      tryFetch = false;
    }
    if (fetchResults === void 0) {
      fetchResults = true;
    }
    this.isTornDown = false;
    variables = variables || this.variables;
    if (!tryFetch && equal(variables, this.variables)) {
      return this.observers.size && fetchResults ? this.result() : Promise.resolve();
    }
    this.variables = this.options.variables = variables;
    if (!this.observers.size) {
      return Promise.resolve();
    }
    return this.queryManager.fetchQuery(this.queryId, this.options);
  };
  ObservableQuery2.prototype.updateQuery = function(mapFn) {
    var queryManager = this.queryManager;
    var _a3 = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a3.previousResult, variables = _a3.variables, document2 = _a3.document;
    var newResult = tryFunctionOrLogError(function() {
      return mapFn(previousResult, { variables });
    });
    if (newResult) {
      queryManager.dataStore.markUpdateQueryResult(document2, variables, newResult);
      queryManager.broadcastQueries();
    }
  };
  ObservableQuery2.prototype.stopPolling = function() {
    this.queryManager.stopPollingQuery(this.queryId);
    this.options.pollInterval = void 0;
  };
  ObservableQuery2.prototype.startPolling = function(pollInterval) {
    assertNotCacheFirstOrOnly(this);
    this.options.pollInterval = pollInterval;
    this.queryManager.startPollingQuery(this.options, this.queryId);
  };
  ObservableQuery2.prototype.updateLastResult = function(newResult) {
    var previousResult = this.lastResult;
    this.lastResult = newResult;
    this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : cloneDeep(newResult);
    return previousResult;
  };
  ObservableQuery2.prototype.onSubscribe = function(observer) {
    var _this = this;
    try {
      var subObserver = observer._subscription._observer;
      if (subObserver && !subObserver.error) {
        subObserver.error = defaultSubscriptionObserverErrorCallback;
      }
    } catch (_a3) {
    }
    var first = !this.observers.size;
    this.observers.add(observer);
    if (observer.next && this.lastResult)
      observer.next(this.lastResult);
    if (observer.error && this.lastError)
      observer.error(this.lastError);
    if (first) {
      this.setUpQuery();
    }
    return function() {
      if (_this.observers.delete(observer) && !_this.observers.size) {
        _this.tearDownQuery();
      }
    };
  };
  ObservableQuery2.prototype.setUpQuery = function() {
    var _this = this;
    var _a3 = this, queryManager = _a3.queryManager, queryId = _a3.queryId;
    if (this.shouldSubscribe) {
      queryManager.addObservableQuery(queryId, this);
    }
    if (this.options.pollInterval) {
      assertNotCacheFirstOrOnly(this);
      queryManager.startPollingQuery(this.options, queryId);
    }
    var onError = function(error) {
      _this.updateLastResult(__assign2(__assign2({}, _this.lastResult), { errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false }));
      iterateObserversSafely(_this.observers, "error", _this.lastError = error);
    };
    queryManager.observeQuery(queryId, this.options, {
      next: function(result2) {
        if (_this.lastError || _this.isDifferentFromLastResult(result2)) {
          var previousResult_1 = _this.updateLastResult(result2);
          var _a4 = _this.options, query_1 = _a4.query, variables = _a4.variables, fetchPolicy_1 = _a4.fetchPolicy;
          if (queryManager.transform(query_1).hasClientExports) {
            queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables2) {
              var previousVariables = _this.variables;
              _this.variables = _this.options.variables = variables2;
              if (!result2.loading && previousResult_1 && fetchPolicy_1 !== "cache-only" && queryManager.transform(query_1).serverQuery && !equal(previousVariables, variables2)) {
                _this.refetch();
              } else {
                iterateObserversSafely(_this.observers, "next", result2);
              }
            });
          } else {
            iterateObserversSafely(_this.observers, "next", result2);
          }
        }
      },
      error: onError
    }).catch(onError);
  };
  ObservableQuery2.prototype.tearDownQuery = function() {
    var queryManager = this.queryManager;
    this.isTornDown = true;
    queryManager.stopPollingQuery(this.queryId);
    this.subscriptions.forEach(function(sub) {
      return sub.unsubscribe();
    });
    this.subscriptions.clear();
    queryManager.removeObservableQuery(this.queryId);
    queryManager.stopQuery(this.queryId);
    this.observers.clear();
  };
  return ObservableQuery2;
}(Observable2);
function defaultSubscriptionObserverErrorCallback(error) {
  invariant.error("Unhandled error", error.message, error.stack);
}
function iterateObserversSafely(observers, method, argument) {
  var observersWithMethod = [];
  observers.forEach(function(obs) {
    return obs[method] && observersWithMethod.push(obs);
  });
  observersWithMethod.forEach(function(obs) {
    return obs[method](argument);
  });
}
function assertNotCacheFirstOrOnly(obsQuery) {
  var fetchPolicy = obsQuery.options.fetchPolicy;
  false ? invariant(fetchPolicy !== "cache-first" && fetchPolicy !== "cache-only", 3) : invariant(fetchPolicy !== "cache-first" && fetchPolicy !== "cache-only", "Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.");
}
var MutationStore = function() {
  function MutationStore2() {
    this.store = {};
  }
  MutationStore2.prototype.getStore = function() {
    return this.store;
  };
  MutationStore2.prototype.get = function(mutationId) {
    return this.store[mutationId];
  };
  MutationStore2.prototype.initMutation = function(mutationId, mutation, variables) {
    this.store[mutationId] = {
      mutation,
      variables: variables || {},
      loading: true,
      error: null
    };
  };
  MutationStore2.prototype.markMutationError = function(mutationId, error) {
    var mutation = this.store[mutationId];
    if (mutation) {
      mutation.loading = false;
      mutation.error = error;
    }
  };
  MutationStore2.prototype.markMutationResult = function(mutationId) {
    var mutation = this.store[mutationId];
    if (mutation) {
      mutation.loading = false;
      mutation.error = null;
    }
  };
  MutationStore2.prototype.reset = function() {
    this.store = {};
  };
  return MutationStore2;
}();
var QueryStore = function() {
  function QueryStore2() {
    this.store = {};
  }
  QueryStore2.prototype.getStore = function() {
    return this.store;
  };
  QueryStore2.prototype.get = function(queryId) {
    return this.store[queryId];
  };
  QueryStore2.prototype.initQuery = function(query) {
    var previousQuery = this.store[query.queryId];
    false ? invariant(!previousQuery || previousQuery.document === query.document || equal(previousQuery.document, query.document), 19) : invariant(!previousQuery || previousQuery.document === query.document || equal(previousQuery.document, query.document), "Internal Error: may not update existing query string in store");
    var isSetVariables = false;
    var previousVariables = null;
    if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== NetworkStatus.loading) {
      if (!equal(previousQuery.variables, query.variables)) {
        isSetVariables = true;
        previousVariables = previousQuery.variables;
      }
    }
    var networkStatus;
    if (isSetVariables) {
      networkStatus = NetworkStatus.setVariables;
    } else if (query.isPoll) {
      networkStatus = NetworkStatus.poll;
    } else if (query.isRefetch) {
      networkStatus = NetworkStatus.refetch;
    } else {
      networkStatus = NetworkStatus.loading;
    }
    var graphQLErrors = [];
    if (previousQuery && previousQuery.graphQLErrors) {
      graphQLErrors = previousQuery.graphQLErrors;
    }
    this.store[query.queryId] = {
      document: query.document,
      variables: query.variables,
      previousVariables,
      networkError: null,
      graphQLErrors,
      networkStatus,
      metadata: query.metadata
    };
    if (typeof query.fetchMoreForQueryId === "string" && this.store[query.fetchMoreForQueryId]) {
      this.store[query.fetchMoreForQueryId].networkStatus = NetworkStatus.fetchMore;
    }
  };
  QueryStore2.prototype.markQueryResult = function(queryId, result2, fetchMoreForQueryId) {
    if (!this.store || !this.store[queryId])
      return;
    this.store[queryId].networkError = null;
    this.store[queryId].graphQLErrors = isNonEmptyArray(result2.errors) ? result2.errors : [];
    this.store[queryId].previousVariables = null;
    this.store[queryId].networkStatus = NetworkStatus.ready;
    if (typeof fetchMoreForQueryId === "string" && this.store[fetchMoreForQueryId]) {
      this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
    }
  };
  QueryStore2.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
    if (!this.store || !this.store[queryId])
      return;
    this.store[queryId].networkError = error;
    this.store[queryId].networkStatus = NetworkStatus.error;
    if (typeof fetchMoreForQueryId === "string") {
      this.markQueryResultClient(fetchMoreForQueryId, true);
    }
  };
  QueryStore2.prototype.markQueryResultClient = function(queryId, complete) {
    var storeValue = this.store && this.store[queryId];
    if (storeValue) {
      storeValue.networkError = null;
      storeValue.previousVariables = null;
      if (complete) {
        storeValue.networkStatus = NetworkStatus.ready;
      }
    }
  };
  QueryStore2.prototype.stopQuery = function(queryId) {
    delete this.store[queryId];
  };
  QueryStore2.prototype.reset = function(observableQueryIds) {
    var _this = this;
    Object.keys(this.store).forEach(function(queryId) {
      if (observableQueryIds.indexOf(queryId) < 0) {
        _this.stopQuery(queryId);
      } else {
        _this.store[queryId].networkStatus = NetworkStatus.loading;
      }
    });
  };
  return QueryStore2;
}();
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
var LocalState = function() {
  function LocalState2(_a3) {
    var cache = _a3.cache, client = _a3.client, resolvers = _a3.resolvers, fragmentMatcher = _a3.fragmentMatcher;
    this.cache = cache;
    if (client) {
      this.client = client;
    }
    if (resolvers) {
      this.addResolvers(resolvers);
    }
    if (fragmentMatcher) {
      this.setFragmentMatcher(fragmentMatcher);
    }
  }
  LocalState2.prototype.addResolvers = function(resolvers) {
    var _this = this;
    this.resolvers = this.resolvers || {};
    if (Array.isArray(resolvers)) {
      resolvers.forEach(function(resolverGroup) {
        _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
      });
    } else {
      this.resolvers = mergeDeep(this.resolvers, resolvers);
    }
  };
  LocalState2.prototype.setResolvers = function(resolvers) {
    this.resolvers = {};
    this.addResolvers(resolvers);
  };
  LocalState2.prototype.getResolvers = function() {
    return this.resolvers || {};
  };
  LocalState2.prototype.runResolvers = function(_a3) {
    var document2 = _a3.document, remoteResult = _a3.remoteResult, context = _a3.context, variables = _a3.variables, _b = _a3.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
    return __awaiter2(this, void 0, void 0, function() {
      return __generator2(this, function(_c) {
        if (document2) {
          return [2, this.resolveDocument(document2, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
            return __assign2(__assign2({}, remoteResult), { data: localResult.result });
          })];
        }
        return [2, remoteResult];
      });
    });
  };
  LocalState2.prototype.setFragmentMatcher = function(fragmentMatcher) {
    this.fragmentMatcher = fragmentMatcher;
  };
  LocalState2.prototype.getFragmentMatcher = function() {
    return this.fragmentMatcher;
  };
  LocalState2.prototype.clientQuery = function(document2) {
    if (hasDirectives(["client"], document2)) {
      if (this.resolvers) {
        return document2;
      }
      invariant.warn("Found @client directives in a query but no ApolloClient resolvers were specified. This means ApolloClient local resolver handling has been disabled, and @client directives will be passed through to your link chain.");
    }
    return null;
  };
  LocalState2.prototype.serverQuery = function(document2) {
    return this.resolvers ? removeClientSetsFromDocument(document2) : document2;
  };
  LocalState2.prototype.prepareContext = function(context) {
    if (context === void 0) {
      context = {};
    }
    var cache = this.cache;
    var newContext = __assign2(__assign2({}, context), { cache, getCacheKey: function(obj2) {
      if (cache.config) {
        return cache.config.dataIdFromObject(obj2);
      } else {
        false ? invariant(false, 6) : invariant(false, "To use context.getCacheKey, you need to use a cache that has a configurable dataIdFromObject, like apollo-cache-inmemory.");
      }
    } });
    return newContext;
  };
  LocalState2.prototype.addExportedVariables = function(document2, variables, context) {
    if (variables === void 0) {
      variables = {};
    }
    if (context === void 0) {
      context = {};
    }
    return __awaiter2(this, void 0, void 0, function() {
      return __generator2(this, function(_a3) {
        if (document2) {
          return [2, this.resolveDocument(document2, this.buildRootValueFromCache(document2, variables) || {}, this.prepareContext(context), variables).then(function(data) {
            return __assign2(__assign2({}, variables), data.exportedVariables);
          })];
        }
        return [2, __assign2({}, variables)];
      });
    });
  };
  LocalState2.prototype.shouldForceResolvers = function(document2) {
    var forceResolvers = false;
    (0, import_visitor2.visit)(document2, {
      Directive: {
        enter: function(node) {
          if (node.name.value === "client" && node.arguments) {
            forceResolvers = node.arguments.some(function(arg) {
              return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
            });
            if (forceResolvers) {
              return import_visitor2.BREAK;
            }
          }
        }
      }
    });
    return forceResolvers;
  };
  LocalState2.prototype.buildRootValueFromCache = function(document2, variables) {
    return this.cache.diff({
      query: buildQueryFromSelectionSet(document2),
      variables,
      returnPartialData: true,
      optimistic: false
    }).result;
  };
  LocalState2.prototype.resolveDocument = function(document2, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
    if (context === void 0) {
      context = {};
    }
    if (variables === void 0) {
      variables = {};
    }
    if (fragmentMatcher === void 0) {
      fragmentMatcher = function() {
        return true;
      };
    }
    if (onlyRunForcedResolvers === void 0) {
      onlyRunForcedResolvers = false;
    }
    return __awaiter2(this, void 0, void 0, function() {
      var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a3, cache, client, execContext;
      return __generator2(this, function(_b) {
        mainDefinition = getMainDefinition(document2);
        fragments = getFragmentDefinitions(document2);
        fragmentMap = createFragmentMap(fragments);
        definitionOperation = mainDefinition.operation;
        defaultOperationType = definitionOperation ? capitalizeFirstLetter(definitionOperation) : "Query";
        _a3 = this, cache = _a3.cache, client = _a3.client;
        execContext = {
          fragmentMap,
          context: __assign2(__assign2({}, context), {
            cache,
            client
          }),
          variables,
          fragmentMatcher,
          defaultOperationType,
          exportedVariables: {},
          onlyRunForcedResolvers
        };
        return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result2) {
          return {
            result: result2,
            exportedVariables: execContext.exportedVariables
          };
        })];
      });
    });
  };
  LocalState2.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
    return __awaiter2(this, void 0, void 0, function() {
      var fragmentMap, context, variables, resultsToMerge, execute2;
      var _this = this;
      return __generator2(this, function(_a3) {
        fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
        resultsToMerge = [rootValue];
        execute2 = function(selection) {
          return __awaiter2(_this, void 0, void 0, function() {
            var fragment, typeCondition;
            return __generator2(this, function(_a4) {
              if (!shouldInclude(selection, variables)) {
                return [2];
              }
              if (isField(selection)) {
                return [2, this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                  var _a5;
                  if (typeof fieldResult !== "undefined") {
                    resultsToMerge.push((_a5 = {}, _a5[resultKeyNameFromField(selection)] = fieldResult, _a5));
                  }
                })];
              }
              if (isInlineFragment(selection)) {
                fragment = selection;
              } else {
                fragment = fragmentMap[selection.name.value];
                false ? invariant(fragment, 7) : invariant(fragment, "No fragment named " + selection.name.value);
              }
              if (fragment && fragment.typeCondition) {
                typeCondition = fragment.typeCondition.name.value;
                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                  return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                    resultsToMerge.push(fragmentResult);
                  })];
                }
              }
              return [2];
            });
          });
        };
        return [2, Promise.all(selectionSet.selections.map(execute2)).then(function() {
          return mergeDeepArray(resultsToMerge);
        })];
      });
    });
  };
  LocalState2.prototype.resolveField = function(field, rootValue, execContext) {
    return __awaiter2(this, void 0, void 0, function() {
      var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
      var _this = this;
      return __generator2(this, function(_a3) {
        variables = execContext.variables;
        fieldName = field.name.value;
        aliasedFieldName = resultKeyNameFromField(field);
        aliasUsed = fieldName !== aliasedFieldName;
        defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
        resultPromise = Promise.resolve(defaultResult);
        if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
          resolverType = rootValue.__typename || execContext.defaultOperationType;
          resolverMap = this.resolvers && this.resolvers[resolverType];
          if (resolverMap) {
            resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
            if (resolve) {
              resultPromise = Promise.resolve(resolve(rootValue, argumentsObjectFromField(field, variables), execContext.context, { field, fragmentMap: execContext.fragmentMap }));
            }
          }
        }
        return [2, resultPromise.then(function(result2) {
          if (result2 === void 0) {
            result2 = defaultResult;
          }
          if (field.directives) {
            field.directives.forEach(function(directive) {
              if (directive.name.value === "export" && directive.arguments) {
                directive.arguments.forEach(function(arg) {
                  if (arg.name.value === "as" && arg.value.kind === "StringValue") {
                    execContext.exportedVariables[arg.value.value] = result2;
                  }
                });
              }
            });
          }
          if (!field.selectionSet) {
            return result2;
          }
          if (result2 == null) {
            return result2;
          }
          if (Array.isArray(result2)) {
            return _this.resolveSubSelectedArray(field, result2, execContext);
          }
          if (field.selectionSet) {
            return _this.resolveSelectionSet(field.selectionSet, result2, execContext);
          }
        })];
      });
    });
  };
  LocalState2.prototype.resolveSubSelectedArray = function(field, result2, execContext) {
    var _this = this;
    return Promise.all(result2.map(function(item) {
      if (item === null) {
        return null;
      }
      if (Array.isArray(item)) {
        return _this.resolveSubSelectedArray(field, item, execContext);
      }
      if (field.selectionSet) {
        return _this.resolveSelectionSet(field.selectionSet, item, execContext);
      }
    }));
  };
  return LocalState2;
}();
function multiplex(inner) {
  var observers = /* @__PURE__ */ new Set();
  var sub = null;
  return new Observable2(function(observer) {
    observers.add(observer);
    sub = sub || inner.subscribe({
      next: function(value) {
        observers.forEach(function(obs) {
          return obs.next && obs.next(value);
        });
      },
      error: function(error) {
        observers.forEach(function(obs) {
          return obs.error && obs.error(error);
        });
      },
      complete: function() {
        observers.forEach(function(obs) {
          return obs.complete && obs.complete();
        });
      }
    });
    return function() {
      if (observers.delete(observer) && !observers.size && sub) {
        sub.unsubscribe();
        sub = null;
      }
    };
  });
}
function asyncMap(observable, mapFn) {
  return new Observable2(function(observer) {
    var next = observer.next, error = observer.error, complete = observer.complete;
    var activeNextCount = 0;
    var completed = false;
    var handler = {
      next: function(value) {
        ++activeNextCount;
        new Promise(function(resolve) {
          resolve(mapFn(value));
        }).then(function(result2) {
          --activeNextCount;
          next && next.call(observer, result2);
          completed && handler.complete();
        }, function(e) {
          --activeNextCount;
          error && error.call(observer, e);
        });
      },
      error: function(e) {
        error && error.call(observer, e);
      },
      complete: function() {
        completed = true;
        if (!activeNextCount) {
          complete && complete.call(observer);
        }
      }
    };
    var sub = observable.subscribe(handler);
    return function() {
      return sub.unsubscribe();
    };
  });
}
var hasOwnProperty3 = Object.prototype.hasOwnProperty;
var QueryManager = function() {
  function QueryManager2(_a3) {
    var link = _a3.link, _b = _a3.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a3.store, _c = _a3.onBroadcast, onBroadcast = _c === void 0 ? function() {
      return void 0;
    } : _c, _d = _a3.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a3.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a3.localState, assumeImmutableResults = _a3.assumeImmutableResults;
    this.mutationStore = new MutationStore();
    this.queryStore = new QueryStore();
    this.clientAwareness = {};
    this.idCounter = 1;
    this.queries = /* @__PURE__ */ new Map();
    this.fetchQueryRejectFns = /* @__PURE__ */ new Map();
    this.transformCache = new (canUseWeakMap ? WeakMap : Map)();
    this.inFlightLinkObservables = /* @__PURE__ */ new Map();
    this.pollingInfoByQueryId = /* @__PURE__ */ new Map();
    this.link = link;
    this.queryDeduplication = queryDeduplication;
    this.dataStore = store;
    this.onBroadcast = onBroadcast;
    this.clientAwareness = clientAwareness;
    this.localState = localState || new LocalState({ cache: store.getCache() });
    this.ssrMode = ssrMode;
    this.assumeImmutableResults = !!assumeImmutableResults;
  }
  QueryManager2.prototype.stop = function() {
    var _this = this;
    this.queries.forEach(function(_info, queryId) {
      _this.stopQueryNoBroadcast(queryId);
    });
    this.fetchQueryRejectFns.forEach(function(reject) {
      reject(false ? new InvariantError(8) : new InvariantError("QueryManager stopped while query was in flight"));
    });
  };
  QueryManager2.prototype.mutate = function(_a3) {
    var mutation = _a3.mutation, variables = _a3.variables, optimisticResponse = _a3.optimisticResponse, updateQueriesByName = _a3.updateQueries, _b = _a3.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a3.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a3.update, _d = _a3.errorPolicy, errorPolicy = _d === void 0 ? "none" : _d, fetchPolicy = _a3.fetchPolicy, _e = _a3.context, context = _e === void 0 ? {} : _e;
    return __awaiter2(this, void 0, void 0, function() {
      var mutationId, generateUpdateQueriesInfo, self2;
      var _this = this;
      return __generator2(this, function(_f) {
        switch (_f.label) {
          case 0:
            false ? invariant(mutation, 9) : invariant(mutation, "mutation option is required. You must specify your GraphQL document in the mutation option.");
            false ? invariant(!fetchPolicy || fetchPolicy === "no-cache", 10) : invariant(!fetchPolicy || fetchPolicy === "no-cache", "Mutations only support a 'no-cache' fetchPolicy. If you don't want to disable the cache, remove your fetchPolicy setting to proceed with the default mutation behavior.");
            mutationId = this.generateQueryId();
            mutation = this.transform(mutation).document;
            this.setQuery(mutationId, function() {
              return { document: mutation };
            });
            variables = this.getVariables(mutation, variables);
            if (!this.transform(mutation).hasClientExports)
              return [3, 2];
            return [4, this.localState.addExportedVariables(mutation, variables, context)];
          case 1:
            variables = _f.sent();
            _f.label = 2;
          case 2:
            generateUpdateQueriesInfo = function() {
              var ret2 = {};
              if (updateQueriesByName) {
                _this.queries.forEach(function(_a4, queryId) {
                  var observableQuery = _a4.observableQuery;
                  if (observableQuery) {
                    var queryName = observableQuery.queryName;
                    if (queryName && hasOwnProperty3.call(updateQueriesByName, queryName)) {
                      ret2[queryId] = {
                        updater: updateQueriesByName[queryName],
                        query: _this.queryStore.get(queryId)
                      };
                    }
                  }
                });
              }
              return ret2;
            };
            this.mutationStore.initMutation(mutationId, mutation, variables);
            this.dataStore.markMutationInit({
              mutationId,
              document: mutation,
              variables,
              updateQueries: generateUpdateQueriesInfo(),
              update: updateWithProxyFn,
              optimisticResponse
            });
            this.broadcastQueries();
            self2 = this;
            return [2, new Promise(function(resolve, reject) {
              var storeResult;
              var error;
              self2.getObservableFromLink(mutation, __assign2(__assign2({}, context), { optimisticResponse }), variables, false).subscribe({
                next: function(result2) {
                  if (graphQLResultHasError(result2) && errorPolicy === "none") {
                    error = new ApolloError({
                      graphQLErrors: result2.errors
                    });
                    return;
                  }
                  self2.mutationStore.markMutationResult(mutationId);
                  if (fetchPolicy !== "no-cache") {
                    self2.dataStore.markMutationResult({
                      mutationId,
                      result: result2,
                      document: mutation,
                      variables,
                      updateQueries: generateUpdateQueriesInfo(),
                      update: updateWithProxyFn
                    });
                  }
                  storeResult = result2;
                },
                error: function(err) {
                  self2.mutationStore.markMutationError(mutationId, err);
                  self2.dataStore.markMutationComplete({
                    mutationId,
                    optimisticResponse
                  });
                  self2.broadcastQueries();
                  self2.setQuery(mutationId, function() {
                    return { document: null };
                  });
                  reject(new ApolloError({
                    networkError: err
                  }));
                },
                complete: function() {
                  if (error) {
                    self2.mutationStore.markMutationError(mutationId, error);
                  }
                  self2.dataStore.markMutationComplete({
                    mutationId,
                    optimisticResponse
                  });
                  self2.broadcastQueries();
                  if (error) {
                    reject(error);
                    return;
                  }
                  if (typeof refetchQueries === "function") {
                    refetchQueries = refetchQueries(storeResult);
                  }
                  var refetchQueryPromises = [];
                  if (isNonEmptyArray(refetchQueries)) {
                    refetchQueries.forEach(function(refetchQuery) {
                      if (typeof refetchQuery === "string") {
                        self2.queries.forEach(function(_a4) {
                          var observableQuery = _a4.observableQuery;
                          if (observableQuery && observableQuery.queryName === refetchQuery) {
                            refetchQueryPromises.push(observableQuery.refetch());
                          }
                        });
                      } else {
                        var queryOptions = {
                          query: refetchQuery.query,
                          variables: refetchQuery.variables,
                          fetchPolicy: "network-only"
                        };
                        if (refetchQuery.context) {
                          queryOptions.context = refetchQuery.context;
                        }
                        refetchQueryPromises.push(self2.query(queryOptions));
                      }
                    });
                  }
                  Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                    self2.setQuery(mutationId, function() {
                      return { document: null };
                    });
                    if (errorPolicy === "ignore" && storeResult && graphQLResultHasError(storeResult)) {
                      delete storeResult.errors;
                    }
                    resolve(storeResult);
                  });
                }
              });
            })];
        }
      });
    });
  };
  QueryManager2.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
    return __awaiter2(this, void 0, void 0, function() {
      var _a3, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result2, shouldFetch, requestId, cancel, networkResult;
      var _this = this;
      return __generator2(this, function(_e) {
        switch (_e.label) {
          case 0:
            _a3 = options.metadata, metadata = _a3 === void 0 ? null : _a3, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? "cache-first" : _b, _c = options.context, context = _c === void 0 ? {} : _c;
            query = this.transform(options.query).document;
            variables = this.getVariables(query, options.variables);
            if (!this.transform(query).hasClientExports)
              return [3, 2];
            return [4, this.localState.addExportedVariables(query, variables, context)];
          case 1:
            variables = _e.sent();
            _e.label = 2;
          case 2:
            options = __assign2(__assign2({}, options), { variables });
            isNetworkOnly = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
            needToFetch = isNetworkOnly;
            if (!isNetworkOnly) {
              _d = this.dataStore.getCache().diff({
                query,
                variables,
                returnPartialData: true,
                optimistic: false
              }), complete = _d.complete, result2 = _d.result;
              needToFetch = !complete || fetchPolicy === "cache-and-network";
              storeResult = result2;
            }
            shouldFetch = needToFetch && fetchPolicy !== "cache-only" && fetchPolicy !== "standby";
            if (hasDirectives(["live"], query))
              shouldFetch = true;
            requestId = this.idCounter++;
            cancel = fetchPolicy !== "no-cache" ? this.updateQueryWatch(queryId, query, options) : void 0;
            this.setQuery(queryId, function() {
              return {
                document: query,
                lastRequestId: requestId,
                invalidated: true,
                cancel
              };
            });
            this.invalidate(fetchMoreForQueryId);
            this.queryStore.initQuery({
              queryId,
              document: query,
              storePreviousVariables: shouldFetch,
              variables,
              isPoll: fetchType === FetchType.poll,
              isRefetch: fetchType === FetchType.refetch,
              metadata,
              fetchMoreForQueryId
            });
            this.broadcastQueries();
            if (shouldFetch) {
              networkResult = this.fetchRequest({
                requestId,
                queryId,
                document: query,
                options,
                fetchMoreForQueryId
              }).catch(function(error) {
                if (isApolloError(error)) {
                  throw error;
                } else {
                  if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                  }
                  throw new ApolloError({ networkError: error });
                }
              });
              if (fetchPolicy !== "cache-and-network") {
                return [2, networkResult];
              }
              networkResult.catch(function() {
              });
            }
            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
            this.invalidate(queryId);
            this.invalidate(fetchMoreForQueryId);
            if (this.transform(query).hasForcedResolvers) {
              return [2, this.localState.runResolvers({
                document: query,
                remoteResult: { data: storeResult },
                context,
                variables,
                onlyRunForcedResolvers: true
              }).then(function(result3) {
                _this.markQueryResult(queryId, result3, options, fetchMoreForQueryId);
                _this.broadcastQueries();
                return result3;
              })];
            }
            this.broadcastQueries();
            return [2, { data: storeResult }];
        }
      });
    });
  };
  QueryManager2.prototype.markQueryResult = function(queryId, result2, _a3, fetchMoreForQueryId) {
    var fetchPolicy = _a3.fetchPolicy, variables = _a3.variables, errorPolicy = _a3.errorPolicy;
    if (fetchPolicy === "no-cache") {
      this.setQuery(queryId, function() {
        return {
          newData: { result: result2.data, complete: true }
        };
      });
    } else {
      this.dataStore.markQueryResult(result2, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === "ignore" || errorPolicy === "all");
    }
  };
  QueryManager2.prototype.queryListenerForObserver = function(queryId, options, observer) {
    var _this = this;
    function invoke(method, argument) {
      if (observer[method]) {
        try {
          observer[method](argument);
        } catch (e) {
          invariant.error(e);
        }
      } else if (method === "error") {
        invariant.error(argument);
      }
    }
    return function(queryStoreValue, newData) {
      _this.invalidate(queryId, false);
      if (!queryStoreValue)
        return;
      var _a3 = _this.getQuery(queryId), observableQuery = _a3.observableQuery, document2 = _a3.document;
      var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
      if (fetchPolicy === "standby")
        return;
      var loading = isNetworkRequestInFlight(queryStoreValue.networkStatus);
      var lastResult = observableQuery && observableQuery.getLastResult();
      var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
      var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === "cache-only" || fetchPolicy === "cache-and-network";
      if (loading && !shouldNotifyIfLoading) {
        return;
      }
      var hasGraphQLErrors = isNonEmptyArray(queryStoreValue.graphQLErrors);
      var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || "none";
      if (errorPolicy === "none" && hasGraphQLErrors || queryStoreValue.networkError) {
        return invoke("error", new ApolloError({
          graphQLErrors: queryStoreValue.graphQLErrors,
          networkError: queryStoreValue.networkError
        }));
      }
      try {
        var data = void 0;
        var isMissing = void 0;
        if (newData) {
          if (fetchPolicy !== "no-cache" && fetchPolicy !== "network-only") {
            _this.setQuery(queryId, function() {
              return { newData: null };
            });
          }
          data = newData.result;
          isMissing = !newData.complete;
        } else {
          var lastError = observableQuery && observableQuery.getLastError();
          var errorStatusChanged = errorPolicy !== "none" && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
          if (lastResult && lastResult.data && !errorStatusChanged) {
            data = lastResult.data;
            isMissing = false;
          } else {
            var diffResult = _this.dataStore.getCache().diff({
              query: document2,
              variables: queryStoreValue.previousVariables || queryStoreValue.variables,
              returnPartialData: true,
              optimistic: true
            });
            data = diffResult.result;
            isMissing = !diffResult.complete;
          }
        }
        var stale = isMissing && !(options.returnPartialData || fetchPolicy === "cache-only");
        var resultFromStore = {
          data: stale ? lastResult && lastResult.data : data,
          loading,
          networkStatus: queryStoreValue.networkStatus,
          stale
        };
        if (errorPolicy === "all" && hasGraphQLErrors) {
          resultFromStore.errors = queryStoreValue.graphQLErrors;
        }
        invoke("next", resultFromStore);
      } catch (networkError) {
        invoke("error", new ApolloError({ networkError }));
      }
    };
  };
  QueryManager2.prototype.transform = function(document2) {
    var transformCache = this.transformCache;
    if (!transformCache.has(document2)) {
      var cache = this.dataStore.getCache();
      var transformed = cache.transformDocument(document2);
      var forLink = removeConnectionDirectiveFromDocument(cache.transformForLink(transformed));
      var clientQuery = this.localState.clientQuery(transformed);
      var serverQuery = this.localState.serverQuery(forLink);
      var cacheEntry_1 = {
        document: transformed,
        hasClientExports: hasClientExports(transformed),
        hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
        clientQuery,
        serverQuery,
        defaultVars: getDefaultValues(getOperationDefinition(transformed))
      };
      var add = function(doc) {
        if (doc && !transformCache.has(doc)) {
          transformCache.set(doc, cacheEntry_1);
        }
      };
      add(document2);
      add(transformed);
      add(clientQuery);
      add(serverQuery);
    }
    return transformCache.get(document2);
  };
  QueryManager2.prototype.getVariables = function(document2, variables) {
    return __assign2(__assign2({}, this.transform(document2).defaultVars), variables);
  };
  QueryManager2.prototype.watchQuery = function(options, shouldSubscribe) {
    if (shouldSubscribe === void 0) {
      shouldSubscribe = true;
    }
    false ? invariant(options.fetchPolicy !== "standby", 11) : invariant(options.fetchPolicy !== "standby", 'client.watchQuery cannot be called with fetchPolicy set to "standby"');
    options.variables = this.getVariables(options.query, options.variables);
    if (typeof options.notifyOnNetworkStatusChange === "undefined") {
      options.notifyOnNetworkStatusChange = false;
    }
    var transformedOptions = __assign2({}, options);
    return new ObservableQuery({
      queryManager: this,
      options: transformedOptions,
      shouldSubscribe
    });
  };
  QueryManager2.prototype.query = function(options) {
    var _this = this;
    false ? invariant(options.query, 12) : invariant(options.query, "query option is required. You must specify your GraphQL document in the query option.");
    false ? invariant(options.query.kind === "Document", 13) : invariant(options.query.kind === "Document", 'You must wrap the query string in a "gql" tag.');
    false ? invariant(!options.returnPartialData, 14) : invariant(!options.returnPartialData, "returnPartialData option only supported on watchQuery.");
    false ? invariant(!options.pollInterval, 15) : invariant(!options.pollInterval, "pollInterval option only supported on watchQuery.");
    return new Promise(function(resolve, reject) {
      var watchedQuery = _this.watchQuery(options, false);
      _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
      watchedQuery.result().then(resolve, reject).then(function() {
        return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
      });
    });
  };
  QueryManager2.prototype.generateQueryId = function() {
    return String(this.idCounter++);
  };
  QueryManager2.prototype.stopQueryInStore = function(queryId) {
    this.stopQueryInStoreNoBroadcast(queryId);
    this.broadcastQueries();
  };
  QueryManager2.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
    this.stopPollingQuery(queryId);
    this.queryStore.stopQuery(queryId);
    this.invalidate(queryId);
  };
  QueryManager2.prototype.addQueryListener = function(queryId, listener) {
    this.setQuery(queryId, function(_a3) {
      var listeners = _a3.listeners;
      listeners.add(listener);
      return { invalidated: false };
    });
  };
  QueryManager2.prototype.updateQueryWatch = function(queryId, document2, options) {
    var _this = this;
    var cancel = this.getQuery(queryId).cancel;
    if (cancel)
      cancel();
    var previousResult = function() {
      var previousResult2 = null;
      var observableQuery = _this.getQuery(queryId).observableQuery;
      if (observableQuery) {
        var lastResult = observableQuery.getLastResult();
        if (lastResult) {
          previousResult2 = lastResult.data;
        }
      }
      return previousResult2;
    };
    return this.dataStore.getCache().watch({
      query: document2,
      variables: options.variables,
      optimistic: true,
      previousResult,
      callback: function(newData) {
        _this.setQuery(queryId, function() {
          return { invalidated: true, newData };
        });
      }
    });
  };
  QueryManager2.prototype.addObservableQuery = function(queryId, observableQuery) {
    this.setQuery(queryId, function() {
      return { observableQuery };
    });
  };
  QueryManager2.prototype.removeObservableQuery = function(queryId) {
    var cancel = this.getQuery(queryId).cancel;
    this.setQuery(queryId, function() {
      return { observableQuery: null };
    });
    if (cancel)
      cancel();
  };
  QueryManager2.prototype.clearStore = function() {
    this.fetchQueryRejectFns.forEach(function(reject) {
      reject(false ? new InvariantError(16) : new InvariantError("Store reset while query was in flight (not completed in link chain)"));
    });
    var resetIds = [];
    this.queries.forEach(function(_a3, queryId) {
      var observableQuery = _a3.observableQuery;
      if (observableQuery)
        resetIds.push(queryId);
    });
    this.queryStore.reset(resetIds);
    this.mutationStore.reset();
    return this.dataStore.reset();
  };
  QueryManager2.prototype.resetStore = function() {
    var _this = this;
    return this.clearStore().then(function() {
      return _this.reFetchObservableQueries();
    });
  };
  QueryManager2.prototype.reFetchObservableQueries = function(includeStandby) {
    var _this = this;
    if (includeStandby === void 0) {
      includeStandby = false;
    }
    var observableQueryPromises = [];
    this.queries.forEach(function(_a3, queryId) {
      var observableQuery = _a3.observableQuery;
      if (observableQuery) {
        var fetchPolicy = observableQuery.options.fetchPolicy;
        observableQuery.resetLastResults();
        if (fetchPolicy !== "cache-only" && (includeStandby || fetchPolicy !== "standby")) {
          observableQueryPromises.push(observableQuery.refetch());
        }
        _this.setQuery(queryId, function() {
          return { newData: null };
        });
        _this.invalidate(queryId);
      }
    });
    this.broadcastQueries();
    return Promise.all(observableQueryPromises);
  };
  QueryManager2.prototype.observeQuery = function(queryId, options, observer) {
    this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
    return this.fetchQuery(queryId, options);
  };
  QueryManager2.prototype.startQuery = function(queryId, options, listener) {
    invariant.warn("The QueryManager.startQuery method has been deprecated");
    this.addQueryListener(queryId, listener);
    this.fetchQuery(queryId, options).catch(function() {
      return void 0;
    });
    return queryId;
  };
  QueryManager2.prototype.startGraphQLSubscription = function(_a3) {
    var _this = this;
    var query = _a3.query, fetchPolicy = _a3.fetchPolicy, variables = _a3.variables;
    query = this.transform(query).document;
    variables = this.getVariables(query, variables);
    var makeObservable = function(variables2) {
      return _this.getObservableFromLink(query, {}, variables2, false).map(function(result2) {
        if (!fetchPolicy || fetchPolicy !== "no-cache") {
          _this.dataStore.markSubscriptionResult(result2, query, variables2);
          _this.broadcastQueries();
        }
        if (graphQLResultHasError(result2)) {
          throw new ApolloError({
            graphQLErrors: result2.errors
          });
        }
        return result2;
      });
    };
    if (this.transform(query).hasClientExports) {
      var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
      return new Observable2(function(observer) {
        var sub = null;
        observablePromise_1.then(function(observable) {
          return sub = observable.subscribe(observer);
        }, observer.error);
        return function() {
          return sub && sub.unsubscribe();
        };
      });
    }
    return makeObservable(variables);
  };
  QueryManager2.prototype.stopQuery = function(queryId) {
    this.stopQueryNoBroadcast(queryId);
    this.broadcastQueries();
  };
  QueryManager2.prototype.stopQueryNoBroadcast = function(queryId) {
    this.stopQueryInStoreNoBroadcast(queryId);
    this.removeQuery(queryId);
  };
  QueryManager2.prototype.removeQuery = function(queryId) {
    this.fetchQueryRejectFns.delete("query:" + queryId);
    this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
    this.getQuery(queryId).subscriptions.forEach(function(x) {
      return x.unsubscribe();
    });
    this.queries.delete(queryId);
  };
  QueryManager2.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
    if (optimistic === void 0) {
      optimistic = true;
    }
    var _a3 = observableQuery.options, variables = _a3.variables, query = _a3.query, fetchPolicy = _a3.fetchPolicy, returnPartialData = _a3.returnPartialData;
    var lastResult = observableQuery.getLastResult();
    var newData = this.getQuery(observableQuery.queryId).newData;
    if (newData && newData.complete) {
      return { data: newData.result, partial: false };
    }
    if (fetchPolicy === "no-cache" || fetchPolicy === "network-only") {
      return { data: void 0, partial: false };
    }
    var _b = this.dataStore.getCache().diff({
      query,
      variables,
      previousResult: lastResult ? lastResult.data : void 0,
      returnPartialData: true,
      optimistic
    }), result2 = _b.result, complete = _b.complete;
    return {
      data: complete || returnPartialData ? result2 : void 0,
      partial: !complete
    };
  };
  QueryManager2.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
    var observableQuery;
    if (typeof queryIdOrObservable === "string") {
      var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
      false ? invariant(foundObserveableQuery, 17) : invariant(foundObserveableQuery, "ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
      observableQuery = foundObserveableQuery;
    } else {
      observableQuery = queryIdOrObservable;
    }
    var _a3 = observableQuery.options, variables = _a3.variables, query = _a3.query;
    return {
      previousResult: this.getCurrentQueryResult(observableQuery, false).data,
      variables,
      document: query
    };
  };
  QueryManager2.prototype.broadcastQueries = function() {
    var _this = this;
    this.onBroadcast();
    this.queries.forEach(function(info, id) {
      if (info.invalidated) {
        info.listeners.forEach(function(listener) {
          if (listener) {
            listener(_this.queryStore.get(id), info.newData);
          }
        });
      }
    });
  };
  QueryManager2.prototype.getLocalState = function() {
    return this.localState;
  };
  QueryManager2.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
    var _this = this;
    if (deduplication === void 0) {
      deduplication = this.queryDeduplication;
    }
    var observable;
    var serverQuery = this.transform(query).serverQuery;
    if (serverQuery) {
      var _a3 = this, inFlightLinkObservables_1 = _a3.inFlightLinkObservables, link = _a3.link;
      var operation = {
        query: serverQuery,
        variables,
        operationName: getOperationName(serverQuery) || void 0,
        context: this.prepareContext(__assign2(__assign2({}, context), { forceFetch: !deduplication }))
      };
      context = operation.context;
      if (deduplication) {
        var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || /* @__PURE__ */ new Map();
        inFlightLinkObservables_1.set(serverQuery, byVariables_1);
        var varJson_1 = JSON.stringify(variables);
        observable = byVariables_1.get(varJson_1);
        if (!observable) {
          byVariables_1.set(varJson_1, observable = multiplex(execute(link, operation)));
          var cleanup = function() {
            byVariables_1.delete(varJson_1);
            if (!byVariables_1.size)
              inFlightLinkObservables_1.delete(serverQuery);
            cleanupSub_1.unsubscribe();
          };
          var cleanupSub_1 = observable.subscribe({
            next: cleanup,
            error: cleanup,
            complete: cleanup
          });
        }
      } else {
        observable = multiplex(execute(link, operation));
      }
    } else {
      observable = Observable2.of({ data: {} });
      context = this.prepareContext(context);
    }
    var clientQuery = this.transform(query).clientQuery;
    if (clientQuery) {
      observable = asyncMap(observable, function(result2) {
        return _this.localState.runResolvers({
          document: clientQuery,
          remoteResult: result2,
          context,
          variables
        });
      });
    }
    return observable;
  };
  QueryManager2.prototype.fetchRequest = function(_a3) {
    var _this = this;
    var requestId = _a3.requestId, queryId = _a3.queryId, document2 = _a3.document, options = _a3.options, fetchMoreForQueryId = _a3.fetchMoreForQueryId;
    var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, fetchPolicy = options.fetchPolicy;
    var resultFromStore;
    var errorsFromStore;
    return new Promise(function(resolve, reject) {
      var observable = _this.getObservableFromLink(document2, options.context, variables);
      var fqrfId = "fetchRequest:" + queryId;
      _this.fetchQueryRejectFns.set(fqrfId, reject);
      var cleanup = function() {
        _this.fetchQueryRejectFns.delete(fqrfId);
        _this.setQuery(queryId, function(_a4) {
          var subscriptions = _a4.subscriptions;
          subscriptions.delete(subscription);
        });
      };
      var subscription = observable.map(function(result2) {
        if (requestId >= _this.getQuery(queryId).lastRequestId) {
          _this.markQueryResult(queryId, result2, options, fetchMoreForQueryId);
          _this.queryStore.markQueryResult(queryId, result2, fetchMoreForQueryId);
          _this.invalidate(queryId);
          _this.invalidate(fetchMoreForQueryId);
          _this.broadcastQueries();
        }
        if (errorPolicy === "none" && isNonEmptyArray(result2.errors)) {
          return reject(new ApolloError({
            graphQLErrors: result2.errors
          }));
        }
        if (errorPolicy === "all") {
          errorsFromStore = result2.errors;
        }
        if (fetchMoreForQueryId || fetchPolicy === "no-cache") {
          resultFromStore = result2.data;
        } else {
          var _a4 = _this.dataStore.getCache().diff({
            variables,
            query: document2,
            optimistic: false,
            returnPartialData: true
          }), result_1 = _a4.result, complete = _a4.complete;
          if (complete || options.returnPartialData) {
            resultFromStore = result_1;
          }
        }
      }).subscribe({
        error: function(error) {
          cleanup();
          reject(error);
        },
        complete: function() {
          cleanup();
          resolve({
            data: resultFromStore,
            errors: errorsFromStore,
            loading: false,
            networkStatus: NetworkStatus.ready,
            stale: false
          });
        }
      });
      _this.setQuery(queryId, function(_a4) {
        var subscriptions = _a4.subscriptions;
        subscriptions.add(subscription);
      });
    });
  };
  QueryManager2.prototype.getQuery = function(queryId) {
    return this.queries.get(queryId) || {
      listeners: /* @__PURE__ */ new Set(),
      invalidated: false,
      document: null,
      newData: null,
      lastRequestId: 1,
      observableQuery: null,
      subscriptions: /* @__PURE__ */ new Set()
    };
  };
  QueryManager2.prototype.setQuery = function(queryId, updater) {
    var prev = this.getQuery(queryId);
    var newInfo = __assign2(__assign2({}, prev), updater(prev));
    this.queries.set(queryId, newInfo);
  };
  QueryManager2.prototype.invalidate = function(queryId, invalidated) {
    if (invalidated === void 0) {
      invalidated = true;
    }
    if (queryId) {
      this.setQuery(queryId, function() {
        return { invalidated };
      });
    }
  };
  QueryManager2.prototype.prepareContext = function(context) {
    if (context === void 0) {
      context = {};
    }
    var newContext = this.localState.prepareContext(context);
    return __assign2(__assign2({}, newContext), { clientAwareness: this.clientAwareness });
  };
  QueryManager2.prototype.checkInFlight = function(queryId) {
    var query = this.queryStore.get(queryId);
    return query && query.networkStatus !== NetworkStatus.ready && query.networkStatus !== NetworkStatus.error;
  };
  QueryManager2.prototype.startPollingQuery = function(options, queryId, listener) {
    var _this = this;
    var pollInterval = options.pollInterval;
    false ? invariant(pollInterval, 18) : invariant(pollInterval, "Attempted to start a polling query without a polling interval.");
    if (!this.ssrMode) {
      var info = this.pollingInfoByQueryId.get(queryId);
      if (!info) {
        this.pollingInfoByQueryId.set(queryId, info = {});
      }
      info.interval = pollInterval;
      info.options = __assign2(__assign2({}, options), { fetchPolicy: "network-only" });
      var maybeFetch_1 = function() {
        var info2 = _this.pollingInfoByQueryId.get(queryId);
        if (info2) {
          if (_this.checkInFlight(queryId)) {
            poll_1();
          } else {
            _this.fetchQuery(queryId, info2.options, FetchType.poll).then(poll_1, poll_1);
          }
        }
      };
      var poll_1 = function() {
        var info2 = _this.pollingInfoByQueryId.get(queryId);
        if (info2) {
          clearTimeout(info2.timeout);
          info2.timeout = setTimeout(maybeFetch_1, info2.interval);
        }
      };
      if (listener) {
        this.addQueryListener(queryId, listener);
      }
      poll_1();
    }
    return queryId;
  };
  QueryManager2.prototype.stopPollingQuery = function(queryId) {
    this.pollingInfoByQueryId.delete(queryId);
  };
  return QueryManager2;
}();
var DataStore = function() {
  function DataStore2(initialCache) {
    this.cache = initialCache;
  }
  DataStore2.prototype.getCache = function() {
    return this.cache;
  };
  DataStore2.prototype.markQueryResult = function(result2, document2, variables, fetchMoreForQueryId, ignoreErrors) {
    if (ignoreErrors === void 0) {
      ignoreErrors = false;
    }
    var writeWithErrors = !graphQLResultHasError(result2);
    if (ignoreErrors && graphQLResultHasError(result2) && result2.data) {
      writeWithErrors = true;
    }
    if (!fetchMoreForQueryId && writeWithErrors) {
      this.cache.write({
        result: result2.data,
        dataId: "ROOT_QUERY",
        query: document2,
        variables
      });
    }
  };
  DataStore2.prototype.markSubscriptionResult = function(result2, document2, variables) {
    if (!graphQLResultHasError(result2)) {
      this.cache.write({
        result: result2.data,
        dataId: "ROOT_SUBSCRIPTION",
        query: document2,
        variables
      });
    }
  };
  DataStore2.prototype.markMutationInit = function(mutation) {
    var _this = this;
    if (mutation.optimisticResponse) {
      var optimistic_1;
      if (typeof mutation.optimisticResponse === "function") {
        optimistic_1 = mutation.optimisticResponse(mutation.variables);
      } else {
        optimistic_1 = mutation.optimisticResponse;
      }
      this.cache.recordOptimisticTransaction(function(c) {
        var orig = _this.cache;
        _this.cache = c;
        try {
          _this.markMutationResult({
            mutationId: mutation.mutationId,
            result: { data: optimistic_1 },
            document: mutation.document,
            variables: mutation.variables,
            updateQueries: mutation.updateQueries,
            update: mutation.update
          });
        } finally {
          _this.cache = orig;
        }
      }, mutation.mutationId);
    }
  };
  DataStore2.prototype.markMutationResult = function(mutation) {
    var _this = this;
    if (!graphQLResultHasError(mutation.result)) {
      var cacheWrites_1 = [{
        result: mutation.result.data,
        dataId: "ROOT_MUTATION",
        query: mutation.document,
        variables: mutation.variables
      }];
      var updateQueries_1 = mutation.updateQueries;
      if (updateQueries_1) {
        Object.keys(updateQueries_1).forEach(function(id) {
          var _a3 = updateQueries_1[id], query = _a3.query, updater = _a3.updater;
          var _b = _this.cache.diff({
            query: query.document,
            variables: query.variables,
            returnPartialData: true,
            optimistic: false
          }), currentQueryResult = _b.result, complete = _b.complete;
          if (complete) {
            var nextQueryResult = tryFunctionOrLogError(function() {
              return updater(currentQueryResult, {
                mutationResult: mutation.result,
                queryName: getOperationName(query.document) || void 0,
                queryVariables: query.variables
              });
            });
            if (nextQueryResult) {
              cacheWrites_1.push({
                result: nextQueryResult,
                dataId: "ROOT_QUERY",
                query: query.document,
                variables: query.variables
              });
            }
          }
        });
      }
      this.cache.performTransaction(function(c) {
        cacheWrites_1.forEach(function(write) {
          return c.write(write);
        });
        var update = mutation.update;
        if (update) {
          tryFunctionOrLogError(function() {
            return update(c, mutation.result);
          });
        }
      });
    }
  };
  DataStore2.prototype.markMutationComplete = function(_a3) {
    var mutationId = _a3.mutationId, optimisticResponse = _a3.optimisticResponse;
    if (optimisticResponse) {
      this.cache.removeOptimistic(mutationId);
    }
  };
  DataStore2.prototype.markUpdateQueryResult = function(document2, variables, newResult) {
    this.cache.write({
      result: newResult,
      dataId: "ROOT_QUERY",
      variables,
      query: document2
    });
  };
  DataStore2.prototype.reset = function() {
    return this.cache.reset();
  };
  return DataStore2;
}();
var version = "2.6.10";
var hasSuggestedDevtools = false;
var ApolloClient = function() {
  function ApolloClient2(options) {
    var _this = this;
    this.defaultOptions = {};
    this.resetStoreCallbacks = [];
    this.clearStoreCallbacks = [];
    var cache = options.cache, _a3 = options.ssrMode, ssrMode = _a3 === void 0 ? false : _a3, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions3 = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
    var link = options.link;
    if (!link && resolvers) {
      link = ApolloLink.empty();
    }
    if (!link || !cache) {
      throw false ? new InvariantError(4) : new InvariantError("In order to initialize Apollo Client, you must specify 'link' and 'cache' properties in the options object.\nThese options are part of the upgrade requirements when migrating from Apollo Client 1.x to Apollo Client 2.x.\nFor more information, please visit: https://www.apollographql.com/docs/tutorial/client.html#apollo-client-setup");
    }
    this.link = link;
    this.cache = cache;
    this.store = new DataStore(cache);
    this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
    this.queryDeduplication = queryDeduplication;
    this.defaultOptions = defaultOptions3 || {};
    this.typeDefs = typeDefs;
    if (ssrForceFetchDelay) {
      setTimeout(function() {
        return _this.disableNetworkFetches = false;
      }, ssrForceFetchDelay);
    }
    this.watchQuery = this.watchQuery.bind(this);
    this.query = this.query.bind(this);
    this.mutate = this.mutate.bind(this);
    this.resetStore = this.resetStore.bind(this);
    this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
    var defaultConnectToDevTools = typeof window !== "undefined" && !window.__APOLLO_CLIENT__;
    if (typeof connectToDevTools === "undefined" ? defaultConnectToDevTools : connectToDevTools && typeof window !== "undefined") {
      window.__APOLLO_CLIENT__ = this;
    }
    if (!hasSuggestedDevtools && true) {
      hasSuggestedDevtools = true;
      if (typeof window !== "undefined" && window.document && window.top === window.self) {
        if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === "undefined") {
          if (window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("Chrome") > -1) {
            console.debug("Download the Apollo DevTools for a better development experience: https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm");
          }
        }
      }
    }
    this.version = version;
    this.localState = new LocalState({
      cache,
      client: this,
      resolvers,
      fragmentMatcher
    });
    this.queryManager = new QueryManager({
      link: this.link,
      store: this.store,
      queryDeduplication,
      ssrMode,
      clientAwareness: {
        name: clientAwarenessName,
        version: clientAwarenessVersion
      },
      localState: this.localState,
      assumeImmutableResults,
      onBroadcast: function() {
        if (_this.devToolsHookCb) {
          _this.devToolsHookCb({
            action: {},
            state: {
              queries: _this.queryManager.queryStore.getStore(),
              mutations: _this.queryManager.mutationStore.getStore()
            },
            dataWithOptimisticResults: _this.cache.extract(true)
          });
        }
      }
    });
  }
  ApolloClient2.prototype.stop = function() {
    this.queryManager.stop();
  };
  ApolloClient2.prototype.watchQuery = function(options) {
    if (this.defaultOptions.watchQuery) {
      options = __assign2(__assign2({}, this.defaultOptions.watchQuery), options);
    }
    if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) {
      options = __assign2(__assign2({}, options), { fetchPolicy: "cache-first" });
    }
    return this.queryManager.watchQuery(options);
  };
  ApolloClient2.prototype.query = function(options) {
    if (this.defaultOptions.query) {
      options = __assign2(__assign2({}, this.defaultOptions.query), options);
    }
    false ? invariant(options.fetchPolicy !== "cache-and-network", 5) : invariant(options.fetchPolicy !== "cache-and-network", "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.");
    if (this.disableNetworkFetches && options.fetchPolicy === "network-only") {
      options = __assign2(__assign2({}, options), { fetchPolicy: "cache-first" });
    }
    return this.queryManager.query(options);
  };
  ApolloClient2.prototype.mutate = function(options) {
    if (this.defaultOptions.mutate) {
      options = __assign2(__assign2({}, this.defaultOptions.mutate), options);
    }
    return this.queryManager.mutate(options);
  };
  ApolloClient2.prototype.subscribe = function(options) {
    return this.queryManager.startGraphQLSubscription(options);
  };
  ApolloClient2.prototype.readQuery = function(options, optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }
    return this.cache.readQuery(options, optimistic);
  };
  ApolloClient2.prototype.readFragment = function(options, optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }
    return this.cache.readFragment(options, optimistic);
  };
  ApolloClient2.prototype.writeQuery = function(options) {
    var result2 = this.cache.writeQuery(options);
    this.queryManager.broadcastQueries();
    return result2;
  };
  ApolloClient2.prototype.writeFragment = function(options) {
    var result2 = this.cache.writeFragment(options);
    this.queryManager.broadcastQueries();
    return result2;
  };
  ApolloClient2.prototype.writeData = function(options) {
    var result2 = this.cache.writeData(options);
    this.queryManager.broadcastQueries();
    return result2;
  };
  ApolloClient2.prototype.__actionHookForDevTools = function(cb) {
    this.devToolsHookCb = cb;
  };
  ApolloClient2.prototype.__requestRaw = function(payload) {
    return execute(this.link, payload);
  };
  ApolloClient2.prototype.initQueryManager = function() {
    invariant.warn("Calling the initQueryManager method is no longer necessary, and it will be removed from ApolloClient in version 3.0.");
    return this.queryManager;
  };
  ApolloClient2.prototype.resetStore = function() {
    var _this = this;
    return Promise.resolve().then(function() {
      return _this.queryManager.clearStore();
    }).then(function() {
      return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
        return fn();
      }));
    }).then(function() {
      return _this.reFetchObservableQueries();
    });
  };
  ApolloClient2.prototype.clearStore = function() {
    var _this = this;
    return Promise.resolve().then(function() {
      return _this.queryManager.clearStore();
    }).then(function() {
      return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
        return fn();
      }));
    });
  };
  ApolloClient2.prototype.onResetStore = function(cb) {
    var _this = this;
    this.resetStoreCallbacks.push(cb);
    return function() {
      _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
        return c !== cb;
      });
    };
  };
  ApolloClient2.prototype.onClearStore = function(cb) {
    var _this = this;
    this.clearStoreCallbacks.push(cb);
    return function() {
      _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
        return c !== cb;
      });
    };
  };
  ApolloClient2.prototype.reFetchObservableQueries = function(includeStandby) {
    return this.queryManager.reFetchObservableQueries(includeStandby);
  };
  ApolloClient2.prototype.extract = function(optimistic) {
    return this.cache.extract(optimistic);
  };
  ApolloClient2.prototype.restore = function(serializedState) {
    return this.cache.restore(serializedState);
  };
  ApolloClient2.prototype.addResolvers = function(resolvers) {
    this.localState.addResolvers(resolvers);
  };
  ApolloClient2.prototype.setResolvers = function(resolvers) {
    this.localState.setResolvers(resolvers);
  };
  ApolloClient2.prototype.getResolvers = function() {
    return this.localState.getResolvers();
  };
  ApolloClient2.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
    this.localState.setFragmentMatcher(fragmentMatcher);
  };
  return ApolloClient2;
}();

// ../../node_modules/.pnpm/apollo-link-http-common@0.2.16_graphql@14.7.0/node_modules/apollo-link-http-common/lib/bundle.esm.js
var import_printer = __toESM(require_printer());
var defaultHttpOptions = {
  includeQuery: true,
  includeExtensions: false
};
var defaultHeaders = {
  accept: "*/*",
  "content-type": "application/json"
};
var defaultOptions = {
  method: "POST"
};
var fallbackHttpConfig = {
  http: defaultHttpOptions,
  headers: defaultHeaders,
  options: defaultOptions
};
var throwServerError = function(response, result2, message) {
  var error = new Error(message);
  error.name = "ServerError";
  error.response = response;
  error.statusCode = response.status;
  error.result = result2;
  throw error;
};
var parseAndCheckHttpResponse = function(operations) {
  return function(response) {
    return response.text().then(function(bodyText) {
      try {
        return JSON.parse(bodyText);
      } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        return Promise.reject(parseError);
      }
    }).then(function(result2) {
      if (response.status >= 300) {
        throwServerError(response, result2, "Response not successful: Received status code " + response.status);
      }
      if (!Array.isArray(result2) && !result2.hasOwnProperty("data") && !result2.hasOwnProperty("errors")) {
        throwServerError(response, result2, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
          return op.operationName;
        }) : operations.operationName) + "'.");
      }
      return result2;
    });
  };
};
var checkFetcher = function(fetcher) {
  if (!fetcher && typeof fetch === "undefined") {
    var library = "unfetch";
    if (typeof window === "undefined")
      library = "node-fetch";
    throw false ? new InvariantError(1) : new InvariantError("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
  }
};
var createSignalIfSupported = function() {
  if (typeof AbortController === "undefined")
    return { controller: false, signal: false };
  var controller = new AbortController();
  var signal = controller.signal;
  return { controller, signal };
};
var selectHttpOptionsAndBody = function(operation, fallbackConfig) {
  var configs = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    configs[_i - 2] = arguments[_i];
  }
  var options = __assign2({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
  var http = fallbackConfig.http;
  configs.forEach(function(config) {
    options = __assign2({}, options, config.options, { headers: __assign2({}, options.headers, config.headers) });
    if (config.credentials)
      options.credentials = config.credentials;
    http = __assign2({}, http, config.http);
  });
  var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
  var body = { operationName, variables };
  if (http.includeExtensions)
    body.extensions = extensions;
  if (http.includeQuery)
    body.query = (0, import_printer.print)(query);
  return {
    options,
    body
  };
};
var serializeFetchParameter = function(p, label) {
  var serialized;
  try {
    serialized = JSON.stringify(p);
  } catch (e) {
    var parseError = false ? new InvariantError(2) : new InvariantError("Network request failed. " + label + " is not serializable: " + e.message);
    parseError.parseError = e;
    throw parseError;
  }
  return serialized;
};
var selectURI = function(operation, fallbackURI) {
  var context = operation.getContext();
  var contextURI = context.uri;
  if (contextURI) {
    return contextURI;
  } else if (typeof fallbackURI === "function") {
    return fallbackURI(operation);
  } else {
    return fallbackURI || "/graphql";
  }
};

// ../../node_modules/.pnpm/apollo-link-http@1.5.17_graphql@14.7.0/node_modules/apollo-link-http/lib/bundle.esm.js
var createHttpLink = function(linkOptions) {
  if (linkOptions === void 0) {
    linkOptions = {};
  }
  var _a3 = linkOptions.uri, uri = _a3 === void 0 ? "/graphql" : _a3, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = __rest2(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
  checkFetcher(fetcher);
  if (!fetcher) {
    fetcher = fetch;
  }
  var linkConfig = {
    http: { includeExtensions },
    options: requestOptions.fetchOptions,
    credentials: requestOptions.credentials,
    headers: requestOptions.headers
  };
  return new ApolloLink(function(operation) {
    var chosenURI = selectURI(operation, uri);
    var context = operation.getContext();
    var clientAwarenessHeaders = {};
    if (context.clientAwareness) {
      var _a4 = context.clientAwareness, name_1 = _a4.name, version2 = _a4.version;
      if (name_1) {
        clientAwarenessHeaders["apollographql-client-name"] = name_1;
      }
      if (version2) {
        clientAwarenessHeaders["apollographql-client-version"] = version2;
      }
    }
    var contextHeaders = __assign2({}, clientAwarenessHeaders, context.headers);
    var contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: contextHeaders
    };
    var _b = selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
    var controller;
    if (!options.signal) {
      var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
      controller = _controller;
      if (controller)
        options.signal = signal;
    }
    var definitionIsMutation = function(d) {
      return d.kind === "OperationDefinition" && d.operation === "mutation";
    };
    if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) {
      options.method = "GET";
    }
    if (options.method === "GET") {
      var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
      if (parseError) {
        return fromError(parseError);
      }
      chosenURI = newURI;
    } else {
      try {
        options.body = serializeFetchParameter(body, "Payload");
      } catch (parseError2) {
        return fromError(parseError2);
      }
    }
    return new bundle_esm_default(function(observer) {
      fetcher(chosenURI, options).then(function(response) {
        operation.setContext({ response });
        return response;
      }).then(parseAndCheckHttpResponse(operation)).then(function(result2) {
        observer.next(result2);
        observer.complete();
        return result2;
      }).catch(function(err) {
        if (err.name === "AbortError")
          return;
        if (err.result && err.result.errors && err.result.data) {
          observer.next(err.result);
        }
        observer.error(err);
      });
      return function() {
        if (controller)
          controller.abort();
      };
    });
  });
};
function rewriteURIForGET(chosenURI, body) {
  var queryParams = [];
  var addQueryParam = function(key, value) {
    queryParams.push(key + "=" + encodeURIComponent(value));
  };
  if ("query" in body) {
    addQueryParam("query", body.query);
  }
  if (body.operationName) {
    addQueryParam("operationName", body.operationName);
  }
  if (body.variables) {
    var serializedVariables = void 0;
    try {
      serializedVariables = serializeFetchParameter(body.variables, "Variables map");
    } catch (parseError) {
      return { parseError };
    }
    addQueryParam("variables", serializedVariables);
  }
  if (body.extensions) {
    var serializedExtensions = void 0;
    try {
      serializedExtensions = serializeFetchParameter(body.extensions, "Extensions map");
    } catch (parseError) {
      return { parseError };
    }
    addQueryParam("extensions", serializedExtensions);
  }
  var fragment = "", preFragment = chosenURI;
  var fragmentStart = chosenURI.indexOf("#");
  if (fragmentStart !== -1) {
    fragment = chosenURI.substr(fragmentStart);
    preFragment = chosenURI.substr(0, fragmentStart);
  }
  var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
  var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
  return { newURI };
}
var HttpLink = function(_super) {
  __extends2(HttpLink2, _super);
  function HttpLink2(opts) {
    return _super.call(this, createHttpLink(opts).request) || this;
  }
  return HttpLink2;
}(ApolloLink);

// ../../node_modules/.pnpm/apollo-cache@1.3.5_graphql@14.7.0/node_modules/apollo-cache/lib/bundle.esm.js
function queryFromPojo(obj2) {
  var op = {
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "GeneratedClientQuery"
    },
    selectionSet: selectionSetFromObj(obj2)
  };
  var out = {
    kind: "Document",
    definitions: [op]
  };
  return out;
}
function fragmentFromPojo(obj2, typename) {
  var frag = {
    kind: "FragmentDefinition",
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: typename || "__FakeType"
      }
    },
    name: {
      kind: "Name",
      value: "GeneratedClientQuery"
    },
    selectionSet: selectionSetFromObj(obj2)
  };
  var out = {
    kind: "Document",
    definitions: [frag]
  };
  return out;
}
function selectionSetFromObj(obj2) {
  if (typeof obj2 === "number" || typeof obj2 === "boolean" || typeof obj2 === "string" || typeof obj2 === "undefined" || obj2 === null) {
    return null;
  }
  if (Array.isArray(obj2)) {
    return selectionSetFromObj(obj2[0]);
  }
  var selections = [];
  Object.keys(obj2).forEach(function(key) {
    var nestedSelSet = selectionSetFromObj(obj2[key]);
    var field = {
      kind: "Field",
      name: {
        kind: "Name",
        value: key
      },
      selectionSet: nestedSelSet || void 0
    };
    selections.push(field);
  });
  var selectionSet = {
    kind: "SelectionSet",
    selections
  };
  return selectionSet;
}
var justTypenameQuery = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: null,
      variableDefinitions: null,
      directives: [],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: null,
            name: {
              kind: "Name",
              value: "__typename"
            },
            arguments: [],
            directives: [],
            selectionSet: null
          }
        ]
      }
    }
  ]
};
var ApolloCache = function() {
  function ApolloCache2() {
  }
  ApolloCache2.prototype.transformDocument = function(document2) {
    return document2;
  };
  ApolloCache2.prototype.transformForLink = function(document2) {
    return document2;
  };
  ApolloCache2.prototype.readQuery = function(options, optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }
    return this.read({
      query: options.query,
      variables: options.variables,
      optimistic
    });
  };
  ApolloCache2.prototype.readFragment = function(options, optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }
    return this.read({
      query: getFragmentQueryDocument(options.fragment, options.fragmentName),
      variables: options.variables,
      rootId: options.id,
      optimistic
    });
  };
  ApolloCache2.prototype.writeQuery = function(options) {
    this.write({
      dataId: "ROOT_QUERY",
      result: options.data,
      query: options.query,
      variables: options.variables
    });
  };
  ApolloCache2.prototype.writeFragment = function(options) {
    this.write({
      dataId: options.id,
      result: options.data,
      variables: options.variables,
      query: getFragmentQueryDocument(options.fragment, options.fragmentName)
    });
  };
  ApolloCache2.prototype.writeData = function(_a3) {
    var id = _a3.id, data = _a3.data;
    if (typeof id !== "undefined") {
      var typenameResult = null;
      try {
        typenameResult = this.read({
          rootId: id,
          optimistic: false,
          query: justTypenameQuery
        });
      } catch (e) {
      }
      var __typename = typenameResult && typenameResult.__typename || "__ClientData";
      var dataToWrite = Object.assign({ __typename }, data);
      this.writeFragment({
        id,
        fragment: fragmentFromPojo(dataToWrite, __typename),
        data: dataToWrite
      });
    } else {
      this.writeQuery({ query: queryFromPojo(data), data });
    }
  };
  return ApolloCache2;
}();
var Cache;
(function(Cache3) {
})(Cache || (Cache = {}));

// ../../node_modules/.pnpm/@wry+context@0.4.4/node_modules/@wry/context/lib/context.esm.js
var currentContext = null;
var MISSING_VALUE = {};
var idCounter = 1;
var makeSlotClass = function() {
  return function() {
    function Slot2() {
      this.id = [
        "slot",
        idCounter++,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join(":");
    }
    Slot2.prototype.hasValue = function() {
      for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
        if (this.id in context_1.slots) {
          var value = context_1.slots[this.id];
          if (value === MISSING_VALUE)
            break;
          if (context_1 !== currentContext) {
            currentContext.slots[this.id] = value;
          }
          return true;
        }
      }
      if (currentContext) {
        currentContext.slots[this.id] = MISSING_VALUE;
      }
      return false;
    };
    Slot2.prototype.getValue = function() {
      if (this.hasValue()) {
        return currentContext.slots[this.id];
      }
    };
    Slot2.prototype.withValue = function(value, callback, args, thisArg) {
      var _a3;
      var slots = (_a3 = {
        __proto__: null
      }, _a3[this.id] = value, _a3);
      var parent2 = currentContext;
      currentContext = { parent: parent2, slots };
      try {
        return callback.apply(thisArg, args);
      } finally {
        currentContext = parent2;
      }
    };
    Slot2.bind = function(callback) {
      var context = currentContext;
      return function() {
        var saved = currentContext;
        try {
          currentContext = context;
          return callback.apply(this, arguments);
        } finally {
          currentContext = saved;
        }
      };
    };
    Slot2.noContext = function(callback, args, thisArg) {
      if (currentContext) {
        var saved = currentContext;
        try {
          currentContext = null;
          return callback.apply(thisArg, args);
        } finally {
          currentContext = saved;
        }
      } else {
        return callback.apply(thisArg, args);
      }
    };
    return Slot2;
  }();
};
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function() {
  var Slot2 = makeSlotClass();
  try {
    Object.defineProperty(host, globalKey, {
      value: host[globalKey] = Slot2,
      enumerable: false,
      writable: false,
      configurable: false
    });
  } finally {
    return Slot2;
  }
}();
var bind = Slot.bind;
var noContext = Slot.noContext;

// ../../node_modules/.pnpm/optimism@0.10.3/node_modules/optimism/lib/bundle.esm.js
function defaultDispose() {
}
var Cache2 = function() {
  function Cache3(max, dispose) {
    if (max === void 0) {
      max = Infinity;
    }
    if (dispose === void 0) {
      dispose = defaultDispose;
    }
    this.max = max;
    this.dispose = dispose;
    this.map = /* @__PURE__ */ new Map();
    this.newest = null;
    this.oldest = null;
  }
  Cache3.prototype.has = function(key) {
    return this.map.has(key);
  };
  Cache3.prototype.get = function(key) {
    var entry = this.getEntry(key);
    return entry && entry.value;
  };
  Cache3.prototype.getEntry = function(key) {
    var entry = this.map.get(key);
    if (entry && entry !== this.newest) {
      var older = entry.older, newer = entry.newer;
      if (newer) {
        newer.older = older;
      }
      if (older) {
        older.newer = newer;
      }
      entry.older = this.newest;
      entry.older.newer = entry;
      entry.newer = null;
      this.newest = entry;
      if (entry === this.oldest) {
        this.oldest = newer;
      }
    }
    return entry;
  };
  Cache3.prototype.set = function(key, value) {
    var entry = this.getEntry(key);
    if (entry) {
      return entry.value = value;
    }
    entry = {
      key,
      value,
      newer: null,
      older: this.newest
    };
    if (this.newest) {
      this.newest.newer = entry;
    }
    this.newest = entry;
    this.oldest = this.oldest || entry;
    this.map.set(key, entry);
    return entry.value;
  };
  Cache3.prototype.clean = function() {
    while (this.oldest && this.map.size > this.max) {
      this.delete(this.oldest.key);
    }
  };
  Cache3.prototype.delete = function(key) {
    var entry = this.map.get(key);
    if (entry) {
      if (entry === this.newest) {
        this.newest = entry.older;
      }
      if (entry === this.oldest) {
        this.oldest = entry.newer;
      }
      if (entry.newer) {
        entry.newer.older = entry.older;
      }
      if (entry.older) {
        entry.older.newer = entry.newer;
      }
      this.map.delete(key);
      this.dispose(entry.value, key);
      return true;
    }
    return false;
  };
  return Cache3;
}();
var parentEntrySlot = new Slot();
var reusableEmptyArray = [];
var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
function assert(condition, optionalMessage) {
  if (!condition) {
    throw new Error(optionalMessage || "assertion failure");
  }
}
function valueIs(a, b) {
  var len = a.length;
  return len > 0 && len === b.length && a[len - 1] === b[len - 1];
}
function valueGet(value) {
  switch (value.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return value[0];
    case 2:
      throw value[1];
  }
}
function valueCopy(value) {
  return value.slice(0);
}
var Entry = function() {
  function Entry2(fn, args) {
    this.fn = fn;
    this.args = args;
    this.parents = /* @__PURE__ */ new Set();
    this.childValues = /* @__PURE__ */ new Map();
    this.dirtyChildren = null;
    this.dirty = true;
    this.recomputing = false;
    this.value = [];
    ++Entry2.count;
  }
  Entry2.prototype.recompute = function() {
    assert(!this.recomputing, "already recomputing");
    if (!rememberParent(this) && maybeReportOrphan(this)) {
      return void 0;
    }
    return mightBeDirty(this) ? reallyRecompute(this) : valueGet(this.value);
  };
  Entry2.prototype.setDirty = function() {
    if (this.dirty)
      return;
    this.dirty = true;
    this.value.length = 0;
    reportDirty(this);
    maybeUnsubscribe(this);
  };
  Entry2.prototype.dispose = function() {
    var _this = this;
    forgetChildren(this).forEach(maybeReportOrphan);
    maybeUnsubscribe(this);
    this.parents.forEach(function(parent2) {
      parent2.setDirty();
      forgetChild(parent2, _this);
    });
  };
  Entry2.count = 0;
  return Entry2;
}();
function rememberParent(child) {
  var parent2 = parentEntrySlot.getValue();
  if (parent2) {
    child.parents.add(parent2);
    if (!parent2.childValues.has(child)) {
      parent2.childValues.set(child, []);
    }
    if (mightBeDirty(child)) {
      reportDirtyChild(parent2, child);
    } else {
      reportCleanChild(parent2, child);
    }
    return parent2;
  }
}
function reallyRecompute(entry) {
  var originalChildren = forgetChildren(entry);
  parentEntrySlot.withValue(entry, recomputeNewValue, [entry]);
  if (maybeSubscribe(entry)) {
    setClean(entry);
  }
  originalChildren.forEach(maybeReportOrphan);
  return valueGet(entry.value);
}
function recomputeNewValue(entry) {
  entry.recomputing = true;
  entry.value.length = 0;
  try {
    entry.value[0] = entry.fn.apply(null, entry.args);
  } catch (e) {
    entry.value[1] = e;
  }
  entry.recomputing = false;
}
function mightBeDirty(entry) {
  return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
  entry.dirty = false;
  if (mightBeDirty(entry)) {
    return;
  }
  reportClean(entry);
}
function reportDirty(child) {
  child.parents.forEach(function(parent2) {
    return reportDirtyChild(parent2, child);
  });
}
function reportClean(child) {
  child.parents.forEach(function(parent2) {
    return reportCleanChild(parent2, child);
  });
}
function reportDirtyChild(parent2, child) {
  assert(parent2.childValues.has(child));
  assert(mightBeDirty(child));
  if (!parent2.dirtyChildren) {
    parent2.dirtyChildren = emptySetPool.pop() || /* @__PURE__ */ new Set();
  } else if (parent2.dirtyChildren.has(child)) {
    return;
  }
  parent2.dirtyChildren.add(child);
  reportDirty(parent2);
}
function reportCleanChild(parent2, child) {
  assert(parent2.childValues.has(child));
  assert(!mightBeDirty(child));
  var childValue = parent2.childValues.get(child);
  if (childValue.length === 0) {
    parent2.childValues.set(child, valueCopy(child.value));
  } else if (!valueIs(childValue, child.value)) {
    parent2.setDirty();
  }
  removeDirtyChild(parent2, child);
  if (mightBeDirty(parent2)) {
    return;
  }
  reportClean(parent2);
}
function removeDirtyChild(parent2, child) {
  var dc = parent2.dirtyChildren;
  if (dc) {
    dc.delete(child);
    if (dc.size === 0) {
      if (emptySetPool.length < POOL_TARGET_SIZE) {
        emptySetPool.push(dc);
      }
      parent2.dirtyChildren = null;
    }
  }
}
function maybeReportOrphan(entry) {
  return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
function forgetChildren(parent2) {
  var children = reusableEmptyArray;
  if (parent2.childValues.size > 0) {
    children = [];
    parent2.childValues.forEach(function(_value, child) {
      forgetChild(parent2, child);
      children.push(child);
    });
  }
  assert(parent2.dirtyChildren === null);
  return children;
}
function forgetChild(parent2, child) {
  child.parents.delete(parent2);
  parent2.childValues.delete(child);
  removeDirtyChild(parent2, child);
}
function maybeSubscribe(entry) {
  if (typeof entry.subscribe === "function") {
    try {
      maybeUnsubscribe(entry);
      entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
      entry.setDirty();
      return false;
    }
  }
  return true;
}
function maybeUnsubscribe(entry) {
  var unsubscribe = entry.unsubscribe;
  if (typeof unsubscribe === "function") {
    entry.unsubscribe = void 0;
    unsubscribe();
  }
}
var KeyTrie = function() {
  function KeyTrie2(weakness) {
    this.weakness = weakness;
  }
  KeyTrie2.prototype.lookup = function() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      array[_i] = arguments[_i];
    }
    return this.lookupArray(array);
  };
  KeyTrie2.prototype.lookupArray = function(array) {
    var node = this;
    array.forEach(function(key) {
      return node = node.getChildTrie(key);
    });
    return node.data || (node.data = /* @__PURE__ */ Object.create(null));
  };
  KeyTrie2.prototype.getChildTrie = function(key) {
    var map = this.weakness && isObjRef(key) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map());
    var child = map.get(key);
    if (!child)
      map.set(key, child = new KeyTrie2(this.weakness));
    return child;
  };
  return KeyTrie2;
}();
function isObjRef(value) {
  switch (typeof value) {
    case "object":
      if (value === null)
        break;
    case "function":
      return true;
  }
  return false;
}
var keyTrie = new KeyTrie(typeof WeakMap === "function");
function defaultMakeCacheKey() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  return keyTrie.lookupArray(args);
}
var caches = /* @__PURE__ */ new Set();
function wrap(originalFunction, options) {
  if (options === void 0) {
    options = /* @__PURE__ */ Object.create(null);
  }
  var cache = new Cache2(options.max || Math.pow(2, 16), function(entry) {
    return entry.dispose();
  });
  var disposable = !!options.disposable;
  var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
  function optimistic() {
    if (disposable && !parentEntrySlot.hasValue()) {
      return void 0;
    }
    var key = makeCacheKey.apply(null, arguments);
    if (key === void 0) {
      return originalFunction.apply(null, arguments);
    }
    var args = Array.prototype.slice.call(arguments);
    var entry = cache.get(key);
    if (entry) {
      entry.args = args;
    } else {
      entry = new Entry(originalFunction, args);
      cache.set(key, entry);
      entry.subscribe = options.subscribe;
      if (disposable) {
        entry.reportOrphan = function() {
          return cache.delete(key);
        };
      }
    }
    var value = entry.recompute();
    cache.set(key, entry);
    caches.add(cache);
    if (!parentEntrySlot.hasValue()) {
      caches.forEach(function(cache2) {
        return cache2.clean();
      });
      caches.clear();
    }
    return disposable ? void 0 : value;
  }
  optimistic.dirty = function() {
    var key = makeCacheKey.apply(null, arguments);
    var child = key !== void 0 && cache.get(key);
    if (child) {
      child.setDirty();
    }
  };
  return optimistic;
}

// ../../node_modules/.pnpm/apollo-cache-inmemory@1.6.6_graphql@14.7.0/node_modules/apollo-cache-inmemory/lib/bundle.esm.js
var haveWarned = false;
function shouldWarn() {
  var answer = !haveWarned;
  if (!isTest()) {
    haveWarned = true;
  }
  return answer;
}
var HeuristicFragmentMatcher = function() {
  function HeuristicFragmentMatcher2() {
  }
  HeuristicFragmentMatcher2.prototype.ensureReady = function() {
    return Promise.resolve();
  };
  HeuristicFragmentMatcher2.prototype.canBypassInit = function() {
    return true;
  };
  HeuristicFragmentMatcher2.prototype.match = function(idValue, typeCondition, context) {
    var obj2 = context.store.get(idValue.id);
    var isRootQuery = idValue.id === "ROOT_QUERY";
    if (!obj2) {
      return isRootQuery;
    }
    var _a3 = obj2.__typename, __typename = _a3 === void 0 ? isRootQuery && "Query" : _a3;
    if (!__typename) {
      if (shouldWarn()) {
        invariant.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
        invariant.warn("Could not find __typename on Fragment ", typeCondition, obj2);
        invariant.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
      }
      return "heuristic";
    }
    if (__typename === typeCondition) {
      return true;
    }
    if (shouldWarn()) {
      invariant.error("You are using the simple (heuristic) fragment matcher, but your queries contain union or interface types. Apollo Client will not be able to accurately map fragments. To make this error go away, use the `IntrospectionFragmentMatcher` as described in the docs: https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher");
    }
    return "heuristic";
  };
  return HeuristicFragmentMatcher2;
}();
var IntrospectionFragmentMatcher = function() {
  function IntrospectionFragmentMatcher2(options) {
    if (options && options.introspectionQueryResultData) {
      this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
      this.isReady = true;
    } else {
      this.isReady = false;
    }
    this.match = this.match.bind(this);
  }
  IntrospectionFragmentMatcher2.prototype.match = function(idValue, typeCondition, context) {
    false ? invariant(this.isReady, 1) : invariant(this.isReady, "FragmentMatcher.match() was called before FragmentMatcher.init()");
    var obj2 = context.store.get(idValue.id);
    var isRootQuery = idValue.id === "ROOT_QUERY";
    if (!obj2) {
      return isRootQuery;
    }
    var _a3 = obj2.__typename, __typename = _a3 === void 0 ? isRootQuery && "Query" : _a3;
    false ? invariant(__typename, 2) : invariant(__typename, "Cannot match fragment because __typename property is missing: " + JSON.stringify(obj2));
    if (__typename === typeCondition) {
      return true;
    }
    var implementingTypes = this.possibleTypesMap[typeCondition];
    if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) {
      return true;
    }
    return false;
  };
  IntrospectionFragmentMatcher2.prototype.parseIntrospectionResult = function(introspectionResultData) {
    var typeMap = {};
    introspectionResultData.__schema.types.forEach(function(type) {
      if (type.kind === "UNION" || type.kind === "INTERFACE") {
        typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
          return implementingType.name;
        });
      }
    });
    return typeMap;
  };
  return IntrospectionFragmentMatcher2;
}();
var hasOwn = Object.prototype.hasOwnProperty;
var DepTrackingCache = function() {
  function DepTrackingCache2(data) {
    var _this = this;
    if (data === void 0) {
      data = /* @__PURE__ */ Object.create(null);
    }
    this.data = data;
    this.depend = wrap(function(dataId) {
      return _this.data[dataId];
    }, {
      disposable: true,
      makeCacheKey: function(dataId) {
        return dataId;
      }
    });
  }
  DepTrackingCache2.prototype.toObject = function() {
    return this.data;
  };
  DepTrackingCache2.prototype.get = function(dataId) {
    this.depend(dataId);
    return this.data[dataId];
  };
  DepTrackingCache2.prototype.set = function(dataId, value) {
    var oldValue = this.data[dataId];
    if (value !== oldValue) {
      this.data[dataId] = value;
      this.depend.dirty(dataId);
    }
  };
  DepTrackingCache2.prototype.delete = function(dataId) {
    if (hasOwn.call(this.data, dataId)) {
      delete this.data[dataId];
      this.depend.dirty(dataId);
    }
  };
  DepTrackingCache2.prototype.clear = function() {
    this.replace(null);
  };
  DepTrackingCache2.prototype.replace = function(newData) {
    var _this = this;
    if (newData) {
      Object.keys(newData).forEach(function(dataId) {
        _this.set(dataId, newData[dataId]);
      });
      Object.keys(this.data).forEach(function(dataId) {
        if (!hasOwn.call(newData, dataId)) {
          _this.delete(dataId);
        }
      });
    } else {
      Object.keys(this.data).forEach(function(dataId) {
        _this.delete(dataId);
      });
    }
  };
  return DepTrackingCache2;
}();
function defaultNormalizedCacheFactory(seed) {
  return new DepTrackingCache(seed);
}
var StoreReader = function() {
  function StoreReader2(_a3) {
    var _this = this;
    var _b = _a3 === void 0 ? {} : _a3, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new KeyTrie(canUseWeakMap) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
    var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
    this.freezeResults = freezeResults;
    this.executeStoreQuery = wrap(function(options) {
      return executeStoreQuery.call(_this, options);
    }, {
      makeCacheKey: function(_a4) {
        var query = _a4.query, rootValue = _a4.rootValue, contextValue = _a4.contextValue, variableValues = _a4.variableValues, fragmentMatcher = _a4.fragmentMatcher;
        if (contextValue.store instanceof DepTrackingCache) {
          return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
        }
      }
    });
    this.executeSelectionSet = wrap(function(options) {
      return executeSelectionSet.call(_this, options);
    }, {
      makeCacheKey: function(_a4) {
        var selectionSet = _a4.selectionSet, rootValue = _a4.rootValue, execContext = _a4.execContext;
        if (execContext.contextValue.store instanceof DepTrackingCache) {
          return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
        }
      }
    });
    this.executeSubSelectedArray = wrap(function(options) {
      return executeSubSelectedArray.call(_this, options);
    }, {
      makeCacheKey: function(_a4) {
        var field = _a4.field, array = _a4.array, execContext = _a4.execContext;
        if (execContext.contextValue.store instanceof DepTrackingCache) {
          return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
        }
      }
    });
  }
  StoreReader2.prototype.readQueryFromStore = function(options) {
    return this.diffQueryAgainstStore(__assign2(__assign2({}, options), { returnPartialData: false })).result;
  };
  StoreReader2.prototype.diffQueryAgainstStore = function(_a3) {
    var store = _a3.store, query = _a3.query, variables = _a3.variables, previousResult = _a3.previousResult, _b = _a3.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a3.rootId, rootId = _c === void 0 ? "ROOT_QUERY" : _c, fragmentMatcherFunction = _a3.fragmentMatcherFunction, config = _a3.config;
    var queryDefinition = getQueryDefinition(query);
    variables = assign({}, getDefaultValues(queryDefinition), variables);
    var context = {
      store,
      dataIdFromObject: config && config.dataIdFromObject,
      cacheRedirects: config && config.cacheRedirects || {}
    };
    var execResult = this.executeStoreQuery({
      query,
      rootValue: {
        type: "id",
        id: rootId,
        generated: true,
        typename: "Query"
      },
      contextValue: context,
      variableValues: variables,
      fragmentMatcher: fragmentMatcherFunction
    });
    var hasMissingFields = execResult.missing && execResult.missing.length > 0;
    if (hasMissingFields && !returnPartialData) {
      execResult.missing.forEach(function(info) {
        if (info.tolerable)
          return;
        throw false ? new InvariantError(8) : new InvariantError("Can't find field " + info.fieldName + " on object " + JSON.stringify(info.object, null, 2) + ".");
      });
    }
    if (previousResult) {
      if (equal(previousResult, execResult.result)) {
        execResult.result = previousResult;
      }
    }
    return {
      result: execResult.result,
      complete: !hasMissingFields
    };
  };
  StoreReader2.prototype.executeStoreQuery = function(_a3) {
    var query = _a3.query, rootValue = _a3.rootValue, contextValue = _a3.contextValue, variableValues = _a3.variableValues, _b = _a3.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
    var mainDefinition = getMainDefinition(query);
    var fragments = getFragmentDefinitions(query);
    var fragmentMap = createFragmentMap(fragments);
    var execContext = {
      query,
      fragmentMap,
      contextValue,
      variableValues,
      fragmentMatcher
    };
    return this.executeSelectionSet({
      selectionSet: mainDefinition.selectionSet,
      rootValue,
      execContext
    });
  };
  StoreReader2.prototype.executeSelectionSet = function(_a3) {
    var _this = this;
    var selectionSet = _a3.selectionSet, rootValue = _a3.rootValue, execContext = _a3.execContext;
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var finalResult = { result: null };
    var objectsToMerge = [];
    var object = contextValue.store.get(rootValue.id);
    var typename = object && object.__typename || rootValue.id === "ROOT_QUERY" && "Query" || void 0;
    function handleMissing(result2) {
      var _a4;
      if (result2.missing) {
        finalResult.missing = finalResult.missing || [];
        (_a4 = finalResult.missing).push.apply(_a4, result2.missing);
      }
      return result2.result;
    }
    selectionSet.selections.forEach(function(selection) {
      var _a4;
      if (!shouldInclude(selection, variables)) {
        return;
      }
      if (isField(selection)) {
        var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
        if (typeof fieldResult !== "undefined") {
          objectsToMerge.push((_a4 = {}, _a4[resultKeyNameFromField(selection)] = fieldResult, _a4));
        }
      } else {
        var fragment = void 0;
        if (isInlineFragment(selection)) {
          fragment = selection;
        } else {
          fragment = fragmentMap[selection.name.value];
          if (!fragment) {
            throw false ? new InvariantError(9) : new InvariantError("No fragment named " + selection.name.value);
          }
        }
        var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
        var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
        if (match) {
          var fragmentExecResult = _this.executeSelectionSet({
            selectionSet: fragment.selectionSet,
            rootValue,
            execContext
          });
          if (match === "heuristic" && fragmentExecResult.missing) {
            fragmentExecResult = __assign2(__assign2({}, fragmentExecResult), { missing: fragmentExecResult.missing.map(function(info) {
              return __assign2(__assign2({}, info), { tolerable: true });
            }) });
          }
          objectsToMerge.push(handleMissing(fragmentExecResult));
        }
      }
    });
    finalResult.result = mergeDeepArray(objectsToMerge);
    if (this.freezeResults && true) {
      Object.freeze(finalResult.result);
    }
    return finalResult;
  };
  StoreReader2.prototype.executeField = function(object, typename, field, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue;
    var fieldName = field.name.value;
    var args = argumentsObjectFromField(field, variables);
    var info = {
      resultKey: resultKeyNameFromField(field),
      directives: getDirectiveInfoFromField(field, variables)
    };
    var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
    if (Array.isArray(readStoreResult.result)) {
      return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
        field,
        array: readStoreResult.result,
        execContext
      }));
    }
    if (!field.selectionSet) {
      assertSelectionSetForIdValue(field, readStoreResult.result);
      if (this.freezeResults && true) {
        maybeDeepFreeze(readStoreResult);
      }
      return readStoreResult;
    }
    if (readStoreResult.result == null) {
      return readStoreResult;
    }
    return this.combineExecResults(readStoreResult, this.executeSelectionSet({
      selectionSet: field.selectionSet,
      rootValue: readStoreResult.result,
      execContext
    }));
  };
  StoreReader2.prototype.combineExecResults = function() {
    var execResults = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      execResults[_i] = arguments[_i];
    }
    var missing;
    execResults.forEach(function(execResult) {
      if (execResult.missing) {
        missing = missing || [];
        missing.push.apply(missing, execResult.missing);
      }
    });
    return {
      result: execResults.pop().result,
      missing
    };
  };
  StoreReader2.prototype.executeSubSelectedArray = function(_a3) {
    var _this = this;
    var field = _a3.field, array = _a3.array, execContext = _a3.execContext;
    var missing;
    function handleMissing(childResult) {
      if (childResult.missing) {
        missing = missing || [];
        missing.push.apply(missing, childResult.missing);
      }
      return childResult.result;
    }
    array = array.map(function(item) {
      if (item === null) {
        return null;
      }
      if (Array.isArray(item)) {
        return handleMissing(_this.executeSubSelectedArray({
          field,
          array: item,
          execContext
        }));
      }
      if (field.selectionSet) {
        return handleMissing(_this.executeSelectionSet({
          selectionSet: field.selectionSet,
          rootValue: item,
          execContext
        }));
      }
      assertSelectionSetForIdValue(field, item);
      return item;
    });
    if (this.freezeResults && true) {
      Object.freeze(array);
    }
    return { result: array, missing };
  };
  return StoreReader2;
}();
function assertSelectionSetForIdValue(field, value) {
  if (!field.selectionSet && isIdValue(value)) {
    throw false ? new InvariantError(10) : new InvariantError("Missing selection set for object of type " + value.typename + " returned for query field " + field.name.value);
  }
}
function defaultFragmentMatcher() {
  return true;
}
function readStoreResolver(object, typename, fieldName, args, context, _a3) {
  var resultKey = _a3.resultKey, directives = _a3.directives;
  var storeKeyName = fieldName;
  if (args || directives) {
    storeKeyName = getStoreKeyName(storeKeyName, args, directives);
  }
  var fieldValue = void 0;
  if (object) {
    fieldValue = object[storeKeyName];
    if (typeof fieldValue === "undefined" && context.cacheRedirects && typeof typename === "string") {
      var type = context.cacheRedirects[typename];
      if (type) {
        var resolver = type[fieldName];
        if (resolver) {
          fieldValue = resolver(object, args, {
            getCacheKey: function(storeObj) {
              var id = context.dataIdFromObject(storeObj);
              return id && toIdValue({
                id,
                typename: storeObj.__typename
              });
            }
          });
        }
      }
    }
  }
  if (typeof fieldValue === "undefined") {
    return {
      result: fieldValue,
      missing: [{
        object,
        fieldName: storeKeyName,
        tolerable: false
      }]
    };
  }
  if (isJsonValue(fieldValue)) {
    fieldValue = fieldValue.json;
  }
  return {
    result: fieldValue
  };
}
var ObjectCache = function() {
  function ObjectCache2(data) {
    if (data === void 0) {
      data = /* @__PURE__ */ Object.create(null);
    }
    this.data = data;
  }
  ObjectCache2.prototype.toObject = function() {
    return this.data;
  };
  ObjectCache2.prototype.get = function(dataId) {
    return this.data[dataId];
  };
  ObjectCache2.prototype.set = function(dataId, value) {
    this.data[dataId] = value;
  };
  ObjectCache2.prototype.delete = function(dataId) {
    this.data[dataId] = void 0;
  };
  ObjectCache2.prototype.clear = function() {
    this.data = /* @__PURE__ */ Object.create(null);
  };
  ObjectCache2.prototype.replace = function(newData) {
    this.data = newData || /* @__PURE__ */ Object.create(null);
  };
  return ObjectCache2;
}();
var WriteError = function(_super) {
  __extends2(WriteError2, _super);
  function WriteError2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = "WriteError";
    return _this;
  }
  return WriteError2;
}(Error);
function enhanceErrorWithDocument(error, document2) {
  var enhancedError = new WriteError("Error writing result to store for query:\n " + JSON.stringify(document2));
  enhancedError.message += "\n" + error.message;
  enhancedError.stack = error.stack;
  return enhancedError;
}
var StoreWriter = function() {
  function StoreWriter2() {
  }
  StoreWriter2.prototype.writeQueryToStore = function(_a3) {
    var query = _a3.query, result2 = _a3.result, _b = _a3.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a3.variables, dataIdFromObject = _a3.dataIdFromObject, fragmentMatcherFunction = _a3.fragmentMatcherFunction;
    return this.writeResultToStore({
      dataId: "ROOT_QUERY",
      result: result2,
      document: query,
      store,
      variables,
      dataIdFromObject,
      fragmentMatcherFunction
    });
  };
  StoreWriter2.prototype.writeResultToStore = function(_a3) {
    var dataId = _a3.dataId, result2 = _a3.result, document2 = _a3.document, _b = _a3.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a3.variables, dataIdFromObject = _a3.dataIdFromObject, fragmentMatcherFunction = _a3.fragmentMatcherFunction;
    var operationDefinition = getOperationDefinition(document2);
    try {
      return this.writeSelectionSetToStore({
        result: result2,
        dataId,
        selectionSet: operationDefinition.selectionSet,
        context: {
          store,
          processedData: {},
          variables: assign({}, getDefaultValues(operationDefinition), variables),
          dataIdFromObject,
          fragmentMap: createFragmentMap(getFragmentDefinitions(document2)),
          fragmentMatcherFunction
        }
      });
    } catch (e) {
      throw enhanceErrorWithDocument(e, document2);
    }
  };
  StoreWriter2.prototype.writeSelectionSetToStore = function(_a3) {
    var _this = this;
    var result2 = _a3.result, dataId = _a3.dataId, selectionSet = _a3.selectionSet, context = _a3.context;
    var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
    selectionSet.selections.forEach(function(selection) {
      var _a4;
      if (!shouldInclude(selection, variables)) {
        return;
      }
      if (isField(selection)) {
        var resultFieldKey = resultKeyNameFromField(selection);
        var value = result2[resultFieldKey];
        if (typeof value !== "undefined") {
          _this.writeFieldToStore({
            dataId,
            value,
            field: selection,
            context
          });
        } else {
          var isDefered = false;
          var isClient = false;
          if (selection.directives && selection.directives.length) {
            isDefered = selection.directives.some(function(directive) {
              return directive.name && directive.name.value === "defer";
            });
            isClient = selection.directives.some(function(directive) {
              return directive.name && directive.name.value === "client";
            });
          }
          if (!isDefered && !isClient && context.fragmentMatcherFunction) {
            invariant.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result2, null, 2).substring(0, 100));
          }
        }
      } else {
        var fragment = void 0;
        if (isInlineFragment(selection)) {
          fragment = selection;
        } else {
          fragment = (fragmentMap || {})[selection.name.value];
          false ? invariant(fragment, 3) : invariant(fragment, "No fragment named " + selection.name.value + ".");
        }
        var matches = true;
        if (context.fragmentMatcherFunction && fragment.typeCondition) {
          var id = dataId || "self";
          var idValue = toIdValue({ id, typename: void 0 });
          var fakeContext = {
            store: new ObjectCache((_a4 = {}, _a4[id] = result2, _a4)),
            cacheRedirects: {}
          };
          var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
          if (!isProduction() && match === "heuristic") {
            invariant.error("WARNING: heuristic fragment matching going on!");
          }
          matches = !!match;
        }
        if (matches) {
          _this.writeSelectionSetToStore({
            result: result2,
            selectionSet: fragment.selectionSet,
            dataId,
            context
          });
        }
      }
    });
    return store;
  };
  StoreWriter2.prototype.writeFieldToStore = function(_a3) {
    var _b;
    var field = _a3.field, value = _a3.value, dataId = _a3.dataId, context = _a3.context;
    var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
    var storeValue;
    var storeObject;
    var storeFieldName = storeKeyNameFromField(field, variables);
    if (!field.selectionSet || value === null) {
      storeValue = value != null && typeof value === "object" ? { type: "json", json: value } : value;
    } else if (Array.isArray(value)) {
      var generatedId = dataId + "." + storeFieldName;
      storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
    } else {
      var valueDataId = dataId + "." + storeFieldName;
      var generated = true;
      if (!isGeneratedId(valueDataId)) {
        valueDataId = "$" + valueDataId;
      }
      if (dataIdFromObject) {
        var semanticId = dataIdFromObject(value);
        false ? invariant(!semanticId || !isGeneratedId(semanticId), 4) : invariant(!semanticId || !isGeneratedId(semanticId), 'IDs returned by dataIdFromObject cannot begin with the "$" character.');
        if (semanticId || typeof semanticId === "number" && semanticId === 0) {
          valueDataId = semanticId;
          generated = false;
        }
      }
      if (!isDataProcessed(valueDataId, field, context.processedData)) {
        this.writeSelectionSetToStore({
          dataId: valueDataId,
          result: value,
          selectionSet: field.selectionSet,
          context
        });
      }
      var typename = value.__typename;
      storeValue = toIdValue({ id: valueDataId, typename }, generated);
      storeObject = store.get(dataId);
      var escapedId = storeObject && storeObject[storeFieldName];
      if (escapedId !== storeValue && isIdValue(escapedId)) {
        var hadTypename = escapedId.typename !== void 0;
        var hasTypename = typename !== void 0;
        var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
        false ? invariant(!generated || escapedId.generated || typenameChanged, 5) : invariant(!generated || escapedId.generated || typenameChanged, "Store error: the application attempted to write an object with no provided id but the store already contains an id of " + escapedId.id + " for this object. The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
        false ? invariant(!hadTypename || hasTypename, 6) : invariant(!hadTypename || hasTypename, "Store error: the application attempted to write an object with no provided typename but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
        if (escapedId.generated) {
          if (typenameChanged) {
            if (!generated) {
              store.delete(escapedId.id);
            }
          } else {
            mergeWithGenerated(escapedId.id, storeValue.id, store);
          }
        }
      }
    }
    storeObject = store.get(dataId);
    if (!storeObject || !equal(storeValue, storeObject[storeFieldName])) {
      store.set(dataId, __assign2(__assign2({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    }
  };
  StoreWriter2.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
    var _this = this;
    return value.map(function(item, index) {
      if (item === null) {
        return null;
      }
      var itemDataId = generatedId + "." + index;
      if (Array.isArray(item)) {
        return _this.processArrayValue(item, itemDataId, selectionSet, context);
      }
      var generated = true;
      if (context.dataIdFromObject) {
        var semanticId = context.dataIdFromObject(item);
        if (semanticId) {
          itemDataId = semanticId;
          generated = false;
        }
      }
      if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
        _this.writeSelectionSetToStore({
          dataId: itemDataId,
          result: item,
          selectionSet,
          context
        });
      }
      return toIdValue({ id: itemDataId, typename: item.__typename }, generated);
    });
  };
  return StoreWriter2;
}();
function isGeneratedId(id) {
  return id[0] === "$";
}
function mergeWithGenerated(generatedKey, realKey, cache) {
  if (generatedKey === realKey) {
    return false;
  }
  var generated = cache.get(generatedKey);
  var real = cache.get(realKey);
  var madeChanges = false;
  Object.keys(generated).forEach(function(key) {
    var value = generated[key];
    var realValue = real[key];
    if (isIdValue(value) && isGeneratedId(value.id) && isIdValue(realValue) && !equal(value, realValue) && mergeWithGenerated(value.id, realValue.id, cache)) {
      madeChanges = true;
    }
  });
  cache.delete(generatedKey);
  var newRealValue = __assign2(__assign2({}, generated), real);
  if (equal(newRealValue, real)) {
    return madeChanges;
  }
  cache.set(realKey, newRealValue);
  return true;
}
function isDataProcessed(dataId, field, processedData) {
  if (!processedData) {
    return false;
  }
  if (processedData[dataId]) {
    if (processedData[dataId].indexOf(field) >= 0) {
      return true;
    } else {
      processedData[dataId].push(field);
    }
  } else {
    processedData[dataId] = [field];
  }
  return false;
}
var defaultConfig = {
  fragmentMatcher: new HeuristicFragmentMatcher(),
  dataIdFromObject: defaultDataIdFromObject,
  addTypename: true,
  resultCaching: true,
  freezeResults: false
};
function defaultDataIdFromObject(result2) {
  if (result2.__typename) {
    if (result2.id !== void 0) {
      return result2.__typename + ":" + result2.id;
    }
    if (result2._id !== void 0) {
      return result2.__typename + ":" + result2._id;
    }
  }
  return null;
}
var hasOwn$1 = Object.prototype.hasOwnProperty;
var OptimisticCacheLayer = function(_super) {
  __extends2(OptimisticCacheLayer2, _super);
  function OptimisticCacheLayer2(optimisticId, parent2, transaction) {
    var _this = _super.call(this, /* @__PURE__ */ Object.create(null)) || this;
    _this.optimisticId = optimisticId;
    _this.parent = parent2;
    _this.transaction = transaction;
    return _this;
  }
  OptimisticCacheLayer2.prototype.toObject = function() {
    return __assign2(__assign2({}, this.parent.toObject()), this.data);
  };
  OptimisticCacheLayer2.prototype.get = function(dataId) {
    return hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
  };
  return OptimisticCacheLayer2;
}(ObjectCache);
var InMemoryCache = function(_super) {
  __extends2(InMemoryCache2, _super);
  function InMemoryCache2(config) {
    if (config === void 0) {
      config = {};
    }
    var _this = _super.call(this) || this;
    _this.watches = /* @__PURE__ */ new Set();
    _this.typenameDocumentCache = /* @__PURE__ */ new Map();
    _this.cacheKeyRoot = new KeyTrie(canUseWeakMap);
    _this.silenceBroadcast = false;
    _this.config = __assign2(__assign2({}, defaultConfig), config);
    if (_this.config.customResolvers) {
      invariant.warn("customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.");
      _this.config.cacheRedirects = _this.config.customResolvers;
    }
    if (_this.config.cacheResolvers) {
      invariant.warn("cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.");
      _this.config.cacheRedirects = _this.config.cacheResolvers;
    }
    _this.addTypename = !!_this.config.addTypename;
    _this.data = _this.config.resultCaching ? new DepTrackingCache() : new ObjectCache();
    _this.optimisticData = _this.data;
    _this.storeWriter = new StoreWriter();
    _this.storeReader = new StoreReader({
      cacheKeyRoot: _this.cacheKeyRoot,
      freezeResults: config.freezeResults
    });
    var cache = _this;
    var maybeBroadcastWatch = cache.maybeBroadcastWatch;
    _this.maybeBroadcastWatch = wrap(function(c) {
      return maybeBroadcastWatch.call(_this, c);
    }, {
      makeCacheKey: function(c) {
        if (c.optimistic) {
          return;
        }
        if (c.previousResult) {
          return;
        }
        if (cache.data instanceof DepTrackingCache) {
          return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
        }
      }
    });
    return _this;
  }
  InMemoryCache2.prototype.restore = function(data) {
    if (data)
      this.data.replace(data);
    return this;
  };
  InMemoryCache2.prototype.extract = function(optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }
    return (optimistic ? this.optimisticData : this.data).toObject();
  };
  InMemoryCache2.prototype.read = function(options) {
    if (typeof options.rootId === "string" && typeof this.data.get(options.rootId) === "undefined") {
      return null;
    }
    var fragmentMatcher = this.config.fragmentMatcher;
    var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
    return this.storeReader.readQueryFromStore({
      store: options.optimistic ? this.optimisticData : this.data,
      query: this.transformDocument(options.query),
      variables: options.variables,
      rootId: options.rootId,
      fragmentMatcherFunction,
      previousResult: options.previousResult,
      config: this.config
    }) || null;
  };
  InMemoryCache2.prototype.write = function(write) {
    var fragmentMatcher = this.config.fragmentMatcher;
    var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
    this.storeWriter.writeResultToStore({
      dataId: write.dataId,
      result: write.result,
      variables: write.variables,
      document: this.transformDocument(write.query),
      store: this.data,
      dataIdFromObject: this.config.dataIdFromObject,
      fragmentMatcherFunction
    });
    this.broadcastWatches();
  };
  InMemoryCache2.prototype.diff = function(query) {
    var fragmentMatcher = this.config.fragmentMatcher;
    var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
    return this.storeReader.diffQueryAgainstStore({
      store: query.optimistic ? this.optimisticData : this.data,
      query: this.transformDocument(query.query),
      variables: query.variables,
      returnPartialData: query.returnPartialData,
      previousResult: query.previousResult,
      fragmentMatcherFunction,
      config: this.config
    });
  };
  InMemoryCache2.prototype.watch = function(watch) {
    var _this = this;
    this.watches.add(watch);
    return function() {
      _this.watches.delete(watch);
    };
  };
  InMemoryCache2.prototype.evict = function(query) {
    throw false ? new InvariantError(7) : new InvariantError("eviction is not implemented on InMemory Cache");
  };
  InMemoryCache2.prototype.reset = function() {
    this.data.clear();
    this.broadcastWatches();
    return Promise.resolve();
  };
  InMemoryCache2.prototype.removeOptimistic = function(idToRemove) {
    var toReapply = [];
    var removedCount = 0;
    var layer = this.optimisticData;
    while (layer instanceof OptimisticCacheLayer) {
      if (layer.optimisticId === idToRemove) {
        ++removedCount;
      } else {
        toReapply.push(layer);
      }
      layer = layer.parent;
    }
    if (removedCount > 0) {
      this.optimisticData = layer;
      while (toReapply.length > 0) {
        var layer_1 = toReapply.pop();
        this.performTransaction(layer_1.transaction, layer_1.optimisticId);
      }
      this.broadcastWatches();
    }
  };
  InMemoryCache2.prototype.performTransaction = function(transaction, optimisticId) {
    var _a3 = this, data = _a3.data, silenceBroadcast = _a3.silenceBroadcast;
    this.silenceBroadcast = true;
    if (typeof optimisticId === "string") {
      this.data = this.optimisticData = new OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
    }
    try {
      transaction(this);
    } finally {
      this.silenceBroadcast = silenceBroadcast;
      this.data = data;
    }
    this.broadcastWatches();
  };
  InMemoryCache2.prototype.recordOptimisticTransaction = function(transaction, id) {
    return this.performTransaction(transaction, id);
  };
  InMemoryCache2.prototype.transformDocument = function(document2) {
    if (this.addTypename) {
      var result2 = this.typenameDocumentCache.get(document2);
      if (!result2) {
        result2 = addTypenameToDocument(document2);
        this.typenameDocumentCache.set(document2, result2);
        this.typenameDocumentCache.set(result2, result2);
      }
      return result2;
    }
    return document2;
  };
  InMemoryCache2.prototype.broadcastWatches = function() {
    var _this = this;
    if (!this.silenceBroadcast) {
      this.watches.forEach(function(c) {
        return _this.maybeBroadcastWatch(c);
      });
    }
  };
  InMemoryCache2.prototype.maybeBroadcastWatch = function(c) {
    c.callback(this.diff({
      query: c.query,
      variables: c.variables,
      previousResult: c.previousResult && c.previousResult(),
      optimistic: c.optimistic
    }));
  };
  return InMemoryCache2;
}(ApolloCache);

// ../../node_modules/.pnpm/apollo-link-context@1.0.20_graphql@14.7.0/node_modules/apollo-link-context/lib/bundle.esm.js
function setContext(setter) {
  return new ApolloLink(function(operation, forward) {
    var request = __rest2(operation, []);
    return new bundle_esm_default(function(observer) {
      var handle;
      Promise.resolve(request).then(function(req) {
        return setter(req, operation.getContext());
      }).then(operation.setContext).then(function() {
        handle = forward(operation).subscribe({
          next: observer.next.bind(observer),
          error: observer.error.bind(observer),
          complete: observer.complete.bind(observer)
        });
      }).catch(observer.error.bind(observer));
      return function() {
        if (handle)
          handle.unsubscribe();
      };
    });
  });
}

// ../../node_modules/.pnpm/apollo-link-retry@2.2.16_graphql@14.7.0/node_modules/apollo-link-retry/lib/bundle.esm.js
function buildDelayFunction(delayOptions) {
  var _a3 = delayOptions || {}, _b = _a3.initial, initial = _b === void 0 ? 300 : _b, _c = _a3.jitter, jitter = _c === void 0 ? true : _c, _d = _a3.max, max = _d === void 0 ? Infinity : _d;
  var baseDelay = jitter ? initial : initial / 2;
  return function delayFunction(count) {
    var delay = Math.min(max, baseDelay * Math.pow(2, count));
    if (jitter) {
      delay = Math.random() * delay;
    }
    return delay;
  };
}
function buildRetryFunction(retryOptions) {
  var _a3 = retryOptions || {}, retryIf = _a3.retryIf, _b = _a3.max, max = _b === void 0 ? 5 : _b;
  return function retryFunction(count, operation, error) {
    if (count >= max)
      return false;
    return retryIf ? retryIf(error, operation) : !!error;
  };
}
var RetryableOperation = function() {
  function RetryableOperation2(operation, nextLink, delayFor, retryIf) {
    var _this = this;
    this.operation = operation;
    this.nextLink = nextLink;
    this.delayFor = delayFor;
    this.retryIf = retryIf;
    this.retryCount = 0;
    this.values = [];
    this.complete = false;
    this.canceled = false;
    this.observers = [];
    this.currentSubscription = null;
    this.onNext = function(value) {
      _this.values.push(value);
      for (var _i = 0, _a3 = _this.observers; _i < _a3.length; _i++) {
        var observer = _a3[_i];
        if (!observer)
          continue;
        observer.next(value);
      }
    };
    this.onComplete = function() {
      _this.complete = true;
      for (var _i = 0, _a3 = _this.observers; _i < _a3.length; _i++) {
        var observer = _a3[_i];
        if (!observer)
          continue;
        observer.complete();
      }
    };
    this.onError = function(error) {
      return __awaiter2(_this, void 0, void 0, function() {
        var shouldRetry, _i, _a3, observer;
        return __generator2(this, function(_b) {
          switch (_b.label) {
            case 0:
              this.retryCount += 1;
              return [4, this.retryIf(this.retryCount, this.operation, error)];
            case 1:
              shouldRetry = _b.sent();
              if (shouldRetry) {
                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                return [2];
              }
              this.error = error;
              for (_i = 0, _a3 = this.observers; _i < _a3.length; _i++) {
                observer = _a3[_i];
                if (!observer)
                  continue;
                observer.error(error);
              }
              return [2];
          }
        });
      });
    };
  }
  RetryableOperation2.prototype.subscribe = function(observer) {
    if (this.canceled) {
      throw new Error("Subscribing to a retryable link that was canceled is not supported");
    }
    this.observers.push(observer);
    for (var _i = 0, _a3 = this.values; _i < _a3.length; _i++) {
      var value = _a3[_i];
      observer.next(value);
    }
    if (this.complete) {
      observer.complete();
    } else if (this.error) {
      observer.error(this.error);
    }
  };
  RetryableOperation2.prototype.unsubscribe = function(observer) {
    var index = this.observers.indexOf(observer);
    if (index < 0) {
      throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
    }
    this.observers[index] = null;
    if (this.observers.every(function(o) {
      return o === null;
    })) {
      this.cancel();
    }
  };
  RetryableOperation2.prototype.start = function() {
    if (this.currentSubscription)
      return;
    this.try();
  };
  RetryableOperation2.prototype.cancel = function() {
    if (this.currentSubscription) {
      this.currentSubscription.unsubscribe();
    }
    clearTimeout(this.timerId);
    this.timerId = null;
    this.currentSubscription = null;
    this.canceled = true;
  };
  RetryableOperation2.prototype.try = function() {
    this.currentSubscription = this.nextLink(this.operation).subscribe({
      next: this.onNext,
      error: this.onError,
      complete: this.onComplete
    });
  };
  RetryableOperation2.prototype.scheduleRetry = function(delay) {
    var _this = this;
    if (this.timerId) {
      throw new Error("RetryLink BUG! Encountered overlapping retries");
    }
    this.timerId = setTimeout(function() {
      _this.timerId = null;
      _this.try();
    }, delay);
  };
  return RetryableOperation2;
}();
var RetryLink = function(_super) {
  __extends2(RetryLink2, _super);
  function RetryLink2(options) {
    var _this = _super.call(this) || this;
    var _a3 = options || {}, attempts = _a3.attempts, delay = _a3.delay;
    _this.delayFor = typeof delay === "function" ? delay : buildDelayFunction(delay);
    _this.retryIf = typeof attempts === "function" ? attempts : buildRetryFunction(attempts);
    return _this;
  }
  RetryLink2.prototype.request = function(operation, nextLink) {
    var retryable = new RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
    retryable.start();
    return new bundle_esm_default(function(observer) {
      retryable.subscribe(observer);
      return function() {
        retryable.unsubscribe(observer);
      };
    });
  };
  return RetryLink2;
}(ApolloLink);

// ../../packages/vim-connect/build/index.js
var import_dayjs = __toESM(require_dayjs_min());

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root2 = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root2;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty4 = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty4.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result2 = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result2;
}
var getRawTag_default = getRawTag;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectToString_default = objectToString;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var baseGetTag_default = baseGetTag;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default = isObjectLike;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var isSymbol_default = isSymbol;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_trimmedEndIndex.js
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var trimmedEndIndex_default = trimmedEndIndex;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseTrim.js
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
}
var baseTrim_default = baseTrim;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObject.js
function isObject3(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_default = isObject3;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toNumber.js
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_default = toNumber;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toFinite.js
var INFINITY = 1 / 0;
var MAX_INTEGER = 17976931348623157e292;
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_default(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_default = toFinite;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toInteger.js
function toInteger(value) {
  var result2 = toFinite_default(value), remainder = result2 % 1;
  return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
}
var toInteger_default = toInteger;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isFunction.js
var asyncTag = "[object AsyncFunction]";
var funcTag = "[object Function]";
var genTag = "[object GeneratorFunction]";
var proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject_default(value)) {
    return false;
  }
  var tag = baseGetTag_default(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_default = isFunction;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isInteger.js
function isInteger(value) {
  return typeof value == "number" && value == toInteger_default(value);
}
var isInteger_default = isInteger;

// ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
function isNil(value) {
  return value == null;
}
var isNil_default = isNil;

// ../../packages/promise/build/index.js
var import_bluebird = __toESM(require_bluebird());
var import_bluebird2 = __toESM(require_bluebird());
var import_promise_retry = __toESM(require_promise_retry());
var defaultOptions2 = {
  minTimeout: 25,
  retries: 8,
  maxTimeout: Infinity,
  factor: 2
};
function retry(functionToRetry, optionsOverride) {
  return import_bluebird2.default.resolve().then(() => {
    const options = Object.assign({}, defaultOptions2, optionsOverride);
    const { stopRetryPredicate, retries, minTimeout, maxTimeout, factor } = options;
    if (!isFunction_default(functionToRetry)) {
      return import_bluebird2.default.reject("functionToRetry must be a function");
    }
    if (!isNil_default(stopRetryPredicate) && !isFunction_default(stopRetryPredicate)) {
      return import_bluebird2.default.reject("stopRetryPredicate must be a function");
    }
    if (isNil_default(retries) || !isInteger_default(retries) || retries < 0) {
      return import_bluebird2.default.reject(`retries must be an integer >= 0,  got ${retries}`);
    }
    if (isNil_default(minTimeout) || !isInteger_default(minTimeout) || minTimeout < 0) {
      return import_bluebird2.default.reject("minTimeout must be an integer >= 0");
    }
    let attemptNumber = 0;
    return (0, import_promise_retry.default)((retryFunc, internalAttemptNumber) => {
      attemptNumber = internalAttemptNumber;
      return functionToRetry(attemptNumber).catch((error) => {
        if (stopRetryPredicate && stopRetryPredicate(error, attemptNumber)) {
          throw error;
        } else {
          retryFunc(error);
        }
      });
    }, { retries, minTimeout, maxTimeout, factor });
  });
}
var rejectOnTimeout = (ms) => new Promise((resolve, reject) => setTimeout(() => reject(new TimeoutError(`Timed out after ${ms / 1e3} seconds!`)), ms));
var withTimeout = (func, ms) => (...args) => {
  return Promise.race([rejectOnTimeout(ms), func(...args)]);
};
var TimeoutError = class extends Error {
  constructor(message) {
    super(message);
  }
};

// ../../packages/core-apps/organizations/src/types.ts
var ProviderSource = /* @__PURE__ */ ((ProviderSource2) => {
  ProviderSource2["MyCare"] = "mycare";
  ProviderSource2["Aledade"] = "aledade";
  ProviderSource2["MaxHealth"] = "maxhealth";
  ProviderSource2["AledadeSearchCare"] = "aledade-search-care";
  ProviderSource2["Agilon"] = "agilon";
  ProviderSource2["Stellar"] = "stellar";
  ProviderSource2["Premier"] = "premier";
  ProviderSource2["MdiclPark"] = "mdiclpark";
  ProviderSource2["BrimhallPediatrics"] = "brimhall-pediatrics";
  ProviderSource2["Archwell"] = "archwell";
  ProviderSource2["Privia"] = "privia";
  ProviderSource2["Vytalize"] = "vytalize";
  ProviderSource2["VytalizeTest"] = "vytalize-test";
  ProviderSource2["Mock"] = "mock";
  ProviderSource2["Yuvo"] = "yuvo";
  ProviderSource2["Caap"] = "caap";
  ProviderSource2["Credo"] = "credo";
  ProviderSource2["Concerto"] = "concerto";
  ProviderSource2["Empassion"] = "empassion";
  ProviderSource2["Honest"] = "honest";
  ProviderSource2["PearlHealth"] = "pearlhealth";
  ProviderSource2["MockDemoPartner"] = "mock-demo-partner";
  ProviderSource2["Evolent"] = "evolent";
  ProviderSource2["Apixio"] = "apixio";
  ProviderSource2["Allymar"] = "allymar";
  ProviderSource2["Teladoc"] = "teladoc";
  ProviderSource2["Optum"] = "optum";
  ProviderSource2["Veradigm"] = "veradigm";
  ProviderSource2["TeladocGarner"] = "teladoc-garner";
  ProviderSource2["Rendr"] = "rendr";
  return ProviderSource2;
})(ProviderSource || {});

// ../../packages/vim-connect/build/index.js
var import_node_cache2 = __toESM(require_node_cache2());

// ../../packages/provider-types/build/index.js
var ReferralStatus = /* @__PURE__ */ ((ReferralStatus2) => {
  ReferralStatus2["DRAFT"] = "DRAFT";
  ReferralStatus2["SIGNED"] = "SIGNED";
  ReferralStatus2["DELETED"] = "DELETED";
  ReferralStatus2["DEFAULT"] = "DRAFT";
  return ReferralStatus2;
})(ReferralStatus || {});
var patientFragment = lib_default`
  fragment patient on Patient {
    id
    firstName
    middleName
    lastName
    mobilePhoneNumber
    dateOfBirth
    memberId
    plan
    insurer
    address
    email
    gender
    vimPatientId
  }
`;
var fullAppointmentFragment = lib_default`
  ${patientFragment}
  fragment fullAppointment on Appointment {
    id
    npi
    appointmentType
    status
    reasonForVisit
    npiType
    ehrLocationId
    ehrProviderId
    startTime
    endTime
    timezone
    patient {
      ...patient
    }
  }
`;
var patientlessAppointmentFragment = lib_default`
  fragment patientlessAppointment on Appointment {
    id
    npi
    appointmentType
    status
    reasonForVisit
    npiType
    ehrLocationId
    ehrProviderId
    startTime
    endTime
    timezone
    patientId
  }
`;
var syncAppointmentFragment = lib_default`
  fragment syncAppointment on Appointment {
    id
    npi
    appointmentType
    status
    reasonForVisit
    npiType
    ehrLocationId
    ehrProviderId
    startTime
    endTime
    patientId
  }
`;
var partialAppointmentFragment = lib_default`
  fragment partialAppointment on MinimalAppointmentData {
    id
    status
    npi
    startTime
    endTime
  }
`;
var fullAppointmentActionFragment = lib_default`
  fragment fullAppointmentAction on AppointmentAction {
    id
    memberId
    platformId
    createdAt
    updatedAt
    actionType
    status
    npi
    firstName
    middleName
    lastName
    dateOfBirth
    patientAddress
    appointmentType
    startTime
    endTime
    reasonForVisit
    ehrLocationId
    ehrProviderId
    npiType
    memberId
    plan
    insurer
    patientId
    appointmentId
    timezone
  }
`;
var appointmentPhiFragment = lib_default`
  fragment phiData on AppointmentPhi {
    firstName
    middleName
    lastName
    dateOfBirth
    email
    patientAddress
    reasonForVisit
    memberId
    memberIdPrefix
    gender
    plan
    phoneNumbers {
      name
      number
    }
    insurer
  }
`;
var appointmentRequestPhiFragment = lib_default`
  fragment requestPhiData on AppointmentRequestPhi {
    firstName
    middleName
    lastName
    dateOfBirth
    email
    patientAddress
    reasonForVisit
    memberId
    memberIdPrefix
    gender
    plan
    phoneNumbers {
      name
      number
    }
    insurer
  }
`;

// ../../packages/vim-connect/build/index.js
var import_axios = __toESM(require_axios2());

// ../../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}

// ../../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/regex.js
var regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

// ../../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/validate.js
function validate(uuid) {
  return typeof uuid === "string" && regex_default.test(uuid);
}
var validate_default = validate;

// ../../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex = [];
for (i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).substr(1));
}
var i;
function stringify2(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate_default(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
var stringify_default = stringify2;

// ../../node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v4.js
function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return stringify_default(rnds);
}
var v4_default = v4;

// ../../packages/vim-connect/build/index.js
var import_flat = __toESM(require_flat());
var __defProp3 = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp3(target, name, { get: all[name], enumerable: true });
};
var runtime_contract_exports = {};
__export(runtime_contract_exports, {
  Incoming: () => incoming_exports,
  LoginEvent: () => LoginEvent,
  Outgoing: () => outgoing_exports,
  WorkflowEvent: () => WorkflowEvent
});
var outgoing_exports = {};
__export(outgoing_exports, {
  OutgoingMessages: () => OutgoingMessages,
  VimConnectUIMessageType: () => VimConnectUIMessageType
});
var OutgoingMessages = /* @__PURE__ */ ((OutgoingMessages2) => {
  OutgoingMessages2["SEND_EVENT"] = "vim-connect-event";
  OutgoingMessages2["WIDGET_DATA_TO_APP"] = "vim-connect-widget-data-to-app";
  OutgoingMessages2["INITIALIZE_DATA"] = "vim-connect-initialize-data";
  OutgoingMessages2["INITIALIZE_ME"] = "vim-connect-initialize-me";
  OutgoingMessages2["GET_HOSTNAME"] = "vim-connect-get-hostname";
  OutgoingMessages2["UPDATE_ACCESS_TOKEN"] = "vim-connect-update-access-token";
  OutgoingMessages2["DATA_TO_VIM_CONNECT_UI"] = "vim-connect-data-to-vim-connect-ui";
  OutgoingMessages2["ON_LOGOUT"] = "vim-connect-logout";
  OutgoingMessages2["SET_LOGGER_USER_METADATA"] = "set-logger-user-metadata";
  OutgoingMessages2["RUNTIME_LOGIN_FAILED"] = "vim-connect-runtime-login-failed";
  return OutgoingMessages2;
})(OutgoingMessages || {});
var VimConnectUIMessageType = /* @__PURE__ */ ((VimConnectUIMessageType2) => {
  VimConnectUIMessageType2["InjectApplication"] = "platform-inject-application";
  VimConnectUIMessageType2["ModifyApplication"] = "platform-modify-application";
  VimConnectUIMessageType2["SelectApplication"] = "platform-select-application";
  VimConnectUIMessageType2["RemoveApplication"] = "platform-remove-application";
  VimConnectUIMessageType2["SendDataToWidget"] = "platform-send-data-to-widget";
  return VimConnectUIMessageType2;
})(VimConnectUIMessageType || {});
var incoming_exports = {};
__export(incoming_exports, {
  IncomingMessages: () => IncomingMessages,
  IncomingVimOsMessages: () => IncomingVimOsMessages,
  VimConnectUI: () => vim_connect_ui_exports
});
var IncomingVimOsMessages = /* @__PURE__ */ ((IncomingVimOsMessages2) => {
  IncomingVimOsMessages2["EXECUTE_ACTION"] = "vim-os-to-runtime-execute-action";
  IncomingVimOsMessages2["EXECUTE_WRITE_BACK"] = "vim-os-to-runtime-execute-write-back";
  IncomingVimOsMessages2["HUB_WIDGET_POSITION_CHANGED"] = "vim-os-to-runtime-hub-widget-position-changed";
  IncomingVimOsMessages2["INJECT_LAUNCH_BUTTON"] = "vim-os-to-runtime-inject-launch-button";
  IncomingVimOsMessages2["ANALYTICS_TRACK"] = "vim-os-to-runtime-analytics-track";
  IncomingVimOsMessages2["ANALYTICS_SET_BASE_PROPERTIES"] = "vim-os-to-runtime-analytics-set-base-properties";
  IncomingVimOsMessages2["ANALYTICS_SET_SESSIONS"] = "vim-os-to-runtime-analytics-set-sessions";
  IncomingVimOsMessages2["APP_ANALYTICS_TRACK"] = "vim-os-to-runtime-app-analytics-track";
  IncomingVimOsMessages2["CLEAR_ME_REQUEST"] = "vim-os-to-runtime-clear-me-request";
  return IncomingVimOsMessages2;
})(IncomingVimOsMessages || {});
var IncomingMessages = /* @__PURE__ */ ((IncomingMessages2) => {
  IncomingMessages2["ACCESS_TOKEN"] = "vim-connect-access-token";
  IncomingMessages2["GET_APP_DATA"] = "vim-connect-vim-get-app-data";
  IncomingMessages2["GET_SEAMLESS_AUTH_TOKEN"] = "vim-connect-vim-get-seamless-auth-token";
  IncomingMessages2["ANALYTICS_TRACK"] = "analytics-track";
  IncomingMessages2["ANALYTICS_SET_BASE_PROPERTIES"] = "analytics-set-base-properties";
  IncomingMessages2["ANALYTICS_SET_SESSIONS"] = "analytics-set-sessions";
  IncomingMessages2["APP_INITIALIZED"] = "vim-connect-on-initialize";
  IncomingMessages2["COPY_TO_CLIPBOARD"] = "vim-connect-copy-to-clipboard";
  IncomingMessages2["EHR_API"] = "vim-connect-ehr-api";
  IncomingMessages2["INJECT_VIM_CONNECT_UI_APP"] = "vim-connect-ui-inject-app";
  IncomingMessages2["INJECT_WIDGET"] = "vim-connect-inject-widget";
  IncomingMessages2["REMOVE_WIDGET"] = "vim-connect-remove-widget";
  IncomingMessages2["LISTEN_TO_EVENT"] = "vim-connect-listen-to-event";
  IncomingMessages2["LOGIN_FAILED"] = "vim-connect-login-failed";
  IncomingMessages2["ON_LOGIN_APP_DISPLAYED"] = "vim-connect-on-login-app-displayed";
  IncomingMessages2["ON_LOGIN_APP_NOT_DISPLAYED"] = "vim-connect-on-login-app-not-displayed";
  IncomingMessages2["ON_EHR_USER_NOT_EXISTS"] = "vim-connect-on-ehr-user-not-exists";
  IncomingMessages2["MODIFY_VIM_CONNECT_UI_APP"] = "vim-connect-ui-modify-app";
  IncomingMessages2["MODIFY_WIDGET"] = "vim-connect-modify-widget";
  IncomingMessages2["REMOVE_VIM_CONNECT_UI_APP"] = "vim-connect-ui-remove-app";
  IncomingMessages2["RUN_ACTION"] = "vim-connect-run-actions";
  IncomingMessages2["SELECT_VIM_CONNECT_UI_APP"] = "vim-connect-ui-select-app";
  IncomingMessages2["SEND_DATA_TO_WIDGET"] = "vim-connect-send-data-to-widget";
  IncomingMessages2["SEND_DATA_TO_WIDGET_VIM_CONNECT_UI_APP"] = "vim-connect-ui-send-data-to-widget";
  IncomingMessages2["STORAGE_SET"] = "vim-connect-storage-set";
  IncomingMessages2["TRIGGER_SSO_LOGIN"] = "trigger-sso-login";
  IncomingMessages2["WRITE_BACK"] = "vim-connect-write-back";
  IncomingMessages2["DEVICE_ID"] = "vim-connect-device-id";
  IncomingMessages2["IS_OUTDATED"] = "vim-connect-outdateness-query";
  IncomingMessages2["EHR_EVENT"] = "vim-connect-ehr-event";
  IncomingMessages2["INCOMING_VIM_OS_HUB_WIDGET_DATA"] = "vim-connect-incoming-from-os-hub-widget-data";
  IncomingMessages2["TRIGGER_RELOGIN"] = "vim-connect-trigger-relogin";
  IncomingMessages2["REMOVE_USER_TOKENS_FROM_STORAGE"] = "vim-connect-remove-user-tokens-from-storage";
  return IncomingMessages2;
})(IncomingMessages || {});
var vim_connect_ui_exports = {};
var LoginEvent = /* @__PURE__ */ ((LoginEvent3) => {
  LoginEvent3["onLoggedIn"] = "onLoggedIn";
  LoginEvent3["onReLogin"] = "onReLogin";
  LoginEvent3["logout"] = "logout";
  return LoginEvent3;
})(LoginEvent || {});
var WorkflowEvent = /* @__PURE__ */ ((WorkflowEvent2) => {
  WorkflowEvent2["patientInContext"] = "patientInContext";
  WorkflowEvent2["claimStarted"] = "claimStarted";
  WorkflowEvent2["claimExited"] = "claimExited";
  WorkflowEvent2["claimUpdated"] = "claimUpdated";
  WorkflowEvent2["patientOutOfContext"] = "patientOutOfContext";
  WorkflowEvent2["patientChartOpened"] = "patientChartOpened";
  WorkflowEvent2["patientChartClosed"] = "patientChartClosed";
  WorkflowEvent2["patientSaved"] = "patientSaved";
  WorkflowEvent2["referralViewed"] = "referralViewed";
  WorkflowEvent2["encounterStart"] = "encounterStart";
  WorkflowEvent2["encounterUpdated"] = "encounterUpdated";
  WorkflowEvent2["encounterExit"] = "encounterExit";
  WorkflowEvent2["referralClosed"] = "referralClosed";
  WorkflowEvent2["referralSaved"] = "referralSaved";
  WorkflowEvent2["referralDeleted"] = "referralDeleted";
  WorkflowEvent2["orderCreated"] = "orderCreated";
  WorkflowEvent2["orderViewed"] = "orderViewed";
  WorkflowEvent2["orderClosed"] = "orderClosed";
  WorkflowEvent2["ordersViewed"] = "ordersViewed";
  WorkflowEvent2["ordersClosed"] = "ordersClosed";
  WorkflowEvent2["sendAnalytics"] = "sendAnalytics";
  WorkflowEvent2["corruptedEhrState"] = "corruptedEhrState";
  WorkflowEvent2["sendEhrData"] = "sendEhrData";
  return WorkflowEvent2;
})(WorkflowEvent || {});
var analytics_exports = {};
__export(analytics_exports, {
  track: () => track
});
var track = async (data, accessToken2, deviceId) => {
  const options = {
    method: "POST",
    body: JSON.stringify(data),
    headers: __spreadProps(__spreadValues(__spreadValues({}, accessToken2 ? { authorization: accessToken2 } : void 0), deviceId ? { ["x-vim-device-id"]: deviceId } : void 0), {
      "Content-Type": "application/json"
    })
  };
  return fetch(`/api/info/save`, options);
};
var standard_exports = {};
__export(standard_exports, {
  Actions: () => actions_exports,
  ActionsTransformers: () => actions_transformers_exports,
  Connectors: () => connectors_exports,
  Entities: () => entities_exports,
  ErrorCodes: () => ErrorCodes,
  Errors: () => errors_exports,
  Events: () => events_exports,
  Secrets: () => secrets_exports,
  WriteBacks: () => write_backs_exports
});
var actions_exports = {};
__export(actions_exports, {
  ActionNames: () => ActionNames
});
var ActionNames = /* @__PURE__ */ ((ActionNames2) => {
  ActionNames2["GET_PATIENT"] = "GET_PATIENT";
  ActionNames2["GET_ENCOUNTER_DATA"] = "GET_ENCOUNTER_DATA";
  ActionNames2["GET_ENCOUNTER_CPTS"] = "GET_ENCOUNTER_CPTS";
  ActionNames2["SEARCH_PROVIDERS"] = "SEARCH_PROVIDERS";
  ActionNames2["GET_CURRENT_EHR_USER_INFORMATION"] = "GET_CURRENT_EHR_USER_INFORMATION";
  ActionNames2["NAVIGATE_TO_ENCOUNTER"] = "NAVIGATE_TO_ENCOUNTER";
  ActionNames2["GET_PROVIDER_DAILY_SUMMARY"] = "GET_PROVIDER_DAILY_SUMMARY";
  ActionNames2["GET_PATIENT_SCHEDULED_APPOINTMENTS"] = "GET_PATIENT_SCHEDULED_APPOINTMENTS";
  ActionNames2["FIND_PATIENT"] = "FIND_PATIENT";
  ActionNames2["PRINT_ENCOUNTER"] = "PRINT_ENCOUNTER";
  ActionNames2["PRINT_ENCOUNTERS"] = "PRINT_ENCOUNTERS";
  ActionNames2["GET_PATIENT_ENCOUNTERS"] = "GET_PATIENT_ENCOUNTERS";
  ActionNames2["GET_ENCOUNTER_LAB_RESULTS"] = "GET_ENCOUNTER_LAB_RESULTS";
  ActionNames2["GET_ENCOUNTER_VITALS"] = "GET_ENCOUNTER_VITALS";
  ActionNames2["GET_PROVIDER_APPOINTMENTS"] = "GET_PROVIDER_APPOINTMENTS";
  ActionNames2["GET_GAPS_FROM_SHARED_REQUEST"] = "GET_GAPS_FROM_SHARED_REQUEST";
  ActionNames2["SUBSCRIBE_TELEVISIT"] = "SUBSCRIBE_TELEVISIT";
  ActionNames2["UNSUBSCRIBE_TELEVISIT"] = "UNSUBSCRIBE_TELEVISIT";
  ActionNames2["GET_INFORMATION"] = "GET_INFORMATION";
  ActionNames2["GET_PATIENT_MEDICATION"] = "GET_PATIENT_MEDICATION";
  ActionNames2["GET_PATIENT_ALLERGIES"] = "GET_PATIENT_ALLERGIES";
  ActionNames2["GET_PATIENT_PROBLEM_LIST"] = "GET_PATIENT_PROBLEM_LIST";
  ActionNames2["GET_PATIENT_LAB_RESULTS"] = "GET_PATIENT_LAB_RESULTS";
  ActionNames2["GET_PATIENT_VITALS"] = "GET_PATIENT_VITALS";
  return ActionNames2;
})(ActionNames || {});
var actions_transformers_exports = {};
__export(actions_transformers_exports, {
  GET_PATIENT: () => GET_PATIENT
});
var errors_exports = {};
__export(errors_exports, {
  ActionFailed: () => ActionFailed,
  ActionNotSupported: () => ActionNotSupported,
  AppointmentAlreadyBooked: () => AppointmentAlreadyBooked,
  BadGateway: () => BadGateway,
  CopyToClipboardFailed: () => CopyToClipboardFailed,
  CreateAppointmentFailed: () => CreateAppointmentFailed,
  CreatePatientFailed: () => CreatePatientFailed,
  EhrDown: () => EhrDown,
  InternalError: () => InternalError,
  InvalidInput: () => InvalidInput,
  LocationNotFound: () => LocationNotFound,
  NotFound: () => NotFound,
  OrganizationConfigIsInvalid: () => OrganizationConfigIsInvalid,
  PatientNotFoundError: () => PatientNotFoundError,
  ProviderNotFoundError: () => ProviderNotFoundError,
  ResourceNotFound: () => ResourceNotFound,
  ServiceUnavailable: () => ServiceUnavailable,
  SessionExpired: () => SessionExpired,
  StandardError: () => StandardError,
  SyncExtensionConnectorTimeoutError: () => SyncExtensionConnectorTimeoutError,
  SyncRuntimeMessageFailed: () => SyncRuntimeMessageFailed,
  SyncRuntimeMessageTimeoutError: () => SyncRuntimeMessageTimeoutError,
  Timeout: () => Timeout,
  UnexpectedScrapingResultError: () => UnexpectedScrapingResultError,
  UnimplementedWriteBackError: () => UnimplementedWriteBackError,
  UnprocessableEntity: () => UnprocessableEntity,
  UnsupportedWriteBackPayloadError: () => UnsupportedWriteBackPayloadError,
  VersionNotSupported: () => VersionNotSupported,
  WriteBackError: () => WriteBackError,
  WriteDiagnosisError: () => WriteDiagnosisError,
  WriteSpecialityError: () => WriteSpecialityError,
  WriteTargetProviderError: () => WriteTargetProviderError,
  WriteUpdatingProviderAlertError: () => WriteUpdatingProviderAlertError
});
var ErrorCodes = /* @__PURE__ */ ((ErrorCodes2) => {
  ErrorCodes2[ErrorCodes2["INTERNAL_ERROR"] = 500] = "INTERNAL_ERROR";
  ErrorCodes2[ErrorCodes2["INVALID_INPUT"] = 400] = "INVALID_INPUT";
  ErrorCodes2[ErrorCodes2["NOT_FOUND"] = 404] = "NOT_FOUND";
  ErrorCodes2[ErrorCodes2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  ErrorCodes2[ErrorCodes2["TIMEOUT"] = 504] = "TIMEOUT";
  ErrorCodes2[ErrorCodes2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  ErrorCodes2[ErrorCodes2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  ErrorCodes2[ErrorCodes2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  return ErrorCodes2;
})(ErrorCodes || {});
var StandardError = class extends Error {
  constructor(message, code = 500, properties = {}) {
    super(message);
    this.message = message;
    this.code = code;
    if (properties) {
      Object.keys(properties).forEach((key) => {
        this[key] = properties[key];
      });
    }
  }
  toJSON() {
    return Object.getOwnPropertyNames(this).filter((key) => key !== "properties").reduce((serialized, key) => __spreadProps(__spreadValues({}, serialized), {
      [key]: this[key]
    }), {});
  }
};
function errorMessage(action, originalError, ingrateErrorMessage) {
  if (ingrateErrorMessage) {
    return `Action ${action} has failed with error: ${originalError == null ? void 0 : originalError.message}`;
  }
  return `Action ${action} has failed with error.`;
}
var ActionFailed = class extends StandardError {
  constructor(action, originalError, ingrateErrorMessage = false) {
    super(errorMessage(action, originalError, ingrateErrorMessage), 500, {
      originalError
    });
  }
};
var InvalidInput = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 400, __spreadValues({ errorName: "InvalidInput" }, properties));
  }
};
var ActionNotSupported = class extends InvalidInput {
  constructor(action) {
    super(`action ${action} is not supported!`, { errorName: "ActionNotSupported" });
  }
};
var AppointmentAlreadyBooked = class extends StandardError {
  constructor(message, bookedAppointmentId = void 0, properties = {}) {
    super(message, 400, __spreadProps(__spreadValues({}, properties), {
      errorName: "AppointmentAlreadyBooked"
    }));
    this.bookedAppointmentId = bookedAppointmentId;
  }
};
var CreateAppointmentFailed = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 500, __spreadProps(__spreadValues({}, properties), {
      errorName: "CreateAppointmentFailed"
    }));
  }
};
var BadGateway = class extends StandardError {
  constructor(message = "Bad Gateway", properties = {}) {
    super(message, 502, __spreadValues({ errorName: "BadGateway" }, properties));
  }
};
var CopyToClipboardFailed = class extends StandardError {
  constructor(error) {
    super(`${incoming_exports.IncomingMessages.COPY_TO_CLIPBOARD} has failed with error`, 500, { error });
  }
};
var EhrDown = class extends StandardError {
  constructor(message = "Ehr is down", properties = {}) {
    super(message, 503, __spreadValues({ errorName: "EhrDown" }, properties));
  }
};
var InternalError = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 500, __spreadValues({ errorName: "InternalError" }, properties));
  }
};
var NotFound = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 404, __spreadValues({ errorName: "NotFound" }, properties));
  }
};
var LocationNotFound = class extends NotFound {
  constructor(properties) {
    super("Location not found", __spreadProps(__spreadValues({}, properties), { errorName: "LocationNotFound" }));
    this.properties = properties;
  }
};
var OrganizationConfigIsInvalid = class extends InvalidInput {
  constructor(configError) {
    super(`Organization config that was received is invalid - ${configError}`);
  }
};
var PatientNotFoundError = class extends NotFound {
  constructor(properties) {
    super("Patient not found", __spreadProps(__spreadValues({}, properties), {
      errorName: "PatientNotFoundError"
    }));
  }
};
var CreatePatientFailed = class extends InternalError {
  constructor(properties) {
    super("Failed to create patient", __spreadProps(__spreadValues({}, properties), { errorName: "CreatePatientFailed" }));
    this.properties = properties;
  }
};
var ProviderNotFoundError = class extends NotFound {
  constructor(message, properties = {}) {
    super(message, __spreadValues({
      errorName: "ProviderNotFoundError"
    }, properties));
  }
};
var ResourceNotFound = class extends NotFound {
  constructor(properties = {}) {
    super("Resource not found", __spreadProps(__spreadValues({}, properties), { errorName: "ResourceNotFound" }));
    this.properties = properties;
  }
};
var ServiceUnavailable = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 503, __spreadValues({
      errorName: "ServiceUnavailable"
    }, properties));
  }
};
var SessionExpired = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 503, __spreadValues({ errorName: "SessionExpired" }, properties));
  }
};
var SyncRuntimeMessageFailed = class extends StandardError {
  constructor(type, error) {
    super(`Sync message response from runtime failed`, 500, { type, error });
  }
};
var SyncRuntimeMessageTimeoutError = class extends StandardError {
  constructor(type, timeout2) {
    super(`Didn't get response from runtime message`, 500, { type, timeout: timeout2 });
  }
};
var Timeout = class extends StandardError {
  constructor(message = "Timeout", properties = {}) {
    super(message, 504, __spreadValues({ errorName: "Timeout" }, properties));
  }
};
var SyncExtensionConnectorTimeoutError = class extends StandardError {
  constructor(type, payload, timeout2, id = "", ackResponse) {
    super(`Didn't get response from extension/electron`, 500, {
      type,
      payload,
      timeout: timeout2,
      id,
      ackResponse
    });
  }
};
var UnexpectedScrapingResultError = class extends StandardError {
  constructor(message, properties) {
    super(message, 404, properties);
  }
};
var UnprocessableEntity = class extends StandardError {
  constructor(message, properties = {}) {
    super(message, 422, __spreadValues({
      errorName: "UnprocessableEntity"
    }, properties));
  }
};
var WriteBackError = class extends InternalError {
  constructor(message, properties = {}) {
    super(message, __spreadValues({ errorName: "WriteBackError" }, properties));
  }
};
var WriteDiagnosisError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, __spreadValues({
      errorName: "WriteDiagnosisError"
    }, properties));
  }
};
var WriteSpecialityError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, __spreadValues({
      errorName: "WriteSpecialityError"
    }, properties));
  }
};
var WriteTargetProviderError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, __spreadValues({
      errorName: "WriteTargetProviderError"
    }, properties));
  }
};
var WriteUpdatingProviderAlertError = class extends WriteBackError {
  constructor(message, properties = {}) {
    super(message, __spreadValues({
      errorName: "WriteUpdatingProviderAlertError"
    }, properties));
  }
};
var UnimplementedWriteBackError = class extends WriteBackError {
  constructor(name, properties = {}) {
    super("Unimplemented WriteBack Error", __spreadValues({ name }, properties));
  }
};
var UnsupportedWriteBackPayloadError = class extends WriteBackError {
  constructor(name, payload) {
    super("Unsupported payload for event", { name, payload });
  }
};
var VersionNotSupported = class extends StandardError {
  constructor(version2, expectedVersion) {
    super("Version Not Supported", 500, {
      errorName: "VersionNotSupported",
      version: version2,
      expectedVersion
    });
  }
};
var RETRIES_ERRORS_WHITELIST = [
  "Failed to fetch",
  "ECONNRESET",
  "ENOTFOUND",
  "EHOSTUNREACH",
  "ECONNREFUSED",
  "socket hang up"
];
var RETRY_MUTATION_WHITELIST = /* @__PURE__ */ new Set(["initialLogin"]);
function isNetworkError(error) {
  return error && (RETRIES_ERRORS_WHITELIST.includes(error.message) || RETRIES_ERRORS_WHITELIST.find((errorCode) => error.code === errorCode || error.message.includes(errorCode)));
}
var MAX_RETRIES = 3;
var RETRY_DELAY = 250;
var NoAccessTokenError = class extends StandardError {
  constructor(context) {
    super("No Access Token Received", 401, context);
  }
};
var VimConnectGraphQLClient = class extends ApolloClient {
  constructor() {
    const httpLink = createHttpLink({ uri: "/api/graphql" });
    const authLink = setContext((_, { headers }) => {
      return {
        headers: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, this.accessToken ? { authorization: this.accessToken } : void 0), this.deviceId ? { ["x-vim-device-id"]: this.deviceId } : void 0), this.isVimOsEnabled !== void 0 ? { ["x-vim-os-enabled"]: this.isVimOsEnabled } : void 0), headers)
      };
    });
    const errorLink = new ApolloLink((operation, forward) => {
      return forward(operation).map((data) => {
        if (data && data.errors) {
          const networkError = data.errors.find(isNetworkError);
          if (networkError) {
            throw new Error(networkError.message);
          }
        }
        return data;
      });
    });
    const retryLink = new RetryLink({
      delay: {
        initial: RETRY_DELAY,
        max: 2500,
        jitter: true
      },
      attempts: {
        max: MAX_RETRIES,
        retryIf: (error, operation) => {
          var _a3;
          const isBaking = (_a3 = error == null ? void 0 : error.bodyText) == null ? void 0 : _a3.toLowerCase().includes("baking");
          const operationDefinition = operation.query.definitions[0];
          const operationType = operationDefinition == null ? void 0 : operationDefinition.operation;
          const operationName = this.getOperationName(operationDefinition);
          const shouldRetry = operationType === "query" || RETRY_MUTATION_WHITELIST.has(operationName);
          return shouldRetry && (isBaking || isNetworkError(error));
        }
      }
    });
    super({
      link: ApolloLink.from([retryLink, authLink, errorLink, httpLink]),
      cache: new InMemoryCache({ resultCaching: true })
    });
  }
  setAccessToken(token) {
    this.accessToken = token;
  }
  setIsVimOsEnabled(isVimOsEnabled) {
    this.isVimOsEnabled = isVimOsEnabled;
  }
  setDeviceId(deviceId) {
    this.deviceId = deviceId;
  }
  getDeviceId() {
    return this.deviceId;
  }
  getOperationName(operationDefinition) {
    var _a3, _b, _c, _d, _e;
    return ((_d = (_c = (_b = (_a3 = operationDefinition.selectionSet) == null ? void 0 : _a3.selections) == null ? void 0 : _b[0]) == null ? void 0 : _c.name) == null ? void 0 : _d.value) || ((_e = operationDefinition.name) == null ? void 0 : _e.value) || "";
  }
  mutateAuthenticated(options) {
    if (!this.accessToken) {
      throw new NoAccessTokenError({
        options,
        accessToken: this.accessToken,
        deviceId: this.deviceId
      });
    }
    return this.mutate(options);
  }
  async mutate(options) {
    try {
      return await super.mutate(options);
    } catch (error) {
      if (error) {
        error.options = options;
      }
      throw error;
    }
  }
  async query(options) {
    try {
      return await super.query(options);
    } catch (error) {
      if (error) {
        error.options = options;
      }
      throw error;
    }
  }
  queryAuthenticated(options) {
    if (!this.accessToken) {
      throw new NoAccessTokenError({
        options,
        accessToken: this.accessToken,
        deviceId: this.deviceId
      });
    }
    return this.query(options);
  }
};
var gqlClient = new VimConnectGraphQLClient();
var GET_VIM_PATIENT_ID_QUERY = lib_default`
  query GetPatient($input: GetPatientInput!) {
    getPatient(input: $input) {
      vimPatientId
    }
  }
`;
var vimPatientIdLogger = logger.scope("getVimPatientId");
var getVimPatientId = async (input) => {
  var _a3, _b;
  const { patientId: id, firstName, lastName, dateOfBirth } = input;
  if (!id) {
    vimPatientIdLogger.warning("Cannot query vim patient id without patient id", { input });
    return;
  }
  try {
    const response = await gqlClient.queryAuthenticated({
      query: GET_VIM_PATIENT_ID_QUERY,
      variables: { input: { id, firstName, lastName, dateOfBirth } },
      context: { uri: "/runtime/api/graphql" }
    });
    const vimPatientId = (_b = (_a3 = response == null ? void 0 : response.data) == null ? void 0 : _a3.getPatient) == null ? void 0 : _b.vimPatientId;
    vimPatientIdLogger.info("fetched vimPatientId", { patientId: id, vimPatientId });
    return vimPatientId;
  } catch (error) {
    const sanitizedError = sanitizeError(error);
    if (error instanceof NoAccessTokenError) {
      vimPatientIdLogger.info("getVimPatientId called when user not logged in", {
        patientId: id,
        error: sanitizedError
      });
    } else {
      vimPatientIdLogger.error("Failed to fetch to vimPatientId", {
        patientId: id,
        error: sanitizedError
      });
    }
    return void 0;
  }
};
var sanitizeError = (error) => {
  var _a3, _b;
  if (!error)
    return error;
  const sanitized = __spreadValues({}, error);
  if ((_b = (_a3 = sanitized.options) == null ? void 0 : _a3.variables) == null ? void 0 : _b.input) {
    const { id } = sanitized.options.variables.input;
    sanitized.options.variables.input = { id };
  }
  return sanitized;
};
var common_exports = {};
__export(common_exports, {
  formatDate: () => formatDate,
  getActivePayerSource: () => getActivePayerSource,
  getActiveSource: () => getActiveSource,
  getDiffFromDateInDays: () => getDiffFromDateInDays,
  isDevelopmentMode: () => isDevelopmentMode,
  isDirectSource: () => isDirectSource,
  isHtmlOrXML: () => isHtmlOrXML,
  isProvider: () => isProvider,
  timeoutAfter: () => timeoutAfter
});
var timeoutAfter = async (asyncFunc, timeoutInMs, shouldThrow) => {
  try {
    const asyncFunctionWithTimeout = withTimeout(asyncFunc, timeoutInMs);
    return await asyncFunctionWithTimeout();
  } catch (error) {
    if (shouldThrow) {
      throw error;
    }
  }
};
var isHtmlOrXML = (str) => {
  return /(<([^>]+)>)/i.test(str);
};
var formatDate = (date, format) => (0, import_dayjs.default)(date).format(format);
var getDiffFromDateInDays = (date) => (0, import_dayjs.default)().diff(date, "days");
var getActiveSource = (patient, sources) => {
  if (!sources)
    return;
  const safeSources = unifySources(sources);
  if (safeSources.includes("direct" /* Direct */))
    return "direct" /* Direct */;
  const payerSource = safeSources == null ? void 0 : safeSources.find((source) => {
    var _a3, _b;
    return source === ((_b = (_a3 = patient == null ? void 0 : patient.insurance) == null ? void 0 : _a3.insurer) == null ? void 0 : _b.toString());
  });
  if (payerSource)
    return payerSource;
};
var getActivePayerSource = (patient, sources) => {
  if (!sources)
    return;
  const safeSources = unifySources(sources);
  const payerSource = safeSources == null ? void 0 : safeSources.find((source) => {
    var _a3, _b;
    return source === ((_b = (_a3 = patient == null ? void 0 : patient.insurance) == null ? void 0 : _a3.insurer) == null ? void 0 : _b.toString());
  });
  if (payerSource)
    return payerSource;
};
var isDirectSource = (sources) => {
  if (!sources)
    return false;
  const safeSources = unifySources(sources);
  return safeSources.includes("direct" /* Direct */);
};
var isProvider = (contentSources) => {
  if (!contentSources)
    return false;
  return contentSources.some((source) => Object.values(ProviderSource).includes(source));
};
var unifySources = (sources) => {
  return Array.isArray(sources) ? sources : sources.split(",");
};
function isDevelopmentMode(origin) {
  const developmentUrls = [
    "localhost",
    "10.211.55.2",
    ".sish.devim.io",
    ".sish.dev.getvim.com",
    ".localhost.getvim.com",
    "your_mac_ip:"
  ];
  return developmentUrls.some((urlPart) => origin.includes(urlPart));
}
var TIMEOUT_AFTER = 3e3;
var CACHE_TTL = 15 * 60;
var vimPatientIdCache = new import_node_cache.default({ stdTTL: CACHE_TTL });
var getVimPatientId2 = async (patient, logger10, options) => {
  try {
    const { shouldUseTimeoutOnTransformers } = options != null ? options : {};
    const { demographics, patientId } = patient;
    const { firstName, lastName, dateOfBirth } = demographics != null ? demographics : {};
    if (!firstName || !lastName || !dateOfBirth) {
      logger10.info("Received a patient with missing demographics fields in setVimPatientId", {
        demographics
      });
      return;
    }
    let vimPatientId = vimPatientIdCache.get(patientId);
    logger10.info("Current cached VimPatientId", {
      noPHI: true,
      patientId,
      cachedVimPatientId: vimPatientId
    });
    if (!vimPatientId) {
      vimPatientId = shouldUseTimeoutOnTransformers ? await timeoutAfter(() => getVimPatientId({ patientId, firstName, lastName, dateOfBirth }), TIMEOUT_AFTER, true) : await getVimPatientId({ patientId, firstName, lastName, dateOfBirth });
      vimPatientIdCache.set(patientId, vimPatientId);
    }
    return vimPatientId;
  } catch (error) {
    logger10.error("Failed to set vimPatientId in patient payload transformer", {
      error,
      patient
    });
  }
};
var contentSupplierIdentifiersLogger = logger.scope("getContentSupplierIdentifiers query");
var CACHE_TTL2 = 15 * 60;
var contentSupplierPatientIdentifiersCache = new import_node_cache2.default({ stdTTL: CACHE_TTL2 });
var transformerActionLogger = logger.scope("GET_PATIENT action transformer");
var GET_PATIENT = async (actionResponse) => {
  const vimPatientId = await getVimPatientId2(actionResponse, transformerActionLogger);
  return __spreadProps(__spreadValues({}, actionResponse), { vimPatientId });
};
var events_exports = {};
var entities_exports = {};
__export(entities_exports, {
  Gender: () => Gender,
  OrderType: () => OrderType,
  ProviderType: () => ProviderType,
  ReferralPriority: () => ReferralPriority,
  ReferralStatus: () => ReferralStatus,
  ReleaseOfInformation: () => ReleaseOfInformation,
  UIElements: () => ui_elements_exports
});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["male"] = "male";
  Gender2["female"] = "female";
  return Gender2;
})(Gender || {});
var ReleaseOfInformation = /* @__PURE__ */ ((ReleaseOfInformation2) => {
  ReleaseOfInformation2["Y"] = "Yes allow to release";
  ReleaseOfInformation2["M"] = "modified release (partial release)";
  ReleaseOfInformation2["N"] = "no release";
  ReleaseOfInformation2["ANSI"] = "ansi 5010";
  ReleaseOfInformation2["UNKNOWN"] = "option not mapped";
  return ReleaseOfInformation2;
})(ReleaseOfInformation || {});
var ProviderType = /* @__PURE__ */ ((ProviderType2) => {
  ProviderType2["ORGANIZATION"] = "ORGANIZATION";
  ProviderType2["UNKNOWN"] = "UNKNOWN";
  return ProviderType2;
})(ProviderType || {});
var ReferralPriority = /* @__PURE__ */ ((ReferralPriority2) => {
  ReferralPriority2["ROUTINE"] = "ROUTINE";
  ReferralPriority2["URGENT"] = "URGENT";
  ReferralPriority2["STAT"] = "STAT";
  return ReferralPriority2;
})(ReferralPriority || {});
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["LAB"] = "LAB";
  OrderType2["DI"] = "DI";
  OrderType2["PROCEDURE"] = "PROCEDURE";
  OrderType2["RX"] = "RX";
  OrderType2["REFERRAL"] = "REFERRAL";
  return OrderType2;
})(OrderType || {});
var ui_elements_exports = {};
__export(ui_elements_exports, {
  ExpandingType: () => ExpandingType,
  ModifyReason: () => ModifyReason,
  UISectionNames: () => UISectionNames,
  VimConnectUIUtilsWidget: () => VimConnectUIUtilsWidget
});
var UISectionNames = /* @__PURE__ */ ((UISectionNames2) => {
  UISectionNames2["referralSelectProvider"] = "referralSelectProvider";
  UISectionNames2["labsSelectProvider"] = "labsSelectProvider";
  UISectionNames2["diSelectProvider"] = "diSelectProvider";
  return UISectionNames2;
})(UISectionNames || {});
var ModifyReason = /* @__PURE__ */ ((ModifyReason2) => {
  ModifyReason2["Response"] = "response";
  ModifyReason2["PatientEligible"] = "patientEligible";
  return ModifyReason2;
})(ModifyReason || {});
var VimConnectUIUtilsWidget = /* @__PURE__ */ ((VimConnectUIUtilsWidget2) => {
  VimConnectUIUtilsWidget2["Overlay"] = "overlay";
  VimConnectUIUtilsWidget2["WriteBackLoading"] = "writeBackLoading";
  return VimConnectUIUtilsWidget2;
})(VimConnectUIUtilsWidget || {});
var ExpandingType = /* @__PURE__ */ ((ExpandingType2) => {
  ExpandingType2["AUTOMATIC"] = "automatic";
  ExpandingType2["VIM_HUB_MANUAL"] = "manual";
  ExpandingType2["VIM_APP_MANUAL"] = "vim-app-manual";
  ExpandingType2["VIM_NOTIFICATION_MANUAL"] = "vim-notification-manual";
  return ExpandingType2;
})(ExpandingType || {});
var connectors_exports = {};
__export(connectors_exports, {
  Common: () => common_exports2,
  Web: () => web_exports
});
var web_exports = {};
__export(web_exports, {
  ActionType: () => ActionType,
  Enums: () => enums_exports,
  WebConnectorMessageTypes: () => WebConnectorMessageTypes
});
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["GET_ACTION_RESULT"] = "getActionResult";
  ActionType2["GET_PATH_RESULT"] = "getPathResult";
  ActionType2["INVOKE_LAST_ITERATION_RESULT"] = "invokeLastIterationResult";
  return ActionType2;
})(ActionType || {});
var WebConnectorMessageTypes = /* @__PURE__ */ ((WebConnectorMessageTypes2) => {
  WebConnectorMessageTypes2["getActiveTab"] = "getActiveTab";
  WebConnectorMessageTypes2["extensionVersion"] = "extensionVersion";
  WebConnectorMessageTypes2["getLastLoginRequest"] = "getLastLoginRequest";
  WebConnectorMessageTypes2["sendUserDetails"] = "sendUserDetails";
  WebConnectorMessageTypes2["sendPopupDetails"] = "sendPopupDetails";
  WebConnectorMessageTypes2["addEventListener"] = "addEventListener";
  WebConnectorMessageTypes2["observeMutations"] = "observeMutations";
  WebConnectorMessageTypes2["disconnectObserver"] = "disconnectObserver";
  WebConnectorMessageTypes2["fetchData"] = "fetchData";
  WebConnectorMessageTypes2["callJQueryAjax"] = "callJQueryAjax";
  WebConnectorMessageTypes2["insertElement"] = "insertElement";
  WebConnectorMessageTypes2["getAttribute"] = "getAttribute";
  WebConnectorMessageTypes2["invokeFunction"] = "invokeFunction";
  WebConnectorMessageTypes2["jqueryInvokeFunction"] = "jqueryInvokeFunction";
  WebConnectorMessageTypes2["scrape"] = "scrape";
  WebConnectorMessageTypes2["scrapeFirst"] = "scrapeFirst";
  WebConnectorMessageTypes2["scrapeInnerHtml"] = "scrapeInnerHtml";
  WebConnectorMessageTypes2["scrapeParent"] = "scrapeParent";
  WebConnectorMessageTypes2["updateElement"] = "updateElement";
  WebConnectorMessageTypes2["changeValue"] = "changeValue";
  WebConnectorMessageTypes2["dispatchEvent"] = "dispatchEvent";
  WebConnectorMessageTypes2["dispatchMouseEvent"] = "dispatchMouseEvent";
  WebConnectorMessageTypes2["backboneGetModel"] = "backboneGetModel";
  WebConnectorMessageTypes2["backboneInvoke"] = "backboneInvoke";
  WebConnectorMessageTypes2["backboneDoesFunctionExists"] = "backboneDoesFunctionExists";
  WebConnectorMessageTypes2["angularGetScope"] = "angularGetScope";
  WebConnectorMessageTypes2["angularSetScope"] = "angularSetScope";
  WebConnectorMessageTypes2["angularGetService"] = "angularGetService";
  WebConnectorMessageTypes2["angularInvokeOnScope"] = "angularInvokeOnScope";
  WebConnectorMessageTypes2["angularInvokeOnService"] = "angularInvokeOnService";
  WebConnectorMessageTypes2["addWebRequestListener"] = "addWebRequestListener";
  WebConnectorMessageTypes2["chromeCreateTab"] = "chromeCreateTab";
  WebConnectorMessageTypes2["chromeSetBrowserAction"] = "chromeSetBrowserAction";
  WebConnectorMessageTypes2["getCurrentUrl"] = "getCurrentUrl";
  WebConnectorMessageTypes2["setCurrentUrl"] = "setCurrentUrl";
  WebConnectorMessageTypes2["addOpenedTabsMessageListener"] = "addOpenedTabsMessageListener";
  WebConnectorMessageTypes2["eventBusInitialized"] = "eventBusInitialized";
  WebConnectorMessageTypes2["webPageUnstable"] = "webPageUnstable";
  WebConnectorMessageTypes2["addAjaxRequestListener"] = "addAjaxRequestListener";
  WebConnectorMessageTypes2["decryptECWStringByKey"] = "decryptECWStringByKey";
  WebConnectorMessageTypes2["getLocalStorageKey"] = "getLocalStorageKey";
  WebConnectorMessageTypes2["setLocalStorageKey"] = "setLocalStorageKey";
  WebConnectorMessageTypes2["removeLocalStorageKey"] = "removeLocalStorageKey";
  WebConnectorMessageTypes2["overrideGlobalFunction"] = "overrideGlobalFunction";
  WebConnectorMessageTypes2["getInstallationType"] = "getInstallationType";
  WebConnectorMessageTypes2["invokeFunctionWithCachedParams"] = "invokeFunctionWithCachedParams";
  return WebConnectorMessageTypes2;
})(WebConnectorMessageTypes || {});
var enums_exports = {};
__export(enums_exports, {
  AllowedEvents: () => AllowedEvents,
  AllowedFunctions: () => AllowedFunctions,
  OverrideGlobalFunctionTypes: () => OverrideGlobalFunctionTypes
});
var AllowedEvents = /* @__PURE__ */ ((AllowedEvents2) => {
  AllowedEvents2["change"] = "change";
  AllowedEvents2["keydown"] = "keydown";
  AllowedEvents2["keyup"] = "keyup";
  AllowedEvents2["click"] = "click";
  AllowedEvents2["mousedown"] = "mousedown";
  AllowedEvents2["mouseover"] = "mouseover";
  AllowedEvents2["pointerover"] = "pointerover";
  AllowedEvents2["blur"] = "blur";
  AllowedEvents2["input"] = "input";
  return AllowedEvents2;
})(AllowedEvents || {});
var AllowedFunctions = /* @__PURE__ */ ((AllowedFunctions2) => {
  AllowedFunctions2["blur"] = "blur";
  AllowedFunctions2["click"] = "click";
  AllowedFunctions2["closest"] = "closest";
  AllowedFunctions2["focus"] = "focus";
  AllowedFunctions2["getAttribute"] = "getAttribute";
  AllowedFunctions2["setAttribute"] = "setAttribute";
  AllowedFunctions2["makeURL"] = "makeURL";
  AllowedFunctions2["removeAttribute"] = "removeAttribute";
  AllowedFunctions2["urlGet"] = "urlGet";
  AllowedFunctions2["urlPost"] = "urlPost";
  AllowedFunctions2["getMappedVisitTypesToResource"] = "getMappedVisitTypesToResource";
  AllowedFunctions2["MD5"] = "MD5";
  AllowedFunctions2["hex_sha1"] = "hex_sha1";
  AllowedFunctions2["getBoundingClientRect"] = "getBoundingClientRect";
  AllowedFunctions2["close"] = "close";
  AllowedFunctions2["refreshDashboard"] = "refreshDashboard";
  AllowedFunctions2["reloadOVItemContext"] = "reloadOVItemContext";
  return AllowedFunctions2;
})(AllowedFunctions || {});
var OverrideGlobalFunctionTypes = /* @__PURE__ */ ((OverrideGlobalFunctionTypes2) => {
  OverrideGlobalFunctionTypes2["RETURN_ITSELF"] = "return_itself";
  return OverrideGlobalFunctionTypes2;
})(OverrideGlobalFunctionTypes || {});
var common_exports2 = {};
__export(common_exports2, {
  CommonConnectorMessageTypes: () => CommonConnectorMessageTypes
});
var CommonConnectorMessageTypes = /* @__PURE__ */ ((CommonConnectorMessageTypes2) => {
  CommonConnectorMessageTypes2["removeListener"] = "removeListener";
  CommonConnectorMessageTypes2["sendExtensionLog"] = "sendExtensionLog";
  CommonConnectorMessageTypes2["chromeStorageGet"] = "chromeStorageGet";
  CommonConnectorMessageTypes2["chromeStorageSet"] = "chromeStorageSet";
  CommonConnectorMessageTypes2["chromeStorageRemove"] = "chromeStorageRemove";
  CommonConnectorMessageTypes2["injectWidget"] = "injectWidget";
  CommonConnectorMessageTypes2["removeWidget"] = "removeWidget";
  CommonConnectorMessageTypes2["sendDataToWidget"] = "sendDataToWidget";
  CommonConnectorMessageTypes2["modifyWidget"] = "modifyWidget";
  CommonConnectorMessageTypes2["listenToDataFromWidgets"] = "listenToDataFromWidgets";
  return CommonConnectorMessageTypes2;
})(CommonConnectorMessageTypes || {});
var secrets_exports = {};
__export(secrets_exports, {
  Notes: () => Notes
});
var Notes = /* @__PURE__ */ ((Notes2) => {
  Notes2["SQL_SECRETS_NOTE_NAME"] = "sql secrets";
  return Notes2;
})(Notes || {});
var write_backs_exports = {};
__export(write_backs_exports, {
  ActionStatus: () => ActionStatus,
  SelectAction: () => SelectAction,
  formatProvider: () => formatProvider
});
var SelectAction = /* @__PURE__ */ ((SelectAction2) => {
  SelectAction2["WRITEBACK"] = "writeback";
  SelectAction2["COPY_TO_CLIPBOARD"] = "copy_to_clipboard";
  return SelectAction2;
})(SelectAction || {});
var ActionStatus = /* @__PURE__ */ ((ActionStatus2) => {
  ActionStatus2["SUCCESS"] = "success";
  ActionStatus2["FAILED"] = "failed";
  return ActionStatus2;
})(ActionStatus || {});
var formatProvider = (provider, withNewLines = false) => {
  var _a3, _b, _c, _d, _e, _f;
  const divider = withNewLines ? "\n" : ", ";
  const name = ((_a3 = provider.demographics) == null ? void 0 : _a3.lastName) ? `${provider.demographics.lastName}, ${provider.demographics.firstName}` : void 0;
  const providerInfo = `Provider Result:${withNewLines ? "\n" : " "}${name}, NPI: ${provider.npi}`;
  const specialities = `Specialties: ${(_c = (_b = provider.specialty) == null ? void 0 : _b.map((specialty) => specialty.description)) == null ? void 0 : _c.join(", ")}`;
  const organization = (_f = (_e = (_d = provider.organizations) == null ? void 0 : _d[0]) != null ? _e : provider.organization) != null ? _f : {};
  const { address, contact_info: contactInfo } = organization;
  const fullAddress = (address == null ? void 0 : address.fullAddress) || getFullAddress(address);
  const providerOfficeName = organization.name ? `Office Name: ${organization.name}` : void 0;
  const providerFullAddress = fullAddress ? `Address: ${fullAddress}` : "No address available";
  const providerAddress = providerOfficeName ? `${providerOfficeName}${divider}${providerFullAddress}` : providerFullAddress;
  const { mobilePhoneNumber, faxNumber } = contactInfo != null ? contactInfo : {};
  const providerContactInfo = mobilePhoneNumber ? `Phone: ${mobilePhoneNumber}${divider}Fax: ${faxNumber}` : "No phone number available";
  return [providerInfo, specialities, providerAddress, providerContactInfo].map((str) => str.replace(new RegExp("undefined", "g"), "---")).join(divider);
};
var getFullAddress = ({ address1, address2, city, state, zipCode } = {}) => {
  return [address1, address2, city, state, zipCode].filter((item) => !!item).join(", ");
};
var login_exports = {};
__export(login_exports, {
  ContactDetailType: () => ContactDetailType,
  INTERNAL_SERVER_ERROR_MESSAGE: () => INTERNAL_SERVER_ERROR_MESSAGE,
  LoginMethodType: () => LoginMethodType
});
var LoginMethodType = /* @__PURE__ */ ((LoginMethodType3) => {
  LoginMethodType3["SINGLE_SIGN_ON"] = "SINGLE_SIGN_ON";
  LoginMethodType3["INTERACTIVE_SSO"] = "INTERACTIVE_SSO";
  LoginMethodType3["CREDENTIALS"] = "CREDENTIALS";
  LoginMethodType3["SEAMLESS_LOGIN"] = "SEAMLESS_LOGIN";
  LoginMethodType3["ID_TOKEN"] = "ID_TOKEN";
  LoginMethodType3["SILENT_LOGIN"] = "SILENT_LOGIN";
  LoginMethodType3["ACCESS_TOKEN"] = "ACCESS_TOKEN";
  LoginMethodType3["REFRESH_TOKEN"] = "REFRESH_TOKEN";
  LoginMethodType3["OTP"] = "OTP";
  return LoginMethodType3;
})(LoginMethodType || {});
var ContactDetailType = /* @__PURE__ */ ((ContactDetailType2) => {
  ContactDetailType2["Email"] = "email";
  ContactDetailType2["Phone"] = "phone";
  return ContactDetailType2;
})(ContactDetailType || {});
var INTERNAL_SERVER_ERROR_MESSAGE = "Internal server error on initial login";
var widget_events_exports = {};
__export(widget_events_exports, {
  SelectProviderButtonSource: () => SelectProviderButtonSource
});
var SelectProviderButtonSource = /* @__PURE__ */ ((SelectProviderButtonSource2) => {
  SelectProviderButtonSource2["REFERRAL"] = "referral";
  SelectProviderButtonSource2["DI"] = "di";
  SelectProviderButtonSource2["LAB"] = "lab";
  return SelectProviderButtonSource2;
})(SelectProviderButtonSource || {});
var infra_exports = {};
__export(infra_exports, {
  Apps: () => apps_exports,
  Common: () => common_exports3,
  MessageChannel: () => messageChannel_exports
});
var apps_exports = {};
__export(apps_exports, {
  Product: () => Product,
  VimConnectWidgetIncomingEventName: () => VimConnectWidgetIncomingEventName,
  VimConnectWidgetOutgoingEventName: () => VimConnectWidgetOutgoingEventName,
  WidgetPayloadType: () => WidgetPayloadType,
  calculateWidgetUrl: () => calculateWidgetUrl,
  getWidgetsConfig: () => getWidgetsConfig,
  isProvidersEquals: () => isProvidersEquals,
  searchProviders: () => searchProviders
});
var scopedLogger = logger.scope("getWidgetConfig");
var axiosInstance = import_axios.default.create({ timeout: 3e4 });
async function getWidgetsConfig() {
  try {
    let response;
    await retry(async (retryNumber) => {
      scopedLogger.info("Trying to get widgets config", {
        noPHI: true,
        retryNumber
      });
      try {
        response = await axiosInstance.get("/api/widgetsConfig");
      } catch (error) {
        scopedLogger.warning("Failed to get widgets config", {
          error,
          noPHI: true
        });
        throw error;
      }
      scopedLogger.info("get widgets config completed", { noPHI: true });
    }, { retries: 5 });
    return response.data;
  } catch (error) {
    scopedLogger.error(`Could not fetch client config!`, { error });
    throw error;
  }
}
var isProvidersEquals = (firstProvider, secondProvider) => {
  return JSON.stringify(firstProvider) === JSON.stringify(secondProvider);
};
async function calculateWidgetUrl(widgetName, envToUrlMap, overrideWidgetsConfig) {
  var _a3, _b;
  const overrideWidgetEnv = (_a3 = overrideWidgetsConfig == null ? void 0 : overrideWidgetsConfig[widgetName]) == null ? void 0 : _a3.widgetEnv;
  const urlByOverrideWidgetEnv = overrideWidgetEnv && (envToUrlMap == null ? void 0 : envToUrlMap[overrideWidgetEnv]);
  if (urlByOverrideWidgetEnv) {
    logger.scope("calculateWidgetUrl").info(`Widget "${widgetName}" calculated URL is [${urlByOverrideWidgetEnv}] since an override widget config was provided`, { widgetEnv: overrideWidgetEnv });
    return urlByOverrideWidgetEnv;
  }
  const config = await getWidgetsConfig();
  if (!(config == null ? void 0 : config.widgetsDefaultEnv)) {
    throw new Error(`client config has no parameter widgetsDefaultEnv`);
  }
  const overrideUrlConfig = (_b = config.widgetsUrl) == null ? void 0 : _b[widgetName];
  if (overrideUrlConfig) {
    logger.scope("calculateWidgetUrl").info(`Widget "${widgetName}" calculated URL is [${overrideUrlConfig}] since an override was provided`, config);
    return overrideUrlConfig;
  }
  const urlByDefaultEnv = envToUrlMap[config.widgetsDefaultEnv];
  if (urlByDefaultEnv) {
    logger.scope("calculateWidgetUrl").info(`Widget "${widgetName}" calculated URL is [${urlByDefaultEnv}] due to default widget env "${config == null ? void 0 : config.widgetsDefaultEnv}"`, config);
    return urlByDefaultEnv;
  }
  throw new Error(`Could not find matching URL for widget [${widgetName}]! client configuration: ${JSON.stringify(config)}, envToUrlMap: ${JSON.stringify(envToUrlMap)}`);
}
function searchProviders(allProviders, limit, offset, searchTerm) {
  if (!searchTerm) {
    return allProviders.slice(offset, offset + limit);
  }
  const lowerSearchTerm = searchTerm.toLowerCase().trim();
  const allResults = allProviders.filter((provider) => {
    const firstName = provider.demographics.firstName.toLowerCase();
    const lastName = provider.demographics.lastName.toLowerCase();
    const fullName = `{${firstName} ${lastName}}`;
    return fullName.startsWith(lowerSearchTerm) || lastName.startsWith(lowerSearchTerm) || firstName.startsWith(lowerSearchTerm);
  });
  return allResults.slice(offset, offset + limit);
}
var VimConnectWidgetOutgoingEventName = /* @__PURE__ */ ((VimConnectWidgetOutgoingEventName2) => {
  VimConnectWidgetOutgoingEventName2["GetVimPatientId"] = "GetVimPatientId";
  VimConnectWidgetOutgoingEventName2["TrackAnalyticsData"] = "TrackAnalyticsData";
  return VimConnectWidgetOutgoingEventName2;
})(VimConnectWidgetOutgoingEventName || {});
var VimConnectWidgetIncomingEventName = /* @__PURE__ */ ((VimConnectWidgetIncomingEventName2) => {
  VimConnectWidgetIncomingEventName2["GetVimPatientIdResult"] = "GetVimPatientIdResult";
  VimConnectWidgetIncomingEventName2["AnalyticsApplicationProperties"] = "AnalyticsApplicationProperties";
  return VimConnectWidgetIncomingEventName2;
})(VimConnectWidgetIncomingEventName || {});
var WidgetPayloadType = /* @__PURE__ */ ((WidgetPayloadType2) => {
  WidgetPayloadType2["LOGIN_FAILURE"] = "vim-connect-login-failure";
  WidgetPayloadType2["ACCESS_TOKEN"] = "vim-connect-login-access-token";
  WidgetPayloadType2["CLOSE"] = "vim-connect-login-close";
  WidgetPayloadType2["WIDGET_READY"] = "vim-connect-widget-ready";
  WidgetPayloadType2["MODIFY_WIDGET"] = "vim-connect-modify-widget";
  WidgetPayloadType2["SEAMLESS_LOGIN_APPROVED"] = "vim-connect-seamless-login-approved";
  WidgetPayloadType2["SEAMLESS_LOGIN_FAILED"] = "vim-connect-seamless-login-failed";
  WidgetPayloadType2["USER_LOGIN_ATTEMPT"] = "vim-connect-user-login-attempt";
  return WidgetPayloadType2;
})(WidgetPayloadType || {});
var Product = /* @__PURE__ */ ((Product2) => {
  Product2["DiagnosisGaps"] = "diagnosis-gaps";
  Product2["Eligibility"] = "eligibility";
  Product2["OrderAssist"] = "order-assist";
  Product2["PatientHealthHistory"] = "patient-health-history";
  Product2["PriorAuthCheck"] = "prior-auth-check";
  Product2["QualityGaps"] = "quality-gaps";
  Product2["ReferralGuidance"] = "referral-guidance";
  Product2["OptumReferralUtility"] = "optum-referral-utility";
  Product2["OptimalCare"] = "optimal-care";
  Product2["Scheduling"] = "scheduling";
  Product2["OptumDataCore"] = "optum-data-core";
  Product2["OptumPro"] = "optum-pro";
  Product2["OptumDataCoreDashboard"] = "optum-data-core-dashboard";
  Product2["MockCanvasApp"] = "mock-canvas-app";
  Product2["FhirSimulator"] = "fhir-simulator";
  Product2["CDE"] = "clinical-data-exchange";
  Product2["Kahun"] = "kahun";
  Product2["PriviaInsights"] = "privia-insights";
  Product2["RxAssist"] = "rx-assist";
  return Product2;
})(Product || {});
var common_exports3 = {};
__export(common_exports3, {
  Api: () => api_exports,
  Consts: () => consts_exports,
  LTSSupport: () => lts_support_exports,
  Poller: () => poller_exports,
  Types: () => types_exports,
  Utils: () => utils_exports
});
var types_exports = {};
__export(types_exports, {
  HorizontalDirection: () => HorizontalDirection,
  HorizontalHubPosition: () => HorizontalHubPosition,
  LoginEvent: () => LoginEvent2,
  LoginMethodType: () => LoginMethodType2,
  LoginResultType: () => LoginResultType,
  SMARTApp: () => SMARTApp,
  StorageKnownKey: () => StorageKnownKey,
  VerticalDirection: () => VerticalDirection,
  VerticalHubPosition: () => VerticalHubPosition
});
var VerticalHubPosition = /* @__PURE__ */ ((VerticalHubPosition2) => {
  VerticalHubPosition2["Low"] = "Low";
  VerticalHubPosition2["Low_Middle"] = "Low_Middle";
  VerticalHubPosition2["Middle"] = "Middle";
  VerticalHubPosition2["High_Middle"] = "High_Middle";
  VerticalHubPosition2["High"] = "High";
  return VerticalHubPosition2;
})(VerticalHubPosition || {});
var VerticalDirection = /* @__PURE__ */ ((VerticalDirection2) => {
  VerticalDirection2["Down"] = "Down";
  VerticalDirection2["Up"] = "Up";
  return VerticalDirection2;
})(VerticalDirection || {});
var HorizontalHubPosition = /* @__PURE__ */ ((HorizontalHubPosition2) => {
  HorizontalHubPosition2["Right"] = "Right";
  HorizontalHubPosition2["Left"] = "Left";
  return HorizontalHubPosition2;
})(HorizontalHubPosition || {});
var HorizontalDirection = /* @__PURE__ */ ((HorizontalDirection2) => {
  HorizontalDirection2["Right"] = "Right";
  HorizontalDirection2["Left"] = "Left";
  return HorizontalDirection2;
})(HorizontalDirection || {});
var StorageKnownKey = /* @__PURE__ */ ((StorageKnownKey2) => {
  StorageKnownKey2["DEVICE_ID"] = "device_id";
  StorageKnownKey2["HOSTNAME"] = "hostname";
  StorageKnownKey2["USERNAME"] = "username";
  StorageKnownKey2["SALT"] = "salt";
  StorageKnownKey2["VIM_TOKENS"] = "vimTokens";
  StorageKnownKey2["OVERRIDE_ORGANIZATION"] = "overrideOrgName";
  StorageKnownKey2["OVERRIDE_WIDGETS_CONFIGURATION"] = "overrideWidgetsConfiguration";
  StorageKnownKey2["MSI_VERSION"] = "MSI_VERSION";
  StorageKnownKey2["KEY"] = "KEY";
  StorageKnownKey2["EHR"] = "EHR";
  StorageKnownKey2["EHR_URL"] = "EHR_URL";
  StorageKnownKey2["OVERRIDE_ENV_CONFIG"] = "overrideEnvironmentConfig";
  StorageKnownKey2["OVERRIDE_ORG_KEY"] = "overrideOrgKey";
  StorageKnownKey2["OVERRIDE_PROCESS"] = "overrideProcess";
  StorageKnownKey2["OVERRIDE_EHR_INSTANCE_URL"] = "overrideEhrInstanceUrl";
  StorageKnownKey2["NOTIFICATIONS_DETAILS"] = "notificationsDetails";
  StorageKnownKey2["VIM_CONNECT_UI"] = "vim-connect-ui";
  StorageKnownKey2["TECHNICAL_OPTIONS"] = "technicalOptions";
  StorageKnownKey2["LAST_AUTOMATIC_REFRESH_TIME"] = "lastAutomaticRefreshTime";
  StorageKnownKey2["OS_VERSION"] = "os_version";
  StorageKnownKey2["USE_OS_SIMULATOR"] = "osSimulator";
  StorageKnownKey2["WORKFLOW_INTEGRATION_LOGGER_URL"] = "WORKFLOW_INTEGRATION_LOGGER_URL";
  StorageKnownKey2["OS_SIMULATOR_DATA"] = "OS_SIMULATOR_DATA";
  StorageKnownKey2["ORGANIZATION_KEY"] = "organizationKey";
  StorageKnownKey2["WIN32DEPRECATION_DEBUG"] = "win32Deprecation_debugMode";
  StorageKnownKey2["WIN32DETECTOR_STOP"] = "win32Deprecation_stop";
  StorageKnownKey2["VC_PLAYGROUND"] = "vcPlaygroundConfig";
  return StorageKnownKey2;
})(StorageKnownKey || {});
var LoginMethodType2 = /* @__PURE__ */ ((LoginMethodType3) => {
  LoginMethodType3["SINGLE_SIGN_ON"] = "SINGLE_SIGN_ON";
  LoginMethodType3["INTERACTIVE_SSO"] = "INTERACTIVE_SSO";
  LoginMethodType3["CREDENTIALS"] = "CREDENTIALS";
  LoginMethodType3["SEAMLESS_LOGIN"] = "SEAMLESS_LOGIN";
  LoginMethodType3["ID_TOKEN"] = "ID_TOKEN";
  LoginMethodType3["SILENT_LOGIN"] = "SILENT_LOGIN";
  LoginMethodType3["ACCESS_TOKEN"] = "ACCESS_TOKEN";
  LoginMethodType3["REFRESH_TOKEN"] = "REFRESH_TOKEN";
  LoginMethodType3["OTP"] = "OTP";
  return LoginMethodType3;
})(LoginMethodType2 || {});
var LoginEvent2 = /* @__PURE__ */ ((LoginEvent3) => {
  LoginEvent3["PLEASE_RE_LOGIN_DISPLAYED"] = "vim_connect_re_login_displayed";
  LoginEvent3["LOGIN_NOT_DISPLAYED"] = "vim_connect_login_not_displayed";
  LoginEvent3["INITIAL_SUCCESSFUL_LOGIN"] = "vim_connect_initial_successful_login";
  LoginEvent3["INITIAL_FAILED_LOGIN"] = "vim_connect_initial_failed_login";
  LoginEvent3["SUCCESSFUL_LOGIN"] = "vim_connect_successful_login";
  LoginEvent3["FAILED_SILENT_LOGIN"] = "vim_connect_failed_silent_login";
  LoginEvent3["START_SSO_LOGIN"] = "vim_connect_start_sso_login";
  LoginEvent3["SUCCESSFUL_SSO_LOGIN"] = "vim_connect_successful_sso_login";
  LoginEvent3["FAILED_SSO_LOGIN"] = "vim_connect_failed_sso_login";
  LoginEvent3["LOGIN_CLOSED"] = "vim_connect_login_screen_closed";
  LoginEvent3["LOGIN_CLOSED_BY_USER"] = "vim_connect_login_screen_closed_by_user";
  LoginEvent3["SEAMLESS_LOGIN_START"] = "vim_connect_seamless_login_start";
  LoginEvent3["SEAMLESS_LOGIN_APPROVED"] = "vim_connect_seamless_login_approved";
  LoginEvent3["SEAMLESS_LOGIN_END"] = "vim_connect_seamless_login_end";
  LoginEvent3["DISPLAY_RE_LOGIN_SCREEN"] = "vim-ehr-display-re-login-screen";
  LoginEvent3["NON_EXISTING_SDK_USER_DETECTED"] = "non_existing_sdk_user_detected";
  LoginEvent3["USER_LOGIN"] = "vim_connect_user_login";
  LoginEvent3["USER_RE_LOGIN"] = "vim_connect_user_re_login";
  return LoginEvent3;
})(LoginEvent2 || {});
var LoginResultType = /* @__PURE__ */ ((LoginResultType2) => {
  LoginResultType2["Success"] = "success";
  LoginResultType2["Failure"] = "failure";
  LoginResultType2["Cancelled"] = "cancelled";
  return LoginResultType2;
})(LoginResultType || {});
var SMARTApp = /* @__PURE__ */ ((SMARTApp2) => {
  SMARTApp2["PACS"] = "PACS";
  SMARTApp2["PACSU"] = "PACSU";
  SMARTApp2["fhirSimulator"] = "fhirSimulator";
  return SMARTApp2;
})(SMARTApp || {});
var poller_exports = {};
__export(poller_exports, {
  createLockedPoller: () => createLockedPoller,
  createPoller: () => createPoller
});
var logger6 = logger.scope("Poller/poller.ts");
function createPoller(periodicPromise, intervalInMs = 0) {
  let isRunning = false;
  function execute2() {
    if (isRunning) {
      setTimeout(() => {
        if (isRunning)
          periodicPromise().catch((error) => {
            logger6.warning("Got error while polling, continuing to poll", error);
          }).then(() => {
            execute2();
          });
      }, intervalInMs);
    }
  }
  const start = () => {
    if (isRunning) {
      logger6.warning(`Poller is already running`);
    } else {
      isRunning = true;
      execute2();
    }
  };
  const stop = () => {
    isRunning = false;
  };
  return { start, stop, isRunning };
}
var logger7 = logger.scope("Poller/lockedPoller.ts");
function createLockedPoller(periodicPromise, intervalInMs = 0, onError, retryOptions) {
  let isRunning = false;
  let currentIntervalInMs = intervalInMs;
  function execute2() {
    if (isRunning) {
      const promises = [
        sleep2(currentIntervalInMs),
        retry(() => periodicPromise().catch((error) => {
          if (isRunning) {
            throw error;
          } else {
            return void 0;
          }
        }), __spreadValues({
          retries: 0,
          minTimeout: currentIntervalInMs
        }, retryOptions))
      ];
      Promise.allSettled(promises).then((results) => {
        const error = results.find((result2) => result2.status === "rejected");
        if (error) {
          if (onError) {
            onError(error.reason);
          } else {
            logger7.warning("Got error while polling, continuing to poll", error.reason);
          }
        }
        if (isRunning) {
          execute2();
        }
      });
    }
  }
  function sleep2(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  const start = () => {
    isRunning = true;
    execute2();
  };
  const stop = () => {
    isRunning = false;
  };
  const changeInterval = (newInterval) => {
    currentIntervalInMs = newInterval;
  };
  return { start, stop, isRunning, changeInterval };
}
var api_exports = {};
__export(api_exports, {
  FreeText: () => freeTextQuery_exports,
  Patient: () => patient_exports,
  Preferences: () => preferences_exports,
  Referral: () => referral_exports,
  Secrets: () => secrets_query_exports
});
var secrets_query_exports = {};
__export(secrets_query_exports, {
  getUserSecrets: () => getUserSecrets
});
var getUserSecretsLogger = logger.scope("Get user secrets queries");
var getUserSecretsQuery = lib_default`
  query UserSecrets {
    getUserSecrets {
      sqlSecrets {
        database
        server
        user
        password
      }
    }
  }
`;
var getUserSecrets = async () => {
  var _a3;
  try {
    const result2 = await retry(async () => {
      return await gqlClient.query({
        query: getUserSecretsQuery,
        fetchPolicy: "no-cache"
      });
    }, {
      retries: 3,
      minTimeout: 200
    });
    return (_a3 = result2 == null ? void 0 : result2.data) == null ? void 0 : _a3.getUserSecrets;
  } catch (error) {
    getUserSecretsLogger.error("error while receiving user secrets", { error });
    return void 0;
  }
};
var referral_exports = {};
__export(referral_exports, {
  getReferralIdMapping: () => getReferralIdMapping,
  saveReferralIdMapping: () => saveReferralIdMapping
});
var GET_REFERRAL_ID_MAPPING_QUERY = lib_default`
  query GetReferralIdMapping($input: GetReferralIdMappingInput!) {
    getReferralIdMapping(input: $input) {
      createdDate
      ehrId
      externalId
      source
    }
  }
`;
var SAVE_REFERRAL_ID_MAPPING_MUTATION = lib_default`
  mutation SaveReferralIdMapping($input: SaveReferralIdMappingInput!) {
    saveReferralIdMapping(input: $input) {
      createdDate
      ehrId
      externalId
      source
    }
  }
`;
var getReferralIdMapping = async (input) => {
  const response = await gqlClient.queryAuthenticated({
    query: GET_REFERRAL_ID_MAPPING_QUERY,
    variables: { input },
    context: { uri: "/runtime/api/graphql" },
    fetchPolicy: "network-only"
  });
  const {
    data: { getReferralIdMapping: result2 }
  } = response;
  return result2;
};
var saveReferralIdMapping = async (input) => {
  var _a3;
  const response = await gqlClient.mutateAuthenticated({
    mutation: SAVE_REFERRAL_ID_MAPPING_MUTATION,
    variables: { input },
    context: { uri: "/runtime/api/graphql" }
  });
  return (_a3 = response == null ? void 0 : response.data) == null ? void 0 : _a3.saveReferralIdMapping;
};
var preferences_exports = {};
__export(preferences_exports, {
  getHubPosition: () => getHubPosition,
  setHubPosition: () => setHubPosition
});
var getHubPositionQuery = lib_default`
  query getHubPosition {
    getHubPosition {
      horizontal
      vertical
    }
  }
`;
var setHubPositionMutation = lib_default`
  mutation setHubPosition($input: SetHubPositionInput!) {
    setHubPosition(input: $input) {
      success
    }
  }
`;
var getHubPosition = async () => {
  try {
    const deviceId = gqlClient.getDeviceId();
    const { data } = await gqlClient.queryAuthenticated({
      query: getHubPositionQuery,
      fetchPolicy: "no-cache",
      context: {
        uri: "/runtime/api/graphql",
        headers: __spreadValues({}, deviceId ? { ["x-vim-device-id"]: deviceId } : void 0)
      }
    });
    const { horizontal, vertical } = data == null ? void 0 : data.getHubPosition;
    return { horizontal, vertical };
  } catch (error) {
    return infra_exports.Common.Consts.DEFAULT_HUB_POSITION;
  }
};
var setHubPosition = async (hubPosition) => {
  const deviceId = gqlClient.getDeviceId();
  await gqlClient.mutateAuthenticated({
    mutation: setHubPositionMutation,
    variables: { input: { hubPosition, sentAt: new Date() } },
    context: {
      uri: "/runtime/api/graphql",
      headers: __spreadValues({}, deviceId ? { ["x-vim-device-id"]: deviceId } : void 0)
    }
  });
  return;
};
var freeTextQuery_exports = {};
__export(freeTextQuery_exports, {
  getFreeTextGQLQuery: () => getFreeTextGQLQuery
});
var getFreeTextQuery = lib_default`
  query QueryFreeText($input: FreeTextInput!) {
    queryFreeText(input: $input) {
      suggestions {
        cpt {
          filters {
            value {
              taxonomyCode
              taxonomyDisplayName
            }
          }
        }
        icd {
          filters {
            value {
              taxonomyCode
              taxonomyDisplayName
            }
          }
        }
        nucc {
          filters {
            value {
              taxonomyCode
              taxonomyDisplayName
            }
          }
        }
      }
    }
  }
`;
var getFreeTextGQLQuery = async (input) => {
  const { data } = await gqlClient.query({
    query: getFreeTextQuery,
    variables: { input },
    fetchPolicy: "no-cache",
    context: { uri: "/prior-auth/api/graphql" }
  });
  return data == null ? void 0 : data.queryFreeText;
};
var patient_exports = {};
__export(patient_exports, {
  GetMember: () => get_member_exports,
  getVimPatientId: () => getVimPatientId
});
var get_member_exports = {};
__export(get_member_exports, {
  getMemberEligibilityGQLQuery: () => getMemberEligibilityGQLQuery,
  getMemberGQLQuery: () => getMemberGQLQuery,
  getMemberTokenGQLQuery: () => getMemberTokenGQLQuery
});
var getMemberLogger = logger.scope("Get member queries");
var getMemberTokenQuery = lib_default`
  query getMember($input: GetMemberInput!) {
    getMember(input: $input) {
      memberToken
    }
  }
`;
var getMemberQuery = lib_default`
  query getMember($input: GetMemberInput!) {
    getMember(input: $input) {
      firstName
      lastName
      dateOfBirth
      memberId
      plan
      memberToken
      groupNumber
      careGaps {
        title
        notes
        providerNpi
        dateSubmitted
      }
    }
  }
`;
var getMemberTokenGQLQuery = async (input) => {
  var _a3;
  try {
    const { data } = await gqlClient.query({
      query: getMemberTokenQuery,
      variables: { input },
      fetchPolicy: "no-cache"
    });
    return (_a3 = data == null ? void 0 : data.getMember) == null ? void 0 : _a3.memberToken;
  } catch (error) {
    getMemberLogger.error("Failed get member query for memberToken", { error, input });
    return;
  }
};
var getMemberGQLQuery = async (input) => {
  try {
    const { data } = await gqlClient.query({
      query: getMemberQuery,
      variables: { input },
      fetchPolicy: "no-cache"
    });
    return data == null ? void 0 : data.getMember;
  } catch (error) {
    getMemberLogger.error("Failed get member query", { error, input });
    return;
  }
};
var getMemberEligibilityGQLQuery = async (input) => {
  try {
    const { data } = await gqlClient.query({
      query: getMemberQuery,
      variables: { input },
      fetchPolicy: "no-cache"
    });
    return data == null ? void 0 : data.getMember;
  } catch (error) {
    getMemberLogger.error("Failed get member query", { error, input });
    return;
  }
};
var consts_exports = {};
__export(consts_exports, {
  DEFAULT_HUB_POSITION: () => DEFAULT_HUB_POSITION,
  LOGIN_APP_NAME: () => LOGIN_APP_NAME,
  LOGIN_WIDGET_NAME: () => LOGIN_WIDGET_NAME,
  VIM_CONNECT_NOTIFICATION_WIDGET_NAME: () => VIM_CONNECT_NOTIFICATION_WIDGET_NAME,
  VIM_CONNECT_UI_APP_NAME: () => VIM_CONNECT_UI_APP_NAME,
  VIM_CONNECT_UI_TOAST_WIDGET_NAME: () => VIM_CONNECT_UI_TOAST_WIDGET_NAME,
  VIM_CONNECT_UI_TOOLTIP_WIDGET_NAME: () => VIM_CONNECT_UI_TOOLTIP_WIDGET_NAME,
  VIM_CONNECT_UI_UTILS_APP_NAME: () => VIM_CONNECT_UI_UTILS_APP_NAME,
  appNameAttribute: () => appNameAttribute,
  loginEvents: () => loginEvents,
  userNotExistReasonToDescription: () => userNotExistReasonToDescription
});
var appNameAttribute = "vim-app-name";
var LOGIN_APP_NAME = "login";
var LOGIN_WIDGET_NAME = "login-form";
var VIM_CONNECT_UI_APP_NAME = "vim-connect-ui";
var VIM_CONNECT_UI_UTILS_APP_NAME = "vim-connect-ui-utils";
var VIM_CONNECT_NOTIFICATION_WIDGET_NAME = "vim-connect-ui-notifications";
var VIM_CONNECT_UI_TOOLTIP_WIDGET_NAME = "vim-connect-ui-tooltip";
var VIM_CONNECT_UI_TOAST_WIDGET_NAME = "vim-connect-ui-toast";
var loginEvents = ["onLoggedIn"];
var DEFAULT_HUB_POSITION = {
  vertical: "High",
  horizontal: "Right"
};
var userNotExistReasonToDescription = {
  organization: "Organization was not identified",
  user: `User is not part of the organization`
};
var utils_exports = {};
__export(utils_exports, {
  TimeoutError: () => TimeoutError2,
  flattenBySubstring: () => flattenBySubstring,
  getAppNameBySource: () => getAppNameBySource,
  listenAndRespondToAppMessages: () => listenAndRespondToAppMessages,
  listenToAppMessages: () => listenToAppMessages,
  listenToRuntimeMessages: () => listenToRuntimeMessages,
  sendMessageToApp: () => sendMessageToApp,
  sendMessageToRuntime: () => sendMessageToRuntime,
  sendRequestMessage: () => sendRequestMessage,
  sendRespondableMessageToRuntime: () => sendRespondableMessageToRuntime,
  sleep: () => sleep,
  timeout: () => timeout,
  urlEncodedParams: () => urlEncodedParams
});
var sendMessageToApp = (subscriber, type, payload) => {
  subscriber.postMessage({ type, payload }, "*");
};
var listenToRuntimeMessages = (messageHandlerType, messageHandler) => {
  if (!messageHandler || !messageHandlerType)
    return;
  const onRuntimeMessage = async (browserEvent) => {
    var _a3;
    const browserEventType = (_a3 = browserEvent.data) == null ? void 0 : _a3.type;
    if (browserEventType !== messageHandlerType)
      return;
    const data = browserEvent.data;
    const payload = data == null ? void 0 : data.payload;
    await messageHandler({ payload });
  };
  window.addEventListener("message", onRuntimeMessage);
  return () => window.removeEventListener("message", onRuntimeMessage);
};
var sendMessageToRuntime = (type, payload) => {
  parent.postMessage({ type, payload }, "*");
};
var sendRespondableMessageToRuntime = (type, payload) => sendRequestMessage(parent, type, payload);
var sendRequestMessage = (target, type, payload) => {
  const messageId = v4_default();
  return new Promise((resolve, reject) => {
    window.addEventListener("message", (message) => {
      var _a3;
      if (((_a3 = message == null ? void 0 : message.data) == null ? void 0 : _a3.messageId) !== messageId) {
        return;
      }
      const { response, error } = message.data;
      if (error) {
        reject(error);
      } else {
        resolve(response);
      }
    });
    target.postMessage({ type, payload: __spreadProps(__spreadValues({}, payload), { messageId }) }, "*");
  });
};
var listenToAppMessages = (messageHandlerType, messageHandler) => {
  if (!messageHandler || !messageHandlerType)
    return;
  window.addEventListener("message", async (browserEvent) => {
    var _a3;
    const browserEventType = (_a3 = browserEvent.data) == null ? void 0 : _a3.type;
    if (browserEventType !== messageHandlerType)
      return;
    const source = browserEvent.source;
    const data = browserEvent.data;
    const payload = data == null ? void 0 : data.payload;
    await messageHandler({ source, payload });
  });
};
var listenAndRespondToAppMessages = (messageHandlerType, messageHandler) => {
  if (!messageHandler || !messageHandlerType)
    return;
  listenToAppMessages(messageHandlerType, async (data) => {
    const { source, payload } = data;
    const { messageId } = payload != null ? payload : {};
    let response, handlerError;
    try {
      response = await messageHandler(data);
    } catch (error) {
      if (error instanceof errors_exports.StandardError) {
        handlerError = error.toJSON();
      } else {
        handlerError = new errors_exports.InternalError(error.message, {
          messageHandlerType,
          payload,
          originalError: error.originalError
        }).toJSON();
      }
    }
    source.postMessage({ messageId, response, error: handlerError }, "*");
  });
};
var getAppNameBySource = (source) => {
  var _a3, _b;
  if (source === window)
    return VIM_CONNECT_UI_APP_NAME;
  return (_b = (_a3 = source == null ? void 0 : source.window) == null ? void 0 : _a3.frameElement) == null ? void 0 : _b.getAttribute(appNameAttribute);
};
var urlEncodedParams = (params) => {
  const urlencoded = new URLSearchParams();
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      urlencoded.append(key, params[key]);
    }
  }
  return urlencoded;
};
var sleep = (ms) => new Promise((res) => setTimeout(res, ms));
var TimeoutError2 = class extends Error {
  constructor() {
    super(...arguments);
    this.message = "A timeout has been reached.";
  }
};
var TIMEOUT_SYMBOL = Symbol("Timeout");
var timeout = async (promise, ms) => {
  const result2 = await Promise.race([promise, sleep(ms).then(() => TIMEOUT_SYMBOL)]);
  if (result2 === TIMEOUT_SYMBOL) {
    throw new TimeoutError2();
  }
  return result2;
};
var flattenBySubstring = (obj2, substring) => {
  const flattenObj = (0, import_flat.flatten)(obj2);
  return Object.keys(flattenObj).filter((item) => item.includes(substring));
};
var lts_support_exports = {};
__export(lts_support_exports, {
  LATEST_VERSION: () => LATEST_VERSION,
  getCurrentPageVersion: () => getCurrentPageVersion,
  insertVersionToUrl: () => insertVersionToUrl
});
var insertVersionToUrl = ({ version: version2, url }) => {
  const urlObj = new URL(url);
  const urlQuery = url.split("?")[1];
  const baseURL = `${urlObj.origin}/${version2}${urlObj.pathname}`;
  return `${baseURL}${urlQuery ? `?${urlQuery}` : ""}`;
};
var VERSION_PREFIX = "ver--";
var getCurrentPageVersion = () => {
  const firstURLRoute = window.location.pathname.split("/")[1];
  const isFirstURLRouteVersion = firstURLRoute.startsWith(VERSION_PREFIX);
  return isFirstURLRouteVersion ? firstURLRoute : void 0;
};
var LATEST_VERSION = "latest";
var messageChannel_exports = {};
__export(messageChannel_exports, {
  setupParentPorts: () => setupParentPorts
});
var OS_HANDSHAKE_MESSAGE_TYPE = "vim-os-message-channel-handshake";
var HANDSHAKE_MESSAGE_TYPE = "vim-connect-message-channel-handshake";
var HANDSHAKE_MESSAGE_REPLY_TYPE = "vim-connect-message-channel-handshake-reply";
var AWAIT_CALLBACK_CHANNEL_TIMEOUT = 3e3;
var setupParentPorts = async () => {
  let setupCompleted = false;
  const params = new URLSearchParams(window.location.search);
  const useOsMessageChannel = params.get("use_os_message_channel");
  const useMessageChannel = params.get("use_message_channel");
  if (useMessageChannel !== "true" && useOsMessageChannel !== "true") {
    return Promise.resolve();
  }
  let onHandshake = void 0;
  window.addEventListener("message", (message) => {
    const port = message.ports[0];
    if (message.data.type === HANDSHAKE_MESSAGE_TYPE) {
      setupCompleted = true;
      window.$vimConnectParentPort = port;
      port.postMessage({ type: HANDSHAKE_MESSAGE_REPLY_TYPE });
      onHandshake == null ? void 0 : onHandshake();
    } else if (message.data.type === OS_HANDSHAKE_MESSAGE_TYPE) {
      window.$vimOSMessagePort = port;
      if (useOsMessageChannel && !useMessageChannel) {
        onHandshake == null ? void 0 : onHandshake();
      }
    }
  });
  return new Promise((resolve) => {
    const portToCheck = useOsMessageChannel && !useMessageChannel ? window.$vimOSMessagePort : window.$vimConnectParentPort;
    if (portToCheck) {
      resolve();
      return;
    } else {
      onHandshake = resolve;
    }
    setTimeout(() => {
      if (!setupCompleted) {
        resolve();
      }
    }, AWAIT_CALLBACK_CHANNEL_TIMEOUT);
  });
};
var graphql_exports = {};
__export(graphql_exports, {
  Auth: () => auth_exports,
  DecisionCode: () => DecisionCode
});
var auth_exports = {};
var DecisionCode = /* @__PURE__ */ ((DecisionCode22) => {
  DecisionCode22[DecisionCode22["Required"] = 1] = "Required";
  DecisionCode22[DecisionCode22["NotRequired"] = 2] = "NotRequired";
  DecisionCode22[DecisionCode22["Conditional"] = 3] = "Conditional";
  DecisionCode22[DecisionCode22["Blocked"] = 4] = "Blocked";
  return DecisionCode22;
})(DecisionCode || {});
var widgetsMessageChannel_exports = {};
__export(widgetsMessageChannel_exports, {
  setupParentPorts: () => setupParentPorts2
});
var setupParentPorts2 = async () => {
  if (window.$vimConnectParentPortSetupPromise)
    await window.$vimConnectParentPortSetupPromise;
};

// src/hooks/useAccessToken.ts
var accessToken = null;
var getAccessToken = () => {
  return accessToken;
};
var setAccessToken = (token) => {
  accessToken = token;
};
var useAccessToken = () => {
  const { vimCommunication } = useVimCommunication();
  const [stateAccessToken, setStateAccessToken] = useState(null);
  const setStateAndGlobalAccessToken = useCallback((token) => {
    setStateAccessToken(token);
    setAccessToken(token);
  }, []);
  if (!accessToken) {
    const initialAccessToken = new URLSearchParams(window.location.search).get("initialAccessToken");
    if (initialAccessToken)
      setStateAndGlobalAccessToken(initialAccessToken);
  }
  useEffect(() => {
    const getTokenFromRuntime = async () => {
      try {
        const token = await (vimCommunication == null ? void 0 : vimCommunication.getAccessToken());
        if (token)
          setStateAndGlobalAccessToken(token);
      } catch (error) {
        console.log("Failed to get accessToken", error);
      }
    };
    if (!stateAccessToken)
      getTokenFromRuntime();
  }, [setStateAndGlobalAccessToken, stateAccessToken, vimCommunication]);
  useEffect(() => {
    vimCommunication == null ? void 0 : vimCommunication.listenToEvent(runtime_contract_exports.Outgoing.OutgoingMessages.UPDATE_ACCESS_TOKEN, ({ data }) => {
      setStateAndGlobalAccessToken(data == null ? void 0 : data.accessToken);
    });
  }, [setStateAndGlobalAccessToken, vimCommunication]);
  return [stateAccessToken, setStateAndGlobalAccessToken];
};

// src/hooks/useProductConfig.ts
import { useEffect as useEffect2, useState as useState2 } from "react";
var useProductConfig = (applicationName) => {
  const [productConfig, setProductConfig] = useState2(void 0);
  const { vimCommunication } = useVimCommunication();
  useEffect2(() => {
    vimCommunication == null ? void 0 : vimCommunication.getProductConfig(applicationName).then((config) => setProductConfig(config)).catch((error) => console.error("Could not get product configuration!", { error, applicationName }));
  }, [vimCommunication, applicationName]);
  return productConfig;
};

// src/useProductMetadata.tsx
var productMetadataContext = createContext({});
var ProductMetadataProvider = ({ children, widgetId }) => {
  const productConfig = useProductConfig(widgetId);
  const [accessToken2] = useAccessToken();
  const productMetadata = useMemo(() => {
    return { productConfig, accessToken: accessToken2 };
  }, [accessToken2, productConfig]);
  return /* @__PURE__ */ React.createElement(productMetadataContext.Provider, {
    value: productMetadata
  }, children);
};
var useProductMetadata = () => {
  const productMetadata = useContext(productMetadataContext);
  return productMetadata;
};

// src/useVimCommunication.tsx
import { ModuleNames } from "@getvim-communication/management";
var VimCommunicationContext = createContext2(void 0);
var createVimCommunicationInstance = ({
  widgetId,
  parentAppId,
  communicationModules
}) => {
  return parentAppId ? new SubApplicationVimCommunication(parentAppId, {
    moduleId: widgetId,
    tabId: getTabIdFromUrl(),
    moduleNames: communicationModules != null ? communicationModules : []
  }) : new WidgetVimCommunication({
    moduleId: widgetId,
    tabId: getTabIdFromUrl(),
    moduleNames: communicationModules
  });
};
var VimCommunicationProvider = (_a3) => {
  var _b = _a3, { children } = _b, props = __objRest(_b, ["children"]);
  const { parentAppId, widgetId } = props;
  const [vimCommunication] = useState3(() => createVimCommunicationInstance(props));
  return /* @__PURE__ */ React2.createElement(VimCommunicationContext.Provider, {
    value: vimCommunication
  }, parentAppId ? children : /* @__PURE__ */ React2.createElement(ProductMetadataProvider, {
    widgetId
  }, children));
};
function useVimCommunication() {
  const vimCommunication = useContext2(VimCommunicationContext);
  return { vimCommunication };
}

// src/useAnalytics.tsx
import { useMemo as useMemo2 } from "react";

// ../../packages/platform-types/build/index.js
var __defProp4 = Object.defineProperty;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp3 = (obj2, key, value) => key in obj2 ? __defProp4(obj2, key, { enumerable: true, configurable: true, writable: true, value }) : obj2[key] = value;
var __spreadValues2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp2.call(b, prop))
      __defNormalProp3(a, prop, b[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b)) {
      if (__propIsEnum2.call(b, prop))
        __defNormalProp3(a, prop, b[prop]);
    }
  return a;
};
var __export2 = (target, all) => {
  for (var name in all)
    __defProp4(target, name, { get: all[name], enumerable: true });
};
var AnalyticsEvents = /* @__PURE__ */ ((AnalyticsEvents2) => {
  AnalyticsEvents2["ANALYTICS_TRACK"] = "analytics-track";
  AnalyticsEvents2["ANALYTICS_SET_BASE_PROPERTIES"] = "analytics-set-base-properties";
  AnalyticsEvents2["ANALYTICS_SET_SESSIONS"] = "analytics-set-sessions";
  return AnalyticsEvents2;
})(AnalyticsEvents || {});
var extractMemberFragment = lib_default`
  fragment extractMemberFragment on ExtractMemberResult {
    id
    firstName
    lastName
    dateOfBirth
    email
    address {
      addressLine1
      addressLine2
      city
      state
      zip
    }
    gender
    phoneNumber {
      countryDialingCode
      number
    }
    memberIdPrefix
    memberId
    plan
  }
`;
var healthHistory_exports = {};
__export2(healthHistory_exports, {
  ResourceType: () => ResourceType
});
var ResourceType = /* @__PURE__ */ ((ResourceType3) => {
  ResourceType3["HEALTH_CONDITION"] = "HEALTH_CONDITION";
  ResourceType3["MEDICATION"] = "MEDICATION";
  ResourceType3["IMMUNIZATION"] = "IMMUNIZATION";
  ResourceType3["VISIT_HISTORY"] = "VISIT_HISTORY";
  ResourceType3["PROCEDURE"] = "PROCEDURE";
  return ResourceType3;
})(ResourceType || {});
var priorAuth_exports = {};
__export2(priorAuth_exports, {
  DecisionCode: () => DecisionCode2
});
var DecisionCode2 = /* @__PURE__ */ ((DecisionCode22) => {
  DecisionCode22[DecisionCode22["Required"] = 1] = "Required";
  DecisionCode22[DecisionCode22["NotRequired"] = 2] = "NotRequired";
  DecisionCode22[DecisionCode22["Conditional"] = 3] = "Conditional";
  DecisionCode22[DecisionCode22["Blocked"] = 4] = "Blocked";
  return DecisionCode22;
})(DecisionCode2 || {});
var AppointmentStatus = /* @__PURE__ */ ((AppointmentStatus2) => {
  AppointmentStatus2["ACCEPTED"] = "ACCEPTED";
  AppointmentStatus2["REQUESTED"] = "REQUESTED";
  AppointmentStatus2["CANCELED"] = "CANCELED";
  AppointmentStatus2["CANCELED_BY_BACKPACK"] = "CANCELED_BY_BACKPACK";
  AppointmentStatus2["CANCELED_BY_MEMBER"] = "CANCELED_BY_MEMBER";
  AppointmentStatus2["CHECKED_IN"] = "CHECKED_IN";
  AppointmentStatus2["ARCHIVED"] = "ARCHIVED";
  AppointmentStatus2["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
  AppointmentStatus2["PENDING"] = "PENDING";
  AppointmentStatus2["RESCHEDULE"] = "RESCHEDULE";
  AppointmentStatus2["NO_SHOW"] = "NO_SHOW";
  AppointmentStatus2["FAILED_TO_BOOK"] = "FAILED_TO_BOOK";
  return AppointmentStatus2;
})(AppointmentStatus || {});
var AppointmentRequestExternalStatus = /* @__PURE__ */ ((AppointmentRequestExternalStatus2) => {
  AppointmentRequestExternalStatus2["WAITING_FOR_CLINIC_ACTION"] = "WAITING_FOR_CLINIC_ACTION";
  AppointmentRequestExternalStatus2["WAITING_FOR_PATIENT_ACTION"] = "WAITING_FOR_PATIENT_ACTION";
  AppointmentRequestExternalStatus2["ARCHIVED"] = "ARCHIVED";
  AppointmentRequestExternalStatus2["DECLINED_BY_CLINIC"] = "DECLINED_BY_CLINIC";
  AppointmentRequestExternalStatus2["BOOKED"] = "BOOKED";
  return AppointmentRequestExternalStatus2;
})(AppointmentRequestExternalStatus || {});
var UnifiedAppointmentStatus = __spreadValues2(__spreadValues2({}, AppointmentStatus), AppointmentRequestExternalStatus);

// src/useAnalytics.tsx
var useAnalytics = () => {
  const { vimCommunication } = useVimCommunication();
  const analyticsClient = useMemo2(() => {
    const track2 = (payload) => {
      sendEvent(AnalyticsEvents.ANALYTICS_TRACK, payload);
    };
    const setSession = (payload) => {
      sendEvent(AnalyticsEvents.ANALYTICS_SET_SESSIONS, payload);
    };
    const setBaseProperties = (payload) => {
      sendEvent(AnalyticsEvents.ANALYTICS_SET_BASE_PROPERTIES, payload);
    };
    const sendEvent = (analyticsEvents, payload) => {
      vimCommunication == null ? void 0 : vimCommunication.sendEvent(ModuleNames.Runtime, analyticsEvents, payload);
    };
    return { track: track2, setSession, setBaseProperties };
  }, [vimCommunication]);
  return { analyticsClient };
};
export {
  ModuleNames,
  ProductMetadataProvider,
  VimCommunicationContext,
  VimCommunicationProvider,
  getAccessToken,
  productMetadataContext,
  setAccessToken,
  useAccessToken,
  useAnalytics,
  useProductMetadata,
  useVimCommunication
};
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
//# sourceMappingURL=index.js.map
